
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("48Eol", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $6cnUO = parcelRequire("6cnUO");


var $k7Tf7 = parcelRequire("k7Tf7");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $4kfV4 = parcelRequire("4kfV4");







const $75d67dd405790b85$export$79cc7820899d3234 = /*#__PURE__*/ (0, $42omo.createContext)(false);



var $9gVcn = parcelRequire("9gVcn");

const $1274ccb8dddd72cd$export$797f6437373337da = ({ children: children, value: value })=>{
    const isCustomIsFhsEnabled = (0, $42omo.useContext)((0, $75d67dd405790b85$export$79cc7820899d3234));
    if (isCustomIsFhsEnabled) throw new Error('A custom value for IsFhsEnabledContext has already been provided');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75d67dd405790b85$export$79cc7820899d3234).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gVcn.IsFhsEnabledContext).Provider, {
        value: value
    }, children));
};



var $eK5zz = parcelRequire("eK5zz");

/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $3RzOP = parcelRequire("3RzOP");


var $8zs3p = parcelRequire("8zs3p");


var $K0HEo = parcelRequire("K0HEo");


var $9w5su = parcelRequire("9w5su");


var $4jxPT = parcelRequire("4jxPT");


var $8jREP = parcelRequire("8jREP");


var $d4FF7 = parcelRequire("d4FF7");

const $f0df34b67538a54c$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat",
    fullHeightSidebar: "_1pby11wp"
}; /**
    * The banner layout area. It will always be displayed at the top of the screen.
    *
    * Should be used to render a `Banner` component from `@atlaskit/banner`.
    */ 
function $f0df34b67538a54c$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = 48, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $d4FF7.useLayoutId)({
        providedId: providedId
    });
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)(); /**
                                           * Don't show the skip link if the slot has 0 height.
                                           *
                                           * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
                                           */ 
    (0, $3RzOP.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0 || (0, $dh538.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    return /*#__PURE__*/ $42omo.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $gMc0m.default)([
            $f0df34b67538a54c$var$styles.root,
            isFhsEnabled && $f0df34b67538a54c$var$styles.fullHeightSidebar,
            xcss
        ]),
        "data-testid": testId
    }, /*#__PURE__*/ $42omo.createElement((0, $4jxPT.HoistCssVarToLocalGrid), {
        variableName: (0, $K0HEo.bannerMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $42omo.createElement((0, $9w5su.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $K0HEo.UNSAFE_bannerVar),
        value: height
    }), children);
}



var $1imNS = parcelRequire("1imNS");


var $82dFP = parcelRequire("82dFP");


var $9wGTI = parcelRequire("9wGTI");


var $58PBI = parcelRequire("58PBI");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7xVCs = parcelRequire("7xVCs");


var $5XPyz = parcelRequire("5XPyz");


var $hrAmX = parcelRequire("hrAmX");


var $cgsIj = parcelRequire("cgsIj");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $1C7kY = parcelRequire("1C7kY");


var $3u0dr = parcelRequire("3u0dr");











var $dpPtd = parcelRequire("dpPtd");





var $bssir = parcelRequire("bssir");


var $6tLpM = parcelRequire("6tLpM");

var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");


var $gz8ZY = parcelRequire("gz8ZY");




const $36b11f7822ba6f88$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    panelSplitter: {
        id: "preview-panel-api.resize.label",
        defaultMessage: "Resize panel"
    }
});


const $2c25ef82052c394f$var$PreviewPanelSplitter = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const intl = (0, $aXWIB.useIntl)();
    const { setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    let t0;
    if ($[0] !== setPanelWidth) {
        t0 = (t1)=>{
            const { finalWidth: finalWidth } = t1;
            setPanelWidth(finalWidth);
        };
        $[0] = setPanelWidth;
        $[1] = t0;
    } else t0 = $[1];
    const onResizeEnd = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onResizeEnd || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bssir.PanelSplitter), {
            label: t1,
            onResizeEnd: onResizeEnd
        });
        $[4] = onResizeEnd;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const { setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const onResizeEnd = (0, $42omo.useCallback)(({ finalWidth: finalWidth })=>{
        setPanelWidth(finalWidth);
    }, [
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bssir.PanelSplitter), {
        label: intl.formatMessage((0, $36b11f7822ba6f88$export$defe85febe8b728c).panelSplitter),
        onResizeEnd: onResizeEnd
    });
};
const $2c25ef82052c394f$var$NavWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children, width: width } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eK5zz.Panel), {
            defaultWidth: width
        }, t1, children);
        $[1] = children;
        $[2] = width;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eK5zz.Panel), {
        defaultWidth: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$PreviewPanelSplitter, null), children);
const $2c25ef82052c394f$export$f143b4bd86d1e004 = (0, $3u0dr.isReactCompilerActiveV2)() ? function PreviewPanelContainer() {
    const $ = (0, $frIzR.c)(5);
    const panel = (0, $6tLpM.useCurrentPreviewPanel)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (!(0, $6mKj3.expValEquals)("confluence_preview_panels_exp", "isEnabled", true)) return null;
    if (!isNav4Enabled) return null;
    if (panel == null) return null;
    const { content: PanelContent, width: width } = panel;
    let t0;
    if ($[0] !== PanelContent) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PanelContent, null));
        $[0] = PanelContent;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0 || $[3] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$NavWrapper, {
            width: width
        }, t0);
        $[2] = t0;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function PreviewPanelContainer() {
    const panel = (0, $6tLpM.useCurrentPreviewPanel)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (!(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) return null;
    if (!isNav4Enabled) return null;
    if (panel == null) return null;
    const { content: PanelContent, width: width } = panel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c25ef82052c394f$var$NavWrapper, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PanelContent, null)));
};






var $jmjWc = parcelRequire("jmjWc");



const $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zbjaW",
    name: "ObjectSidebarContent",
    loader: async ()=>(await (parcelRequire("8XaNQ"))).ObjectSidebarContent
});



var $jvYFk = parcelRequire("jvYFk");


var $aWwYt = parcelRequire("aWwYt");


var $2vuKf = parcelRequire("2vuKf");


var $8zMP3 = parcelRequire("8zMP3");


var $fZAJP = parcelRequire("fZAJP");


var $jAOzg = parcelRequire("jAOzg");





var $ep3mz = parcelRequire("ep3mz");








var $bpufi = parcelRequire("bpufi");


var $ftFOj = parcelRequire("ftFOj");

/**
 * Inner component that runs the sync hook. Kept separate so the ErrorBoundary
 * above it can catch any errors thrown during the hook's execution without
 * taking down the rest of the page layout.
 */ const $3260f1cb149f21d4$var$SmartFolderAncestorSyncInner = ({ contentId: contentId })=>{
    (0, $bpufi.useSmartFolderAncestorSync)(contentId);
    return null;
};
const $3260f1cb149f21d4$export$2e1f52d6d7a935bc = ({ contentId: contentId })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSmartFoldersEnabled: isSmartFoldersEnabled } = (0, $ftFOj.useIsSmartFoldersEnabled)(spaceKey ?? '');
    if (!isSmartFoldersEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3260f1cb149f21d4$var$SmartFolderAncestorSyncInner, {
        contentId: contentId
    }));
};









var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $lFjPc = parcelRequire("lFjPc");

const $bd996ec529999f47$export$ac3e7903e24ee02d = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { view: view, children: children, navVersion: navVersion } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker || $[1] !== navVersion) {
        t1 = (name)=>experienceTracker.abort({
                name: name,
                reason: "navigation container view changed",
                attributes: {
                    navVersion: navVersion
                }
            });
        $[0] = experienceTracker;
        $[1] = navVersion;
        $[2] = t1;
    } else t1 = $[2];
    const abortExp = t1;
    let t2;
    if ($[3] !== experienceTracker || $[4] !== navVersion) {
        t2 = (name_0)=>experienceTracker.start({
                name: name_0,
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: navVersion
                }
            });
        $[3] = experienceTracker;
        $[4] = navVersion;
        $[5] = t2;
    } else t2 = $[5];
    const startExp = t2;
    let t3;
    let t4;
    if ($[6] !== abortExp || $[7] !== startExp || $[8] !== view) {
        t3 = ()=>{
            bb6: switch(view){
                case 0, $lFjPc.CONTAINER_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $lFjPc.PRODUCT_HOME_ID:
                case 0, $lFjPc.PRODUCT_ADDONS_ID:
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    break bb6;
                case 0, $lFjPc.ADMIN_HOME_ID:
                    startExp((0, $irVI7.APP_NAV_ADMIN_EXPERIENCE));
                    abortExp((0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE));
            }
        };
        t4 = [
            view,
            startExp,
            abortExp
        ];
        $[6] = abortExp;
        $[7] = startExp;
        $[8] = view;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $42omo.useLayoutEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== startExp) {
        t5 = ()=>{
            startExp((0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE));
        };
        t6 = [
            startExp
        ];
        $[11] = startExp;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $42omo.useLayoutEffect)(t5, t6);
    let t7;
    if ($[14] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[14] = children;
        $[15] = t7;
    } else t7 = $[15];
    return t7;
};












var $inPa6 = parcelRequire("inPa6");


var $hnvzE = parcelRequire("hnvzE");




var $dcJ7R = parcelRequire("dcJ7R");










var $2SvFZ = parcelRequire("2SvFZ");


var $1pSma = parcelRequire("1pSma");



// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $i834V = parcelRequire("i834V");




var $b3j2Y = parcelRequire("b3j2Y");





var $hSqtY = parcelRequire("hSqtY");


var $1uFM6 = parcelRequire("1uFM6");





var $8YePs = parcelRequire("8YePs");


var $7aRa9 = parcelRequire("7aRa9");


var $jFFx4 = parcelRequire("jFFx4");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $de2j9 = parcelRequire("de2j9");





const $f92bf53981932d65$export$347b3004b45f815 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "x9Mbz",
    name: "AdminNavigationLoader",
    loader: async ()=>(await (parcelRequire("5fd2s"))).AdminNavigation
});












var $6bJyJ = parcelRequire("6bJyJ");




var $1GzhS = parcelRequire("1GzhS");




var $kpYGL = parcelRequire("kpYGL");


var $7yDmn = parcelRequire("7yDmn");





var $7p8VW = parcelRequire("7p8VW");

var $c8gOp = parcelRequire("c8gOp");


var $9x2sR = parcelRequire("9x2sR");





var $dVkip = parcelRequire("dVkip");





var $iKskQ = parcelRequire("iKskQ");


var $bQm3c = parcelRequire("bQm3c");





var $hXDOc = parcelRequire("hXDOc");

const $38b2da651c37b412$var$StarredSpacesListComponent = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { flags: flags } = t0;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { starredSpaces: starredSpaces, error: error, loading: loading } = (0, $dVkip.useStarredData)(isLicensed);
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = ()=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "fixedItem",
                itemId: "viewAllSpaces",
                section: "starredSpaces"
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const onViewAllClick = t1;
    let t2;
    if ($[2] !== createAnalyticsEvent) {
        t2 = (spaceId)=>{
            $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics(createAnalyticsEvent, "4", {
                componentType: "customItem",
                itemType: "space",
                itemId: spaceId,
                section: "starredSpaces"
            });
        };
        $[2] = createAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const onStarredSpaceItemClick = t2;
    let t3;
    let t4;
    if ($[4] !== error || $[5] !== flags || $[6] !== loading) {
        t3 = ()=>{
            if (!loading && error) flags.showErrorFlag({
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $38b2da651c37b412$var$i18n.errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $38b2da651c37b412$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
        };
        t4 = [
            loading,
            error,
            flags
        ];
        $[4] = error;
        $[5] = flags;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8gOp.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $38b2da651c37b412$var$i18n.title));
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== loading) {
        t6 = loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($38b2da651c37b412$var$LoadingSkeletons, null);
        $[10] = loading;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== intl || $[13] !== loading || $[14] !== starredSpaces) {
        t7 = !loading && starredSpaces.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            padding: "space.100",
            xcss: $38b2da651c37b412$var$emptySpacesTextStyles
        }, intl.formatMessage($38b2da651c37b412$var$i18n.empty));
        $[12] = intl;
        $[13] = loading;
        $[14] = starredSpaces;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== loading || $[17] !== onStarredSpaceItemClick || $[18] !== starredSpaces) {
        t8 = !loading && starredSpaces && starredSpaces.map((space)=>{
            const spaceAlias = space.alias || space.key;
            const url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                spaceKey: spaceAlias
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
                key: space.id,
                name: "starred-spaces",
                preloadUrl: url,
                preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                key: space.id,
                href: url,
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
                    size: "xsmall",
                    src: space.icon?.path
                }),
                onClick: ()=>onStarredSpaceItemClick(space.id)
            }, space.name));
        });
        $[16] = loading;
        $[17] = onStarredSpaceItemClick;
        $[18] = starredSpaces;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== loading || $[21] !== onViewAllClick) {
        t9 = !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: (0, $1NBp8.SPACE_DIRECTORY).toUrl(),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: "",
                color: "currentColor"
            }),
            onClick: onViewAllClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $38b2da651c37b412$var$i18n.viewAll));
        $[20] = loading;
        $[21] = onViewAllClick;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p8VW.MenuSection), null, t5, t6, t7, t8, t9);
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    return t10;
};
const $38b2da651c37b412$export$79ffca654f6ab234 = (0, $7aRa9.withFlags)($38b2da651c37b412$var$StarredSpacesListComponent);
const $38b2da651c37b412$var$fireStarredSpacesListItemClickedAnalytics = (createAnalyticsEvent, navVersion, options = {})=>{
    const { componentType: componentType, itemId: itemId, itemType: itemType, section: section } = options;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'spacesNavigationMenuItem',
            source: 'globalNavigation',
            attributes: {
                navigationLayer: 'global',
                navigationContainer: 'sidebar',
                navVersion: navVersion,
                componentType: componentType,
                itemId: itemId,
                itemType: itemType,
                section: section
            }
        }
    }).fire();
};
const $38b2da651c37b412$var$LoadingSkeletons = ()=>{
    const $ = (0, $frIzR.c)(1);
    const skeletonBorderRadius = (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? "var(--ds-radius-small, 4px)" : "3px";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlockStart: "space.075",
            paddingInlineStart: "space.075",
            testId: "loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $38b2da651c37b412$var$emptySpacesTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small'
});
const $38b2da651c37b412$var$i18n = (0, $aXWIB.defineMessages)({
    title: {
        id: "side-navigation.starred-spaces-list.title",
        defaultMessage: "Starred spaces"
    },
    viewAll: {
        id: "side-navigation.starred-spaces-list.view-all",
        defaultMessage: "View all spaces"
    },
    empty: {
        id: "side-navigation.starred-spaces-list.empty-message",
        defaultMessage: "Spaces you star will appear here"
    },
    errorFlagTitle: {
        id: "side-navigation.starred-spaces-list.error-flag-title",
        defaultMessage: "We couldn\u2019t load starred spaces"
    },
    errorFlagDescription: {
        id: "side-navigation.starred-spaces-list.error-flag-description",
        defaultMessage: "We are unable to show your spaces at this time. Refresh the page or try again."
    }
});






const $4ad4ea954990a797$export$9c64eb3c7e74d13c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zC56Y",
    loader: async ()=>(await (parcelRequire("eG6LW"))).HubSettingsNavigation,
    name: 'HubSettingsNavigation'
});









var $7Ri6A = parcelRequire("7Ri6A");














var $feuG2 = parcelRequire("feuG2");


var $cLo2u = parcelRequire("cLo2u");

const $5a5cd25c242b4596$var$SpaceAdminNavigationInternal = ()=>{
    const $ = (0, $frIzR.c)(13);
    const spaceAlias = (0, $cLo2u.useSpaceKey)();
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = (0, $7Ri6A.usePageLayoutResize)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { location: location, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const t0 = location?.pathname || "";
    let t1;
    if ($[0] !== matchRoute || $[1] !== t0) {
        t1 = matchRoute(t0);
        $[0] = matchRoute;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const route = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== isLeftSidebarCollapsed || $[5] !== route?.name) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "spaceAdminSideNavigation",
                    attributes: {
                        tab: route?.name || "",
                        isVisible: !isLeftSidebarCollapsed
                    }
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = isLeftSidebarCollapsed;
        $[5] = route?.name;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = route?.name;
    let t4;
    if ($[7] !== createAnalyticsEvent || $[8] !== isLeftSidebarCollapsed || $[9] !== t3) {
        t4 = [
            createAnalyticsEvent,
            isLeftSidebarCollapsed,
            t3
        ];
        $[7] = createAnalyticsEvent;
        $[8] = isLeftSidebarCollapsed;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    (0, $42omo.useEffect)(t2, t4);
    const t5 = spaceAlias || "";
    let t6;
    if ($[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsSideNavigation), {
            spaceAlias: t5
        });
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
};
const $5a5cd25c242b4596$export$a5608b5e4da20698 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a5cd25c242b4596$var$SpaceAdminNavigationInternal, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};












var $7boqA = parcelRequire("7boqA");


var $1uFsv = parcelRequire("1uFsv");


const $4ccde8579962336f$var$GlobalNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6E8ob",
    name: "GlobalNavigationLoader",
    loader: async ()=>(await (parcelRequire("vkc68"))).GlobalNavigationComponent
});
const $4ccde8579962336f$export$796d3395e4dcf32b = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ccde8579962336f$var$GlobalNavigationLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};



var $2qRJj = parcelRequire("2qRJj");


var $l65Bo = parcelRequire("l65Bo");


var $6GD8y = parcelRequire("6GD8y");


var $bflGB = parcelRequire("bflGB");


var $gnkil = parcelRequire("gnkil");





var $cEgMD = parcelRequire("cEgMD");





var $hQnHK = parcelRequire("hQnHK");





var $efvKr = parcelRequire("efvKr");








var $hmuev = parcelRequire("hmuev");


var $1s5hv = parcelRequire("1s5hv");


var $1qfLF = parcelRequire("1qfLF");







const $ba0fa5890838b7bb$export$ee8ecac8c80214c1 = ()=>{
    const [closedMessage, setClosedMessage] = (0, $42omo.useState)(false);
    const intl = (0, $aXWIB.useIntl)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    (0, $42omo.useEffect)(()=>{
        if (closedMessage) setClosedMessage(false);
    // Should only fire when spaceKey changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    if (closedMessage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SvFZ.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        testId: "anonymous-access-side-nav-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $ba0fa5890838b7bb$var$i18n.anonymousAccessMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: ()=>setClosedMessage(true),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                size: "small"
            }),
        label: intl.formatMessage($ba0fa5890838b7bb$var$i18n.close),
        appearance: "subtle",
        spacing: "compact"
    })));
};
const $ba0fa5890838b7bb$var$i18n = (0, $aXWIB.defineMessages)({
    anonymousAccessMessage: {
        id: "anonymous-access.anonymous-access-side-nav-message.text",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You\u2018re viewing this with anonymous access, so some content might be blocked."
    },
    close: {
        id: "anonymous-access.anonymous-access-side-nav-message.close",
        defaultMessage: "Close"
    }
});



var $gsSsC = parcelRequire("gsSsC");


var $jMyy4 = parcelRequire("jMyy4");

const $da0a91219ee54603$export$b1d9964175452d0b = ({ spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $gsSsC.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skipQuery || !spaceKey,
        __callerPackage__: "@confluence/anonymous-access"
    });
    // For restricted spaces the preloader's query returns a 403 which Apollo evicts from
    // its cache. This leaves `useQueryInterop` in a perpetual `loading: true` state during
    // SSR, while on the client the same query resolves with `loading: false` and
    // `space: null`. The resulting mismatch causes a hydration error in the SideNav footer.
    //
    // The preloader detects this case and persists the space key in a global
    // (`__RESTRICTED_SPACES_FROM_PRELOAD__`). When present, we short-circuit here so both
    // SSR and client agree on `{ loading: false, isUserViewingSpaceAsAnon: false }`.
    const restrictedSpaces = typeof window !== 'undefined' ? window.__RESTRICTED_SPACES_FROM_PRELOAD__ : globalThis.__RESTRICTED_SPACES_FROM_PRELOAD__;
    if (restrictedSpaces?.[spaceKey]) return {
        isUserViewingSpaceAsAnon: false,
        loading: false,
        error: undefined
    };
    return {
        isUserViewingSpaceAsAnon: Boolean(data?.space?.currentUser?.isAnonymouslyAuthorized),
        loading: loading,
        error: error
    };
};


/**
 * @generated SignedSource<<9e6c6d362cc13ed465d44b1891a67188>>
 * @relayHash a912afe2fbea3fe5bd99ea14ca3598df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b
const $068b1fe48e1495bf$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "licenseConsumingUserCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a912afe2fbea3fe5bd99ea14ca3598df",
            "id": "80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b",
            "metadata": {},
            "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
            "operationKind": "query",
            "text": "query usePersistentInviteButtonEligibleLicenseDetailsQuery{license{licenseConsumingUserCount,trialEndDate}}"
        }
    };
}();
$068b1fe48e1495bf$var$node.hash = "ba822387cdd604c4581f577b0c57ca7a";
var $068b1fe48e1495bf$export$2e2bcd8739ae039 = $068b1fe48e1495bf$var$node;






var $1o4fX = parcelRequire("1o4fX");





var $euL71 = parcelRequire("euL71");


var $dPJCf = parcelRequire("dPJCf");




function $463b48fb68db8bff$export$b3cda0b328199f72() {
    const { edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const skipLicenseQuery = isFreeEdition || !isLoggedIn || !isLicensed;
    const { refetch: refetch, data: licenseDetailsData, loading: licenseDetailsLoading, error: licenseDetailsDataError } = (0, $jMyy4.useQueryInterop)((0, $068b1fe48e1495bf$export$2e2bcd8739ae039), {
        skip: skipLicenseQuery,
        __callerPackage__: "@confluence/persistent-invite-button"
    });
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(licenseDetailsData?.license?.trialEndDate);
    const isInTrial = trialDaysLeft ? trialDaysLeft > 0 : false;
    // Sometimes, the trial end date is not set on the initial load for a new tenant, even though they have been put into a trial.
    // This can lead to the invite button not appearing. To mitigate this, we refetch the license details on page transition if we
    // suspect the user is in a trial, but the trial end date is null.
    const transitionId = (0, $dPJCf.useTransitionId)();
    const hasRefetched = (0, $42omo.useRef)(false);
    const initialTransitionId = (0, $42omo.useRef)(transitionId);
    (0, $42omo.useEffect)(()=>{
        if (isInTrial || skipLicenseQuery || licenseDetailsLoading || licenseDetailsDataError) return;
        const trialSuspected = Boolean(licenseDetailsData?.license?.trialEndDate === null && licenseDetailsData?.license?.licenseConsumingUserCount === 1 && !isFreeEdition);
        if (!hasRefetched.current && trialSuspected && transitionId > initialTransitionId.current) {
            refetch();
            hasRefetched.current = true;
        }
    }, [
        edition,
        isFreeEdition,
        isInTrial,
        isLicensed,
        isLoggedIn,
        licenseDetailsData,
        licenseDetailsDataError,
        licenseDetailsLoading,
        refetch,
        skipLicenseQuery,
        transitionId
    ]);
    return {
        loading: licenseDetailsLoading,
        error: licenseDetailsDataError,
        isEligible: isInTrial || isFreeEdition
    };
}



var $7Sm4c = parcelRequire("7Sm4c");













var $92JEG = parcelRequire("92JEG");


const $f542602a6e0f4176$export$4283c4ef2b834aa2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "USWMG",
    name: "Nav4CollapseReminderSpotlightLoader",
    loader: async ()=>(await (parcelRequire("4T2bk"))).Nav4CollapseReminderSpotlight
});



var $4q9NN = parcelRequire("4q9NN");


var $gEtAQ = parcelRequire("gEtAQ");


var $b0EGa = parcelRequire("b0EGa");











const $95859b7288e22ff6$var$PlatformNavigationLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xsgSo",
    name: "PlatformNavigationLoader",
    loader: async ()=>(await (parcelRequire("fRvBq"))).PlatformNavigationComponent
});
const $95859b7288e22ff6$export$446e292f3fdcabd = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95859b7288e22ff6$var$PlatformNavigationLoader, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};












var $i3jcY = parcelRequire("i3jcY");








var $3jwuS = parcelRequire("3jwuS");










const $e486084baed62696$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $e486084baed62696$export$7b73ec245f6c47f8 = ()=>{
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const showRecap2025QueryParam = $e486084baed62696$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isEditorPage;
    // Check if user has already collapsed the sidebar for recap before
    const hasCollapsedBefore = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED) === 'true';
    const shouldCollapse = isEligible && !hasCollapsedBefore;
    // Set the persisted flag when we determine we should collapse
    // This marks that the user has seen this behavior (first visit)
    (0, $42omo.useEffect)(()=>{
        if (shouldCollapse && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_RECAP_SIDEBAR_COLLAPSED, 'true');
    }, [
        shouldCollapse
    ]);
    return shouldCollapse;
};



var $e4o8D = parcelRequire("e4o8D");




const $1b5aa9dc12e56400$export$444990cc7caeb4e0 = 320;
const $1b5aa9dc12e56400$export$6deddaa54d32585b = ()=>{
    const $ = (0, $frIzR.c)(6);
    const shouldCollapseForRecap = (0, $e486084baed62696$export$7b73ec245f6c47f8)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = !userId;
    if ((0, $i3jcY.isStableUIEnabledForTests)()) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                initialCollapsedState: "expanded",
                initialWidth: $1b5aa9dc12e56400$export$444990cc7caeb4e0,
                shouldForceExpand: true,
                needsPostHydrationCollapse: false
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? "expanded";
        $[1] = t0;
    } else t0 = $[1];
    const persistedCollapseState = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH) || $1b5aa9dc12e56400$export$444990cc7caeb4e0;
        $[2] = t1;
    } else t1 = $[2];
    let persistedWidth = parseInt(t1, 10);
    if (Number.isNaN(persistedWidth)) persistedWidth = $1b5aa9dc12e56400$export$444990cc7caeb4e0;
    const isWidthTooLarge = persistedWidth > window.innerWidth;
    const fittedSidebarWidth = isWidthTooLarge ? $1b5aa9dc12e56400$export$444990cc7caeb4e0 : persistedWidth;
    if (isAnonymousUser && renderServerPlaceholder) {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
                initialCollapsedState: "expanded",
                initialWidth: fittedSidebarWidth,
                shouldForceExpand: false,
                needsPostHydrationCollapse: persistedCollapseState === "collapsed"
            };
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let initialCollapsedState;
    if (shouldCollapseForRecap) initialCollapsedState = "collapsed";
    else initialCollapsedState = persistedCollapseState;
    let t2;
    if ($[4] !== initialCollapsedState) {
        t2 = {
            initialCollapsedState: initialCollapsedState,
            initialWidth: fittedSidebarWidth,
            shouldForceExpand: false,
            needsPostHydrationCollapse: false
        };
        $[4] = initialCollapsedState;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};





// Paths
const $ba0a4d7f1b78ed67$export$4b542de2568592b5 = 'container/home/loading';
const $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae = 'container/home';
const $ba0a4d7f1b78ed67$export$c3f826fbea17177 = 'container/admin/home';
const $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b = 'container/admin/company-hub';
const $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1 = 'admin/home';
const $ba0a4d7f1b78ed67$export$823dfce5c2bceecb = 'product/home';


const $ad0ecba6dc7e91fa$export$ccd8c615ba434dec = ({ view: view })=>{
    const pageTreeUpdater = (0, $42omo.useRef)();
    const scrollTree = (0, $42omo.useCallback)(()=>{
        if (view === (0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae) && pageTreeUpdater.current) pageTreeUpdater.current.scrollToCurrentPage();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        view,
        pageTreeUpdater.current
    ]);
    return {
        pageTreeUpdater: pageTreeUpdater,
        scrollTree: scrollTree
    };
};




var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6be64d70b45c3bb0$var$initialState = {
    isCollapsed: false
};
const $6be64d70b45c3bb0$var$actions = {
    setIsCollapsed: (collapsed)=>({ setState: setState })=>{
            setState({
                isCollapsed: collapsed
            });
        }
};
const $6be64d70b45c3bb0$export$c0c3c6fb1b0fe561 = (0, $1P1Tu.createStore)({
    initialState: $6be64d70b45c3bb0$var$initialState,
    actions: $6be64d70b45c3bb0$var$actions
});
const $6be64d70b45c3bb0$export$7d924aef7db527f0 = (0, $9zUhf.createHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);
const $6be64d70b45c3bb0$export$ee6f665bc19ef05d = (0, $9zUhf.createActionsHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);


/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $lAJUP = parcelRequire("lAJUP");


var $keVvA = parcelRequire("keVvA");


var $141Kq = parcelRequire("141Kq");

// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)

























const $9f7a555e7f9dfa42$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("6yQVJ")),
    da: ()=>(parcelRequire("bzSID")),
    de: ()=>(parcelRequire("2FP6T")),
    en: ()=>Promise.resolve((parcelRequire("141Kq"))),
    'en-GB': ()=>(parcelRequire("25qh2")),
    'en-ZZ': ()=>(parcelRequire("3tbTt")),
    es: ()=>(parcelRequire("5HmEI")),
    fi: ()=>(parcelRequire("2JrHA")),
    fr: ()=>(parcelRequire("7K1vi")),
    hu: ()=>(parcelRequire("lvhk9")),
    it: ()=>(parcelRequire("dolI8")),
    ja: ()=>(parcelRequire("hqns1")),
    ko: ()=>(parcelRequire("1vs1T")),
    nb: ()=>(parcelRequire("BAT91")),
    nl: ()=>(parcelRequire("l079O")),
    pl: ()=>(parcelRequire("jEFBo")),
    'pt-BR': ()=>(parcelRequire("gTjoB")),
    ru: ()=>(parcelRequire("kq4sh")),
    sv: ()=>(parcelRequire("bbLxs")),
    th: ()=>(parcelRequire("gfPHN")),
    tr: ()=>(parcelRequire("gMTmr")),
    uk: ()=>(parcelRequire("6ZJsB")),
    vi: ()=>(parcelRequire("dDMw7")),
    zh: ()=>(parcelRequire("c4U6C")),
    'zh-TW': ()=>(parcelRequire("bbzob"))
};


const $86f4c496838d0464$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $9f7a555e7f9dfa42$export$3770c7a7737d463c) ? locale : locale.replace(/-/g, '_') in (0, $9f7a555e7f9dfa42$export$3770c7a7737d463c) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $9f7a555e7f9dfa42$export$3770c7a7737d463c)[languageLocale]?.();
        return localeMessages?.default ?? (0, $141Kq.default);
    } catch (e) {
    // ignore
    }
    return 0, $141Kq.default;
};





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cO1el = parcelRequire("cO1el");




var $5dK2X = parcelRequire("5dK2X");






const $45a6eb3a76009dad$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorStateHeading: {
        id: "navigation.global-invite.error-state-heading",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: "navigation.global-invite.error-state-description",
        defaultMessage: "Try refreshing the page or contact us if the problem persists."
    }
});


const $89f8b391742ea365$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $89f8b391742ea365$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $1GzhS.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $89f8b391742ea365$var$styles
    }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "xsmall"
    }, formatMessage((0, $45a6eb3a76009dad$export$defe85febe8b728c).errorStateHeading)), /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $45a6eb3a76009dad$export$defe85febe8b728c).errorStateDescription)));
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















var $6F6hl = parcelRequire("6F6hl");




const $527f6b7f46807211$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    loadingLabel: {
        id: "navigation.global-invite.loading-visually-hidden-label",
        defaultMessage: "Loading"
    }
});


const $1823c8a7ae00001a$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $1823c8a7ae00001a$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ $42omo.createElement((0, $kpYGL.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering",
            key: index
        }));
    return /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $1823c8a7ae00001a$var$styles,
        testId: "global-invite--loading-state"
    }, /*#__PURE__*/ $42omo.createElement((0, $6F6hl.default), null, formatMessage((0, $527f6b7f46807211$export$defe85febe8b728c).loadingLabel)), /*#__PURE__*/ $42omo.createElement((0, $1GzhS.default), {
        space: "space.100",
        testId: "skeleton-group"
    }, items));
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $7TH2w = parcelRequire("7TH2w");





var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $6xdDU = parcelRequire("6xdDU");

const $52241f5d84d6a74c$export$bb76aeb9f599715c = 'global-invite';
const $52241f5d84d6a74c$export$7622d28bacf170d1 = 'modal-dialog';
const $52241f5d84d6a74c$export$1dab7caa4b20a4cc = 'trigger-element';
const $52241f5d84d6a74c$export$85183a312807388d = 'navigation';


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 



var $ffCOo = parcelRequire("ffCOo");

function $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3({ product: product, children: children }) {
    return /*#__PURE__*/ $42omo.createElement((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        }
    }, children);
}





const $1fe379e53d021c39$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    modalDialogLabel: {
        id: "navigation.global-invite.modal-dialog-label",
        defaultMessage: "Invite people"
    }
});


function $b2599bb59f3b7568$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $52241f5d84d6a74c$export$bb76aeb9f599715c), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $42omo.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $42omo.useState)(false);
        const openModalDialog = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $52241f5d84d6a74c$export$85183a312807388d));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $42omo.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $52241f5d84d6a74c$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $42omo.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $52241f5d84d6a74c$export$85183a312807388d));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $42omo.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ $42omo.createElement((0, $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3), {
            product: props.product
        }, /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": testId
        }, TriggerElement ? /*#__PURE__*/ $42omo.createElement(TriggerElement, {
            onClick: openModalDialog
        }) : /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            shouldFitContainer: true,
            onClick: openModalDialog,
            testId: `${testId}--${(0, $52241f5d84d6a74c$export$1dab7caa4b20a4cc)}`
        }, children), /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isModalDialogOpen ? /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
            width: "small",
            shouldScrollInViewport: true,
            shouldReturnFocus: true,
            onClose: onCancel,
            onOpenComplete: focusDialog,
            label: formatMessage((0, $1fe379e53d021c39$export$defe85febe8b728c).modalDialogLabel),
            testId: `${testId}--${(0, $52241f5d84d6a74c$export$7622d28bacf170d1)}`
        }, /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement(Content, {
            onAdminMenuItemClick: onAdminMenuItemClick,
            onCancel: onCancel,
            onInviteCompleted: onInviteCompleted,
            ...props
        }))) : null)));
    };
}



const $824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("B2ZFV")).then((module)=>({
            default: module.ModalDialogContentWithRelayProvider
        })));
function $824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const modalContent = /*#__PURE__*/ $42omo.createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ $42omo.createElement((0, $89f8b391742ea365$export$c1ed4f415b9e7023), null)
    }, /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ $42omo.createElement((0, $1823c8a7ae00001a$export$62aa48085237e36f), null)
    }, /*#__PURE__*/ $42omo.createElement($824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider, props)));
    return /*#__PURE__*/ $42omo.createElement((0, $keVvA.default), {
        defaultMessages: (0, $141Kq.default),
        loaderFn: (0, $86f4c496838d0464$export$e4882a930a0d91f2)
    }, modalContent);
}
const $824f685f95a3a006$export$73b6b212789f5472 = (0, $b2599bb59f3b7568$export$2d7d84d397d9a585)($824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider);









var $eGUIL = parcelRequire("eGUIL");




const $b524a1c7212bd91f$export$fc95973351613945 = ({ children: children })=>{
    const sideNavRef = (0, $42omo.useRef)(null);
    const handleScrollToTop = (0, $42omo.useCallback)(()=>{
        if (sideNavRef.current) sideNavRef.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        sideNavRef
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            sideNavRef: sideNavRef,
            handleScrollToTop: handleScrollToTop
        }), [
        sideNavRef,
        handleScrollToTop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eGUIL.SideNavigationContext).Provider, {
        value: contextValue
    }, (0, $9wGTI.fg)('navx-global-side-nav-confluence') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(children, {
        sideNavContentRef: sideNavRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SvFZ.SideNavBody), {
        testId: "side-navigation-content",
        ref: sideNavRef
    }, children));
};


const $b56ca6efd7e1c0fa$var$i18n = (0, $aXWIB.defineMessages)({
    dragHandle: {
        id: "page-layout.side-navigation.drag-handle",
        defaultMessage: "Side Navigation Drag Handle"
    },
    sideNavPanelSplitterTooltipContent: {
        id: "page-layout.side-navigation.side-nav-panel-splitter-tooltip-content",
        defaultMessage: "Double click to collapse"
    },
    globalInviteButtonLabel: {
        id: "page-layout.side-navigation.global-invite-button-label",
        defaultMessage: "Invite people"
    }
});
const $b56ca6efd7e1c0fa$var$resize = ()=>{
    window.dispatchEvent(new Event('resize'));
};
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onToggleFromShortcut: onToggleFromShortcut } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const toggleSideNav = (0, $2SvFZ.useToggleSideNav)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    let t2;
    if ($[0] !== onToggleFromShortcut || $[1] !== toggleSideNav) {
        t2 = ()=>{
            if (!(0, $l65Bo.isDialogShown)()) {
                onToggleFromShortcut();
                toggleSideNav();
            }
        };
        $[0] = onToggleFromShortcut;
        $[1] = toggleSideNav;
        $[2] = t2;
    } else t2 = $[2];
    const toggle = t2;
    let t3;
    if ($[3] !== isLiveEditMode || $[4] !== isOnEditRoute || $[5] !== toggle) {
        t3 = isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            listener: toggle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            deprecatedAccelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
            listener: toggle
        });
        $[3] = isLiveEditMode;
        $[4] = isOnEditRoute;
        $[5] = toggle;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
/**
 * Used when full height sidebar (FHS) is enabled.
 * Uses the `Ctrl+[` shortcut that is built into the ADS navigation system, instead of Confluence's
 * own `Ctrl+[` shortcut (UNIVERSAL_SIDE_NAVIGATION_SHORTCUT).
 * But, we keep Confluence's `[` shortcut (SIDE_NAVIGATION_SHORTCUT) on non-edit routes, and display
 * an educational flag pointing to the new shortcut.
 */ const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS = (0, $7aRa9.withFlags)(({ flags: flags, onToggleFromShortcut: onToggleFromShortcut })=>{
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const toggleSideNav = (0, $2SvFZ.useToggleSideNav)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const toggle = (0, $42omo.useCallback)(()=>{
        if (!(0, $l65Bo.isDialogShown)()) {
            onToggleFromShortcut();
            toggleSideNav();
            // Show the educational flag for the `Ctrl+[` shortcut, when the `[` shortcut is used.
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
                accelerator: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                deprecatedAccelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT)
            });
        }
    }, [
        flags,
        onToggleFromShortcut,
        toggleSideNav
    ]);
    if (isLiveEditMode || isOnEditRoute) // Edit routes will still have the side nav shortcut that is built into the ADS SideNav component.
    return null;
    // Non-edit routes still have the `[` shortcut, which will eventually be deprecated.
    // An educational flag is shown during the transition process.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.SIDE_NAVIGATION_SHORTCUT),
        listener: toggle
    });
});
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutWithFG = (0, $8YePs.componentWithCondition)(()=>(0, $8zs3p.useIsFhsEnabled)(), $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutFHS, $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut);
// When full height sidebar is enabled, the SideNavPanelSplitter component should be used.
// It supports double clicking to collapse the side nav.
const $b56ca6efd7e1c0fa$var$PanelSplitterWithFG = (0, $8YePs.componentWithCondition)(()=>(0, $8zs3p.useIsFhsEnabled)(), (0, $2SvFZ.SideNavPanelSplitter), (0, $bssir.PanelSplitter));
const $b56ca6efd7e1c0fa$var$useIsModeGlobal = ()=>{
    const $ = (0, $frIzR.c)(3);
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== match?.query?.mode || $[1] !== spaceKey) {
        t0 = match?.query?.mode === "global" || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[0] = match?.query?.mode;
        $[1] = spaceKey;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
//todo: are all these views still relevant? I'm not certain they are
const $b56ca6efd7e1c0fa$var$getProductSideNavigation = (view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, unhandledError, isLicensed)=>{
    // hide product nav if mode=global unless we're on a settings page
    if (isModeGlobal && !isOnAnySettingsScreen) return null;
    switch(view){
        case 0, $ba0a4d7f1b78ed67$export$4b542de2568592b5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null);
        case 0, $ba0a4d7f1b78ed67$export$c3f826fbea17177:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a5cd25c242b4596$export$a5608b5e4da20698), null);
        case 0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ad4ea954990a797$export$9c64eb3c7e74d13c), null);
        case 0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f92bf53981932d65$export$347b3004b45f815), null);
        case 0, $ba0a4d7f1b78ed67$export$b8c5fd47fee73aae:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2qRJj.SpaceNavigation), {
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                ...unhandledError && {
                    unhandledError: unhandledError
                },
                isBlogNavigation: (0, $gEtAQ.isBlogPage)()
            });
        default:
            return isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $38b2da651c37b412$export$79ffca654f6ab234), null) : null;
    }
};
const $b56ca6efd7e1c0fa$var$PlatformNavigationInner = (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd } = t0;
    let t1;
    if ($[0] !== view) {
        t1 = {
            view: view
        };
        $[0] = view;
        $[1] = t1;
    } else t1 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t1);
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const t2 = spaceKey || "";
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t3);
    let t4;
    if ($[4] !== anonymousAccessQueryError || $[5] !== isLicensed || $[6] !== isModeGlobal || $[7] !== isOnAnySettingsScreen || $[8] !== isSpaceSettingsScreen || $[9] !== view) {
        t4 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[4] = anonymousAccessQueryError;
        $[5] = isLicensed;
        $[6] = isModeGlobal;
        $[7] = isOnAnySettingsScreen;
        $[8] = isSpaceSettingsScreen;
        $[9] = view;
        $[10] = t4;
    } else t4 = $[10];
    const productSideNavigation = t4;
    let t5;
    if ($[11] !== anonymousAccessQueryError || $[12] !== anonymousAccessQueryLoading || $[13] !== isUserViewingSpaceAsAnon) {
        t5 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ba0fa5890838b7bb$export$ee8ecac8c80214c1), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[11] = anonymousAccessQueryError;
        $[12] = anonymousAccessQueryLoading;
        $[13] = isUserViewingSpaceAsAnon;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== productSideNavigation || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, productSideNavigation, t5);
        $[15] = productSideNavigation;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== isOnAnySettingsScreen || $[19] !== onCollapse || $[20] !== onExpand || $[21] !== onPeekEnd || $[22] !== onPeekStart || $[23] !== scrollTree || $[24] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "side-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95859b7288e22ff6$export$446e292f3fdcabd), {
            content: t6,
            hideGSN: isOnAnySettingsScreen,
            scrollTreeToCurrent: scrollTree,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd
        })));
        $[18] = isOnAnySettingsScreen;
        $[19] = onCollapse;
        $[20] = onExpand;
        $[21] = onPeekEnd;
        $[22] = onPeekStart;
        $[23] = scrollTree;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    return t7;
};
const $b56ca6efd7e1c0fa$export$440c2b67033b2fbd = (t0)=>{
    const $ = (0, $frIzR.c)(63);
    const { view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, onCollapse: onCollapse, onExpand: onExpand, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, setTriggeredByShortcut: setTriggeredByShortcut } = t0;
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const intl = (0, $aXWIB.useIntl)();
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth, shouldForceExpand: shouldForceExpand, needsPostHydrationCollapse: needsPostHydrationCollapse } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jFFx4.useSettingsBackButtonUtils)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isPageWithinSpaceSettings = view === (0, $ba0a4d7f1b78ed67$export$c3f826fbea17177);
    const isPageWithinSiteSettings = view === (0, $ba0a4d7f1b78ed67$export$a9aa544aabcc3ca1);
    const isHubSettingsScreen = view === (0, $ba0a4d7f1b78ed67$export$e1cac4d5c92cf74b);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const toggleSideNav = (0, $2SvFZ.useToggleSideNav)();
    let t1;
    let t2;
    if ($[0] !== needsPostHydrationCollapse || $[1] !== toggleSideNav) {
        t1 = ()=>{
            if (needsPostHydrationCollapse) toggleSideNav();
        };
        t2 = [
            needsPostHydrationCollapse,
            toggleSideNav
        ];
        $[0] = needsPostHydrationCollapse;
        $[1] = toggleSideNav;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    const pressTracing = (0, $1pSma.default)("side-nav-collapse-reminder-spotlight");
    const t3 = spaceKey || "";
    let t4;
    if ($[4] !== t3) {
        t4 = {
            spaceKey: t3
        };
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $da0a91219ee54603$export$b1d9964175452d0b)(t4);
    const [t5] = (0, $6be64d70b45c3bb0$export$7d924aef7db527f0)();
    const { isCollapsed: isCollapsed } = t5;
    let t6;
    if ($[6] !== anonymousAccessQueryError || $[7] !== isLicensed || $[8] !== isModeGlobal || $[9] !== isOnAnySettingsScreen || $[10] !== isSpaceSettingsScreen || $[11] !== view) {
        t6 = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, anonymousAccessQueryError, isLicensed);
        $[6] = anonymousAccessQueryError;
        $[7] = isLicensed;
        $[8] = isModeGlobal;
        $[9] = isOnAnySettingsScreen;
        $[10] = isSpaceSettingsScreen;
        $[11] = view;
        $[12] = t6;
    } else t6 = $[12];
    const productSideNavigation = t6;
    let t7;
    if ($[13] !== createAnalyticsEvent) {
        t7 = (t8)=>{
            const { initialWidth: initialWidth_0, finalWidth: finalWidth } = t8;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "resized",
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        initialWidth: initialWidth_0,
                        finalWidth: finalWidth
                    }
                }
            }).fire();
        };
        $[13] = createAnalyticsEvent;
        $[14] = t7;
    } else t7 = $[14];
    const fireSidebarResizeEndAnalytics = t7;
    let t8;
    if ($[15] !== setTriggeredByShortcut) {
        t8 = ()=>{
            setTriggeredByShortcut(true);
        };
        $[15] = setTriggeredByShortcut;
        $[16] = t8;
    } else t8 = $[16];
    const handleToggleFromShortcut = t8;
    if (!isPageWithinSpaceSettings && !isPageWithinSiteSettings && !isHubSettingsScreen) saveCurrentRoute();
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $92JEG.useHasDismissedNav4CollapseReminderSpotlight)();
    const canToggleWithShortcut = $b56ca6efd7e1c0fa$var$_temp;
    const t9 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
            errorBoundaryId: "sideNavigation-globalNavigation"
        };
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== isCollapsed || $[19] !== isOnAnySettingsScreen || $[20] !== productSideNavigation) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t10
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ccde8579962336f$export$796d3395e4dcf32b), {
            productSideNavigation: productSideNavigation,
            isOnAnySettingsScreen: isOnAnySettingsScreen,
            isCollapsed: isCollapsed
        }));
        $[18] = isCollapsed;
        $[19] = isOnAnySettingsScreen;
        $[20] = productSideNavigation;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== isNav4CollapseReminderSpotlightActive || $[23] !== setIsNav4CollapseReminderSpotlightActive) {
        t12 = isNav4CollapseReminderSpotlightActive && setIsNav4CollapseReminderSpotlightActive && !(0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f542602a6e0f4176$export$4283c4ef2b834aa2), {
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[22] = isNav4CollapseReminderSpotlightActive;
        $[23] = setIsNav4CollapseReminderSpotlightActive;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== handleToggleFromShortcut || $[26] !== shouldForceExpand) {
        t13 = !shouldForceExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$ExpandKeyboardShortcutWithFG, {
            onToggleFromShortcut: handleToggleFromShortcut
        });
        $[25] = handleToggleFromShortcut;
        $[26] = shouldForceExpand;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== fireSidebarResizeEndAnalytics || $[29] !== isNav4CollapseReminderSpotlightActive || $[30] !== isNav4CollapseReminderSpotlightDismissed || $[31] !== pressTracing || $[32] !== setIsNav4CollapseReminderSpotlightActive) {
        t14 = (t15)=>{
            const { initialWidth: initialWidth_1, finalWidth: finalWidth_0 } = t15;
            $b56ca6efd7e1c0fa$var$handleResizeEnd({
                finalWidth: finalWidth_0,
                eligibleForCollapseReminderSpotlight: !isNav4CollapseReminderSpotlightActive && !isNav4CollapseReminderSpotlightDismissed,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                pressTracing: pressTracing
            });
            fireSidebarResizeEndAnalytics({
                initialWidth: initialWidth_1,
                finalWidth: finalWidth_0
            });
        };
        $[28] = fireSidebarResizeEndAnalytics;
        $[29] = isNav4CollapseReminderSpotlightActive;
        $[30] = isNav4CollapseReminderSpotlightDismissed;
        $[31] = pressTracing;
        $[32] = setIsNav4CollapseReminderSpotlightActive;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== intl) {
        t15 = intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.dragHandle);
        $[34] = intl;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== intl || $[37] !== isFhsEnabled) {
        t16 = isFhsEnabled ? intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.sideNavPanelSplitterTooltipContent) : undefined;
        $[36] = intl;
        $[37] = isFhsEnabled;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== t14 || $[40] !== t15 || $[41] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$PanelSplitterWithFG, {
            onResizeEnd: t14,
            onResizeStart: $b56ca6efd7e1c0fa$var$onResizeStart,
            label: t15,
            testId: "side-navigation-panel-splitter",
            tooltipContent: t16
        });
        $[39] = t14;
        $[40] = t15;
        $[41] = t16;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== t11 || $[44] !== t12 || $[45] !== t13 || $[46] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, t11, t12, t13, t17);
        $[43] = t11;
        $[44] = t12;
        $[45] = t13;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    let t19;
    if ($[48] !== anonymousAccessQueryError || $[49] !== anonymousAccessQueryLoading || $[50] !== isUserViewingSpaceAsAnon) {
        t19 = isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ba0fa5890838b7bb$export$ee8ecac8c80214c1), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, null);
        $[48] = anonymousAccessQueryError;
        $[49] = anonymousAccessQueryLoading;
        $[50] = isUserViewingSpaceAsAnon;
        $[51] = t19;
    } else t19 = $[51];
    let t20;
    if ($[52] !== t18 || $[53] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "side-nav"
        }, t18, t19);
        $[52] = t18;
        $[53] = t19;
        $[54] = t20;
    } else t20 = $[54];
    let t21;
    if ($[55] !== initialWidth || $[56] !== onCollapse || $[57] !== onExpand || $[58] !== onPeekEnd || $[59] !== onPeekStart || $[60] !== t20 || $[61] !== t9) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SvFZ.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t9,
            onExpand: onExpand,
            onCollapse: onCollapse,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            id: "side-navigation",
            canToggleWithShortcut: canToggleWithShortcut
        }, t20);
        $[55] = initialWidth;
        $[56] = onCollapse;
        $[57] = onExpand;
        $[58] = onPeekEnd;
        $[59] = onPeekStart;
        $[60] = t20;
        $[61] = t9;
        $[62] = t21;
    } else t21 = $[62];
    return t21;
};
const $b56ca6efd7e1c0fa$var$SideNavigationSkeleton = ()=>{
    const $ = (0, $frIzR.c)(4);
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const t0 = isFhsEnabled ? undefined : initialCollapsedState === "collapsed";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "side-nav-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b524a1c7212bd91f$export$fc95973351613945), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2qRJj.SpaceNavigationLoadingSkeleton), null)));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== initialWidth || $[2] !== t0) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SvFZ.SideNav), {
            defaultWidth: initialWidth,
            defaultCollapsed: t0,
            id: "side-navigation-skeleton"
        }, t1);
        $[1] = initialWidth;
        $[2] = t0;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $b56ca6efd7e1c0fa$export$cc4f63927c41742f = (props)=>{
    const $ = (0, $frIzR.c)(27);
    const { setIsCollapsed: setIsCollapsed } = (0, $6be64d70b45c3bb0$export$ee6f665bc19ef05d)();
    const [triggeredByShortcut, setTriggeredByShortcut] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] !== props.view) {
        t0 = {
            view: props.view
        };
        $[0] = props.view;
        $[1] = t0;
    } else t0 = $[1];
    const { scrollTree: scrollTree } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t0);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOnEditRoute) {
        t1 = (action, triggeredBy)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: "spaceNavigation",
                    source: "containerNavigation",
                    attributes: {
                        isOnEditRoute: isOnEditRoute,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = isOnEditRoute;
        $[4] = t1;
    } else t1 = $[4];
    const fireSidebarToggleAnalytics = t1;
    let t2;
    if ($[5] !== fireSidebarToggleAnalytics || $[6] !== setIsCollapsed || $[7] !== triggeredByShortcut) {
        t2 = ()=>{
            if (!(0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                setIsCollapsed(true);
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "collapsed");
            }
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("collapsed", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[5] = fireSidebarToggleAnalytics;
        $[6] = setIsCollapsed;
        $[7] = triggeredByShortcut;
        $[8] = t2;
    } else t2 = $[8];
    const onCollapse = t2;
    let t3;
    if ($[9] !== fireSidebarToggleAnalytics || $[10] !== scrollTree || $[11] !== setIsCollapsed || $[12] !== triggeredByShortcut) {
        t3 = ()=>{
            if (!(0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                setIsCollapsed(false);
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, "expanded");
            }
            scrollTree();
            $b56ca6efd7e1c0fa$var$resize();
            fireSidebarToggleAnalytics("expanded", triggeredByShortcut ? "keyboardShortcut" : "click");
            setTriggeredByShortcut(false);
        };
        $[9] = fireSidebarToggleAnalytics;
        $[10] = scrollTree;
        $[11] = setIsCollapsed;
        $[12] = triggeredByShortcut;
        $[13] = t3;
    } else t3 = $[13];
    const onExpand = t3;
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    let t4;
    if ($[14] !== requestHideOmniBar) {
        t4 = ()=>{
            if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) requestHideOmniBar();
        };
        $[14] = requestHideOmniBar;
        $[15] = t4;
    } else t4 = $[15];
    const onPeekStart = t4;
    let t5;
    if ($[16] !== releaseHideOmniBar) {
        t5 = ()=>{
            if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) releaseHideOmniBar();
        };
        $[16] = releaseHideOmniBar;
        $[17] = t5;
    } else t5 = $[17];
    const onPeekEnd = t5;
    let t6;
    let t7;
    if ($[18] !== releaseHideOmniBar) {
        t6 = ()=>()=>{
                if ((0, $9wGTI.fg)("cc-engagement-omnibar-hide-sidebar-flyout")) releaseHideOmniBar();
            };
        t7 = [
            releaseHideOmniBar
        ];
        $[18] = releaseHideOmniBar;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[21] !== onCollapse || $[22] !== onExpand || $[23] !== onPeekEnd || $[24] !== onPeekStart || $[25] !== props) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "platform-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$PlatformNavigationInner, {
            view: props.view,
            isSpaceSettingsScreen: props.isSpaceSettingsScreen,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "side-navigation",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavigationSkeleton, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$export$440c2b67033b2fbd, {
            ...props,
            onCollapse: onCollapse,
            onExpand: onExpand,
            onPeekStart: onPeekStart,
            onPeekEnd: onPeekEnd,
            setTriggeredByShortcut: setTriggeredByShortcut
        })));
        $[21] = onCollapse;
        $[22] = onExpand;
        $[23] = onPeekEnd;
        $[24] = onPeekStart;
        $[25] = props;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
};
const $b56ca6efd7e1c0fa$var$getSideNavContent = ()=>{
    if (!(0, $9wGTI.fg)('post-office-connie-side-nav-killswitch')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i834V.PostOfficeConfluenceSideNavPlacement), null);
};
const $b56ca6efd7e1c0fa$var$SideNavFooterWrapped = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, $b56ca6efd7e1c0fa$var$getSideNavContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b56ca6efd7e1c0fa$var$globalInviteButtonStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b56ca6efd7e1c0fa$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $824f685f95a3a006$export$73b6b212789f5472), {
        product: "confluence",
        showFlag: flags.showFlag
    }, intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.globalInviteButtonLabel))));
});
const $b56ca6efd7e1c0fa$var$SideNavFooterContent = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { error: error, loading: loading, isEligible: isEligible } = (0, $463b48fb68db8bff$export$b3cda0b328199f72)();
    if (loading) return null;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else {
            let t0;
            if ($[0] !== error) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
                $[0] = error;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        }
    }
    let t0;
    if ($[2] !== isEligible) {
        t0 = isEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SvFZ.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent, null)));
        $[2] = isEligible;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
// CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
// Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
const $b56ca6efd7e1c0fa$var$onResizeStart = ()=>{
    document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.setProperty('pointer-events', 'none');
};
const $b56ca6efd7e1c0fa$var$handleResizeEnd = ({ finalWidth: finalWidth, eligibleForCollapseReminderSpotlight: eligibleForCollapseReminderSpotlight, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, pressTracing: pressTracing })=>{
    // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
    // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
    document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.removeProperty('pointer-events');
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH, finalWidth);
    if (eligibleForCollapseReminderSpotlight) {
        pressTracing();
        setIsNav4CollapseReminderSpotlightActive?.(true);
    }
};
function $b56ca6efd7e1c0fa$var$_temp() {
    return !(0, $l65Bo.isDialogShown)();
}




var $lpfM9 = parcelRequire("lpfM9");




const $5fff77e1c664da88$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    TopNav: {
        id: "page-layout.top.nav",
        defaultMessage: "Confluence navigation"
    },
    Banner: {
        id: "page-layout.banner",
        defaultMessage: "Banner"
    },
    SideNav: {
        id: "page-layout.side.nav",
        defaultMessage: "Side navigation"
    },
    Main: {
        id: "page-layout.main",
        defaultMessage: "Page"
    },
    SkipLinks: {
        id: "page-layout.skip.links",
        defaultMessage: "Jump to"
    }
});











var $7sObp = parcelRequire("7sObp");

/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $ac7ee6dc054aa982$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $ac7ee6dc054aa982$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $ac7ee6dc054aa982$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $ac7ee6dc054aa982$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $ac7ee6dc054aa982$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $ac7ee6dc054aa982$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';





const $234a7212b3053f5f$export$f6b09748eb1e2d30 = 'data-main-content';
const $234a7212b3053f5f$export$2306961d40008e49 = 'data-flex-container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
const $234a7212b3053f5f$export$712225703044cda = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showBreadcrumbNavHeader: showBreadcrumbNavHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1bgi _c3a01fl4 _1u5916n6 _2iuc1fl4 _ylxn1v5u _moiv16n6",
            __cmplp.showBreadcrumbNavHeader ? "_17gl1wqb" : "_17glidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $234a7212b3053f5f$export$6bdda512681a5774 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { zIndex: zIndex, showQuickStart: showQuickStart, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, $7sObp.default)(__cmplp.zIndex)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1pby1fcb _e1qhidpf",
                __cmplp.showQuickStart ? "_1e0c1ule" : "_1e0cglyw",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // This uses CCS variables from atlaskit/page-layout to make sure
const $234a7212b3053f5f$export$d1bb8697b964b9c = `
#ui-global-sidebar-section {
	z-index: auto !important;
	width: 100%;
}

[${$234a7212b3053f5f$export$f6b09748eb1e2d30}], [${$234a7212b3053f5f$export$2306961d40008e49}] {
	width: calc(
		100% - ${(0, $ac7ee6dc054aa982$export$f963aecf2d4465bd)} - ${(0, $ac7ee6dc054aa982$export$f897e1ed9f8ed251)} - ${(0, $ac7ee6dc054aa982$export$750459958906793)} -
			${(0, $ac7ee6dc054aa982$export$b44ab66843c05a69)}
	) !important;
	position: absolute;
	left: calc(${(0, $ac7ee6dc054aa982$export$f963aecf2d4465bd)} + ${(0, $ac7ee6dc054aa982$export$f897e1ed9f8ed251)});
	z-index: auto;
	box-sizing: border-box;
	bottom: 0px;
	overflow: auto;
	top: ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)};

	&#admin-content {
		/* admin nav -> manage apps */
		.upm-manage {
			#upm-manage-type, /* app type dropdown filter */
		.upm-details .upm-plugin-info .upm-column {
				/* expand accordion to show app detail -> 3 column info table */
				z-index: 1;
			}
		}
	}
}
[${$234a7212b3053f5f$export$2306961d40008e49}] > [${$234a7212b3053f5f$export$f6b09748eb1e2d30}] {
	display: none;
}

/* add overflow scrolling to ssred pages with heights longer than side navigation */
[${$234a7212b3053f5f$export$2306961d40008e49}] > main#main.aui-page-panel {
	overflow: hidden;
	overflow-y: auto;
	height: calc(100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px);
	min-height: calc(
		100vh - ${(0, $K0HEo.UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY)} - 2px
	); /* for responsiveness in small height windows */
}
`;
const $234a7212b3053f5f$export$191b652ca0b16b3f = `
	/* CSS hack for code block */
	.code-block.right-shadow {
		z-index: 2;
	}
	/* CSS hack for noPrint */
	[data-ds--page-layout--slot='top-navigation'],
	[data-ds--page-layout--slot='left-sidebar'] {
		@media print {
			display: none !important;
		}
	}
	/* To make sure we are using the same font family set by atlassian-frontend theme. */
	.PageContent {
		font-family: ${"var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
	/* To remove cls from more action dropdown */
	[data-testid='content-tools-dropdown-menu--content'] {
		width: 220px;
	}

	/* CSS hack to override batch CSS h3 styling for account menu */
	[data-testid='confluence-account-menu--content--details--name'] {
		font: ${"var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};
	}
`;
const $234a7212b3053f5f$export$fd1a59daeb9a7e85 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3i1osq _1bsb1osq _10pb1osq _9m3z1osq _16tepfqs",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});













var $hsPNq = parcelRequire("hsPNq");


var $eaL9e = parcelRequire("eaL9e");





var $j5cB3 = parcelRequire("j5cB3");


var $1To4a = parcelRequire("1To4a");


var $9h83k = parcelRequire("9h83k");

const $54e8ca9214c53ec0$var$rgbOffset = {
    red: 0,
    // Pure red has a hue of 0 degrees
    green: 120,
    // Pure green has a hue of 120 degrees
    blue: 240 // Pure blue has a hue of 240 degrees
};
/**
 * Returns the contribution of the given RGB channel to the provided hue.
 *
 * Maximum value is 1, meaning it's the main channel for the hue
 * Minimum value is -1, meaning it doesn't contribute to the hue at all
 *
 * The function looks like a single trapezoidal wave that is
 * horizontally shifted according to the hue offset of the given channel.
 */ const $54e8ca9214c53ec0$var$getChannelContributionToHue = ({ rgbChannel: rgbChannel, hue: hue })=>{
    const k = (360 - $54e8ca9214c53ec0$var$rgbOffset[rgbChannel] + hue) / 30 % 12;
    return Math.max(-1, Math.min(k - 3, 9 - k, 1));
};
/**
 * Derived from Wikipedia article on HSL:
 * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative
 *
 * You can think of it as taking an RGB channel, and the saturation and lightness values
 * to construct a function mapping hue to channel intensity.
 *
 * It then evaluates the function for the given hue.
 */ const $54e8ca9214c53ec0$var$getRgbChannel = ({ rgbChannel: rgbChannel, color: { h: hue, s: saturation, l: lightness } })=>{
    const shiftY = lightness;
    const scaleY = -1 * saturation * Math.min(lightness, 1 - lightness);
    /**
   * Value between 0-1 describing how much the RGB channel contributes to the given HSL color.
   *
   * `getChannelContributionToHue` is the channel contribution for the pure hue,
   * which is why we need to adjust and scale according to saturation and lightness.
   */ const channelContribution = shiftY + scaleY * $54e8ca9214c53ec0$var$getChannelContributionToHue({
        rgbChannel: rgbChannel,
        hue: hue
    });
    return Math.round(255 * channelContribution);
};
function $54e8ca9214c53ec0$export$cbd2e6c3c3c00218(color) {
    /**
   * I was creating increasingly complex regular expressions, aiming for correct parsing.
   *
   * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
   * with some slight improvements.
   *
   * We can refine it as needed.
   *
   * Known limitations of this approach:
   *
   * - It is overly permissive and will allow some invalid syntax,
   *   for example `hsl(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
   * - Only the integer parts of non-integers will be parsed
   * - Only supports the legacy, comma-separated syntax
   */ const [h, s, l] = color.replace(/hsl\(|[)%\s]/g, '').split(',').map((value)=>parseInt(value, 10));
    if ([
        h,
        s,
        l
    ].some((channel)=>!Number.isInteger(channel))) return null;
    /**
   * Normalized HSL value so that:
   *
   * - hue angle is from 0 (inclusive) to 360 (not inclusive)
   * - saturation and lightness percentages are expressed as fractional values from 0 to 1
   */ const normal = {
        h: h % 360,
        s: Math.min(s / 100, 1),
        l: Math.min(l / 100, 1)
    };
    return {
        r: $54e8ca9214c53ec0$var$getRgbChannel({
            rgbChannel: 'red',
            color: normal
        }),
        g: $54e8ca9214c53ec0$var$getRgbChannel({
            rgbChannel: 'green',
            color: normal
        }),
        b: $54e8ca9214c53ec0$var$getRgbChannel({
            rgbChannel: 'blue',
            color: normal
        })
    };
}


function $f38224ba77318aee$export$3f3b9febf881d58b(color) {
    /**
   * I was creating increasingly complex regular expressions, aiming for correct parsing.
   *
   * I decided to be pragmatic and just opt for what Nav 3 does (through the `chromatism` library),
   * with some slight improvements.
   *
   * We can refine it as needed.
   *
   * Known limitations of this approach:
   *
   * - It is overly permissive and will allow some invalid syntax,
   *   for example `rgb(1, 2, 3, 4, 5, 6, 7)` where it would just extract the first 3 parameters
   * - Only the integer parts of non-integers will be parsed
   * - Only supports the legacy, comma-separated syntax
   */ const [r, g, b] = color.replace(/rgb\(|[)\s]/g, '').split(',').map((value)=>parseInt(value, 10))// Clamping to align with CSS behavior
    .map((value)=>Math.max(0, Math.min(value, 255)));
    if ([
        r,
        g,
        b
    ].some((n)=>!Number.isInteger(n))) return null;
    return {
        r: r,
        g: g,
        b: b
    };
}


function $43edff7874ae2c8f$export$1d30bac67697545c(color) {
    if (color.startsWith('#')) return (0, $9h83k.parseHex)(color);
    if (color.startsWith('rgb(')) return (0, $f38224ba77318aee$export$3f3b9febf881d58b)(color);
    if (color.startsWith('hsl(')) return (0, $54e8ca9214c53ec0$export$cbd2e6c3c3c00218)(color);
    return null;
}



var $fZitC = parcelRequire("fZitC");




const $1b7b278c93e24711$var$NULL_THEME_RESULT = {
    backgroundColor: null,
    highlightColor: null
};
const $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES = [
    '0052CC',
    // ADG3,
    '0C66E4' // ADG4
];
const $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX = 35;
const $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e = ({ backgroundColorRaw: backgroundColorRaw, highlightColorRaw: highlightColorRaw, isDarkMode: isDarkMode })=>{
    if (!backgroundColorRaw || !highlightColorRaw) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    const backgroundColor = $1b7b278c93e24711$var$parseColor(backgroundColorRaw);
    const highlightColor = $1b7b278c93e24711$var$parseColor(highlightColorRaw);
    if ($1b7b278c93e24711$var$isDefaultTheme(backgroundColor, highlightColor)) return $1b7b278c93e24711$var$NULL_THEME_RESULT;
    return {
        backgroundColor: isDarkMode && backgroundColor ? $1b7b278c93e24711$var$applyDarkModeTransformation(backgroundColor) : backgroundColor,
        highlightColor: highlightColor
    };
};
/**
 * Determines if the given colors match the default theme.
 */ const $1b7b278c93e24711$var$isDefaultTheme = (backgroundColor, highlightColor)=>{
    if (!backgroundColor || !highlightColor) return false;
    const currentDefaultBackground = $1b7b278c93e24711$var$parseColor((0, $1To4a.default)('elevation.surface', '#ffffff'));
    const isDefaultBackground = $1b7b278c93e24711$var$areColorsEqual(backgroundColor, currentDefaultBackground);
    const highlightColorCodes = (0, $6mKj3.expVal)('confluence_frontend_fix_topnav_styling_hydration', 'isEnabled', false) ? [
        ...$1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES,
        '1868DB'
    ] : $1b7b278c93e24711$var$DEFAULT_HIGHLIGHT_COLOR_CODES;
    const isDefaultHighlight = highlightColorCodes.some((color)=>{
        const currentDefaultColor = $1b7b278c93e24711$var$parseColor((0, $1To4a.default)('color.text.brand', `#${color}`));
        return $1b7b278c93e24711$var$areColorsEqual(highlightColor, currentDefaultColor);
    });
    return isDefaultBackground && isDefaultHighlight;
};
/**
 * Parses and validates a color string using platform utilities.
 * Returns RGB object or null if invalid.
 */ const $1b7b278c93e24711$var$parseColor = (colorToParse)=>{
    if (colorToParse.startsWith('rgba(') && colorToParse.split(',').length === 4) colorToParse = `rgb(${colorToParse.substring(5, colorToParse.lastIndexOf(','))})`;
    else if (colorToParse.startsWith('var(')) colorToParse = $1b7b278c93e24711$var$getCSSVariableValue(colorToParse); // Will only get re-calculated if the variable is from ADS
    return (0, $43edff7874ae2c8f$export$1d30bac67697545c)(colorToParse);
};
/**
 * Transforms a background color for dark mode by either using the dark surface token
 * or reducing lightness for custom colors.
 */ const $1b7b278c93e24711$var$getDarkModeBackgroundColor = (currentBackgroundColor)=>{
    if (currentBackgroundColor.toLowerCase() === '#ffffff') // getTokenValue doesn't work in SSR thus hardcode fallback to current surface value, fix in: https://product-fabric.atlassian.net/browse/DSP-9781
    return (0, $1To4a.default)('elevation.surface', '#1d2125');
    else {
        const lightnessPercentage = (0, $fZitC.getLightnessPercentage)(currentBackgroundColor);
        if (lightnessPercentage === undefined) return currentBackgroundColor;
        return lightnessPercentage > $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX ? (0, $fZitC.reduceLightness)(currentBackgroundColor, $1b7b278c93e24711$var$BACKGROUND_LIGHTNESS_MAX) : currentBackgroundColor;
    }
};
const $1b7b278c93e24711$var$applyDarkModeTransformation = (color)=>{
    const hexColor = $1b7b278c93e24711$var$rgbToHex(color); // utility functions require hex colors
    const darkHex = $1b7b278c93e24711$var$getDarkModeBackgroundColor(hexColor);
    return (0, $43edff7874ae2c8f$export$1d30bac67697545c)(darkHex);
};
const $1b7b278c93e24711$var$areColorsEqual = (color1, color2)=>{
    if (!color1 || !color2) return color1 === color2;
    return color1.r === color2.r && color1.g === color2.g && color1.b === color2.b;
};
const $1b7b278c93e24711$var$rgbToHex = (rgb)=>{
    const toHex = (n)=>{
        const hex = Math.round(n).toString(16);
        return hex.length === 1 ? `0${hex}` : hex;
    };
    return `#${toHex(rgb.r)}${toHex(rgb.g)}${toHex(rgb.b)}`.toUpperCase();
};
const $1b7b278c93e24711$var$getCSSVariableValue = (variableExpression)=>{
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};


const $a61833f951c42c7b$export$c0c5f5b297b77726 = (backgroundColorRaw, highlightColorRaw)=>{
    const $ = (0, $frIzR.c)(4);
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    let t0;
    if ($[0] !== backgroundColorRaw || $[1] !== highlightColorRaw || $[2] !== isDarkMode) {
        t0 = (0, $1b7b278c93e24711$export$3fd3fe4aa4f2fd3e)({
            backgroundColorRaw: backgroundColorRaw,
            highlightColorRaw: highlightColorRaw,
            isDarkMode: isDarkMode
        });
        $[0] = backgroundColorRaw;
        $[1] = highlightColorRaw;
        $[2] = isDarkMode;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};


















var $aJv6Q = parcelRequire("aJv6Q");


const $3183c72dd59199f3$var$ImpersonationFlagV2Loader = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "61Lty",
    name: "ImpersonationFlagV2Loader",
    loader: async ()=>(await (parcelRequire("1ReH7"))).ImpersonationFlag
});
const $3183c72dd59199f3$var$LazyImpersonationFlagComponent = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3183c72dd59199f3$var$ImpersonationFlagV2Loader, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $3183c72dd59199f3$export$4fca365a8ad2f625 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($3183c72dd59199f3$var$LazyImpersonationFlagComponent);



var $emNvf = parcelRequire("emNvf");




const $f06013f8e99ab858$export$41d0d88a6b0e456f = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { defaultCollapsed: defaultCollapsed, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive } = t0;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $emNvf.default), {
        __callerPackage__: "@confluence/page-layout"
    });
    const horizontalHeader = data?.lookAndFeel?.custom?.horizontalHeader;
    const customTheme = (0, $a61833f951c42c7b$export$c0c5f5b297b77726)(horizontalHeader?.backgroundColor, horizontalHeader?.primaryNavigation?.highlightColor);
    let t1;
    if ($[0] !== customTheme || $[1] !== defaultCollapsed || $[2] !== isNav4CollapseReminderSpotlightActive || $[3] !== setIsNav4CollapseReminderSpotlightActive) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eaL9e.TopNavigationBase), {
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[0] = customTheme;
        $[1] = defaultCollapsed;
        $[2] = isNav4CollapseReminderSpotlightActive;
        $[3] = setIsNav4CollapseReminderSpotlightActive;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3183c72dd59199f3$export$4fca365a8ad2f625), null);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "top-nav"
        }, t1, t2);
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== error) {
        t4 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[8] = error;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== customTheme || $[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hsPNq.TopNav), {
            testId: "grid-topNav",
            customTheme: customTheme
        }, t3, t4);
        $[10] = customTheme;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};









var $8Hyz1 = parcelRequire("8Hyz1");


var $jln20 = parcelRequire("jln20");


var $cLgYq = parcelRequire("cLgYq");











var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");








var $2Qxf3 = parcelRequire("2Qxf3");




const $37d6b5f846525abd$export$f43ff4d4aa562c2f = ()=>{
    const { fireOperationalAnalytic: fireOperationalAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    (0, $42omo.useEffect)(()=>{
        (0, $2Qxf3.setOnFetchComplete)((metrics)=>{
            fireOperationalAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).SNIPPETS,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FETCHED,
                attributes: metrics
            });
        });
        return ()=>(0, $2Qxf3.setOnFetchComplete)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



var $cYuYM = parcelRequire("cYuYM");


var $5vi32 = parcelRequire("5vi32");


var $dZUkS = parcelRequire("dZUkS");

const $326f6c6e797b3c09$export$607850563f346b34 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    (0, $37d6b5f846525abd$export$f43ff4d4aa562c2f)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isSnippetCreateEnabled = (0, $cYuYM.useIsSnippetCreateEnabled)();
    let t1;
    let t2;
    if ($[0] !== fireFailedAnalytic || $[1] !== isEmbeddedConfluence || $[2] !== isSnippetCreateEnabled || $[3] !== snippetsActions) {
        t1 = ()=>{
            if (!(0, $6mKj3.expVal)("cc_snippets", "isEnabled", false)) return;
            if (isEmbeddedConfluence && !isSnippetCreateEnabled) return;
            snippetsActions.fetchSnippets().catch(()=>{
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_FETCH, {});
            });
        };
        t2 = [
            snippetsActions,
            fireFailedAnalytic,
            isEmbeddedConfluence,
            isSnippetCreateEnabled
        ];
        $[0] = fireFailedAnalytic;
        $[1] = isEmbeddedConfluence;
        $[2] = isSnippetCreateEnabled;
        $[3] = snippetsActions;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[6] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[6] = children;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};



var $laFNM = parcelRequire("laFNM");

const $e33908ef21162ab8$export$968a8c4aa27e5f45 = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jln20.RightSidebarContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Hyz1.PostOfficeSideNavMessageProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cLgYq.InProductHelpProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $326f6c6e797b3c09$export$607850563f346b34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $laFNM.ApprovalsProvider), null, children)))));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};


const $ba2ff1d1fd865be7$var$isRoute = (pathname, route)=>Boolean(route.match(pathname || ''));
const $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav = [
    (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST),
    (0, $1NBp8.SPACE_PAGES),
    (0, $1NBp8.SPACE_CALENDARS),
    (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW),
    (0, $1NBp8.SPACE_QUESTIONS)
];
const $ba2ff1d1fd865be7$var$PopoverSpotlightWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $ba2ff1d1fd865be7$var$SpotlightManagerSpotlightWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), {
            blanketIsTinted: true
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $ba2ff1d1fd865be7$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader } = t0;
    let t1;
    if ($[0] !== children || $[1] !== editorPreloader || $[2] !== isSpaceSettingsScreen || $[3] !== standalone || $[4] !== view) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba2ff1d1fd865be7$export$f94607b1528a8807, {
            children: children,
            view: view,
            standalone: standalone,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            editorPreloader: editorPreloader
        }));
        $[0] = children;
        $[1] = editorPreloader;
        $[2] = isSpaceSettingsScreen;
        $[3] = standalone;
        $[4] = view;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
});
const $ba2ff1d1fd865be7$export$f94607b1528a8807 = (t0)=>{
    const $ = (0, $frIzR.c)(46);
    const { children: children, view: view, standalone: standalone, isSpaceSettingsScreen: t1, editorPreloader: t2 } = t0;
    const isSpaceSettingsScreen = t1 === undefined ? false : t1;
    const editorPreloader = t2 === undefined ? $ba2ff1d1fd865be7$var$noopEditorPreloader : t2;
    let t3;
    if ($[0] !== view) {
        t3 = {
            view: view
        };
        $[0] = view;
        $[1] = t3;
    } else t3 = $[1];
    const { pageTreeUpdater: pageTreeUpdater } = (0, $ad0ecba6dc7e91fa$export$ccd8c615ba434dec)(t3);
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $aXWIB.useIntl)();
    const { location: location, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t4;
    if ($[2] !== location?.pathname) {
        t4 = $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav.some((route)=>$ba2ff1d1fd865be7$var$isRoute(location?.pathname, route));
        $[2] = location?.pathname;
        $[3] = t4;
    } else t4 = $[3];
    const showBreadcrumbNavHeader = t4;
    let t5;
    if ($[4] !== intl) {
        t5 = intl.formatMessage((0, $5fff77e1c664da88$export$a7357cdd1f0b0168).SideNav);
        $[4] = intl;
        $[5] = t5;
    } else t5 = $[5];
    const SideNavSkiplinkText = t5;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    let t6;
    if ($[6] !== standalone) {
        t6 = ()=>standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$d1bb8697b964b9c)
                },
                "data-testid": "global-styles-SSR"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$191b652ca0b16b3f)
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", {
                "data-testid": "global-styles",
                ...nonceValue !== undefined ? {
                    nonce: nonceValue
                } : {},
                type: "text/css",
                dangerouslySetInnerHTML: {
                    __html: (0, $234a7212b3053f5f$export$191b652ca0b16b3f)
                }
            });
        $[6] = standalone;
        $[7] = t6;
    } else t6 = $[7];
    const standaloneGlobalStylesCompiled = t6;
    const [isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive] = (0, $42omo.useState)(false);
    const { initialCollapsedState: initialCollapsedState } = (0, $1b5aa9dc12e56400$export$6deddaa54d32585b)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const currentContentId = match?.params?.contentId ?? null;
    const isContentRoute = Boolean(currentContentId);
    let t7;
    if ($[8] !== hideObjectSidebar || $[9] !== isContentRoute || $[10] !== isObjectSidebarShown || $[11] !== panel?.id) {
        t7 = ()=>{
            if (isObjectSidebarShown && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && !isContentRoute && (0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar")) hideObjectSidebar();
        };
        $[8] = hideObjectSidebar;
        $[9] = isContentRoute;
        $[10] = isObjectSidebarShown;
        $[11] = panel?.id;
        $[12] = t7;
    } else t7 = $[12];
    const t8 = panel?.id;
    let t9;
    if ($[13] !== hideObjectSidebar || $[14] !== isContentRoute || $[15] !== isObjectSidebarShown || $[16] !== t8) {
        t9 = [
            hideObjectSidebar,
            isContentRoute,
            isObjectSidebarShown,
            t8
        ];
        $[13] = hideObjectSidebar;
        $[14] = isContentRoute;
        $[15] = isObjectSidebarShown;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    (0, $42omo.useEffect)(t7, t9);
    let t10;
    if ($[18] !== currentContentId) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3260f1cb149f21d4$export$2e1f52d6d7a935bc), {
            contentId: currentContentId
        });
        $[18] = currentContentId;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: "NavigationLoading"
        });
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== SideNavSkiplinkText || $[22] !== areKeyboardShortcutsEnabled || $[23] !== children || $[24] !== initialCollapsedState || $[25] !== isContentRoute || $[26] !== isNav4CollapseReminderSpotlightActive || $[27] !== isObjectSidebarShown || $[28] !== isSpaceSettingsScreen || $[29] !== location?.pathname || $[30] !== pageTreeUpdater || $[31] !== panel?.id || $[32] !== showBreadcrumbNavHeader || $[33] !== standalone || $[34] !== standaloneGlobalStylesCompiled || $[35] !== view) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: $ba2ff1d1fd865be7$var$bannerStateContainerArray
        }, (bannerState)=>{
            const bannerHeight = bannerState.getTotalHeight(false);
            const SpotlightWrapper = (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? $ba2ff1d1fd865be7$var$PopoverSpotlightWrapper : $ba2ff1d1fd865be7$var$SpotlightManagerSpotlightWrapper;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpotlightWrapper, null, standaloneGlobalStylesCompiled(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e33908ef21162ab8$export$968a8c4aa27e5f45), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1274ccb8dddd72cd$export$797f6437373337da), {
                value: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82dFP.Root), {
                UNSAFE_dangerouslyHoistSlotSizes: true,
                testId: "page-layout-root",
                defaultSideNavCollapsed: (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false) ? initialCollapsedState === "collapsed" : undefined,
                isSideNavShortcutEnabled: areKeyboardShortcutsEnabled && (0, $6mKj3.expVal)("navx-full-height-sidebar-exp", "isEnabled", false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f0df34b67538a54c$export$3b4e64e77073e307), {
                height: bannerHeight,
                id: "AkBanner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5XPyz.BannerContainer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
                dataFetcherName: "top-nav"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f06013f8e99ab858$export$41d0d88a6b0e456f), {
                defaultCollapsed: initialCollapsedState === "collapsed",
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b56ca6efd7e1c0fa$export$cc4f63927c41742f), {
                view: view,
                skiplinkText: SideNavSkiplinkText,
                isSpaceSettingsScreen: isSpaceSettingsScreen,
                isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
                setTriggeredByShortcut: $ba2ff1d1fd865be7$var$_temp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1imNS.Main), {
                testId: "grid-main-container",
                id: "AkMainContent"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $234a7212b3053f5f$export$712225703044cda), {
                id: "layout-main-wrapper",
                showBreadcrumbNavHeader: showBreadcrumbNavHeader
            }, showBreadcrumbNavHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgsIj.FixedBreadcrumbsNavForPageLayoutLoader), null), children && !standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).DISCO
            }, showBreadcrumbNavHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles
            }, children) : children) : null)), isObjectSidebarShown && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && isContentRoute && !$ba2ff1d1fd865be7$var$isRoute(location?.pathname, (0, $1NBp8.WHITEBOARD_BOARD)) && !$ba2ff1d1fd865be7$var$isRoute(location?.pathname, (0, $1NBp8.DATABASE_VIEW)) && (0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eK5zz.Panel), {
                defaultWidth: 400,
                label: "Object Sidebar"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3bd0aed1e73a4d2$export$cb9ee4d1dffdc955), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lpfM9.PanelLoader), {
                toggleInProductHelp: $ba2ff1d1fd865be7$var$_temp2
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $7xVCs.PageTreeStateUpdater)
                ]
            }, (pageTreeStateUpdatesContainer)=>{
                pageTreeUpdater.current = pageTreeStateUpdatesContainer;
                return null;
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c25ef82052c394f$export$f143b4bd86d1e004), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1C7kY.GlobalComponentsLoader), null))));
        });
        $[21] = SideNavSkiplinkText;
        $[22] = areKeyboardShortcutsEnabled;
        $[23] = children;
        $[24] = initialCollapsedState;
        $[25] = isContentRoute;
        $[26] = isNav4CollapseReminderSpotlightActive;
        $[27] = isObjectSidebarShown;
        $[28] = isSpaceSettingsScreen;
        $[29] = location?.pathname;
        $[30] = pageTreeUpdater;
        $[31] = panel?.id;
        $[32] = showBreadcrumbNavHeader;
        $[33] = standalone;
        $[34] = standaloneGlobalStylesCompiled;
        $[35] = view;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== editorPreloader || $[38] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
            value: editorPreloader
        }, t12);
        $[37] = editorPreloader;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== t13 || $[41] !== view) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd996ec529999f47$export$ac3e7903e24ee02d), {
            view: view,
            navVersion: "4"
        }, t11, t13);
        $[40] = t13;
        $[41] = view;
        $[42] = t14;
    } else t14 = $[42];
    let t15;
    if ($[43] !== t10 || $[44] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jAOzg.SmartFolderSyncProvider), null, t10, t14));
        $[43] = t10;
        $[44] = t14;
        $[45] = t15;
    } else t15 = $[45];
    return t15;
};
const $ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay = ()=>{
    const $ = (0, $frIzR.c)(2);
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    let t0;
    if ($[0] !== isMultiSelectActive) {
        t0 = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
            isTinted: true,
            testId: "content-tree-multi-select-blanket"
        }) : null;
        $[0] = isMultiSelectActive;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles = (0, $ecnYn.xcss)({
    // @ts-ignore This specific value is necessary to ensure the breadcrumbs are offset correctly
    marginTop: '60px'
});
const $ba2ff1d1fd865be7$var$outerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayout-outer'
};
const $ba2ff1d1fd865be7$var$innerErrorBoundaryAttributes = {
    errorBoundaryId: 'PageLayoutInner'
};
const $ba2ff1d1fd865be7$var$bannerStateContainerArray = [
    (0, $hrAmX.BannerStateContainer)
];
const $ba2ff1d1fd865be7$var$noopEditorPreloader = ()=>null;
function $ba2ff1d1fd865be7$var$_temp() {}
function $ba2ff1d1fd865be7$var$_temp2() {}
module.exports["PageLayout"] = $ba2ff1d1fd865be7$export$6d1402fb58384e4f;
module.exports["PageLayoutInner"] = $ba2ff1d1fd865be7$export$f94607b1528a8807;

});

parcelRegister("eK5zz", function(module, exports) {
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $bWLcG = parcelRequire("bWLcG");


var $3RzOP = parcelRequire("3RzOP");


var $K0HEo = parcelRequire("K0HEo");


var $9w5su = parcelRequire("9w5su");


var $8jREP = parcelRequire("8jREP");


var $c9vFp = parcelRequire("c9vFp");


var $ijWqx = parcelRequire("ijWqx");


var $d4FF7 = parcelRequire("d4FF7");


var $38bxn = parcelRequire("38bxn");


var $5KskV = parcelRequire("5KskV");

const $57f246d928e48214$var$panelSplitterResizingVar = '--n_pnlRsz';
const $57f246d928e48214$var$fallbackDefaultWidth = 365; /**
                                   * We typically use the `defaultWidth` as the minimum resizing width,
                                   * but for large default widths we fallback to a standard value.
                                   *
                                   * This standard value of `400px` is to align with the Global Preview Panels.
                                   */ 
const $57f246d928e48214$var$fallbackResizeMinWidth = 400;
const $57f246d928e48214$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _1bsb1dxx _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs130s _1w6eia51 _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
}; /**
    * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
    *
    * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
    *
    * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
    */ 
function $57f246d928e48214$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidthProp = $57f246d928e48214$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true }) {
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $d4FF7.useLayoutId)({
        providedId: providedId
    });
    const defaultWidth = (0, $5KskV.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $57f246d928e48214$var$fallbackDefaultWidth,
        slotName: 'Panel'
    }); /**
       * Don't show the skip link if the slot has 0 width.
       *
       * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
       *
       * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
       */ 
    (0, $3RzOP.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $dh538.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $42omo.useRef)(null);
    const [width, setWidth] = (0, $42omo.useState)(defaultWidth); // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $42omo.useRef)(defaultWidth); /**
                                                 * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
                                                 * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
                                                 * https://jplat.atlassian.net/browse/BLU-3951
                                                 */ 
    (0, $42omo.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $ijWqx.useSideNavRef)(); /**
                                       * The minimum width that the panel can be resized to by the user.
                                       *
                                       * We only use the `defaultWidth` up to a point to avoid huge panels.
                                       */ 
    const minWidth = Math.min(defaultWidth, $57f246d928e48214$var$fallbackResizeMinWidth); /**
                                                                    * Returns the bounds for resizing, evaluated lazily when needed.
                                                                    *
                                                                    * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
                                                                    * and the panel's slot bounds use a complex CSS expression.
                                                                    */ 
    const getResizeBounds = (0, $42omo.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0; /**
                                                                * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
                                                                *
                                                                * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
                                                                */ 
        const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${(0, $K0HEo.sideNavLiveWidthVar)}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $38bxn.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $57f246d928e48214$var$panelSplitterResizingVar,
        panelId: (0, $K0HEo.panelPanelSplitterId)
    });
    return /*#__PURE__*/ $42omo.createElement("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            $57f246d928e48214$var$styles.root,
            defaultWidth === 0 && $57f246d928e48214$var$styles.hidden,
            hasBorder && $57f246d928e48214$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $K0HEo.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: ref
    }, dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    /*#__PURE__*/ $42omo.createElement((0, $9w5su.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $K0HEo.UNSAFE_panelLayoutVar),
        value: "0px",
        mediaQuery: (0, $bWLcG.media).above.lg,
        responsiveValue: `var(${$57f246d928e48214$var$panelSplitterResizingVar}, ${panelVariableWidth})`
    }), /*#__PURE__*/ $42omo.createElement((0, $c9vFp.PanelSplitterProvider), {
        panelId: (0, $K0HEo.panelPanelSplitterId),
        panelRef: ref,
        panelWidth: width,
        onCompleteResize: setWidth,
        getResizeBounds: getResizeBounds,
        resizingCssVar: $57f246d928e48214$var$panelSplitterResizingVar,
        position: "start"
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $57f246d928e48214$var$styles.scrollContainer
        ])
    }, children)));
}
module.exports["Panel"] = $57f246d928e48214$export$2ddb90ad54e5f587;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("6CEg5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $42omo.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("5XPyz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e36ff8521eaa3fdf$export$f316edcbf748c37b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bTjE2",
    name: "BannerContainer",
    loader: async ()=>(await (parcelRequire("3Rwpv"))).BannerContainer
});
module.exports["BannerContainer"] = $e36ff8521eaa3fdf$export$f316edcbf748c37b;

});

parcelRegister("3Rwpv", function(module, exports) {

let $2cff76582f58a1ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2cff76582f58a1ae$var$load("7ETma"),
    $2cff76582f58a1ae$var$load("avZlC")
]).then(()=>parcelRequire('9ZNsj'));

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");


var $1dnxO = parcelRequire("1dnxO");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $T1bCI.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        if (// The increased height change is only applied when FHS is enabled.
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false)) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("i3jcY", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $1xpoY.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("1C7kY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c9ec1f4c06aad517$export$23822a00be419508 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KYiA6",
    name: "GlobalComponentsLoader",
    loader: async ()=>(await (parcelRequire("5wYZR"))).GlobalComponents
});
module.exports["GlobalComponentsLoader"] = $c9ec1f4c06aad517$export$23822a00be419508;

});

parcelRegister("5wYZR", function(module, exports) {

let $406f41986b11a553$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $406f41986b11a553$var$load("2RKtK"),
    $406f41986b11a553$var$load("1DtkX"),
    $406f41986b11a553$var$load("juZ3q"),
    $406f41986b11a553$var$load("4dNRa"),
    $406f41986b11a553$var$load("3GuOt"),
    $406f41986b11a553$var$load("jryQt")
]).then(()=>parcelRequire('73TCo'));

});

parcelRegister("dpPtd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
        const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagType, {
            ...restProps,
            key: flag.id
        });
    })));
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c997cd3fd9f4ee84$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("6tLpM", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $f88282d674f1f8d0$export$5351114e92b31bc6 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $f88282d674f1f8d0$export$5351114e92b31bc6;

});

parcelRegister("fN3iy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = ()=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)((0, $dh538.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        ...initialPanel && (0, $dh538.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("gz8ZY", function(module, exports) {
/**----------------!!!!!!!!!!!!!!!!!!!!!!----------------------------
*   When Changing this file ensure you keep the pure function version
*              getIsNav4Enabled.ts in sync as well!
 -----------------!!!!!!!!!!!!!!!!!!!!!!!--------------------------*/ // eslint-disable-next-line confluence-feature-gating/inline-usage
const $90a9f787a509158d$export$22793b194a2253b9 = ()=>{
    return true;
};
module.exports["useIsNav4Enabled"] = $90a9f787a509158d$export$22793b194a2253b9;

});

parcelRegister("8XaNQ", function(module, exports) {

let $684c36a8ede40f81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $684c36a8ede40f81$var$load("6Ji1C"),
    $684c36a8ede40f81$var$load("gmLCD"),
    $684c36a8ede40f81$var$load("3alGb")
]).then(()=>parcelRequire('23xdA'));

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("jAOzg", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $9612d889a12dc002$var$createSyncStore() {
    let syncingFolderIds = new Set();
    const listeners = new Set();
    const notify = ()=>{
        listeners.forEach((listener)=>listener());
    };
    return {
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        },
        getSnapshot: ()=>syncingFolderIds,
        addSyncingFolder: (folderId)=>{
            if (syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.add(folderId);
            syncingFolderIds = next;
            notify();
        },
        removeSyncingFolder: (folderId)=>{
            if (!syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.delete(folderId);
            syncingFolderIds = next;
            notify();
        }
    };
}
/**
 * A store-based context for tracking which folders are syncing.
 *
 * Uses `useSyncExternalStore` so that each `useIsFolderSyncing(folderId)`
 * subscriber only re-renders when their specific folder's sync boolean
 * changes — not when any arbitrary folder starts/stops syncing.
 *
 * - `SmartFolderSyncStoreContext` holds the store instance.
 * - `SmartFolderSyncActionsContext` holds stable `add`/`remove` callbacks
 *   for writers (e.g. `useSmartFolderSync`) that never re-render on state change.
 */ const $9612d889a12dc002$var$SmartFolderSyncStoreContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $9612d889a12dc002$var$SmartFolderSyncActionsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    addSyncingFolder: ()=>{},
    removeSyncingFolder: ()=>{}
});
const $9612d889a12dc002$export$a225af674c9c7799 = ({ children: children })=>{
    const storeRef = (0, $42omo.useRef)(null);
    if (storeRef.current === null) storeRef.current = $9612d889a12dc002$var$createSyncStore();
    const store = storeRef.current;
    const actions = (0, $42omo.useMemo)(()=>({
            addSyncingFolder: store.addSyncingFolder,
            removeSyncingFolder: store.removeSyncingFolder
        }), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9612d889a12dc002$var$SmartFolderSyncStoreContext.Provider, {
        value: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9612d889a12dc002$var$SmartFolderSyncActionsContext.Provider, {
        value: actions
    }, children));
};
const $9612d889a12dc002$var$EMPTY_SET = new Set();
const $9612d889a12dc002$var$EMPTY_SUBSCRIBE = (_cb)=>()=>{};
const $9612d889a12dc002$var$EMPTY_SNAPSHOT = ()=>$9612d889a12dc002$var$EMPTY_SET;
const $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL = ()=>false;
const $9612d889a12dc002$export$35a8d8248145227a = ()=>{
    const store = (0, $42omo.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    return (0, $42omo.useSyncExternalStore)(store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE, store?.getSnapshot ?? $9612d889a12dc002$var$EMPTY_SNAPSHOT, $9612d889a12dc002$var$EMPTY_SNAPSHOT);
};
const $9612d889a12dc002$export$4cd077b71db9ec99 = (folderId)=>{
    const store = (0, $42omo.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    const subscribe = store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE;
    const getSnapshot = (0, $42omo.useCallback)(()=>store ? store.getSnapshot().has(folderId) : false, [
        store,
        folderId
    ]);
    return (0, $42omo.useSyncExternalStore)(subscribe, getSnapshot, $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL);
};
const $9612d889a12dc002$export$8a3c75bc060e9cf8 = ()=>{
    return (0, $42omo.useContext)($9612d889a12dc002$var$SmartFolderSyncActionsContext);
};
module.exports["SmartFolderSyncProvider"] = $9612d889a12dc002$export$a225af674c9c7799;
module.exports["useIsFolderSyncing"] = $9612d889a12dc002$export$4cd077b71db9ec99;
module.exports["useFolderSyncActions"] = $9612d889a12dc002$export$8a3c75bc060e9cf8;

});

parcelRegister("bpufi", function(module, exports) {

var $84kyw = parcelRequire("84kyw");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $hT3jf = parcelRequire("hT3jf");


var $9B4kz = parcelRequire("9B4kz");

const $20c8471b6a70899f$var$SmartFolderAncestorsQuery = (0, $84kyw.default);
const $20c8471b6a70899f$export$96af50927b5249f0 = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)($20c8471b6a70899f$var$SmartFolderAncestorsQuery, {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId,
        // cache-first avoids unnecessary network requests — the page tree query
        // typically already loaded the ptpage data we need.
        fetchPolicy: 'cache-first',
        __callerPackage__: "@confluence/smart-folder"
    });
    const { triggerSync: triggerSync } = (0, $9B4kz.useSmartFolderSync)();
    const lastTriggeredSyncKeyRef = (0, $42omo.useRef)(null);
    const syncTargetId = (0, $42omo.useMemo)(()=>{
        if (!contentId) return null;
        const ptpage = data?.ptpage;
        if (!ptpage || ptpage.id !== contentId) return null;
        // If the current content IS itself a smart folder, FolderOverview
        // will handle the sync; this hook only covers content nested inside
        // a smart folder.
        if ((0, $hT3jf.isSmartFolder)(ptpage)) return null;
        const ancestors = ptpage?.nearestAncestors?.nodes;
        if (!ancestors || ancestors.length === 0) return null;
        // Find the highest (root) MANAGED ancestor, if any.
        // `nearestAncestors` is ordered nearest-first, so iterate in reverse
        // to find the topmost smart folder.
        for(let i = ancestors.length - 1; i >= 0; i--){
            const ancestor = ancestors[i];
            if (ancestor && (0, $hT3jf.isSmartFolder)(ancestor)) return ancestor.id;
        }
        return null;
    }, [
        contentId,
        data?.ptpage
    ]);
    // syncTargetId is non-null iff a smart folder ancestor exists;
    // also handle the case where the content itself IS a smart folder.
    const isInSmartFolderTree = (0, $42omo.useMemo)(()=>(data?.ptpage ? (0, $hT3jf.isSmartFolder)(data.ptpage) : false) || syncTargetId !== null, [
        data?.ptpage,
        syncTargetId
    ]);
    // Include `contentId` so that navigating away from and back to a page
    // nested inside the same smart folder re-triggers sync even though
    // `syncTargetId` resolves to the same root folder ID both times.
    (0, $42omo.useEffect)(()=>{
        if (!syncTargetId) {
            lastTriggeredSyncKeyRef.current = null;
            return;
        }
        const syncKey = `${contentId}:${syncTargetId}`;
        if (lastTriggeredSyncKeyRef.current === syncKey) return;
        lastTriggeredSyncKeyRef.current = syncKey;
        triggerSync(syncTargetId);
    }, [
        contentId,
        syncTargetId,
        triggerSync
    ]);
    return {
        isInSmartFolderTree: isInSmartFolderTree
    };
};
module.exports["useSmartFolderAncestorSync"] = $20c8471b6a70899f$export$96af50927b5249f0;

});

parcelRegister("84kyw", function(module, exports) {
/**
 * @generated SignedSource<<82f7913184f2c892761a914b67fa0759>>
 * @relayHash 701de8d25c0615cd65d074a2d0d26386
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17
const $ee303482ff843c0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "CURRENT",
                        "DRAFT"
                    ]
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSmartFolderAncestorSyncQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSmartFolderAncestorSyncQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "701de8d25c0615cd65d074a2d0d26386",
            "id": "9e4874aa6f1795a40140739a4ef2d22670502e0aa0add7ff9834458df2767c17",
            "metadata": {},
            "name": "useSmartFolderAncestorSyncQuery",
            "operationKind": "query",
            "text": "query useSmartFolderAncestorSyncQuery($contentId:ID!){ptpage(id:$contentId,status:[CURRENT,DRAFT]){id,type,subType,nearestAncestors{nodes{id,type,subType}}}}"
        }
    };
}();
$ee303482ff843c0d$var$node.hash = "3feebc26cc696b75c6544fb3f45823b7";
var $ee303482ff843c0d$export$2e2bcd8739ae039 = $ee303482ff843c0d$var$node;
module.exports["default"] = $ee303482ff843c0d$export$2e2bcd8739ae039;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("9B4kz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kCXmK = parcelRequire("kCXmK");


var $jAOzg = parcelRequire("jAOzg");

const $5a800d6d1cd2f48a$export$f90756b916c77239 = (options)=>{
    const { onSyncComplete: onSyncComplete } = options ?? {};
    const { syncSmartFolder: syncSmartFolder, loading: loading } = (0, $kCXmK.useSyncSmartFolder)();
    const { addSyncingFolder: addSyncingFolder, removeSyncingFolder: removeSyncingFolder } = (0, $jAOzg.useFolderSyncActions)();
    const syncingFolderRef = (0, $42omo.useRef)(null);
    const statusRef = (0, $42omo.useRef)('idle');
    // Derive a simple status from the mutation state + our local tracking
    const status = loading ? 'syncing' : statusRef.current;
    const triggerSync = (0, $42omo.useCallback)((folderId)=>{
        // De-duplicate: don't fire another request if we're already syncing this folder
        if (syncingFolderRef.current === folderId) return;
        syncingFolderRef.current = folderId;
        statusRef.current = 'syncing';
        addSyncingFolder(folderId);
        syncSmartFolder({
            folderId: folderId
        }).then((result)=>{
            const success = result?.data?.confluence_syncSmartFolder?.success ?? false;
            statusRef.current = success ? 'success' : 'error';
            if (success) onSyncComplete?.();
        }).catch(()=>{
            statusRef.current = 'error';
        }).finally(()=>{
            const finishedId = syncingFolderRef.current;
            syncingFolderRef.current = null;
            if (finishedId) removeSyncingFolder(finishedId);
            statusRef.current = 'idle';
        });
    }, [
        syncSmartFolder,
        onSyncComplete,
        addSyncingFolder,
        removeSyncingFolder
    ]);
    return {
        triggerSync: triggerSync,
        status: status
    };
};
module.exports["useSmartFolderSync"] = $5a800d6d1cd2f48a$export$f90756b916c77239;

});

parcelRegister("kCXmK", function(module, exports) {

var $eY1jG = parcelRequire("eY1jG");


var $42omo = parcelRequire("42omo");


var $lb1Mg = parcelRequire("lb1Mg");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $fPTGf = parcelRequire("fPTGf");

const $a02f9f88b53bbb7f$export$f99b955ffb3c1231 = ()=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [syncSmartFolderMutation, { called: called, data: data, error: error, loading: loading }] = (0, $308Wd.useMutationInterop)((0, $eY1jG.default), {
        __callerPackage__: "@confluence/smart-folder"
    });
    const applySmartFolderSubTypeChange = (0, $fPTGf.useApplySmartFolderSubTypeChange)();
    const syncSmartFolder = (0, $42omo.useCallback)(async ({ folderId: folderId, force: force })=>{
        const folderAri = (0, $lb1Mg.ConfluenceFolderAri).create({
            activationId: activationId,
            folderId: folderId,
            siteId: cloudId
        }).toString();
        // The generated ConfluenceSyncSmartFolderInput type doesn't include `force` yet
        // because the backend schema hasn't propagated. We cast here so we can pass
        // the field ahead of the schema update — unknown input fields are safely
        // ignored by GraphQL servers until the schema supports them.
        const result = await syncSmartFolderMutation({
            variables: {
                cloudId: cloudId,
                input: {
                    folderId: folderAri,
                    ...force !== undefined ? {
                        force: force
                    } : {}
                }
            }
        });
        const payload = result.data?.confluence_syncSmartFolder;
        const hasErrors = Boolean(payload?.errors?.length);
        if (payload?.success && !hasErrors) applySmartFolderSubTypeChange({
            folderId: folderId,
            subType: 'managed'
        });
        return result;
    }, [
        activationId,
        cloudId,
        syncSmartFolderMutation,
        applySmartFolderSubTypeChange
    ]);
    return {
        syncSmartFolder: syncSmartFolder,
        called: called,
        data: data,
        error: error,
        loading: loading
    };
};
module.exports["useSyncSmartFolder"] = $a02f9f88b53bbb7f$export$f99b955ffb3c1231;

});

parcelRegister("eY1jG", function(module, exports) {
/**
 * @generated SignedSource<<d566f367a8cf0935861a51cdfc46abf8>>
 * @relayHash 69f493af18d64a7f4cf70f0087acbb00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55b906b1ae05d709d7caf4b653d8e101a4e11b8141feeb12d643b51e5daab820
const $394869d03facb960$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceSyncSmartFolderPayload",
            "kind": "LinkedField",
            "name": "confluence_syncSmartFolder",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSyncSmartFolderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSyncSmartFolderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "69f493af18d64a7f4cf70f0087acbb00",
            "id": "55b906b1ae05d709d7caf4b653d8e101a4e11b8141feeb12d643b51e5daab820",
            "metadata": {},
            "name": "useSyncSmartFolderMutation",
            "operationKind": "mutation",
            "text": "mutation useSyncSmartFolderMutation($cloudId:ID!,$input:ConfluenceSyncSmartFolderInput!){confluence_syncSmartFolder(cloudId:$cloudId,input:$input){errors{message},success}}"
        }
    };
}();
$394869d03facb960$var$node.hash = "db0693038c4ec4b6cc2029ff542315a6";
var $394869d03facb960$export$2e2bcd8739ae039 = $394869d03facb960$var$node;
module.exports["default"] = $394869d03facb960$export$2e2bcd8739ae039;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("fPTGf", function(module, exports) {

var $8EdIy = parcelRequire("8EdIy");


var $42omo = parcelRequire("42omo");


var $ij4CE = parcelRequire("ij4CE");


var $ficwO = parcelRequire("ficwO");




const $ad18477d67abe91f$export$d0da2224ce3d22b8 = ()=>{
    const writeContentSubType = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $8EdIy.default),
        fragmentSpec: (0, $8EdIy.default),
        __callerPackage__: "@confluence/smart-folder"
    });
    const publishSyncStateChange = (0, $ficwO.useMessagePublisher)((0, $ficwO.Message).SmartFolderSyncStateChanged);
    return (0, $42omo.useCallback)(({ folderId: folderId, subType: subType })=>{
        writeContentSubType({
            fragmentId: `Content:${folderId}`,
            data: {
                id: folderId,
                subType: subType,
                __typename: 'Content'
            }
        });
        publishSyncStateChange({
            contentId: folderId,
            subType: subType
        });
    }, [
        writeContentSubType,
        publishSyncStateChange
    ]);
};
module.exports["useApplySmartFolderSubTypeChange"] = $ad18477d67abe91f$export$d0da2224ce3d22b8;

});

parcelRegister("8EdIy", function(module, exports) {
/**
 * @generated SignedSource<<ccfbad4c0f60d5bd3f54f180fea3262a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ae4c44658947c5d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useApplySmartFolderSubTypeChangeContentWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$4ae4c44658947c5d$var$node.hash = "7b1e91c800d1490b419afc4c6e95fb79";
var $4ae4c44658947c5d$export$2e2bcd8739ae039 = $4ae4c44658947c5d$var$node;
module.exports["default"] = $4ae4c44658947c5d$export$2e2bcd8739ae039;

});

parcelRegister("ficwO", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    Message[Message["SmartFolderSyncStateChanged"] = 2] = "SmartFolderSyncStateChanged";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $6c05dda517103510$var$messageBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (type, callback)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("ftFOj", function(module, exports) {

var $ieWRE = parcelRequire("ieWRE");


var $jtuBN = parcelRequire("jtuBN");


var $gZneu = parcelRequire("gZneu");

/** @schema cc */ const $46cf70134ef7593d$var$query = (0, $ieWRE.default);
const $46cf70134ef7593d$export$957cf4ab6fd3f58e = (spaceKey)=>{
    const isSmartFoldersSupported = (0, $gZneu.useIsSmartFoldersSupported)();
    const { loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($46cf70134ef7593d$var$query, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !isSmartFoldersSupported || !spaceKey
    });
    const enabledContentTypes = data?.space?.spaceTypeSettings?.enabledContentTypes;
    const isFoldersEnabledInSpace = enabledContentTypes?.isFoldersEnabled ?? false;
    const isSmartFoldersEnabledInSpace = enabledContentTypes?.isSmartFoldersEnabled ?? false;
    return {
        isSmartFoldersEnabled: isSmartFoldersSupported && isFoldersEnabledInSpace && isSmartFoldersEnabledInSpace,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabled"] = $46cf70134ef7593d$export$957cf4ab6fd3f58e;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<4f1511016f30960d1bbc443c21231347>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("gZneu", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $23af0ee2a39f4a09$export$4f0b8fcf328460ea = ()=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoEnabled && (0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) && (0, $6mKj3.expVal)('confluence_smart_folders_milestone_1', 'isEnabled', false);
};
module.exports["useIsSmartFoldersSupported"] = $23af0ee2a39f4a09$export$4f0b8fcf328460ea;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("8Hyz1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $2f7c8c88765be2b1$export$730cc5718beea0d0 = ()=>{
    return (0, $42omo.useContext)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext);
};
const $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac = ({ children: children })=>{
    const [enabledMessages, setEnabledMessages] = (0, $42omo.useState)([]);
    const enablePostOfficeSideNavMessage = (0, $42omo.useCallback)((message)=>{
        setEnabledMessages((prev)=>{
            if (prev.includes(message)) return prev;
            return [
                ...prev,
                message
            ];
        });
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            enabledMessages: enabledMessages,
            enablePostOfficeSideNavMessage: enablePostOfficeSideNavMessage
        }), [
        enabledMessages,
        enablePostOfficeSideNavMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["usePostOfficeSideNavMessages"] = $2f7c8c88765be2b1$export$730cc5718beea0d0;
module.exports["PostOfficeSideNavMessageProvider"] = $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $0412590977f134ac$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $42omo.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $gMc0m.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("78z3f", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ const $d6fec807fa1e44ce$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    JiraDC: 'jira-dc',
    JsmDC: 'jsm-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp'
};
const $d6fec807fa1e44ce$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp'
};
module.exports["ProductKeys3P"] = $d6fec807fa1e44ce$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $d6fec807fa1e44ce$export$5378b945bea99ba3;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey',
    onboardingEntryPoint: 'onboardingEntryPoint'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder") return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const onboardingEntryPoint = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.onboardingEntryPoint);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        onboardingEntryPoint: onboardingEntryPoint,
        templateKey: templateKey
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("jFFx4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dPJCf = parcelRequire("dPJCf");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3194c63c7e99e1cb$export$2537d74141d57f9e = ()=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const saveCurrentRoute = (0, $42omo.useCallback)(()=>{
        const currentRoute = routeDataRef.current?.href;
        if (currentRoute) (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL, currentRoute);
    }, [
        routeDataRef
    ]);
    const getRoute = (0, $42omo.useCallback)((defaultPath)=>{
        const previousPath = (0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).NAV4_SETTINGS_BACK_BUTTON_URL);
        return previousPath ?? defaultPath;
    }, []);
    return {
        saveCurrentRoute: saveCurrentRoute,
        getRoute: getRoute
    };
};
module.exports["useSettingsBackButtonUtils"] = $3194c63c7e99e1cb$export$2537d74141d57f9e;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("5fd2s", function(module, exports) {

let $3d1877aa5a2d50a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d1877aa5a2d50a0$var$load("6wr18"),
    $3d1877aa5a2d50a0$var$load("gRwQ3"),
    $3d1877aa5a2d50a0$var$load("lRtGG"),
    $3d1877aa5a2d50a0$var$load("5uN9h"),
    $3d1877aa5a2d50a0$var$load("ffEVr"),
    $3d1877aa5a2d50a0$var$load("Wowvf"),
    $3d1877aa5a2d50a0$var$load("4rKYa"),
    $3d1877aa5a2d50a0$var$load("geh8r")
]).then(()=>parcelRequire('8oHcg'));

});

parcelRegister("7p8VW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $jvL0g = parcelRequire("jvL0g");


var $1AdRC = parcelRequire("1AdRC");

const $945be865edc65072$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $c0qxy.useId)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1AdRC.MenuSectionContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "group",
        "aria-labelledby": `${id}-heading`
    }, children));
    if (isMenuListItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jvL0g.MenuListItem), {
        testId: testId
    }, content);
    // Legacy. isMenuListItem should become default.
    return content;
};
module.exports["MenuSection"] = $945be865edc65072$export$4b1545b4f2016d26;

});

parcelRegister("jvL0g", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eLJ8w = parcelRequire("eLJ8w");

const $ad780ebce5bd3997$export$6c2f3257abc4825b = (0, $eLJ8w.ListItem);
module.exports["MenuListItem"] = $ad780ebce5bd3997$export$6c2f3257abc4825b;

});

parcelRegister("eLJ8w", function(module, exports) {
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");

function $66d0ff3d23490365$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $66d0ff3d23490365$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $42omo.forwardRef)($66d0ff3d23490365$var$_ListItem);
module.exports["ListItem"] = $66d0ff3d23490365$export$a7b06bfba60a8a78;

});

parcelRegister("1AdRC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");

const $f76872a14a62f5bc$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $f76872a14a62f5bc$export$8100cda602411810 = ()=>{
    const context = (0, $42omo.useContext)($f76872a14a62f5bc$export$728ac99b9c7eea8a);
    (0, $dRnqM.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};
module.exports["MenuSectionContext"] = $f76872a14a62f5bc$export$728ac99b9c7eea8a;
module.exports["useMenuSectionContext"] = $f76872a14a62f5bc$export$8100cda602411810;

});

parcelRegister("c8gOp", function(module, exports) {
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1AdRC = parcelRequire("1AdRC");

const $5e57245bca8ff137$var$styles = {
    root: "_11c8i4vh _1rjcu2gc _syaz1rpy _bozg12x7"
}; /**
    * __MenuSectionHeading__
    *
    * The label for the menu section group.
    */ 
const $5e57245bca8ff137$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $1AdRC.useMenuSectionContext)();
    return /*#__PURE__*/ $42omo.createElement("p", {
        id: `${id}-heading`,
        className: (0, $gMc0m.default)([
            $5e57245bca8ff137$var$styles.root
        ])
    }, children);
};
module.exports["MenuSectionHeading"] = $5e57245bca8ff137$export$5d3acdbf9237a364;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root
    }, /*#__PURE__*/ $42omo.createElement((0, $8njHX.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("8njHX", function(module, exports) {
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $gGs3F = parcelRequire("gGs3F");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $k2So4 = parcelRequire("k2So4");


var $6xzqO = parcelRequire("6xzqO");


var $6BXcn = parcelRequire("6BXcn");


var $5TK70 = parcelRequire("5TK70");


var $6hmpf = parcelRequire("6hmpf");

function $5185f3afa6ef08e0$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $5185f3afa6ef08e0$var$defaultAvatarValues = {
    size: 'small'
};
const $5185f3afa6ef08e0$var$elemAfterDisplayVar = '--elem-after-display';
const $5185f3afa6ef08e0$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const $5185f3afa6ef08e0$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
const $5185f3afa6ef08e0$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const $5185f3afa6ef08e0$var$notchColorVar = '--notch-color'; // Note: this is also used in `drag-handle.tsx`
const $5185f3afa6ef08e0$var$dragHandleDisplayVar = '--drag-handle-display';
const $5185f3afa6ef08e0$var$dragCursorAnimation = null; /**
                                   * ## 🤹 `position:relative`
                                   *
                                   * We need `position:relative` on an element that takes
                                   * up the full size of the interactive element so we
                                   * can correctly use `position:absolute` to place:
                                   * 1. the notch for links
                                   * 2. drop indicators for drag and drop
                                   * 3. a child of button / anchor to stretch it out to
                                   *    increase it's pressable area.
                                   *
                                   * ⛔️ We cannot add `position:relative` _only_ on the
                                   * button / anchor as that will cause sibling elements
                                   * to be rendered under the button / anchor when setting
                                   * a background color on the button / anchor.
                                   *
                                   * 📖 Note: `position:relative` elements are painted after
                                   * elements with `position:static` (the default)
                                   * https://drafts.csswg.org/css-position-4/#painting-order
                                   *
                                   * ⛔️ We cannot add `position:relative` to the container
                                   * element, as then the `:focus` ring styles on the
                                   * button / anchor can be cut off by the next sibling if it has
                                   * has a background color set (eg when selected)
                                   *
                                   * ✅ Add `position:relative` to all first level descendants
                                   * of the container element so that we don't impact DOM ordered
                                   * paint ordering within the item and the button / anchor focus
                                   * ring can still bleed over siblings
                                   *
                                   * 📖 We could use `> * { position: relative; }` on the container,
                                   * but that would violate our styling standard.
                                   */ 
const $5185f3afa6ef08e0$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
}; /**
    * All slots on the menu item (eg `elemBefore`) are rendered as siblings
    * of our main button / anchor element and they are visually placed on
    * top of the main button / anchor.
    *
    * 📖 This is done so that we don't nest interactive elements in our markup.
    *
    * ✅ This is great when element in the slot is an interactive element
    * as we don't want the main menu item button / anchor to be triggered
    * when interacting with the element in the slot.
    *
    * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
    * prevent the main button / anchor (that is visually behind the element in
    * the slot) from being clicked. The element in the slot is a sibling of our
    * main button / anchor (not a child of it) so clicking on the element in the
    * slot will not bubble up to the button / anchor.
    *
    * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
    * element so that static content in a slot does not prevent clicking on the main
    * button / anchor.
    */ 
const $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
}; /**
    * This is being _internally_ exported so it can be used in other menu item wrapper components, like
    * ExpandableMenuItemTrigger.
    *
    * This selector is used to apply hover styling on the menu item if it contains an open nested popup.
    * It's looking for a popup trigger with `aria-hasexpanded` and `aria-haspopup` attributes. The
    * reason for targeting the _trigger_ instead of the popup itself, is the popup might be rendered
    * outside the menu item, e.g. if rendered in a portal.
    *
    * An alternative solution might involve wrapping it with a popup context and listening to the popup
    * events through it (and applying the hover style when the popup is open). Exploring this has been
    * captured in [BLU-3354](https://jplat.atlassian.net/browse/BLU-3354).
    */ 
const $5185f3afa6ef08e0$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup])';
const $5185f3afa6ef08e0$var$containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syazazsu _1yyu1j28 _91ju1txw _uomdidpf _pmxpidpf _db80idpf _irr319i6 _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    rootT26Shape: "_2rko1qi0",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_uomdkb7n _pmxp1wug _db801b66",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1mfcglyw _1sjuglyw",
    selected: "_bfhk15s3 _syaz6x5g _1yyujmqp _30l36x5g _irr3ufnl",
    disabled: "_syaz1gmx _bfhkn7od _irr3n7od _30l31gmx",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
const $5185f3afa6ef08e0$var$nestedOpenPopupStyles = {
    root: "_1783kb7n _1d171wug _ligh1b66 _1fpr19i6",
    removeElemAfterOnHoverOrOpenNestedPopup: "_n3ixglyw",
    selected: "_1fprufnl"
};
const $5185f3afa6ef08e0$var$buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk1j28 _syazazsu _4cvr1h6o _y3gnv2br _14iu13ro",
    rootT26Shape: "_2rko1qi0",
    selected: "_syaz6x5g _14iunozp",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
const $5185f3afa6ef08e0$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $5185f3afa6ef08e0$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $5185f3afa6ef08e0$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $5185f3afa6ef08e0$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria _1guo18uv _12s918uv"
};
const $5185f3afa6ef08e0$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $5185f3afa6ef08e0$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh1ntv _1guo18uv _12s918uv"
};
const $5185f3afa6ef08e0$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
}; /**
    * We are using a wrapping element for our interactive content
    * even though only the `Text` element is the only thing not using `position:absolute`
    *
    * Rationale:
    * - Super clear that everything inside the interactive content should be in a specific slot in the grid
    * - To work around a browser bug in Safari where it does not work well with `position:absolute`
    *   on a subgrid child.
    *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
    */ 
const $5185f3afa6ef08e0$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $5185f3afa6ef08e0$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
} /**
   * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
   *
   * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
   * expanded content for ExpandableMenuItem.
   */ 
const $5185f3afa6ef08e0$var$MenuItemBaseNoRef = ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $6BXcn.useLevel)();
    const setFlyoutMenuOpen = (0, $5TK70.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $5TK70.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $42omo.useRef)(null);
    const descriptionRef = (0, $42omo.useRef)(null);
    const tooltipOnClick = (0, $42omo.useRef)(null);
    const handleClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent); // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]); /**
                                                       * Show the tooltip if _either_ label or description is truncated
                                                       */ 
    const canTooltipAppear = (0, $42omo.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
         // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $5185f3afa6ef08e0$var$isTextClamped(label)) return true;
        return Boolean(description && $5185f3afa6ef08e0$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]); // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $6hmpf.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // This extends the clickable area of nested menu items to the width
    , {
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: `calc(-1 * ${level} * ${(0, $k2So4.expandableMenuItemIndentation)})`
        },
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$textStyles.root,
            !showElemBefore && $5185f3afa6ef08e0$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "medium",
        maxLines: 1,
        color: $5185f3afa6ef08e0$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: $5185f3afa6ef08e0$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)), hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xzqO.DragHandle), null) : null, dropIndicator); /**
           *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
           *
           * Note: we also remove the `elemAfter` when showing `actionsOnHover`
           */ 
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGs3F.AvatarContext).Provider, {
        value: $5185f3afa6ef08e0$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$containerStyles.root,
            $5185f3afa6ef08e0$var$nestedOpenPopupStyles.root,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $5185f3afa6ef08e0$var$containerStyles.rootT26Shape,
            isSelected && $5185f3afa6ef08e0$var$containerStyles.selected,
            isSelected && $5185f3afa6ef08e0$var$nestedOpenPopupStyles.selected,
            isDragging && $5185f3afa6ef08e0$var$containerStyles.dragging,
            description && $5185f3afa6ef08e0$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && $5185f3afa6ef08e0$var$containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && $5185f3afa6ef08e0$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $5185f3afa6ef08e0$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            actionsOnHover && elemAfter && $5185f3afa6ef08e0$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $5185f3afa6ef08e0$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, description) : null),
        position: "right-start",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered for the menu item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>{
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = {
            ...tooltipProps,
            'aria-controls': ariaControls,
            'aria-haspopup': ariaHasPopup,
            ref: (0, $3654r.default)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id: id,
            testId: testId,
            interactionName: interactionName
        };
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $1bHXt.cx)($5185f3afa6ef08e0$var$buttonOrAnchorStyles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.rootT26Shape, $5185f3afa6ef08e0$var$topLevelSiblingStyles.root, isSelected && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.selected, hasDragIndicator && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.hasDragIndicator),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                textDecoration: 'none'
            },
            "aria-current": isSelected ? 'page' : undefined,
            href: href,
            target: target,
            draggable: hasDragIndicator ? undefined : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $gMc0m.default)([
                $5185f3afa6ef08e0$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $1bHXt.cx)($5185f3afa6ef08e0$var$buttonOrAnchorStyles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.rootT26Shape, $5185f3afa6ef08e0$var$topLevelSiblingStyles.root, isSelected && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.selected, hasDragIndicator && $5185f3afa6ef08e0$var$buttonOrAnchorStyles.hasDragIndicator),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }, interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$elemBeforeStyles.root,
            $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
            $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$actionsOnHoverStyles.root
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$elemAfterStyles.root,
            $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
            $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $5185f3afa6ef08e0$var$actionStyles.root,
            $5185f3afa6ef08e0$var$topLevelSiblingStyles.root,
            $5185f3afa6ef08e0$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
}; /**
    * __MenuItemBase__
    *
    * The base menu item component used to compose ButtonMenuItem and LinkMenuItem.
    *
    * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
    * This can be inferred from the type of the `onClick` prop.
    */ 
const $5185f3afa6ef08e0$export$859b390bf71e044e = (0, $3hoG4.default)($5185f3afa6ef08e0$var$MenuItemBaseNoRef);
module.exports["MenuItemBase"] = $5185f3afa6ef08e0$export$859b390bf71e044e;

});

parcelRegister("k2So4", function(module, exports) {
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $3bd71abec4b95b70$export$d492445a79a49b48 = '12px';
module.exports["expandableMenuItemIndentation"] = $3bd71abec4b95b70$export$d492445a79a49b48;

});

parcelRegister("6xzqO", function(module, exports) {
/* drag-handle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8aNCk = parcelRequire("8aNCk");

const $1d3ac884996bbce8$var$styles = {
    root: "_syazazsu _1e0c1i3c _2lx21bp4 _1bah1h6o _kqswstnw _152tidpf _u7coidpf _1e02idpf _ahbqxmi2"
};
function $1d3ac884996bbce8$export$a0c24614540b0efb() {
    return /*#__PURE__*/ $42omo.createElement("div", {
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            $1d3ac884996bbce8$var$styles.root
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
        label: "",
        size: "small"
    }));
}
module.exports["DragHandle"] = $1d3ac884996bbce8$export$a0c24614540b0efb;

});

parcelRegister("6BXcn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $9r5xQ = parcelRequire("9r5xQ");

const $835b2725fca28696$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$572ce188c913ceba = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $835b2725fca28696$export$650d12d3c2ddb8fc = (0, $9r5xQ.ExpandableMenuItemLevelContext);
const $835b2725fca28696$export$37e565a09598825e = ()=>{
    const context = (0, $42omo.useContext)($835b2725fca28696$export$c856e5885cc34d81);
    (0, $dRnqM.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $835b2725fca28696$export$c9a171ea8de5861b = ()=>{
    const context = (0, $42omo.useContext)($835b2725fca28696$export$48cb11cb8691f597);
    (0, $dRnqM.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $835b2725fca28696$export$56c8438498b72c7a = ()=>(0, $42omo.useContext)($835b2725fca28696$export$572ce188c913ceba);
const $835b2725fca28696$export$fdfe9e5e8183d4f2 = ()=>(0, $42omo.useContext)($835b2725fca28696$export$650d12d3c2ddb8fc);
const $835b2725fca28696$export$57108b5f08ae5194 = ()=>(0, $42omo.useContext)($835b2725fca28696$export$9c01e0e6a504d553) ?? true;
module.exports["AreAllAncestorsExpandedContext"] = $835b2725fca28696$export$9c01e0e6a504d553;
module.exports["IsExpandedContext"] = $835b2725fca28696$export$c856e5885cc34d81;
module.exports["SetIsExpandedContext"] = $835b2725fca28696$export$48cb11cb8691f597;
module.exports["OnExpansionToggleContext"] = $835b2725fca28696$export$572ce188c913ceba;
module.exports["LevelContext"] = $835b2725fca28696$export$650d12d3c2ddb8fc;
module.exports["useIsExpanded"] = $835b2725fca28696$export$37e565a09598825e;
module.exports["useSetIsExpanded"] = $835b2725fca28696$export$c9a171ea8de5861b;
module.exports["useOnExpansionToggle"] = $835b2725fca28696$export$56c8438498b72c7a;
module.exports["useLevel"] = $835b2725fca28696$export$fdfe9e5e8183d4f2;
module.exports["useAreAllAncestorsExpanded"] = $835b2725fca28696$export$57108b5f08ae5194;

});

parcelRegister("9r5xQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $cd7d1982b9276331$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $42omo.createContext)(0);
module.exports["ExpandableMenuItemLevelContext"] = $cd7d1982b9276331$export$f8d6463f9b5ca897;

});

parcelRegister("5TK70", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $471f84ea38b53016$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $471f84ea38b53016$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
const $471f84ea38b53016$export$6927118f874a49aa = ()=>(0, $42omo.useContext)($471f84ea38b53016$export$efa4d9670e96ac31);
const $471f84ea38b53016$export$538ac1aa421adb94 = ()=>(0, $42omo.useContext)($471f84ea38b53016$export$4c55b1c61a116b42);
const $471f84ea38b53016$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $42omo.createContext)({
    current: null
});
const $471f84ea38b53016$export$fb4c7299c436068c = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $471f84ea38b53016$export$761b237ca835a288 = ()=>(0, $42omo.useContext)($471f84ea38b53016$export$fb4c7299c436068c);
const $471f84ea38b53016$export$9abe8108f4bc916 = $471f84ea38b53016$export$fb4c7299c436068c.Provider;
module.exports["IsOpenContext"] = $471f84ea38b53016$export$efa4d9670e96ac31;
module.exports["SetIsOpenContext"] = $471f84ea38b53016$export$4c55b1c61a116b42;
module.exports["useFlyoutMenuOpen"] = $471f84ea38b53016$export$6927118f874a49aa;
module.exports["useSetFlyoutMenuOpen"] = $471f84ea38b53016$export$538ac1aa421adb94;
module.exports["OnCloseContext"] = $471f84ea38b53016$export$7376ab1fc7707bdd;
module.exports["useTitleId"] = $471f84ea38b53016$export$761b237ca835a288;
module.exports["TitleIdContextProvider"] = $471f84ea38b53016$export$9abe8108f4bc916;

});

parcelRegister("6hmpf", function(module, exports) {
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $3c5b6d18b5aba7eb$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');
module.exports["COLLAPSE_ELEM_BEFORE"] = $3c5b6d18b5aba7eb$export$f4b8e24fae579c6f;

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("dVkip", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $j3b2C = parcelRequire("j3b2C");


var $5t9S7 = parcelRequire("5t9S7");


var $4eIcx = parcelRequire("4eIcx");


var $4H4Pj = parcelRequire("4H4Pj");


var $gW6rh = parcelRequire("gW6rh");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");


var $ep3mz = parcelRequire("ep3mz");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");

const $568e72a32d90ae8c$export$927df7988fec803 = (0, $gW6rh.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery = (0, $4H4Pj.default);
const $568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery = (0, $4eIcx.default);
const $568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery = (0, $5t9S7.default);
const $568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery = (0, $j3b2C.default);
const $568e72a32d90ae8c$var$hasCurrentSpace = (data)=>'space' in data;
const $568e72a32d90ae8c$var$isCurrentSpaceNotFoundError = (gqlError)=>gqlError.path?.[0] === 'space' && gqlError.extensions?.['statusCode'] === 404;
const $568e72a32d90ae8c$var$processStarredError = (error)=>{
    if (!error) return undefined;
    if ((0, $1uFM6.isUnauthorizedError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$var$processRecentError = (error)=>{
    if (!error) return undefined;
    /**
   * space
   *    403: Expected to occur when the user is on a restricted space
   *    404: Expected to occur when the user is on an invalid space
   * recentSpaces
   *    403: Harmless error temporarily being ignored to mitigate CONFDEV-71458.
   *         Removing in CONFDEV-71656.
   */ if ((0, $1uFM6.isUnauthorizedError)(error) || !error.networkError && error.graphQLErrors.every($568e72a32d90ae8c$var$isCurrentSpaceNotFoundError)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$export$e3e9588fd2c1abdd = (isLicensed)=>{
    const { data: starredSpacesData, loading: starredSpacesLoading, error: starredSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$export$927df7988fec803, {
        skip: !isLicensed,
        __callerPackage__: "@confluence/space-utils"
    });
    const { data: anonymousSpacesData, loading: anonymousSpacesLoading, error: anonymousSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataAnonymousSpacesQuery, {
        skip: isLicensed,
        __callerPackage__: "@confluence/space-utils"
    });
    const data = isLicensed ? starredSpacesData : anonymousSpacesData;
    const loading = isLicensed ? starredSpacesLoading : anonymousSpacesLoading;
    const error = isLicensed ? starredSpacesError : anonymousSpacesError;
    const starredSpaces = (data?.spaces?.nodes || []).filter((space)=>space != null).map((space_0)=>({
            ...space_0,
            currentUser: {
                isFavourited: isLicensed
            }
        }));
    const unexpectedError = $568e72a32d90ae8c$var$processStarredError(error);
    return {
        starredSpaces: starredSpaces,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$var$useRecentData = (isLicensed)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: myVisitedSpacesWithCurrentSpaceData, loading: myVisitedSpacesWithCurrentSpaceLoading, error: myVisitedSpacesWithCurrentSpaceError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery, {
        skip: !isLicensed || !spaceKey,
        variables: {
            selectedSpaceKey: spaceKey
        },
        errorPolicy: 'all',
        __callerPackage__: "@confluence/space-utils"
    });
    const { data: myVisitedSpacesData, loading: myVisitedSpacesLoading, error: myVisitedSpacesError } = (0, $jMyy4.useQueryInterop)($568e72a32d90ae8c$var$useSpacesDataMyVisitedSpacesQuery, {
        skip: !isLicensed || !!spaceKey,
        errorPolicy: 'all',
        __callerPackage__: "@confluence/space-utils"
    });
    const data = spaceKey ? myVisitedSpacesWithCurrentSpaceData : myVisitedSpacesData;
    const loading = spaceKey ? myVisitedSpacesWithCurrentSpaceLoading : myVisitedSpacesLoading;
    const error = spaceKey ? myVisitedSpacesWithCurrentSpaceError : myVisitedSpacesError;
    const currentSpace = data && $568e72a32d90ae8c$var$hasCurrentSpace(data) && data.space || undefined;
    const recentData = data?.myVisitedSpaces?.nodes?.spaces;
    const recentSpaces = (recentData || []).filter((space)=>space != null && (!currentSpace || currentSpace.id !== space.id));
    const unexpectedError = $568e72a32d90ae8c$var$processRecentError(error);
    return {
        recentSpaces: recentSpaces,
        currentSpace: currentSpace,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$export$680b01e9499af50d = ()=>{
    const $ = (0, $frIzR.c)(16);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { starredSpaces: starredSpaces, loading: starredLoading, error: starredError } = $568e72a32d90ae8c$export$e3e9588fd2c1abdd(isLicensed);
    const { recentSpaces: unfilteredRecents, currentSpace: currentSpace, loading: recentLoading, error: recentError } = $568e72a32d90ae8c$var$useRecentData(isLicensed);
    let t0;
    if ($[0] !== starredSpaces) {
        t0 = new Set(starredSpaces.map($568e72a32d90ae8c$var$_temp));
        $[0] = starredSpaces;
        $[1] = t0;
    } else t0 = $[1];
    const starredIds = t0;
    let t1;
    if ($[2] !== starredIds || $[3] !== unfilteredRecents) {
        let t2;
        if ($[5] !== starredIds) {
            t2 = (recent)=>!starredIds.has(recent.id);
            $[5] = starredIds;
            $[6] = t2;
        } else t2 = $[6];
        t1 = unfilteredRecents.filter(t2).slice(0, 5);
        $[2] = starredIds;
        $[3] = unfilteredRecents;
        $[4] = t1;
    } else t1 = $[4];
    const recentSpaces = t1;
    let errors;
    if ($[7] !== recentError || $[8] !== starredError) {
        errors = [];
        if (starredError) errors.push(starredError);
        if (recentError) errors.push(recentError);
        $[7] = recentError;
        $[8] = starredError;
        $[9] = errors;
    } else errors = $[9];
    const t2 = starredLoading || recentLoading;
    let t3;
    if ($[10] !== currentSpace || $[11] !== errors || $[12] !== recentSpaces || $[13] !== starredSpaces || $[14] !== t2) {
        t3 = {
            errors: errors,
            loading: t2,
            starredSpaces: starredSpaces,
            recentSpaces: recentSpaces,
            currentSpace: currentSpace
        };
        $[10] = currentSpace;
        $[11] = errors;
        $[12] = recentSpaces;
        $[13] = starredSpaces;
        $[14] = t2;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
};
const $568e72a32d90ae8c$export$ecaaf759b72f2f3d = ()=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const [executeSearch, { data: data, loading: loading, error: error }] = (0, $lvOsp.useLazyQueryInterop)($568e72a32d90ae8c$var$useSpacesDataSearchSpacesQuery, {
        __callerPackage__: "@confluence/space-utils"
    });
    const spaceSearchResults = (data?.spaces?.nodes || []).filter((space)=>space != null);
    const searchSpaces = (0, $42omo.useCallback)((pattern)=>{
        if (pattern) executeSearch({
            variables: {
                spaceNamePattern: pattern,
                isLicensed: isLicensed
            }
        });
    }, [
        executeSearch,
        isLicensed
    ]);
    return {
        spaceSearchResults: spaceSearchResults,
        loading: loading,
        error: error,
        searchSpaces: searchSpaces
    };
};
function $568e72a32d90ae8c$var$_temp(starred) {
    return starred.id;
}
module.exports["useStarredData"] = $568e72a32d90ae8c$export$e3e9588fd2c1abdd;
module.exports["useSpacesData"] = $568e72a32d90ae8c$export$680b01e9499af50d;
module.exports["useSpaceSearchData"] = $568e72a32d90ae8c$export$ecaaf759b72f2f3d;

});

parcelRegister("j3b2C", function(module, exports) {
/**
 * @generated SignedSource<<9e711ad73a62f9a0f8543203d7de991a>>
 * @relayHash 807f0e620b159313dc25553268599830
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee
const $abc61d7dc008195d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceNamePattern"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Variable",
                    "name": "spaceNamePattern",
                    "variableName": "spaceNamePattern"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourited"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpacesDataSearchSpacesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "807f0e620b159313dc25553268599830",
            "id": "70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee",
            "metadata": {},
            "name": "useSpacesDataSearchSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataSearchSpacesQuery($spaceNamePattern:String!,$isLicensed:Boolean!){spaces(first:30,status:\"current\",spaceNamePattern:$spaceNamePattern){nodes{alias,id,name,key,status,icon{path},currentUser@include(if:$isLicensed){isFavourited}}}}"
        }
    };
}();
$abc61d7dc008195d$var$node.hash = "414c959dafecb5d27ba9ddb5658cc68d";
var $abc61d7dc008195d$export$2e2bcd8739ae039 = $abc61d7dc008195d$var$node;
module.exports["default"] = $abc61d7dc008195d$export$2e2bcd8739ae039;

});

parcelRegister("5t9S7", function(module, exports) {
/**
 * @generated SignedSource<<b88a49cb82a3d0f7de8b6ed737480e33>>
 * @relayHash 6a42dba0e2f55d85a4e53a29287ca269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476
const $410f901cf69fac5d$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(first:10)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "6a42dba0e2f55d85a4e53a29287ca269",
            "id": "5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476",
            "metadata": {},
            "name": "useSpacesDataAnonymousSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataAnonymousSpacesQuery{spaces(first:10){nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$410f901cf69fac5d$var$node.hash = "7f837e22c8d2b27a827944523b07b786";
var $410f901cf69fac5d$export$2e2bcd8739ae039 = $410f901cf69fac5d$var$node;
module.exports["default"] = $410f901cf69fac5d$export$2e2bcd8739ae039;

});

parcelRegister("4eIcx", function(module, exports) {
/**
 * @generated SignedSource<<bea1cf48d37ee1b33892cabe98721384>>
 * @relayHash e0d0ca312e455dd89cba54cfb1984fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e
const $f0042d2ade0da40c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedSpaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "selectedSpaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "e0d0ca312e455dd89cba54cfb1984fbb",
            "id": "526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias,id,name,key,status,icon{path},currentUser{isFavourited}},myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$f0042d2ade0da40c$var$node.hash = "24da03b127211694c7ed862f0d6a1ac9";
var $f0042d2ade0da40c$export$2e2bcd8739ae039 = $f0042d2ade0da40c$var$node;
module.exports["default"] = $f0042d2ade0da40c$export$2e2bcd8739ae039;

});

parcelRegister("4H4Pj", function(module, exports) {
/**
 * @generated SignedSource<<ade6ac21736a6b6b2a6721140df74c9c>>
 * @relayHash 0f8f1589411c8c2d9b98218fe1edd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79
const $893f79462ca6be46$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f8f1589411c8c2d9b98218fe1edd493",
            "id": "68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$893f79462ca6be46$var$node.hash = "7082555a280d4e2eb838dda87a12b019";
var $893f79462ca6be46$export$2e2bcd8739ae039 = $893f79462ca6be46$var$node;
module.exports["default"] = $893f79462ca6be46$export$2e2bcd8739ae039;

});

parcelRegister("gW6rh", function(module, exports) {
/**
 * @generated SignedSource<<48f373f48907892540f7ed013be4c2eb>>
 * @relayHash 3aa9658e6db0cb9714f9e327bc6d5bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8
const $af8a2f26164bd677$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "favourite",
                    "value": true
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "3aa9658e6db0cb9714f9e327bc6d5bd0",
            "id": "9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8",
            "metadata": {},
            "name": "useSpacesDataStarredSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataStarredSpacesQuery{spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$af8a2f26164bd677$var$node.hash = "519f9d02cbfeb4f3f118821c02e3a7b9";
var $af8a2f26164bd677$export$2e2bcd8739ae039 = $af8a2f26164bd677$var$node;
module.exports["default"] = $af8a2f26164bd677$export$2e2bcd8739ae039;

});

parcelRegister("lvOsp", function(module, exports) {

var $jxs8y = parcelRequire("jxs8y");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $9x4nt = parcelRequire("9x4nt");


var $422HI = parcelRequire("422HI");


var $26Yfd = parcelRequire("26Yfd");


var $kczYx = parcelRequire("kczYx");


var $iffSy = parcelRequire("iffSy");


var $3NBsC = parcelRequire("3NBsC");


var $5T18X = parcelRequire("5T18X");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/** Synced-each-render ref; no microtask lag. */ function $278c8d04dad7bc1d$var$useSyncedRef(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
/**
 * Coerce an unknown thrown value into an ApolloErrorInterop so callers can
 * read Apollo's `graphQLErrors` / `networkError` fields uniformly across the
 * Apollo and Relay branches.
 */ function $278c8d04dad7bc1d$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $278c8d04dad7bc1d$var$getOperationName(node) {
    if ('definitions' in node) {
        const def = node.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return def?.name?.value ?? 'unknown';
    }
    return 'unknown';
}
function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__)) // eslint-disable-next-line react-hooks/rules-of-hooks -- branch stable per build
    return $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options);
    const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
    // eslint-disable-next-line react-hooks/rules-of-hooks -- branch stable per build
    return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
        ...apolloOptions,
        ...interopApolloAggClient ? {
            client: window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']
        } : {},
        context: {
            ...apolloOptions?.context,
            requestId: query.params?.id
        }
    });
}
function $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${$278c8d04dad7bc1d$var$getOperationName(query)}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $irOoi.useRelayEnvironment)();
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__);
    const hookContext = options?.context;
    const initialFetchPolicy = options?.fetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.fetchPolicy) : undefined;
    const subsequentFetchPolicy = options?.nextFetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.nextFetchPolicy) : initialFetchPolicy;
    const onError = (0, $26Yfd.useStableCallback)(options?.onError ?? function noop() {});
    const onCompleted = (0, $26Yfd.useStableCallback)(options?.onCompleted ?? function noop() {});
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [called, setCalled] = (0, $42omo.useState)(false);
    // Mirrors Apollo's `variables` from the most recent invocation.
    const [activeVariables, setActiveVariables] = (0, $42omo.useState)(hookVariables);
    const isMountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Sequencing counters discard out-of-order responses.
    const executeIdRef = (0, $42omo.useRef)(0);
    const fetchMoreIdRef = (0, $42omo.useRef)(0);
    // hookContext is unmemoised; data/activeVariables can change mid-fetchMore via a concurrent execute.
    const hookContextRef = $278c8d04dad7bc1d$var$useSyncedRef(hookContext);
    const dataRef = $278c8d04dad7bc1d$var$useSyncedRef(data);
    const activeVarsRef = $278c8d04dad7bc1d$var$useSyncedRef(activeVariables);
    const ufoContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const operationName = `relay_${query.params?.name ?? 'unnamed'}`;
    (0, $42omo.useEffect)(()=>{
        if (called && loading) return ufoContext?.hold(operationName);
    }, [
        called,
        loading,
        operationName,
        ufoContext
    ]);
    const execute = (0, $42omo.useCallback)((executeOptions)=>{
        const variables = executeOptions?.variables ?? hookVariables;
        const context = {
            ...hookContextRef.current,
            ...executeOptions?.context
        };
        // First execute uses fetchPolicy, re-invocations use nextFetchPolicy.
        const isFirstCall = executeIdRef.current === 0;
        executeIdRef.current += 1;
        // Invalidate any in-flight fetchMore so it can't merge into fresh execute data.
        fetchMoreIdRef.current += 1;
        const id = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === executeIdRef.current;
        setCalled(true);
        setActiveVariables(variables);
        setLoading(true);
        setError(undefined);
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            fetchPolicy: isFirstCall ? initialFetchPolicy : subsequentFetchPolicy,
            networkCacheConfig: {
                metadata: context
            }
        }).toPromise().then((result)=>{
            if (!isStillCurrent()) return;
            setLoading(false);
            if (result !== undefined) {
                setData(result);
                setError(undefined);
                onCompleted(result);
                return;
            }
            // Store-only cache miss: surface so callers aren't left indeterminate.
            const err = $278c8d04dad7bc1d$var$toApolloError(new Error('[Relay migration] fetchQuery resolved with no data (likely a store-only cache miss)'));
            setError(err);
            onError(err);
        }).catch((rawErr)=>{
            if (!isStillCurrent()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            setLoading(false);
            onError(err);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        hookVariables,
        initialFetchPolicy,
        subsequentFetchPolicy,
        onCompleted,
        onError
    ]);
    const fetchMore = (0, $42omo.useCallback)((fetchMoreOpts)=>{
        const variables = {
            ...activeVarsRef.current,
            ...fetchMoreOpts.variables
        };
        fetchMoreIdRef.current += 1;
        const id = fetchMoreIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === fetchMoreIdRef.current;
        setLoading(true);
        return (0, $kczYx.fetchQuery)(environment, query, variables, {
            // fetchMore must always hit the network (matches Apollo); cached pages would be stale.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }).toPromise().then((fetchMoreResult)=>{
            // Throw so .catch handles it (avoids double onError).
            if (fetchMoreResult === undefined) throw new Error('[Relay migration] fetchMore resolved with no data (likely a store-only cache miss)');
            const merged = fetchMoreOpts.updateQuery(dataRef.current ?? {}, {
                fetchMoreResult: fetchMoreResult,
                variables: variables
            });
            if (isStillCurrent()) {
                setData(merged);
                setLoading(false);
                setError(undefined);
            }
            return {
                data: merged,
                loading: false,
                networkStatus: (0, $5T18X.NetworkStatus).ready,
                stale: false
            };
        }).catch((rawErr)=>{
            // onError gated by isStillCurrent (matches execute); re-throw for Apollo's contract.
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            if (isStillCurrent()) {
                setError(err);
                setLoading(false);
                onError(err);
            }
            throw err;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (activeVarsRef, dataRef, hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        onError
    ]);
    // Lazy hooks don't auto-poll; no-op for Apollo signature parity.
    const stopPolling = (0, $42omo.useCallback)(()=>{}, []);
    // Cast: Apollo's overloaded fetchMore is structurally a superset of FetchMoreType.
    return [
        execute,
        {
            data: data,
            loading: loading,
            error: error,
            called: called,
            variables: activeVariables,
            fetchMore: fetchMore,
            stopPolling: stopPolling
        }
    ];
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $gMc0m.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eG6LW", function(module, exports) {

let $aafa3dc60b4951fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aafa3dc60b4951fc$var$load("6wr18"),
    $aafa3dc60b4951fc$var$load("lRtGG"),
    $aafa3dc60b4951fc$var$load("ffEVr"),
    $aafa3dc60b4951fc$var$load("830Zv")
]).then(()=>parcelRequire('lC5h8'));

});

parcelRegister("7Ri6A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jZM59 = parcelRequire("jZM59");

const $4f1b92ba2c91b695$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $42omo.useContext)((0, $jZM59.SidebarResizeContext));
    return context;
};
module.exports["usePageLayoutResize"] = $4f1b92ba2c91b695$export$10c7104037a7af62;

});

parcelRegister("jZM59", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $42omo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
module.exports["SidebarResizeContext"] = $e6220385bdb59eee$export$aa5a712eea4c2ae8;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("7boqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("1uFsv", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $ee0fdcfc2b35384d$export$b79a5979472006ce = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.GLOBAL_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["GLOBAL_NAVIGATION_METRIC"] = $ee0fdcfc2b35384d$export$b79a5979472006ce;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $cbc8g.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
$parcel$export(module.exports, "createBM3PageSegmentLoadMetricRaw", () => $864083edfead32eb$export$2a2fe1e11b4e0413);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");

const { pageSegmentLoad: $864083edfead32eb$export$2a2fe1e11b4e0413 } = (0, $kyiqo.metrics);

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("vkc68", function(module, exports) {

let $05e28f7fabca8dc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05e28f7fabca8dc0$var$load("4KvE8"),
    $05e28f7fabca8dc0$var$load("lo4Uk"),
    $05e28f7fabca8dc0$var$load("dafa3"),
    $05e28f7fabca8dc0$var$load("kHOMt"),
    $05e28f7fabca8dc0$var$load("6wr18"),
    $05e28f7fabca8dc0$var$load("15bnM"),
    $05e28f7fabca8dc0$var$load("9XOeB"),
    $05e28f7fabca8dc0$var$load("81eQE"),
    $05e28f7fabca8dc0$var$load("6S3Gy"),
    $05e28f7fabca8dc0$var$load("a9w2G"),
    $05e28f7fabca8dc0$var$load("hyzoX"),
    $05e28f7fabca8dc0$var$load("9a2oY"),
    $05e28f7fabca8dc0$var$load("3GuOt"),
    $05e28f7fabca8dc0$var$load("Wowvf"),
    $05e28f7fabca8dc0$var$load("ffEVr"),
    $05e28f7fabca8dc0$var$load("iEUHW"),
    $05e28f7fabca8dc0$var$load("kFiBp"),
    $05e28f7fabca8dc0$var$load("cD5e0")
]).then(()=>parcelRequire('C9t7g'));

});

parcelRegister("2qRJj", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $7boqA = parcelRequire("7boqA");


var $ENihE = parcelRequire("ENihE");


var $aWrnw = parcelRequire("aWrnw");

const $662218afe73e5a2d$var$separatorStyles = null;
const $662218afe73e5a2d$var$separatorStylesFallback = null;

const $662218afe73e5a2d$export$d97a74b7c2565df0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcP7O",
    name: "SpaceNavigationLoader",
    loader: async ()=>(await (parcelRequire("2oymb"))).SpaceNavigation,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        })
});
const $662218afe73e5a2d$export$a91923d0186f609a = (props)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itze3t _1mouze3t _195gxmi2 _n7zlia51"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itidpf _1mouze3t _195gxmi2 _n7zlia51"
            ])
        });
        $[0] = t0;
    } else t0 = $[0];
    const separatorHr = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_NAVIGATION_METRIC)
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, separatorHr, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($662218afe73e5a2d$export$d97a74b7c2565df0, props));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $662218afe73e5a2d$export$d4aec89b198b6129 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            loader: true
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["SpaceNavigationLoader"] = $662218afe73e5a2d$export$d97a74b7c2565df0;
module.exports["SpaceNavigation"] = $662218afe73e5a2d$export$a91923d0186f609a;
module.exports["SpaceNavigationLoadingSkeleton"] = $662218afe73e5a2d$export$d4aec89b198b6129;

});

parcelRegister("ENihE", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $a0Wth = parcelRequire("a0Wth");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a59a0b51f845364$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _bfhkvuon _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1y6m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_vchhusvi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$SkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isloadingState: isloadingState, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx286ug _4t3i1ylp _u5f3u2gc",
            __cmplp.isloadingState ? "_19bvf6fq" : "_19bv19bv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _bfhkvkf5 _1o9zidpf _4t3i1tcg _2hwxpxbi _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$var$Line = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _4t3i7vkz _1bsb68cl _bfhkvkf5",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2a59a0b51f845364$export$73d04a98c9062109 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { header: t1, loader: loader } = t0;
    const header = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== header || $[1] !== loader) {
        t2 = loader && header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0Wth.SpaceHeaderSkeleton), null) : null;
        $[0] = header;
        $[1] = loader;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] !== loader) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t3, t4);
        $[5] = loader;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[7] = t6;
        $[8] = t7;
    } else {
        t6 = $[7];
        t7 = $[8];
    }
    let t8;
    if ($[9] !== loader) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t6, t7);
        $[9] = loader;
        $[10] = t8;
    } else t8 = $[10];
    let t10;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    let t11;
    if ($[13] !== loader) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t9, t10);
        $[13] = loader;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[15] = t12;
        $[16] = t13;
    } else {
        t12 = $[15];
        t13 = $[16];
    }
    let t14;
    if ($[17] !== loader) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t12, t13);
        $[17] = loader;
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    let t16;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Circle, null);
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Line, null);
        $[19] = t15;
        $[20] = t16;
    } else {
        t15 = $[19];
        t16 = $[20];
    }
    let t17;
    if ($[21] !== loader) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonLine, {
            isloadingState: loader
        }, t15, t16);
        $[21] = loader;
        $[22] = t17;
    } else t17 = $[22];
    let t18;
    if ($[23] !== t11 || $[24] !== t14 || $[25] !== t17 || $[26] !== t2 || $[27] !== t5 || $[28] !== t8) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2a59a0b51f845364$var$SkeletonContainer, {
            "data-testid": "sidebar-skeleton"
        }, t2, t5, t8, t11, t14, t17));
        $[23] = t11;
        $[24] = t14;
        $[25] = t17;
        $[26] = t2;
        $[27] = t5;
        $[28] = t8;
        $[29] = t18;
    } else t18 = $[29];
    return t18;
});
module.exports["ContainerSkeleton"] = $2a59a0b51f845364$export$73d04a98c9062109;

});

parcelRegister("a0Wth", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fd8870c1509e72c$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4183j _4cvr1h6o _vchhusvi _1e0c1txw _1bsb1ijo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceIconSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1qi0 _1bsb1tcg _4t3i1tcg _bfhkvkf5 _2hwxf6fq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4fd8870c1509e72c$var$SpaceTitleSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _1bsb1w81 _4t3i7vkz _bfhkvkf5",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $4fd8870c1509e72c$export$76f5179c9c39352c() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fd8870c1509e72c$var$SkeletonContainer, {
            "data-testid": "space-header-skeleton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fd8870c1509e72c$var$SpaceIconSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4fd8870c1509e72c$var$SpaceTitleSkeleton, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
module.exports["SpaceHeaderSkeleton"] = $4fd8870c1509e72c$export$76f5179c9c39352c;

});

parcelRegister("aWrnw", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("2oymb", function(module, exports) {

let $1be8793671196af2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1be8793671196af2$var$load("e4XZ1"),
    $1be8793671196af2$var$load("iEUHW"),
    $1be8793671196af2$var$load("daX4F"),
    $1be8793671196af2$var$load("7EorR"),
    $1be8793671196af2$var$load("aYgZt")
]).then(()=>parcelRequire('absYu'));

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("hFuXC"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("hFuXC", function(module, exports) {

let $cdce481da9c47d1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdce481da9c47d1c$var$load("e1RjR"),
    $cdce481da9c47d1c$var$load("hhss7"),
    $cdce481da9c47d1c$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<ccf01a471b3f103a7f9b7d03914777ce>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "7c791401f0e963cfa78bdcff70a3c87c";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("4T2bk", function(module, exports) {

let $38edfdbc3dc1e53b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38edfdbc3dc1e53b$var$load("fSc0b").then(()=>parcelRequire('vavBY'));

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "@confluence/onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    }
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $42omo.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $42omo.useRef)(undefined);
    const data = (0, $42omo.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<c53781d55d04bcd0c7414229d1ce8a1a>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("l1uFv", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    if ((0, $iffSy.isRelayEnabled)(params.__callerPackage__)) return $65c7b8940c778902$var$readQueryInteropRelay(params);
    else return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    if (!relayEnv) return null;
    const source = relayEnv.getStore().getSource();
    const rootRecord = source.get((0, $3e6Uc.ROOT_ID));
    if (!rootRecord) return null;
    const queryNode = params.query;
    const queryFields = queryNode?.operation?.selections;
    if (!queryFields) return null;
    const variables = params.variables ?? {};
    return $65c7b8940c778902$var$readFields(source, (0, $3e6Uc.ROOT_ID), queryFields, variables);
}
function $65c7b8940c778902$var$getFieldKey(field, variables) {
    // Relay pre-computes `storageKey` for fields whose arguments can be resolved at compile
    // time (typically literal-only args). When present, prefer it as the canonical key —
    // it's guaranteed to match the key Relay actually used when writing to the store.
    if (field.storageKey) return field.storageKey;
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments. Relay's internal `getStorageKey`
    // always sorts arguments alphabetically by name (see relay-runtime/store/RelayStoreUtils),
    // so we must do the same to match the key Relay used when writing to the store.
    const args = field.args.slice().sort((a, b)=>a.name.localeCompare(b.name)).map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readFields(source, recordId, fields, variables) {
    const record = source.get(recordId);
    if (!record) return null;
    const data = {};
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Handle @include/@skip directives with variables
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) {
                const conditionalData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
                if (conditionalData) Object.assign(data, conditionalData);
            }
        } else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldKey = $65c7b8940c778902$var$getFieldKey(linkedField, variables);
            const linkedRef = record[fieldKey];
            if (linkedField.plural) {
                // Relay stores plural refs in two shapes:
                //  - canonical: { __refs: ['id1', 'id2', ...] }
                //  - tolerated: [{ __ref: 'id1' }, { __ref: 'id2' }]
                if (linkedRef && typeof linkedRef === 'object' && !Array.isArray(linkedRef) && Array.isArray(linkedRef.__refs)) {
                    const refs = linkedRef.__refs;
                    data[linkedField.name] = refs.map((id)=>id ? $65c7b8940c778902$var$readFields(source, id, linkedField.selections, variables) : null);
                } else if (Array.isArray(linkedRef)) data[linkedField.name] = linkedRef.map((ref)=>{
                    if (ref && typeof ref === 'object' && '__ref' in ref) return $65c7b8940c778902$var$readFields(source, ref.__ref, linkedField.selections, variables);
                    return null;
                });
                else data[linkedField.name] = null;
            } else if (linkedRef && typeof linkedRef === 'object' && '__ref' in linkedRef) data[linkedField.name] = $65c7b8940c778902$var$readFields(source, linkedRef.__ref, linkedField.selections, variables);
            else data[linkedField.name] = null;
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const fieldKey = $65c7b8940c778902$var$getFieldKey(scalarField, variables);
            data[scalarField.name] = record[fieldKey];
        } else if (field.kind === 'InlineFragment') {
            // Process all inline fragment selections
            const inlineData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
            if (inlineData) Object.assign(data, inlineData);
        }
    // Other selection kinds (e.g., FragmentSpread, ClientExtension) are ignored —
    // readQuery only needs to traverse what the query operation directly selects.
    }
    return data;
}
/* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("fEmGS", function(module, exports) {

var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return (0, $iffSy.isRelayEnabled)(params.__callerPackage__) ? $f0827a369f0dafa9$var$writeQueryInteropRelay(params) : $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$9b71507da8cc81c3 = 'first-ever-view:hasSeenAutoShowAnalytics';
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    $3c94963df51c0e13$export$9b71507da8cc81c3,
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["PROMPT_DATABASE_COMPETITOR_LINK"] = $3c94963df51c0e13$export$5b471e2344a37be7;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["HAS_SEEN_AUTO_SHOW_ANALYTICS"] = $3c94963df51c0e13$export$9b71507da8cc81c3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("b0EGa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $9wGTI = parcelRequire("9wGTI");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0,
    hasReceivedHideRequest: false
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1,
                ...(0, $9wGTI.fg)('cc-engagement-omnibar-transition-fix') && {
                    hasReceivedHideRequest: true
                }
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $1P1Tu.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$13aafec54f1ab41c = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hasReceivedHideRequest
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $9zUhf.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useHasReceivedOmniBarHideRequest"] = $6d5fb7464c13acdf$export$13aafec54f1ab41c;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("fRvBq", function(module, exports) {

let $b8c451d9f981703e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8c451d9f981703e$var$load("4KvE8"),
    $b8c451d9f981703e$var$load("lo4Uk"),
    $b8c451d9f981703e$var$load("dafa3"),
    $b8c451d9f981703e$var$load("kHOMt"),
    $b8c451d9f981703e$var$load("60m6Z"),
    $b8c451d9f981703e$var$load("6wr18"),
    $b8c451d9f981703e$var$load("15bnM"),
    $b8c451d9f981703e$var$load("9XOeB"),
    $b8c451d9f981703e$var$load("iQ4FP"),
    $b8c451d9f981703e$var$load("6S3Gy"),
    $b8c451d9f981703e$var$load("a9w2G"),
    $b8c451d9f981703e$var$load("hyzoX"),
    $b8c451d9f981703e$var$load("9a2oY"),
    $b8c451d9f981703e$var$load("iNa18"),
    $b8c451d9f981703e$var$load("3GuOt"),
    $b8c451d9f981703e$var$load("hhss7"),
    $b8c451d9f981703e$var$load("Wowvf"),
    $b8c451d9f981703e$var$load("ffEVr"),
    $b8c451d9f981703e$var$load("7EorR"),
    $b8c451d9f981703e$var$load("iEUHW"),
    $b8c451d9f981703e$var$load("kFiBp"),
    $b8c451d9f981703e$var$load("9IEev")
]).then(()=>parcelRequire('7dXG0'));

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

function $e1a1ee666860bb23$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("141Kq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $62841e239617d5e4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $57b8ef09e6472437$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};


var $62841e239617d5e4$export$2e2bcd8739ae039 = (0, $57b8ef09e6472437$export$2e2bcd8739ae039);

});

parcelRegister("6yQVJ", function(module, exports) {

let $4c6ef9e5e74dd184$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c6ef9e5e74dd184$var$load("5iVCs").then(()=>parcelRequire('5xx4Y'));

});

parcelRegister("bzSID", function(module, exports) {

let $86dd689af41ba059$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86dd689af41ba059$var$load("k7RZQ").then(()=>parcelRequire('hAVgU'));

});

parcelRegister("2FP6T", function(module, exports) {

let $1f270e83f32cb461$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f270e83f32cb461$var$load("9CFJc").then(()=>parcelRequire('lk8G1'));

});

parcelRegister("25qh2", function(module, exports) {

let $18506dd820d78f5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18506dd820d78f5b$var$load("3fPuK").then(()=>parcelRequire('aR1vS'));

});

parcelRegister("3tbTt", function(module, exports) {

let $286d4e6469420b68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $286d4e6469420b68$var$load("dUyEb").then(()=>parcelRequire('cryKi'));

});

parcelRegister("5HmEI", function(module, exports) {

let $42628adeb16c1acd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42628adeb16c1acd$var$load("PAD2J").then(()=>parcelRequire('6UEa7'));

});

parcelRegister("2JrHA", function(module, exports) {

let $1fd545cce82aadd1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fd545cce82aadd1$var$load("GNuQo").then(()=>parcelRequire('eMR6r'));

});

parcelRegister("7K1vi", function(module, exports) {

let $5a2dfeea5ec5d421$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a2dfeea5ec5d421$var$load("fvsAU").then(()=>parcelRequire('lqRs8'));

});

parcelRegister("lvhk9", function(module, exports) {

let $fa79ee67eedd7f9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa79ee67eedd7f9c$var$load("h7dGJ").then(()=>parcelRequire('abQPO'));

});

parcelRegister("dolI8", function(module, exports) {

let $9bfe5b94426f2bc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9bfe5b94426f2bc1$var$load("kg6sH").then(()=>parcelRequire('koNv9'));

});

parcelRegister("hqns1", function(module, exports) {

let $caf70e3c2540bb6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf70e3c2540bb6b$var$load("fqF5W").then(()=>parcelRequire('lHGQG'));

});

parcelRegister("1vs1T", function(module, exports) {

let $118e6dc5e8cffb51$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $118e6dc5e8cffb51$var$load("1WNp5").then(()=>parcelRequire('hfuHa'));

});

parcelRegister("BAT91", function(module, exports) {

let $07101216ee604e5b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07101216ee604e5b$var$load("iHPxa").then(()=>parcelRequire('4M9Uw'));

});

parcelRegister("l079O", function(module, exports) {

let $f49f26543ad6bdf7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f49f26543ad6bdf7$var$load("Qf3VH").then(()=>parcelRequire('8jbH9'));

});

parcelRegister("jEFBo", function(module, exports) {

let $e4f2060beb20487f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4f2060beb20487f$var$load("79OEV").then(()=>parcelRequire('4zJCj'));

});

parcelRegister("gTjoB", function(module, exports) {

let $c4c0d3fbc9057528$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4c0d3fbc9057528$var$load("27dMt").then(()=>parcelRequire('h0wiX'));

});

parcelRegister("kq4sh", function(module, exports) {

let $edd9b112db2caa32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $edd9b112db2caa32$var$load("bkVVv").then(()=>parcelRequire('fARzr'));

});

parcelRegister("bbLxs", function(module, exports) {

let $825598f47ca268c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $825598f47ca268c9$var$load("MLhYA").then(()=>parcelRequire('7wkkR'));

});

parcelRegister("gfPHN", function(module, exports) {

let $bd5627a8923fc90c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd5627a8923fc90c$var$load("ap7kW").then(()=>parcelRequire('7Ud5x'));

});

parcelRegister("gMTmr", function(module, exports) {

let $c38c128fb79e0a80$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c38c128fb79e0a80$var$load("45YAR").then(()=>parcelRequire('dyiwH'));

});

parcelRegister("6ZJsB", function(module, exports) {

let $517bb411b7d3988c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $517bb411b7d3988c$var$load("kqhVG").then(()=>parcelRequire('i54xW'));

});

parcelRegister("dDMw7", function(module, exports) {

let $9ee48d5fc1aa3060$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ee48d5fc1aa3060$var$load("1susf").then(()=>parcelRequire('6kAMA'));

});

parcelRegister("c4U6C", function(module, exports) {

let $8cb1612c1183126f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8cb1612c1183126f$var$load("aquXY").then(()=>parcelRequire('ffYaF'));

});

parcelRegister("bbzob", function(module, exports) {

let $824c2c56cd8c0a11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $824c2c56cd8c0a11$var$load("dl3k2").then(()=>parcelRequire('cIqRB'));

});

parcelRegister("B2ZFV", function(module, exports) {

let $06f5c750a8f0ee3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $06f5c750a8f0ee3a$var$load("lTK3c"),
    $06f5c750a8f0ee3a$var$load("1WXdc"),
    $06f5c750a8f0ee3a$var$load("5V8sC"),
    $06f5c750a8f0ee3a$var$load("57oeB"),
    $06f5c750a8f0ee3a$var$load("6wr18"),
    $06f5c750a8f0ee3a$var$load("eDzF0"),
    $06f5c750a8f0ee3a$var$load("5uN9h"),
    $06f5c750a8f0ee3a$var$load("ffEVr"),
    $06f5c750a8f0ee3a$var$load("hhss7"),
    $06f5c750a8f0ee3a$var$load("7EorR"),
    $06f5c750a8f0ee3a$var$load("Wowvf"),
    $06f5c750a8f0ee3a$var$load("cRtGo"),
    $06f5c750a8f0ee3a$var$load("gY1B8")
]).then(()=>parcelRequire('gFKFJ'));

});

parcelRegister("eGUIL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $42omo.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("lpfM9", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $d8af34c11b1c225c$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceRightPanelBundle'
    });
};

const $d8af34c11b1c225c$export$bec010aa49373196 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mQOM4",
    name: "PanelLoader",
    loader: async ()=>(await (parcelRequire("47IvD"))).RightPanel,
    loading: $d8af34c11b1c225c$var$createLoadingComponent
});
module.exports["PanelLoader"] = $d8af34c11b1c225c$export$bec010aa49373196;

});

parcelRegister("47IvD", function(module, exports) {

let $300a577b1cbe72e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $300a577b1cbe72e9$var$load("7TbZ2"),
    $300a577b1cbe72e9$var$load("5V8sC"),
    $300a577b1cbe72e9$var$load("57oeB"),
    $300a577b1cbe72e9$var$load("6wr18"),
    $300a577b1cbe72e9$var$load("5UCxV"),
    $300a577b1cbe72e9$var$load("dwSiO"),
    $300a577b1cbe72e9$var$load("2O2Xv"),
    $300a577b1cbe72e9$var$load("i3R6S"),
    $300a577b1cbe72e9$var$load("gdwbX"),
    $300a577b1cbe72e9$var$load("cmqxT"),
    $300a577b1cbe72e9$var$load("9ijrN"),
    $300a577b1cbe72e9$var$load("3BYXV"),
    $300a577b1cbe72e9$var$load("c251E"),
    $300a577b1cbe72e9$var$load("k3Ays"),
    $300a577b1cbe72e9$var$load("1MINO"),
    $300a577b1cbe72e9$var$load("37ldp"),
    $300a577b1cbe72e9$var$load("hhss7"),
    $300a577b1cbe72e9$var$load("cyGuT"),
    $300a577b1cbe72e9$var$load("ffEVr"),
    $300a577b1cbe72e9$var$load("5sTNh"),
    $300a577b1cbe72e9$var$load("jOUAD"),
    $300a577b1cbe72e9$var$load("6bVVs"),
    $300a577b1cbe72e9$var$load("7mo6o"),
    $300a577b1cbe72e9$var$load("hkt44"),
    $300a577b1cbe72e9$var$load("7EorR"),
    $300a577b1cbe72e9$var$load("Wowvf"),
    $300a577b1cbe72e9$var$load("cRtGo"),
    $300a577b1cbe72e9$var$load("cvXSy")
]).then(()=>parcelRequire('8CeBV'));

});

parcelRegister("j5cB3", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cOrQJ = parcelRequire("cOrQJ");


const $43c705326a57355f$export$c720381daa58fcbb = ()=>{
    const $ = (0, $frIzR.c)(2);
    const adsTheme = (0, $cOrQJ.default)();
    let t0;
    if ($[0] !== adsTheme) {
        t0 = adsTheme;
        $[0] = adsTheme;
        $[1] = t0;
    } else t0 = $[1];
    const effectiveTheme = t0;
    return effectiveTheme?.colorMode === "dark";
};
module.exports["useIsDarkMode"] = $43c705326a57355f$export$c720381daa58fcbb;

});

parcelRegister("1ReH7", function(module, exports) {

let $15a623b7b3228855$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15a623b7b3228855$var$load("kNFat").then(()=>parcelRequire('iETFY'));

});

parcelRegister("emNvf", function(module, exports) {
/**
 * @generated SignedSource<<bf3ac8b157c5d7612b0c9678f84533c0>>
 * @relayHash d82ceab955fc558f582faba05877ecf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03
const $34dcc93d00ac09e9$var$node = function() {
    var v0 = [
        {
            "concreteType": "LookAndFeelSettings",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "custom",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HeaderLookAndFeel",
                            "kind": "LinkedField",
                            "name": "horizontalHeader",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundColor"
                                },
                                {
                                    "concreteType": "NavigationLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "primaryNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "highlightColor"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ThemeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d82ceab955fc558f582faba05877ecf8",
            "id": "765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03",
            "metadata": {},
            "name": "ThemeQuery",
            "operationKind": "query",
            "text": "query ThemeQuery{lookAndFeel{custom{horizontalHeader{backgroundColor,primaryNavigation{highlightColor}}}}}"
        }
    };
}();
$34dcc93d00ac09e9$var$node.hash = "1e70f0bab96233984a0d61d455b5303b";
var $34dcc93d00ac09e9$export$2e2bcd8739ae039 = $34dcc93d00ac09e9$var$node;
module.exports["default"] = $34dcc93d00ac09e9$export$2e2bcd8739ae039;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("cLgYq", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");

const $80f6c4cf061c88c5$export$909966f260e2b2b = (articleId, setArticleId, routeName, setRouteName, routeGroup, setRouteGroup)=>({
        getArticleId: ()=>articleId,
        setArticleId: setArticleId,
        getRouteName: ()=>routeName,
        setRouteName: setRouteName,
        getRouteGroup: ()=>routeGroup,
        setRouteGroup: setRouteGroup
    });
const $80f6c4cf061c88c5$var$initialInProductHelpState = {
    articleId: '',
    routeName: '',
    routeGroup: ''
};
const $80f6c4cf061c88c5$var$inProductHelpActions = {
    setArticleId: (articleId)=>({ setState: setState })=>{
            setState({
                articleId: articleId
            });
        },
    setRouteName: (routeName)=>({ setState: setState })=>{
            setState({
                routeName: routeName
            });
        },
    setRouteGroup: (routeGroup)=>({ setState: setState })=>{
            setState({
                routeGroup: routeGroup
            });
        }
};
const $80f6c4cf061c88c5$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$80f6c4cf061c88c5$var$initialInProductHelpState
    },
    actions: $80f6c4cf061c88c5$var$inProductHelpActions,
    name: 'inProductHelpContext'
});
const $80f6c4cf061c88c5$export$d9f3a3de6974e16a = (0, $9zUhf.createActionsHook)($80f6c4cf061c88c5$var$Store);
const $80f6c4cf061c88c5$export$b1fca540f7ef5476 = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.articleId
});
const $80f6c4cf061c88c5$export$15e1d4730ce65e9d = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeName
});
const $80f6c4cf061c88c5$export$1dfb78b8caec7720 = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeGroup
});
const $80f6c4cf061c88c5$export$a611b87b3ebe1475 = (0, $FOT9i.createContainer)($80f6c4cf061c88c5$var$Store, {
    onInit: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        },
    onUpdate: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        }
});
const $80f6c4cf061c88c5$export$a61d77bd8effd79e = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($80f6c4cf061c88c5$export$a611b87b3ebe1475, null, children);
};
module.exports["useInProductHelpActions"] = $80f6c4cf061c88c5$export$d9f3a3de6974e16a;
module.exports["useInProductHelpArticleId"] = $80f6c4cf061c88c5$export$b1fca540f7ef5476;
module.exports["InProductHelpProvider"] = $80f6c4cf061c88c5$export$a61d77bd8effd79e;

});

parcelRegister("hPTbh", function(module, exports) {
/**
 * Centralized analytics constants for the snippets package.
 *
 * Organized into three sections:
 *   1. Shared    – source, event types, origins, page modes (used by all events)
 *   2. UI        – subjects, actions, subject IDs, modal outcomes (sendUIEvent)
 *   3. Operational – subjects, actions (sendOperationalEvent)
 */ // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  Shared
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
/** Event type used to dispatch analytics events */ var $2394c5239b489cef$export$a0913705d36eb84c = /*#__PURE__*/ function(ANALYTICS_EVENT_TYPE) {
    ANALYTICS_EVENT_TYPE["SEND_UI_EVENT"] = "sendUIEvent";
    ANALYTICS_EVENT_TYPE["SEND_OPERATIONAL_EVENT"] = "sendOperationalEvent";
    ANALYTICS_EVENT_TYPE["SEND_TRACK_EVENT"] = "sendTrackEvent";
    return ANALYTICS_EVENT_TYPE;
}({});
var $2394c5239b489cef$export$17897eee0c3e7eb1 = /*#__PURE__*/ function(ANALYTICS_TYPE) {
    ANALYTICS_TYPE["UI"] = "ui";
    ANALYTICS_TYPE["OPERATIONAL"] = "operational";
    return ANALYTICS_TYPE;
}({});
const $2394c5239b489cef$export$f7109619a5e9e0d6 = 'confluenceSnippets';
var $2394c5239b489cef$export$8dd55f56fde129aa = /*#__PURE__*/ function(ANALYTICS_ORIGIN) {
    // snippet CRUD modals
    ANALYTICS_ORIGIN["CREATE_SNIPPET_MODAL"] = "createSnippetModal";
    ANALYTICS_ORIGIN["EDIT_SNIPPET_MODAL"] = "editSnippetModal";
    ANALYTICS_ORIGIN["DUPLICATE_SNIPPET_MODAL"] = "duplicateSnippetModal";
    ANALYTICS_ORIGIN["DELETE_SNIPPET_MODAL"] = "deleteSnippetModal";
    // onboarding
    ANALYTICS_ORIGIN["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // surfaces
    ANALYTICS_ORIGIN["SNIPPET_PANEL"] = "snippetPanel";
    ANALYTICS_ORIGIN["SNIPPET_GALLERY"] = "snippetGallery";
    // toolbars / menus
    ANALYTICS_ORIGIN["CONTEXTUAL_TOOLBAR"] = "contextualToolbar";
    ANALYTICS_ORIGIN["BLOCK_MENU"] = "blockMenu";
    return ANALYTICS_ORIGIN;
}({});
var $2394c5239b489cef$export$b397791890e3384b = /*#__PURE__*/ function(ANALYTICS_CREATE_SOURCE) {
    ANALYTICS_CREATE_SOURCE["EMPTY_PANEL"] = "snippetPanelEmpty";
    ANALYTICS_CREATE_SOURCE["SNIPPET_PANEL_LIST"] = "snippetPanelCreateItem";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_VIEW"] = "snippetHighlightView";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_EDIT"] = "snippetHighlightEdit";
    return ANALYTICS_CREATE_SOURCE;
}({});
var $2394c5239b489cef$export$a23e6d34a2dcf281 = /*#__PURE__*/ function(ANALYTICS_PAGE_MODE) {
    ANALYTICS_PAGE_MODE["VIEW"] = "view";
    ANALYTICS_PAGE_MODE["EDIT"] = "edit";
    ANALYTICS_PAGE_MODE["LIVE"] = "live";
    return ANALYTICS_PAGE_MODE;
}({});
var $2394c5239b489cef$export$eeb695ba3667fc27 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT) {
    ANALYTICS_UI_SUBJECT["BUTTON"] = "button";
    ANALYTICS_UI_SUBJECT["MODAL"] = "modal";
    ANALYTICS_UI_SUBJECT["TEXT_FIELD"] = "textField";
    ANALYTICS_UI_SUBJECT["DROPDOWN_ITEM"] = "dropdownItem";
    ANALYTICS_UI_SUBJECT["SNIPPETS"] = "snippets";
    return ANALYTICS_UI_SUBJECT;
}({});
var $2394c5239b489cef$export$2fdff18978b1ec73 = /*#__PURE__*/ function(ANALYTICS_UI_ACTION) {
    ANALYTICS_UI_ACTION["CLICKED"] = "clicked";
    ANALYTICS_UI_ACTION["CLOSED"] = "closed";
    ANALYTICS_UI_ACTION["TYPED"] = "typed";
    return ANALYTICS_UI_ACTION;
}({});
var $2394c5239b489cef$export$f6034aaa561169a2 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT_ID) {
    // button
    ANALYTICS_UI_SUBJECT_ID["CREATE_SNIPPET"] = "createSnippet";
    ANALYTICS_UI_SUBJECT_ID["DELETE_SNIPPET"] = "deleteSnippet";
    ANALYTICS_UI_SUBJECT_ID["EDIT_SNIPPET"] = "editSnippet";
    ANALYTICS_UI_SUBJECT_ID["DUPLICATE_SNIPPET"] = "duplicateSnippet";
    ANALYTICS_UI_SUBJECT_ID["INSERT_SNIPPET"] = "insertSnippet";
    ANALYTICS_UI_SUBJECT_ID["COPY_SNIPPET_LINK"] = "copySnippetLink";
    ANALYTICS_UI_SUBJECT_ID["USE_SNIPPET_DETAIL_PANEL"] = "useSnippetDetailPanel";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    // textField / button / dropdownItem (filter-related)
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_CATEGORY_FILTER"] = "snippetCategoryFilter";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SEARCH"] = "snippetSearch";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SORT_ORDER"] = "snippetSortOrder";
    // FirstSnippetCreatedModal (use attributes for viewed vs dismissed and dismissalAction)
    ANALYTICS_UI_SUBJECT_ID["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // Empty state primary actions
    ANALYTICS_UI_SUBJECT_ID["EMPTY_MY_TEMPLATES_CALL_TO_ACTION"] = "emptyMyTemplatesCallToAction";
    ANALYTICS_UI_SUBJECT_ID["EMPTY_FAVORITES_CALL_TO_ACTION"] = "emptyFavoritesCallToAction";
    return ANALYTICS_UI_SUBJECT_ID;
}({});
var $2394c5239b489cef$export$4d76a1418128341e = /*#__PURE__*/ function(MODAL_TYPE) {
    MODAL_TYPE["CREATE"] = "CREATE";
    MODAL_TYPE["EDIT"] = "EDIT";
    MODAL_TYPE["DUPLICATE"] = "DUPLICATE";
    return MODAL_TYPE;
}({});
var $2394c5239b489cef$export$42a4ee1a85ef55d2 = /*#__PURE__*/ function(MODAL_OUTCOME) {
    MODAL_OUTCOME["CREATED"] = "created";
    MODAL_OUTCOME["EDITED"] = "edited";
    MODAL_OUTCOME["DUPLICATED"] = "duplicated";
    MODAL_OUTCOME["DELETED"] = "deleted";
    MODAL_OUTCOME["CANCELLED"] = "cancelled";
    MODAL_OUTCOME["CLOSED"] = "closed";
    return MODAL_OUTCOME;
}({});
var $2394c5239b489cef$export$3c94fecf7ead2464 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_SUBJECT) {
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    ANALYTICS_OPERATIONAL_SUBJECT["INSERT_SNIPPET"] = "insertSnippet";
    // API failures
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_CREATE"] = "snippetApiCreate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DUPLICATE"] = "snippetApiDuplicate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UPDATE"] = "snippetApiUpdate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DELETE"] = "snippetApiDelete";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_FETCH"] = "snippetApiFetch";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SHARE"] = "snippetApiShare";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UNSHARE"] = "snippetApiUnshare";
    // API successes
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SAVE_SUCCESS"] = "snippetApiSaveSuccess";
    // AI metadata
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_AI_METADATA"] = "snippetApiAiMetadata";
    // Client-side errors
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_ADF_SERIALIZATION"] = "snippetAdfSerialization";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_PREVIEW_RENDER"] = "snippetPreviewRender";
    return ANALYTICS_OPERATIONAL_SUBJECT;
}({});
var $2394c5239b489cef$export$2fd2c1b71075f9e9 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_ACTION) {
    ANALYTICS_OPERATIONAL_ACTION["FAILED"] = "failed";
    ANALYTICS_OPERATIONAL_ACTION["SUCCEEDED"] = "succeeded";
    ANALYTICS_OPERATIONAL_ACTION["FETCHED"] = "fetched";
    return ANALYTICS_OPERATIONAL_ACTION;
}({});
var $2394c5239b489cef$export$81f6ba2af7de9934 = /*#__PURE__*/ function(ANALYTICS_TRACK_SUBJECT) {
    ANALYTICS_TRACK_SUBJECT["SNIPPET_API_SHARE_CLAIM"] = "snippetApiShareClaim";
    return ANALYTICS_TRACK_SUBJECT;
}({});
var $2394c5239b489cef$export$986b2565e3fbcaf4 = /*#__PURE__*/ function(ANALYTICS_TRACK_ACTION) {
    ANALYTICS_TRACK_ACTION["CLAIMED"] = "claimed";
    return ANALYTICS_TRACK_ACTION;
}({});
module.exports["ANALYTICS_EVENT_TYPE"] = $2394c5239b489cef$export$a0913705d36eb84c;
module.exports["ANALYTICS_TYPE"] = $2394c5239b489cef$export$17897eee0c3e7eb1;
module.exports["ANALYTICS_SOURCE"] = $2394c5239b489cef$export$f7109619a5e9e0d6;
module.exports["ANALYTICS_ORIGIN"] = $2394c5239b489cef$export$8dd55f56fde129aa;
module.exports["ANALYTICS_CREATE_SOURCE"] = $2394c5239b489cef$export$b397791890e3384b;
module.exports["ANALYTICS_PAGE_MODE"] = $2394c5239b489cef$export$a23e6d34a2dcf281;
module.exports["ANALYTICS_UI_SUBJECT"] = $2394c5239b489cef$export$eeb695ba3667fc27;
module.exports["ANALYTICS_UI_ACTION"] = $2394c5239b489cef$export$2fdff18978b1ec73;
module.exports["ANALYTICS_UI_SUBJECT_ID"] = $2394c5239b489cef$export$f6034aaa561169a2;
module.exports["MODAL_TYPE"] = $2394c5239b489cef$export$4d76a1418128341e;
module.exports["MODAL_OUTCOME"] = $2394c5239b489cef$export$42a4ee1a85ef55d2;
module.exports["ANALYTICS_OPERATIONAL_SUBJECT"] = $2394c5239b489cef$export$3c94fecf7ead2464;
module.exports["ANALYTICS_OPERATIONAL_ACTION"] = $2394c5239b489cef$export$2fd2c1b71075f9e9;
module.exports["ANALYTICS_TRACK_SUBJECT"] = $2394c5239b489cef$export$81f6ba2af7de9934;
module.exports["ANALYTICS_TRACK_ACTION"] = $2394c5239b489cef$export$986b2565e3fbcaf4;

});

parcelRegister("jxXkP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $inPa6 = parcelRequire("inPa6");


var $hPTbh = parcelRequire("hPTbh");

const $5d19246504a43db4$export$8076fd3f013c4bb9 = (origin)=>{
    const $ = (0, $frIzR.c)(32);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== origin) {
        t0 = (attributes)=>{
            if (!origin) return attributes;
            return {
                origin: origin,
                ...attributes
            };
        };
        $[0] = origin;
        $[1] = t0;
    } else t0 = $[1];
    const mergeAttributes = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== mergeAttributes) {
        t1 = (data)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_UI_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).UI,
                    ...data,
                    attributes: mergeAttributes(data.attributes)
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = mergeAttributes;
        $[4] = t1;
    } else t1 = $[4];
    const fireUIAnalytic = t1;
    let t2;
    if ($[5] !== createAnalyticsEvent || $[6] !== mergeAttributes) {
        t2 = (data_0)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_OPERATIONAL_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).OPERATIONAL,
                    ...data_0,
                    attributes: mergeAttributes(data_0.attributes)
                }
            }).fire();
        };
        $[5] = createAnalyticsEvent;
        $[6] = mergeAttributes;
        $[7] = t2;
    } else t2 = $[7];
    const fireOperationalAnalytic = t2;
    let t3;
    if ($[8] !== createAnalyticsEvent || $[9] !== mergeAttributes) {
        t3 = (data_1)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_TRACK_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    ...data_1,
                    attributes: mergeAttributes(data_1.attributes)
                }
            }).fire();
        };
        $[8] = createAnalyticsEvent;
        $[9] = mergeAttributes;
        $[10] = t3;
    } else t3 = $[10];
    const fireTrackAnalytic = t3;
    let t4;
    if ($[11] !== fireUIAnalytic) {
        t4 = (actionSubjectId, attributes_0)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).BUTTON,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId,
                attributes: attributes_0
            });
        };
        $[11] = fireUIAnalytic;
        $[12] = t4;
    } else t4 = $[12];
    const fireButtonClickedAnalytic = t4;
    let t5;
    if ($[13] !== fireUIAnalytic) {
        t5 = (actionSubjectId_0, attributes_1)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).MODAL,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLOSED,
                actionSubjectId: actionSubjectId_0,
                attributes: attributes_1
            });
        };
        $[13] = fireUIAnalytic;
        $[14] = t5;
    } else t5 = $[14];
    const fireModalClosedAnalytic = t5;
    let t6;
    if ($[15] !== fireUIAnalytic) {
        t6 = (actionSubjectId_1, attributes_2)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).TEXT_FIELD,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).TYPED,
                actionSubjectId: actionSubjectId_1,
                attributes: attributes_2
            });
        };
        $[15] = fireUIAnalytic;
        $[16] = t6;
    } else t6 = $[16];
    const fireTextFieldTypedAnalytic = t6;
    let t7;
    if ($[17] !== fireUIAnalytic) {
        t7 = (actionSubjectId_2, attributes_3)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).DROPDOWN_ITEM,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId_2,
                attributes: attributes_3
            });
        };
        $[17] = fireUIAnalytic;
        $[18] = t7;
    } else t7 = $[18];
    const fireDropdownItemClickedAnalytic = t7;
    let t8;
    if ($[19] !== fireOperationalAnalytic) {
        t8 = (actionSubject, attributes_4)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FAILED,
                attributes: attributes_4
            });
        };
        $[19] = fireOperationalAnalytic;
        $[20] = t8;
    } else t8 = $[20];
    const fireFailedAnalytic = t8;
    let t9;
    if ($[21] !== fireOperationalAnalytic) {
        t9 = (actionSubject_0, attributes_5)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject_0,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).SUCCEEDED,
                attributes: attributes_5
            });
        };
        $[21] = fireOperationalAnalytic;
        $[22] = t9;
    } else t9 = $[22];
    const fireSuccessAnalytic = t9;
    let t10;
    if ($[23] !== fireButtonClickedAnalytic || $[24] !== fireDropdownItemClickedAnalytic || $[25] !== fireFailedAnalytic || $[26] !== fireModalClosedAnalytic || $[27] !== fireOperationalAnalytic || $[28] !== fireSuccessAnalytic || $[29] !== fireTextFieldTypedAnalytic || $[30] !== fireTrackAnalytic) {
        t10 = {
            fireOperationalAnalytic: fireOperationalAnalytic,
            fireTrackAnalytic: fireTrackAnalytic,
            fireButtonClickedAnalytic: fireButtonClickedAnalytic,
            fireModalClosedAnalytic: fireModalClosedAnalytic,
            fireTextFieldTypedAnalytic: fireTextFieldTypedAnalytic,
            fireDropdownItemClickedAnalytic: fireDropdownItemClickedAnalytic,
            fireFailedAnalytic: fireFailedAnalytic,
            fireSuccessAnalytic: fireSuccessAnalytic
        };
        $[23] = fireButtonClickedAnalytic;
        $[24] = fireDropdownItemClickedAnalytic;
        $[25] = fireFailedAnalytic;
        $[26] = fireModalClosedAnalytic;
        $[27] = fireOperationalAnalytic;
        $[28] = fireSuccessAnalytic;
        $[29] = fireTextFieldTypedAnalytic;
        $[30] = fireTrackAnalytic;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
};
module.exports["useSnippetAnalytics"] = $5d19246504a43db4$export$8076fd3f013c4bb9;

});

parcelRegister("cYuYM", function(module, exports) {

var $5vi32 = parcelRequire("5vi32");


var $9bL1w = parcelRequire("9bL1w");

const $955ee3c4efc889bc$export$349f17fbd3b37cd1 = ()=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    return !!(isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled);
};
module.exports["useIsSnippetCreateEnabled"] = $955ee3c4efc889bc$export$349f17fbd3b37cd1;

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("9bL1w", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $9VQUw.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo') && (0, $9wGTI.fg)('jira_linked_confluence_doc_rovo_nudge_gate');
    const showShare = (0, $9wGTI.fg)('csm_ai_enable_share_feature') && allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("9VQUw", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

const $4ea72974304e25a5$export$1acbaeb6a9a6bc40 = (0, $hpNab.ALLOWED_FEATURES).view;
const $4ea72974304e25a5$export$2c7469b01e61fde2 = (0, $hpNab.ALLOWED_FEATURES).edit;
const $4ea72974304e25a5$export$72afc086e90eb0bf = (0, $hpNab.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $4ea72974304e25a5$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $4ea72974304e25a5$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $4ea72974304e25a5$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iV5Ic = parcelRequire("iV5Ic");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $42omo.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $42omo.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("gKr8t", function(module, exports) {

var $9wEpK = parcelRequire("9wEpK");


var $5v4fk = parcelRequire("5v4fk");


var $guZe9 = parcelRequire("guZe9");


var $jxz2A = parcelRequire("jxz2A");


var $jWs8F = parcelRequire("jWs8F");


var $6mKj3 = parcelRequire("6mKj3");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");


var $kbzou = parcelRequire("kbzou");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)({
    isForAggOnly: true
});
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $jWs8F.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    if ((0, $6mKj3.expValEquals)('cfe_use_persisted_queries_apollo', 'isEnabled', true)) links.push((0, $kbzou.requestIdLink));
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $jxz2A.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $5v4fk.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $guZe9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        !Boolean(undefined);
    }, // WebSocket link for subscriptions
    (0, $5v4fk.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $5v4fk.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9wEpK.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $5v4fk.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $5v4fk = parcelRequire("5v4fk");


var $lB1H3 = parcelRequire("lB1H3");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $5v4fk.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $5v4fk.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $lB1H3.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $lB1H3.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $5v4fk = parcelRequire("5v4fk");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $5v4fk.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/** Used for built-in method references. */ var $3e1566926de40aab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e1566926de40aab$var$hasOwnProperty = $3e1566926de40aab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $w287Y(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$3e1566926de40aab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $9rfkh(object, path);
    return obj == null || delete obj[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("dYU3e", function(module, exports) {


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");




var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__ }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    let single;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    if ((0, $9wGTI.fg)('confluence_preloader_query_interop')) return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    // `client.query` only accepts the narrower `FetchPolicy` (no `cache-and-network`/`standby`).
    // Map the watch-only values to the closest one-shot equivalent.
    const oneShotFetchPolicy = fetchPolicy === 'cache-and-network' || fetchPolicy === 'standby' ? 'cache-first' : fetchPolicy;
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return client.query({
        query: query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: oneShotFetchPolicy,
        context: queryContext
    }).then((result)=>{
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
        return {
            ...result,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("lyWac", function(module, exports) {

var $3mugH = parcelRequire("3mugH");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') {
                const fulfilledValue = result.value;
                if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                else if (Array.isArray(fulfilledValue)) {
                    const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                    errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                }
            }
        }
        if (errors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return errors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = [
    ...Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575)
];
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("hAiCi", function(module, exports) {
/**
 * @generated SignedSource<<efd83134fde9a46873ebc67a729b698d>>
 * @relayHash 03c88593e0a708b4a806a4bb00935330
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee
const $1d80fc45612ce410$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "value"
    }, v1 = [
        {
            "concreteType": "SiteConfiguration",
            "kind": "LinkedField",
            "name": "siteConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customSiteLogo"
                }
            ]
        },
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "siteTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "showApplicationTitle"
                }
            ]
        },
        {
            "concreteType": "SiteDescription",
            "kind": "LinkedField",
            "name": "siteDescription",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "logoUrl"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        v0 /*: any*/ 
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "TopNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "03c88593e0a708b4a806a4bb00935330",
            "id": "2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee",
            "metadata": {},
            "name": "TopNavigationQuery",
            "operationKind": "query",
            "text": "query TopNavigationQuery{siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary},photos{value}}}"
        }
    };
}();
$1d80fc45612ce410$var$node.hash = "58252cd5493d65d590f00c523b3d3ad8";
var $1d80fc45612ce410$export$2e2bcd8739ae039 = $1d80fc45612ce410$var$node;
module.exports["default"] = $1d80fc45612ce410$export$2e2bcd8739ae039;

});

parcelRegister("74VX5", function(module, exports) {
/**
 * @generated SignedSource<<3bf1b1cf04e940c7b7e1b0462969e94a>>
 * @relayHash 13e9ccffd4783d3489f7fdc0bdb79076
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8
const $7964c46f2f85665b$var$node = function() {
    var v0 = [
        {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "unseenNotificationCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "NotificationsButtonQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "13e9ccffd4783d3489f7fdc0bdb79076",
            "id": "9825211d02e39b5f9de725d0593139171b700fa0cd37c30b76eba16becc62de8",
            "metadata": {},
            "name": "NotificationsButtonQuery",
            "operationKind": "query",
            "text": "query NotificationsButtonQuery{notifications{unseenNotificationCount}}"
        }
    };
}();
$7964c46f2f85665b$var$node.hash = "942a544fd139c706378825d031824679";
var $7964c46f2f85665b$export$2e2bcd8739ae039 = $7964c46f2f85665b$var$node;
module.exports["default"] = $7964c46f2f85665b$export$2e2bcd8739ae039;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<99243770d7843a9bcd6325c5cf3c6efa>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("19w2x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("hHhbz", function(module, exports) {

var $5O1YC = parcelRequire("5O1YC");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/workspace/manifest.ts
var $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5O1YC.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $5O1YC.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ce23c8815c812c15$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ce23c8815c812c15$export$d47d8a7e69df1865;

});

parcelRegister("5O1YC", function(module, exports) {
// src/confluence/workspace/types.ts
var $43a327cfc847ac6c$export$19f1a63686ec0369 = "confluence", $43a327cfc847ac6c$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $43a327cfc847ac6c$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $43a327cfc847ac6c$export$f1c423a93fbc71;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $iEfsZ = parcelRequire("iEfsZ");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        },
        __callerPackage__: "@confluence/web-item-location"
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            },
            __callerPackage__: "@confluence/web-item-location"
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    const result = (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables,
        __callerPackage__: "@confluence/web-item-location"
    });
    // When fetching multiple locations in a single batched request, the result is cached
    // under the combined array key { location: null, locations: [...] }. However, consumers
    // (e.g. <WebItemLocation location={SYSTEM_USER} />) query with individual location keys
    // { location: 'system.user', locations: [] }, causing a cache miss.
    // To fix this, we split the batched result and write each location's sections back into
    // the cache under its individual key so consumers get a cache hit.
    // Split and store in cache for any location batch.
    if ((0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true)) {
        if (Array.isArray(location)) result.then(({ data: data })=>{
            if (data?.webItemSections) {
                // Write batched cache key with all sections so consumers using
                // the array variables also get a cache hit
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $iEfsZ.default),
                    variables: {
                        location: null,
                        locations: location,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        version: version
                    },
                    data: {
                        webItemSections: data.webItemSections
                    },
                    __callerPackage__: "@confluence/web-item-location"
                });
                // Write individual cache keys for each location so consumers using
                // single location variables (e.g. <WebItemLocation location={SYSTEM_USER} />)
                // also get a cache hit
                location.forEach((loc)=>{
                    (0, $fEmGS.writeQueryInterop)({
                        query: (0, $iEfsZ.default),
                        variables: {
                            location: loc,
                            locations: [],
                            contentId: contentId,
                            spaceKey: spaceKey,
                            version: version
                        },
                        data: {
                            webItemSections: data.webItemSections?.filter((section)=>section?.id?.includes(loc))
                        },
                        __callerPackage__: "@confluence/web-item-location"
                    });
                });
            }
        });
    }
    return result;
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<2835de3dfc12defdb25dd8893b73b398>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<7e9a878d08bf5ce37193671bfd42e66e>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("aT8im", function(module, exports) {

var $5wdey = parcelRequire("5wdey");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1o4fX = parcelRequire("1o4fX");


var $7Sm4c = parcelRequire("7Sm4c");





var $ivb8S = parcelRequire("ivb8S");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $318f5483656bcff4$export$cf07606bc08d56a7 = 'growth-luna-edition-awareness-standard-to-premium:treatmentPillDismissed';
const $318f5483656bcff4$var$UseConfluenceStandardToPremiumExperimentQuery = (0, $5wdey.default);
const $318f5483656bcff4$export$f2e766b4a1af4c38 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($318f5483656bcff4$var$UseConfluenceStandardToPremiumExperimentQuery, {
        variables: {
            key: [
                $318f5483656bcff4$export$cf07606bc08d56a7
            ]
        },
        fetchPolicy: 'cache-only',
        __callerPackage__: "@confluence/experiment-edition-awareness-for-standard-to-premium"
    });
    const { edition: confluenceEdition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: $318f5483656bcff4$export$cf07606bc08d56a7,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'ea-standard-to-premium-query',
                source: 'useConfluenceStandardToPremiumExperiment',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    // Exposure fired earlier in experiment when they see EA
    const enrolled = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'control') || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('edition_awareness_standard_upsell_confluence_ab', 'cohort', 'treatment');
    const isSiteAdmin = data?.isSiteAdmin;
    const edition = confluenceEdition?.toLocaleLowerCase();
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(data?.license?.trialEndDate);
    const isInTrial = !data || loading || error ? undefined : trialDaysLeft ? trialDaysLeft > 0 : false;
    const firstPredunningEndTime = data?.license?.firstPredunningEndTime;
    const isInPreDunning = firstPredunningEndTime ? Date.now() < firstPredunningEndTime : false;
    const { treatmentPillDismissed: treatmentPillDismissed } = (0, $ivb8S.deserializeState)(data?.onboardingState ? {
        onboardingState: data?.onboardingState
    } : null);
    const isDismissed = loading || !!error || !!treatmentPillDismissed;
    const isEligibleForUpsellExperiment = enrolled && edition === 'standard' && isInTrial === false && !isInPreDunning && !!isSiteAdmin;
    return {
        isEligibleForUpsellExperiment: isEligibleForUpsellExperiment,
        cloudId: cloudId,
        product: 'confluence',
        edition: edition,
        userRoles: isSiteAdmin ? [
            'SITE_ADMIN'
        ] : [],
        hasDismissedButton: isDismissed,
        onDismissButton: handleDismiss
    };
};
module.exports["EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED"] = $318f5483656bcff4$export$cf07606bc08d56a7;
module.exports["useConfluenceStandardToPremiumExperiment"] = $318f5483656bcff4$export$f2e766b4a1af4c38;

});

parcelRegister("5wdey", function(module, exports) {
/**
 * @generated SignedSource<<1a2677925535995504babdc500a14831>>
 * @relayHash 8dc51dcb846862aa9c8f8929ac2aebfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 53d89db9d85056eef82787d8d31a7893b60114ad98b36ee3758ba073330b2852
const $6015d94d40bd1aa0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        },
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "trialEndDate"
                },
                {
                    "kind": "ScalarField",
                    "name": "firstPredunningEndTime"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConfluenceStandardToPremiumExperimentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConfluenceStandardToPremiumExperimentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8dc51dcb846862aa9c8f8929ac2aebfd",
            "id": "53d89db9d85056eef82787d8d31a7893b60114ad98b36ee3758ba073330b2852",
            "metadata": {},
            "name": "useConfluenceStandardToPremiumExperimentQuery",
            "operationKind": "query",
            "text": "query useConfluenceStandardToPremiumExperimentQuery($key:[String]){isSiteAdmin,onboardingState(key:$key){key,value},license{trialEndDate,firstPredunningEndTime}}"
        }
    };
}();
$6015d94d40bd1aa0$var$node.hash = "3dcc62a6c345897ba2c1f5872f6a9096";
var $6015d94d40bd1aa0$export$2e2bcd8739ae039 = $6015d94d40bd1aa0$var$node;
module.exports["default"] = $6015d94d40bd1aa0$export$2e2bcd8739ae039;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "@confluence/loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7bddefba16e0e3fb2655c6e8a82785c2>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<ce6a8bce73876f32a04d2f7fd2550f0b>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8Z78B = parcelRequire("8Z78B");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        }
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $lMdlY = parcelRequire("lMdlY");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("4UYoK", function(module, exports) {
/**
 * Onboarding-state keys for the spotlight that is anchored to the Universal
 * Create menu dropdown shown the first time a user in the Universal Create
 * (CwR) experiment cohort opens the create menu.
 */ const $88afb75838a9f8b5$export$134ea9981ab0c82e = {
    hasSeenUniversalCreateCwRExperimentSpotlight: 'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight'
};
const $88afb75838a9f8b5$export$5b55ba0fa31f0184 = [
    ...Object.values($88afb75838a9f8b5$export$134ea9981ab0c82e)
];
module.exports["UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS"] = $88afb75838a9f8b5$export$134ea9981ab0c82e;
module.exports["UniversalCreateCwRExperimentSpotlightOnboardingKeys"] = $88afb75838a9f8b5$export$5b55ba0fa31f0184;

});

parcelRegister("cxu5H", function(module, exports) {

var $hpNab = parcelRequire("hpNab");

var $9VQUw = parcelRequire("9VQUw");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $hpNab.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $9VQUw.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId,
        __callerPackage__: "@confluence/entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<ad0100fe29e950a1379a2ddc53821b8d>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<47caf30fb1e1105daac0e1107cd5ed40>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<f845cfcec4db37305d62ff3698bca4f3>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<bba9a13a8c149665bd220be9731de503>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("ilSNM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af5bdeaecdb0e37d55178bb1e6c281ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5c4b2a6e8ca72fd$var$_react = $d5c4b2a6e8ca72fd$var$_interopRequireDefault((parcelRequire("42omo")));

var $d5c4b2a6e8ca72fd$var$_baseNew = $d5c4b2a6e8ca72fd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d5c4b2a6e8ca72fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5c4b2a6e8ca72fd$var$LogInIcon = (props)=>/*#__PURE__*/ $d5c4b2a6e8ca72fd$var$_react.default.createElement($d5c4b2a6e8ca72fd$var$_baseNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$d5c4b2a6e8ca72fd$var$LogInIcon.displayName = 'LogInIcon';
var $d5c4b2a6e8ca72fd$var$_default = module.exports.default = $d5c4b2a6e8ca72fd$var$LogInIcon;

});

parcelRegister("kNHXO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55422f7c50559ad266d0694af3ada2f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f24a7c82f1a8c849$var$_react = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("42omo")));

var $f24a7c82f1a8c849$var$_baseNew = $f24a7c82f1a8c849$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f24a7c82f1a8c849$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f24a7c82f1a8c849$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $f24a7c82f1a8c849$var$_react.default.createElement($f24a7c82f1a8c849$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$f24a7c82f1a8c849$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $f24a7c82f1a8c849$var$_default = module.exports.default = $f24a7c82f1a8c849$var$AppSwitcherIcon;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("9nm2F"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("9nm2F", function(module, exports) {

let $6d375c24bac8fa1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d375c24bac8fa1d$var$load("5V8sC"),
    $6d375c24bac8fa1d$var$load("57oeB"),
    $6d375c24bac8fa1d$var$load("hkt44"),
    $6d375c24bac8fa1d$var$load("lPtG0"),
    $6d375c24bac8fa1d$var$load("6YfM6"),
    $6d375c24bac8fa1d$var$load("6wr18"),
    $6d375c24bac8fa1d$var$load("ffEVr"),
    $6d375c24bac8fa1d$var$load("iivLa"),
    $6d375c24bac8fa1d$var$load("ajMch"),
    $6d375c24bac8fa1d$var$load("kFiBp"),
    $6d375c24bac8fa1d$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("8rneB", function(module, exports) {

var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("kNUwp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dwp40 = parcelRequire("dwp40");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $25BDS = parcelRequire("25BDS");


var $7I6bH = parcelRequire("7I6bH");

const $c1ef33da072a3fc0$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ef33da072a3fc0$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ef33da072a3fc0$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ef33da072a3fc0$export$19524a749d98a458 = 'search-config';
const $c1ef33da072a3fc0$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ef33da072a3fc0$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch, update: $c1ef33da072a3fc0$var$update3pCache } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$44d1e7c4ef26c467
});
const $c1ef33da072a3fc0$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ef33da072a3fc0$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ef33da072a3fc0$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ef33da072a3fc0$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ef33da072a3fc0$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {};
    if ((0, $dh538.fg)('rovo-search-config-endpoints-operation-name')) queryParams['operationName'] = 'searchPageFirstPartyConfig';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ef33da072a3fc0$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {};
    if ((0, $dh538.fg)('rovo-search-config-endpoints-operation-name')) queryParams['operationName'] = 'searchPageThirdPartyConfig';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $7I6bH.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $7I6bH.generate3pHash)(userId, cloudId);
    return $c1ef33da072a3fc0$var$update3pCache(key.toString(), updater);
};
const $c1ef33da072a3fc0$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $25BDS.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ef33da072a3fc0$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ef33da072a3fc0$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ef33da072a3fc0$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ef33da072a3fc0$export$46e3d34ee7b8c58a;

});

parcelRegister("2qzBQ", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $44766eafbe4aebec$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $44766eafbe4aebec$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $44766eafbe4aebec$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $44766eafbe4aebec$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $44766eafbe4aebec$export$5c07a4287a46fa1f;

});

parcelRegister("jnPv4", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $5G9KX = parcelRequire("5G9KX");


var $6jKOp = parcelRequire("6jKOp");


var $3WVPu = parcelRequire("3WVPu");


var $5b4k9 = parcelRequire("5b4k9");


var $YBuvR = parcelRequire("YBuvR");

const $582af5ffd704fa53$export$e89e805418f4d2c = (args)=>{
    const { name: name } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
	 * NOTE: Scope control (QS-9209)
	 *
	 * The storage adapter system is introduced specifically so the combined search config cache
	 * can participate in host-provided persistence (e.g., Confluence SSR local storage).
	 *
	 * The combined config experiment (`search_combined_config`, QS-9091) must be enabled for the
	 * adapter system to be used.
	 */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5b4k9.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $5G9KX.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $5G9KX.setLocalStorageItem)(key, value)
    };
    function isCombinedConfigEnabled() {
        return (0, $c6GJD.default).getExperimentValue('search_combined_config', 'isEnabled', false) === true;
    }
    function shouldUseAdapterSystemForThisCache() {
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY && isCombinedConfigEnabled();
    }
    const getCacheInstance = ()=>{
        /**
		 * We lazily create the cache instance to avoid the issue in SSR
		 * where the localStorage isn't available.
		 */ if (!cacheInstance) {
            cacheInstance = (0, $3WVPu.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $YBuvR.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold (e.g. gate transition from direct localStorage
                    // to StorageManager) or the factory isn't registered yet, fall back to the
                    // raw localStorage key. This ensures stale-but-present data from the
                    // pre-transition era is served immediately rather than blocking on the network
                    // and potentially timing out the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $YBuvR.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $5G9KX.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $6jKOp.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $582af5ffd704fa53$export$e89e805418f4d2c;

});

parcelRegister("5G9KX", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $c4TO3 = parcelRequire("c4TO3");

const $34a6846e1e43ece9$export$5aa524d86254b4f = (key, value)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).setItem(key, value);
    else localStorage.setItem(key, value);
};
const $34a6846e1e43ece9$export$93d719890ad66653 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $34a6846e1e43ece9$export$5df15f289f441790 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? item : null;
};
const $34a6846e1e43ece9$export$baf306891f1b93bd = (key)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).removeItem(key);
    else localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $34a6846e1e43ece9$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $34a6846e1e43ece9$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $34a6846e1e43ece9$export$5df15f289f441790;

});

parcelRegister("6jKOp", function(module, exports) {
const $cb37190253d46910$var$NOT_AVAILABLE = 'not_available';
const $cb37190253d46910$export$fca3401e33379daf = (result)=>{
    if (result && typeof result === 'object' && 'extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            traceId: gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $cb37190253d46910$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $cb37190253d46910$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $cb37190253d46910$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $cb37190253d46910$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $cb37190253d46910$export$4acb28c262cd52bd;

});

parcelRegister("3WVPu", function(module, exports) {
const $fc16ad90038db0a8$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $fc16ad90038db0a8$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $fc16ad90038db0a8$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $fc16ad90038db0a8$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $fc16ad90038db0a8$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $fc16ad90038db0a8$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $fc16ad90038db0a8$export$8bedcca5bbd73999 = (args)=>{
    return new $fc16ad90038db0a8$var$Cache(args);
};
module.exports["getInstance"] = $fc16ad90038db0a8$export$8bedcca5bbd73999;

});

parcelRegister("3Tbc2", function(module, exports) {

var $fQifp = parcelRequire("fQifp");

const $3c05ea8f13f2fd4c$export$ff01cc10d3c607be = 6000; // default timeout
const $3c05ea8f13f2fd4c$var$DEGRADE_ERROR = new (0, $fQifp.DegradeError)('Promise is degraded');
class $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $3c05ea8f13f2fd4c$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($3c05ea8f13f2fd4c$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9;

});

parcelRegister("fQifp", function(module, exports) {
class $821f2e34e1284477$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $821f2e34e1284477$export$85bf8e4fb143676a;

});

parcelRegister("25BDS", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $5eb733f1658cb27e$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $5eb733f1658cb27e$export$42b67d93e908c9dc;

});

parcelRegister("7I6bH", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $bf230724a07e1336$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $bf230724a07e1336$export$f80795c7fd0ce9fc;

});

parcelRegister("gpcGZ", function(module, exports) {


const $67ec6358bf4d159a$export$a0110d095394669e = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    Talent: 'radar'
};
const $67ec6358bf4d159a$export$deaa7a6e1403419a = Object.values($67ec6358bf4d159a$export$a0110d095394669e);
const $67ec6358bf4d159a$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $67ec6358bf4d159a$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($67ec6358bf4d159a$export$a93cddd79e3ea530).includes(key);
};
module.exports["ProductKeys1P"] = $67ec6358bf4d159a$export$a0110d095394669e;
module.exports["ARI_EXTRACTED_1P_KEYS"] = $67ec6358bf4d159a$export$deaa7a6e1403419a;
module.exports["NounKeys"] = $67ec6358bf4d159a$export$a93cddd79e3ea530;

});

parcelRegister("khsIl", function(module, exports) {

var $3VnuG = parcelRequire("3VnuG");

const $6e75b22e6c02e0d9$export$e88fb694deeca21a = 'smartlinks-connector';
const $6e75b22e6c02e0d9$export$83921c8e433ffcd9 = 'lite-connector-';
const $6e75b22e6c02e0d9$export$7ad7a95070d8bb93 = (0, $3VnuG.ConnectorSources).Federated;
const $6e75b22e6c02e0d9$export$e3a0662f044cd99b = (0, $3VnuG.ConnectorSources).Lite;
const $6e75b22e6c02e0d9$export$c14e5e3fa6d8b46 = (0, $3VnuG.ConnectorSources).Smartlinks;
const $6e75b22e6c02e0d9$export$aa06c0b5cc41ad9a = (0, $3VnuG.ConnectorSources).Full;
const $6e75b22e6c02e0d9$export$37e0ed5b7fa94503 = (0, $3VnuG.ConnectorSources).Backfill;
const $6e75b22e6c02e0d9$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $3VnuG.ConnectorSources)).includes(value);
};
const $6e75b22e6c02e0d9$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $6e75b22e6c02e0d9$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($6e75b22e6c02e0d9$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry = new Map();
const $6e75b22e6c02e0d9$export$4e96e986802512bd = (productKey, icon)=>{
    $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $6e75b22e6c02e0d9$export$2f2bd8960b497856 = (productKey)=>{
    return $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry.get(productKey);
};
const $6e75b22e6c02e0d9$export$2768da79a2599ca3 = ()=>{
    $6e75b22e6c02e0d9$var$forgeConnectorIconsRegistry.clear();
};
module.exports["SMARTLINKS_RESOURCE_TYPE_PREFIX"] = $6e75b22e6c02e0d9$export$e88fb694deeca21a;
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $6e75b22e6c02e0d9$export$aa06c0b5cc41ad9a;
module.exports["isForgeConnectorProductKey"] = $6e75b22e6c02e0d9$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $6e75b22e6c02e0d9$export$4e96e986802512bd;

});

parcelRegister("3VnuG", function(module, exports) {
const $183da3e19a5e988e$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $183da3e19a5e988e$export$499e9a6668a55181;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t4,
        __callerPackage__: "@confluence/loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "@confluence/loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $42omo.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $5spQU = parcelRequire("5spQU");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<b96ce0d5fd9337cf16cb77dc6aae256c>>
 * @relayHash e4d3106ab141a2f59d322ffcf93f9edf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v13 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v14 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v15 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v16 = [
        v11 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "success"
    }, v18 = {
        "kind": "ScalarField",
        "name": "message"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v21 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v23 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v24 = [
        v11 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v26 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v27 = {
        "kind": "ScalarField",
        "name": "value"
    }, v28 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v29 = [
        v6 /*: any*/ ,
        v26 /*: any*/ ,
        v25 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v27 /*: any*/ ,
                v28 /*: any*/ 
            ]
        }
    ], v30 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v29 /*: any*/ 
    }, v31 = [
        v27 /*: any*/ 
    ], v32 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v25 /*: any*/ ,
            v30 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v29 /*: any*/ 
            }
        ]
    }, v33 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            v30 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            v26 /*: any*/ ,
                            v25 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v28 /*: any*/ ,
                                    v27 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v6 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v16 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v21 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v21 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v16 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v34 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v34 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e4d3106ab141a2f59d322ffcf93f9edf",
            "id": "9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "dc99427393f687e09e4c81762eb96704";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $7hXu9 = parcelRequire("7hXu9");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $7hXu9.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}workflowApplicationChanged{contentId changeType newWorkflowStatusId contentStatus version __typename}markdownModeUpdated{isMarkdownMode __typename}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}contentAccessDecisionMade{contentId decision __typename}inlineReactionAdded{commentId markerRef emojiId newHighlight step{from to pos mark{attrs{annotationType id}type}stepType}publishVersionNumber __typename}inlineReactionRemoved{commentId markerRef emojiId __typename}inlineReactionHighlightDeleted{commentId markerRef __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("7wYo8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $hBkFA = parcelRequire("hBkFA");

function $68a341f15f9dda7b$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $hBkFA.useEntryPointPreload)(load);
    const clickListener = (0, $42omo.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $42omo.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressablePreloadRef"] = $68a341f15f9dda7b$export$1ff47f24e06a5d2d;

});

parcelRegister("hBkFA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $b7a3f72174bcd512$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $b7a3f72174bcd512$var$TIME_TO_INTENT = 200;
function $b7a3f72174bcd512$export$57effc2a5e3611f(load) {
    const actions = (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            if ((0, $dh538.fg)('platform_relay_persist_entrypoint_preloaded_data') === false) request.preload?.dispose();
        };
        const cleanupPreload = ()=>{
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    if ((0, $dh538.fg)('platform_relay_persist_entrypoint_preloaded_data') === false) request.preload?.dispose();
                }, $b7a3f72174bcd512$var$PRELOAD_MAX_AGE);
            }, $b7a3f72174bcd512$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if ((0, $dh538.fg)('platform_relay_persist_entrypoint_preloaded_data')) actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}
module.exports["useEntryPointPreload"] = $b7a3f72174bcd512$export$57effc2a5e3611f;

});

parcelRegister("cQDYl", function(module, exports) {
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;
module.exports["default"] = $e0b2ee147542345d$export$2e2bcd8739ae039;

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ])
    }, children);
}

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("ghphD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bda1d8a3686c6d03$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $2h3f7 = parcelRequire("2h3f7");

function $bda1d8a3686c6d03$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("e0SBo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33b6ba3d9a58f3b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $a33b6ba3d9a58f3b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("6UBEn", function(module, exports) {
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $3cc01bd0176870aa$var$MIN_VALUE = 0;
const $3cc01bd0176870aa$var$MAX_VALUE = 1;
const $3cc01bd0176870aa$var$increasingBarAnimation = null;
const $3cc01bd0176870aa$var$decreasingBarAnimation = null;
const $3cc01bd0176870aa$var$containerStyles = null;
const $3cc01bd0176870aa$var$containerStylesT26Shape = null;
const $3cc01bd0176870aa$var$containerAppearance = {
    default: "_bfhki8nm",
    success: "_bfhki8nm",
    inverse: "_bfhk1vck"
};
const $3cc01bd0176870aa$var$barAppearance = {
    default: "_bfhk1aqn",
    success: "_bfhkkcmj",
    inverse: "_bfhkvuon"
};
const $3cc01bd0176870aa$var$barStyles = null;
const $3cc01bd0176870aa$var$barStylesT26Shape = null;
const $3cc01bd0176870aa$var$determinateBarStyles = null;
const $3cc01bd0176870aa$var$increasingBarStyles = null;
const $3cc01bd0176870aa$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $3cc01bd0176870aa$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $3cc01bd0176870aa$var$MIN_VALUE : Math.max($3cc01bd0176870aa$var$MIN_VALUE, Math.min(value, $3cc01bd0176870aa$var$MAX_VALUE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $3cc01bd0176870aa$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $3cc01bd0176870aa$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0",
            $3cc01bd0176870aa$var$containerAppearance[appearance]
        ])
    }, isIndeterminate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $3cc01bd0176870aa$var$barAppearance[appearance],
            "_5sagymdr _tip812c5 _j7hq7g40",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $3cc01bd0176870aa$var$barAppearance[appearance],
            "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            width: `${Number(value) * 100}%`
        },
        className: (0, $gMc0m.default)([
            "_2rkofajl _1e0c1ule _4t3ii2wt _kqswstnw",
            $3cc01bd0176870aa$var$barAppearance[appearance],
            "_v564calv",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1rr0"
        ])
    }));
};
var $3cc01bd0176870aa$export$2e2bcd8739ae039 = $3cc01bd0176870aa$var$ProgressBar;
module.exports["default"] = $3cc01bd0176870aa$export$2e2bcd8739ae039;

});

parcelRegister("enXC5", function(module, exports) {

var $3pfAb = parcelRequire("3pfAb");

const $38b875aff7a7920b$export$85183a312807388d = (0, $3pfAb.FabricChannel).aiMate;
const $38b875aff7a7920b$export$61b85fb5d2d632d0 = 'csid';
module.exports["ANALYTICS_CHANNEL"] = $38b875aff7a7920b$export$85183a312807388d;
module.exports["CSID_QUERY_PARAM"] = $38b875aff7a7920b$export$61b85fb5d2d632d0;

});

parcelRegister("kbbjt", function(module, exports) {
const $26102f356f7c78e0$export$f6abe2eda5c1912f = ()=>({
        eventType: 'track',
        tags: [
            'atlaskit'
        ]
    });
const $26102f356f7c78e0$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        return {
            ...acc,
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getDefaultTrackEventConfig"] = $26102f356f7c78e0$export$f6abe2eda5c1912f;
module.exports["getAttributesFromContexts"] = $26102f356f7c78e0$export$d97c97ed77ff09e8;

});

parcelRegister("cKUms", function(module, exports) {

var $bqzVl = parcelRequire("bqzVl");

const $90ade48fa7cbb19c$var$getStudioHost = (env)=>env === 'staging' ? (0, $bqzVl.STUDIO_STAGING_URL) : (0, $bqzVl.STUDIO_PROD_URL);
const $90ade48fa7cbb19c$export$b4a3ce4b99911063 = (env, path, email)=>{
    const studioHost = $90ade48fa7cbb19c$var$getStudioHost(env);
    const normalizedPath = path ? path.startsWith('/') ? path : `/${path}` : '';
    const destination = `${studioHost}${normalizedPath}`;
    if (!email) return destination;
    // Merge login_hint into any existing query string.
    const url = new URL(destination);
    url.searchParams.set('login_hint', email);
    return url.toString();
};
module.exports["getStudioSessionSyncUrl"] = $90ade48fa7cbb19c$export$b4a3ce4b99911063;

});

parcelRegister("bqzVl", function(module, exports) {
const $d2485b2101cbc709$export$83a42cd6c4b5f72d = 'https://studio.atlassian.com';
const $d2485b2101cbc709$export$1b2ea4d616a1810d = 'https://studio.stg.atlassian.com';
module.exports["STUDIO_PROD_URL"] = $d2485b2101cbc709$export$83a42cd6c4b5f72d;
module.exports["STUDIO_STAGING_URL"] = $d2485b2101cbc709$export$1b2ea4d616a1810d;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("1wScy", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $11d2d2e303d6c19d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11d2d2e303d6c19d$var$hasOwnProperty = $11d2d2e303d6c19d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $11d2d2e303d6c19d$var$groupBy = $77wHb(function(result, value, key) {
    if ($11d2d2e303d6c19d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3PAnx(result, key, [
        value
    ]);
});
module.exports = $11d2d2e303d6c19d$var$groupBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("2twC9", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");


var $hkHTQ = parcelRequire("hkHTQ");

/** Used to match HTML entities and HTML characters. */ var $1cd796ba122ff88e$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $1cd796ba122ff88e$var$reHasEscapedHtml = RegExp($1cd796ba122ff88e$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $1cd796ba122ff88e$var$unescape(string) {
    string = $fPVB6(string);
    return string && $1cd796ba122ff88e$var$reHasEscapedHtml.test(string) ? string.replace($1cd796ba122ff88e$var$reEscapedHtml, $hkHTQ) : string;
}
module.exports = $1cd796ba122ff88e$var$unescape;

});

parcelRegister("hkHTQ", function(module, exports) {

var $jghHU = parcelRequire("jghHU");

/** Used to map HTML entities to characters. */ var $c9e65b8529dd6337$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $c9e65b8529dd6337$var$unescapeHtmlChar = $jghHU($c9e65b8529dd6337$var$htmlUnescapes);
module.exports = $c9e65b8529dd6337$var$unescapeHtmlChar;

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("7rzV8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2xIMp = parcelRequire("2xIMp");

var $inPa6 = parcelRequire("inPa6");


var $enXC5 = parcelRequire("enXC5");


var $bKMJf = parcelRequire("bKMJf");


var $kbbjt = parcelRequire("kbbjt");

const $662e4cc98739c056$var$DefaultActionSubject = 'rovoAgent';
const $662e4cc98739c056$var$globalEventConfig = (0, $kbbjt.getDefaultTrackEventConfig)();
const $662e4cc98739c056$export$b9dc0ab1bce924aa = (commonAttributes)=>{
    const [{ csid: csid, globalCSID: globalCSID }, { refresh: refreshCSID }] = (0, $bKMJf.useRovoAgentCSID)();
    const analyticsContext = (0, $42omo.useContext)((0, $2xIMp.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const commonAttributesRef = (0, $42omo.useRef)(commonAttributes);
    const fireAnalyticsEvent = (0, $42omo.useCallback)((event)=>{
        const referrer = typeof window !== 'undefined' ? window.document.referrer : 'unknown';
        const attributes = {
            ...(0, $kbbjt.getAttributesFromContexts)(analyticsContext.getAtlaskitAnalyticsContext()),
            ...commonAttributesRef.current,
            ...event.attributes,
            actionGroup: 'createFlow',
            referrer: referrer
        };
        createAnalyticsEvent({
            ...$662e4cc98739c056$var$globalEventConfig,
            ...event,
            attributes: attributes
        }).fire((0, $enXC5.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsContext
    ] // keep number of dependencies minimal to prevent re-rendering
    );
    /**
   * Fires an analytics event for a step in the create agent flow funnel.
   * Uses the CSID from the URL query parameter.
   */ const trackCreateSession = (0, $42omo.useCallback)((action, attributes)=>{
        fireAnalyticsEvent({
            actionSubject: $662e4cc98739c056$var$DefaultActionSubject,
            action: action,
            attributes: {
                csid: globalCSID,
                ...attributes
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    /**
   * Fires `createFlowStart` with the current CSID (matching the href),
   * then refreshes the CSID for the next session.
   * The component re-renders with the new CSID, updating any href attributes.
   */ const trackCreateSessionStart = (0, $42omo.useCallback)((attributes)=>{
        fireAnalyticsEvent({
            actionSubject: $662e4cc98739c056$var$DefaultActionSubject,
            action: 'createFlowStart',
            attributes: {
                csid: csid,
                ...attributes
            }
        });
        refreshCSID();
    }, [
        fireAnalyticsEvent,
        refreshCSID,
        csid
    ]);
    const trackCreateSessionError = (0, $42omo.useCallback)((error, attributes)=>{
        fireAnalyticsEvent({
            actionSubject: $662e4cc98739c056$var$DefaultActionSubject,
            action: 'createFlowError',
            attributes: {
                error: {
                    message: error.message
                },
                csid: globalCSID,
                ...attributes
            }
        });
    }, [
        fireAnalyticsEvent,
        globalCSID
    ]);
    return [
        csid,
        {
            trackCreateSession: trackCreateSession,
            trackCreateSessionStart: trackCreateSessionStart,
            trackCreateSessionError: trackCreateSessionError,
            refreshCSID: refreshCSID
        }
    ];
};
module.exports["useRovoAgentCreateAnalytics"] = $662e4cc98739c056$export$b9dc0ab1bce924aa;

});

parcelRegister("bKMJf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $enXC5 = parcelRequire("enXC5");

let $df044dbaa44f8915$var$CACHED_CSID = null;
const $df044dbaa44f8915$var$generateCSID = ()=>{
    return crypto.randomUUID();
};
const $df044dbaa44f8915$export$2e155615ea28a17b = ()=>{
    const [csid, setCSID] = (0, $42omo.useState)($df044dbaa44f8915$var$CACHED_CSID || $df044dbaa44f8915$var$generateCSID());
    const globalCSID = (0, $42omo.useMemo)(()=>{
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get((0, $enXC5.CSID_QUERY_PARAM));
    }, []);
    const actions = (0, $42omo.useMemo)(()=>{
        return {
            refresh: ()=>{
                const newCSID = $df044dbaa44f8915$var$generateCSID();
                setCSID(newCSID);
                $df044dbaa44f8915$var$CACHED_CSID = newCSID;
                return newCSID;
            }
        };
    }, []);
    return [
        {
            csid: csid,
            globalCSID: // generated CSID to be used in href and createFlowStart events
            globalCSID // CSID from the URL query parameter
        },
        actions
    ];
};
module.exports["useRovoAgentCSID"] = $df044dbaa44f8915$export$2e155615ea28a17b;

});

parcelRegister("blT4H", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $cKUms = parcelRequire("cKUms");


var $bhcGS = parcelRequire("bhcGS");

const $20bd261d1751cd71$var$STUDIO_PROD_URL = 'https://studio.atlassian.com';
const $20bd261d1751cd71$var$STUDIO_STAGING_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';
const $20bd261d1751cd71$export$72eb188ed9591973 = ()=>{
    return (0, $bhcGS.isStaging)() ? $20bd261d1751cd71$var$STUDIO_STAGING_URL : $20bd261d1751cd71$var$STUDIO_PROD_URL;
};
const $20bd261d1751cd71$var$getStudioEnv = ()=>(0, $bhcGS.isStaging)() ? 'staging' : 'production';
const $20bd261d1751cd71$export$372c8de5c124bdc8 = (path, email)=>{
    if (email && (0, $dh538.fg)('asf-944-account-sync')) return (0, $cKUms.getStudioSessionSyncUrl)($20bd261d1751cd71$var$getStudioEnv(), path, email);
    return `${$20bd261d1751cd71$export$72eb188ed9591973()}${path}`;
};
const $20bd261d1751cd71$export$bb5c2ff2ee505e4a = (siteId, navigationSource, csid, email, starterText)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', navigationSource);
    if (csid && (0, $dh538.fg)('rovo-agents-universal-analytics')) searchParams.set('csid', csid);
    if (starterText) searchParams.set('starterText', starterText);
    return $20bd261d1751cd71$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/chat${searchParams.size > 0 ? `?${searchParams}` : ''}`, email);
};
const $20bd261d1751cd71$export$fe475324c26e3007 = (siteId, email)=>{
    return $20bd261d1751cd71$export$372c8de5c124bdc8(`/s/${siteId}/agents/create/overview`, email);
};
const $20bd261d1751cd71$export$ef221a159d6fa3e8 = (siteId, agentId, email)=>$20bd261d1751cd71$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}`, email);
const $20bd261d1751cd71$export$a20abb994c34f0a4 = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/:agentId/overview')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $20bd261d1751cd71$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $20bd261d1751cd71$export$36c11ab884b7b2cb = (siteId, agentId, navigationSource, email)=>{
    const redirectParam = `redirect=${encodeURIComponent('/create')}`;
    const sourceParam = navigationSource ? `&navigationSource=${encodeURIComponent(navigationSource)}` : '';
    return $20bd261d1751cd71$export$372c8de5c124bdc8(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?${redirectParam}${sourceParam}`, email);
};
const $20bd261d1751cd71$export$c2d162390af7b91d = (siteId, agentAri, navigationSource, email)=>{
    const searchParams = new URLSearchParams();
    if (navigationSource) searchParams.set('navigationSource', encodeURIComponent(navigationSource));
    const query = searchParams.size > 0 ? `?${searchParams}` : '';
    return $20bd261d1751cd71$export$372c8de5c124bdc8(`/s/${siteId}/agents/${encodeURIComponent(agentAri)}/permissions${query}`, email);
};
module.exports["getStudioPath"] = $20bd261d1751cd71$export$372c8de5c124bdc8;
module.exports["getAtlassianStudioNLCreateUrl"] = $20bd261d1751cd71$export$bb5c2ff2ee505e4a;
module.exports["getAtlassianStudioAgentEditUrl"] = $20bd261d1751cd71$export$a20abb994c34f0a4;
module.exports["getAtlassianStudioAgentDuplicateUrl"] = $20bd261d1751cd71$export$36c11ab884b7b2cb;

});

parcelRegister("isFEX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70b2843323b118c$var$_react = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("42omo")));

var $d70b2843323b118c$var$_baseNew = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d70b2843323b118c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d70b2843323b118c$var$TemplateIcon = (props)=>/*#__PURE__*/ $d70b2843323b118c$var$_react.default.createElement($d70b2843323b118c$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d70b2843323b118c$var$TemplateIcon.displayName = 'TemplateIcon';
var $d70b2843323b118c$var$_default = module.exports.default = $d70b2843323b118c$var$TemplateIcon;

});

parcelRegister("3uA7H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b031be5ae5f446$var$_react = $28b031be5ae5f446$var$_interopRequireDefault((parcelRequire("42omo")));

var $28b031be5ae5f446$var$_baseNew = $28b031be5ae5f446$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $28b031be5ae5f446$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28b031be5ae5f446$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $28b031be5ae5f446$var$_react.default.createElement($28b031be5ae5f446$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$28b031be5ae5f446$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $28b031be5ae5f446$var$_default = module.exports.default = $28b031be5ae5f446$var$SidebarCollapseIcon;

});

parcelRegister("cN7t9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87b126ba38d591666b6bb1a2ae894895>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94ffdadf1a3ed504$var$_react = $94ffdadf1a3ed504$var$_interopRequireDefault((parcelRequire("42omo")));

var $94ffdadf1a3ed504$var$_baseNew = $94ffdadf1a3ed504$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $94ffdadf1a3ed504$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94ffdadf1a3ed504$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $94ffdadf1a3ed504$var$_react.default.createElement($94ffdadf1a3ed504$var$_baseNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$94ffdadf1a3ed504$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $94ffdadf1a3ed504$var$_default = module.exports.default = $94ffdadf1a3ed504$var$SidebarExpandIcon;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("jK29N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::282b63b14f5d8b9b1a4035ff1652d30e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5f3fc87e4383614$var$_react = $e5f3fc87e4383614$var$_interopRequireDefault((parcelRequire("42omo")));

var $e5f3fc87e4383614$var$_baseNew = $e5f3fc87e4383614$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e5f3fc87e4383614$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5f3fc87e4383614$var$LogOutIcon = (props)=>/*#__PURE__*/ $e5f3fc87e4383614$var$_react.default.createElement($e5f3fc87e4383614$var$_baseNew.default, Object.assign({
        name: "LogOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$e5f3fc87e4383614$var$LogOutIcon.displayName = 'LogOutIcon';
var $e5f3fc87e4383614$var$_default = module.exports.default = $e5f3fc87e4383614$var$LogOutIcon;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("iJ9aA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bsrY7 = parcelRequire("bsrY7");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    let { analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: t1, isGrandfathered: t2, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps } = t0;
    const targetEdition = t1 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t1;
    const isGrandfathered = t2 === undefined ? false : t2;
    const intl = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    let t3;
    if ($[0] !== children) {
        t3 = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
        $[0] = children;
        $[1] = t3;
    } else t3 = $[1];
    const message = t3;
    const iconOnly = icon && !message;
    let t4;
    let t5;
    if ($[2] !== experienceTracker || $[3] !== showUpFlow) {
        t4 = ()=>()=>{
                if (!showUpFlow) experienceTracker.abort({
                    name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                    reason: "Canceled by user"
                });
            };
        t5 = [
            experienceTracker,
            showUpFlow
        ];
        $[2] = experienceTracker;
        $[3] = showUpFlow;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== actionSubjectId || $[7] !== analyticsProps || $[8] !== createAnalyticsEvent || $[9] !== edition || $[10] !== experienceTracker || $[11] !== isSiteAdmin || $[12] !== showUpFlow || $[13] !== source || $[14] !== targetEdition) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "freeLearnMore",
                    ...analyticsProps,
                    attributes: {
                        currentEdition: edition,
                        isSiteAdmin: isSiteAdmin,
                        linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                        targetEdition: targetEdition,
                        ...analyticsProps.attributes
                    }
                }
            }).fire();
            experienceTracker.start({
                name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: edition,
                    linkClicked: actionSubjectId || "freeLearnMore",
                    source: source,
                    targetEdition: targetEdition
                }
            });
        };
        $[6] = actionSubjectId;
        $[7] = analyticsProps;
        $[8] = createAnalyticsEvent;
        $[9] = edition;
        $[10] = experienceTracker;
        $[11] = isSiteAdmin;
        $[12] = showUpFlow;
        $[13] = source;
        $[14] = targetEdition;
        $[15] = t6;
    } else t6 = $[15];
    const fireClickAnalytics = t6;
    let t7;
    if ($[16] !== onUpFlowOpen) {
        t7 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) setIsUpFlowOpen(false);
        };
        $[16] = onUpFlowOpen;
        $[17] = t7;
    } else t7 = $[17];
    const onUpFlowClose = t7;
    const renderLearnMoreButton = (t8)=>{
        const props = t8 === undefined ? {} : t8;
        if (appearance === "inline-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            className: appearance === "subtle-link" ? undefined : "primaryButton",
            id: "learnMoreLink",
            spacing: iconOnly ? "none" : "default",
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    let t9;
    if ($[18] !== createAnalyticsEvent || $[19] !== inProductHelpId) {
        t9 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "helpLink",
                    source: "adminKeyUpSell",
                    attributes: {
                        targetArticleId: inProductHelpId,
                        isSPA: true
                    }
                }
            }).fire();
        };
        $[18] = createAnalyticsEvent;
        $[19] = inProductHelpId;
        $[20] = t9;
    } else t9 = $[20];
    const fireAnalyticsEvent = t9;
    if (isGrandfathered && !isSiteAdmin) return null;
    if (!href) href = showUpFlow ? "#" : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith("#") ? undefined : "_blank";
    let t10;
    if ($[21] !== fireClickAnalytics || $[22] !== onClick || $[23] !== showUpFlow || $[24] !== target) {
        t10 = (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        };
        $[21] = fireClickAnalytics;
        $[22] = onClick;
        $[23] = showUpFlow;
        $[24] = target;
        $[25] = t10;
    } else t10 = $[25];
    const buttonProps = {
        target: target,
        href: href,
        onClick: t10,
        "aria-label": ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    const t11 = !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps);
    let t12;
    if ($[26] !== cloudId || $[27] !== edition || $[28] !== isSiteAdmin || $[29] !== isUpFlowOpen || $[30] !== onUpFlowClose || $[31] !== onUpFlowOpen || $[32] !== showUpFlow || $[33] !== source || $[34] !== targetEdition || $[35] !== userId) {
        t12 = showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            cloudId: cloudId,
            atlassianAccountId: userId || undefined,
            canChangeEdition: isSiteAdmin,
            currentEdition: edition || undefined,
            targetEdition: targetEdition,
            flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
            product: "confluence",
            touchpointId: source,
            onClose: onUpFlowClose,
            onOpen: onUpFlowOpen,
            isExperienceTrackerEnabled: true,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
        $[26] = cloudId;
        $[27] = edition;
        $[28] = isSiteAdmin;
        $[29] = isUpFlowOpen;
        $[30] = onUpFlowClose;
        $[31] = onUpFlowOpen;
        $[32] = showUpFlow;
        $[33] = source;
        $[34] = targetEdition;
        $[35] = userId;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== t11 || $[38] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t11, t12);
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
} : ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $42omo.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("9HR4c"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("9HR4c", function(module, exports) {

let $71114b28ae265066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $71114b28ae265066$var$load("1CUOt"),
    $71114b28ae265066$var$load("82QsP")
]).then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== internalData) {
        t0 = (data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData);
        $[0] = internalData;
        $[1] = t0;
    } else t0 = $[1];
    const wrapAnalyticsEventPayload = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== wrapAnalyticsEventPayload) {
        t1 = (initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        $[2] = createAnalyticsEvent;
        $[3] = wrapAnalyticsEventPayload;
        $[4] = t1;
    } else t1 = $[4];
    const wrappedCreateAnalyticsEvent = t1;
    let t2;
    if ($[5] !== wrapAnalyticsEventPayload || $[6] !== wrappedCreateAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: wrappedCreateAnalyticsEvent,
            wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
        };
        $[5] = wrapAnalyticsEventPayload;
        $[6] = wrappedCreateAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, customAttributes: t1 } = t0;
    const customAttributes = t1 === undefined ? $8ea1c6a3abbe8170$var$emptyAttributes : t1;
    let t2;
    if ($[0] !== customAttributes) {
        t2 = {
            customAttributes: customAttributes
        };
        $[0] = customAttributes;
        $[1] = t2;
    } else t2 = $[1];
    const editionsAnalyticsContextValue = t2;
    let t3;
    if ($[2] !== children || $[3] !== editionsAnalyticsContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
            value: editionsAnalyticsContextValue
        }, children);
        $[2] = children;
        $[3] = editionsAnalyticsContextValue;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $42omo.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
        const $ = (0, $frIzR.c)(3);
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        let t0;
        if ($[0] !== context || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                ...props,
                ...context
            });
            $[0] = context;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $12IaO = parcelRequire("12IaO");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($12IaO)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("dIDyF", function(module, exports) {

var $jO9zg = parcelRequire("jO9zg");

const $c2412d4c16af1f46$export$c43c7444da662fa1 = '1';
const $c2412d4c16af1f46$export$e99efa3985fa3c26 = 'in-product-help';
const $c2412d4c16af1f46$export$23aa6670f346c214 = 368;
const $c2412d4c16af1f46$export$dd8cabd06ab03363 = {
    summary: 'summary',
    wasThisHelpful: 'customfield_10081',
    description: 'description',
    reason: 'customfield_10082',
    title: 'customfield_10083',
    contentId: 'customfield_10084',
    contentLink: 'customfield_10088',
    feedbackContext: 'customfield_10047',
    routeGroup: 'customfield_10085',
    routeName: 'customfield_10086',
    customerName: 'customfield_10045',
    email: 'email',
    contactMe: 'customfield_10043'
};
const $c2412d4c16af1f46$export$597555bbf10f10b8 = {
    yes: {
        id: '10182',
        label: 'yes'
    },
    no: {
        id: '10183',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$cd692d959c11a1e9 = {
    noAccurate: {
        id: '10184',
        label: (0, $jO9zg.notAccurateLabel)
    },
    noClear: {
        id: '10185',
        label: (0, $jO9zg.notClearLabel)
    },
    noRelevant: {
        id: '10186',
        label: (0, $jO9zg.notRelevantLabel)
    }
};
const $c2412d4c16af1f46$export$ee3be114bf2680b4 = {
    yes: {
        id: '10109',
        label: 'yes'
    },
    no: {
        id: '10111',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$31f0ec6fc5b07a82 = 'afae180b-eb61-43c5-bc3f-5f65349a8853';
const $c2412d4c16af1f46$export$d006cfb73688051e = '279';
module.exports["HELP_PANEL_ID"] = $c2412d4c16af1f46$export$e99efa3985fa3c26;
module.exports["HELP_PANEL_WIDTH"] = $c2412d4c16af1f46$export$23aa6670f346c214;
module.exports["FEEDBACK_FIELDS_ID"] = $c2412d4c16af1f46$export$dd8cabd06ab03363;
module.exports["WAS_THIS_HELPFUL_OPTIONS"] = $c2412d4c16af1f46$export$597555bbf10f10b8;
module.exports["FEEDBACK_REASON_OPTIONS"] = $c2412d4c16af1f46$export$cd692d959c11a1e9;
module.exports["CAN_BE_CONTACTED_OPTIONS"] = $c2412d4c16af1f46$export$ee3be114bf2680b4;
module.exports["EMBEDDABLE_KEY"] = $c2412d4c16af1f46$export$31f0ec6fc5b07a82;
module.exports["REQUEST_TYPE_ID"] = $c2412d4c16af1f46$export$d006cfb73688051e;

});

parcelRegister("jO9zg", function(module, exports) {
const $136af91396913aa8$export$653b1475ad2952b = "It wasn\u2019t accurate";
const $136af91396913aa8$export$910eb5168d5e4926 = "It wasn\u2019t clear";
const $136af91396913aa8$export$7e4b37ff0a487bc2 = "It wasn\u2019t relevant";
module.exports["notAccurateLabel"] = $136af91396913aa8$export$653b1475ad2952b;
module.exports["notClearLabel"] = $136af91396913aa8$export$910eb5168d5e4926;
module.exports["notRelevantLabel"] = $136af91396913aa8$export$7e4b37ff0a487bc2;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    // Legacy state — type and update logic are verbatim from the original implementation
    const [legacyState, setLegacyState] = (0, $42omo.useState)({
        activeTriggerId: undefined
    });
    // New record state — each trigger tracks its own boolean independently
    const [recordState, setRecordState] = (0, $42omo.useState)({});
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        if ((0, $dh538.fg)('post-office_enable-trigger-record-state')) // New: each trigger tracks its own state independently.
        // Mutual exclusion is enforced at render time by the choreographer.
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
        else // Legacy: verbatim original logic — only one trigger active at a time
        setLegacyState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    // Unified record view exposed to context consumers.
    // In legacy mode, converts the single activeTriggerId to a one-entry record
    // so useTrigger works identically for both paths.
    const activeTriggerState = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('post-office_enable-trigger-record-state')) return recordState;
        const { activeTriggerId: activeTriggerId } = legacyState;
        return activeTriggerId ? {
            [activeTriggerId]: true
        } : {};
    }, [
        recordState,
        legacyState
    ]);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    const enableEpExternalMessageCleanup = (0, $dh538.fg)('post-office_enable-ep-external-message-cleanup');
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    // In legacy mode (gate off), the record has at most one true entry, so we reconstruct
    // activeTriggerId to preserve the original guard logic verbatim.
    // In record mode (gate on), the guard is unnecessary — setTriggerState is a no-op if
    // the trigger is already active, so we skip the reconstruction.
    const activeTriggerId = (0, $dh538.fg)('post-office_enable-trigger-record-state') ? undefined : Object.keys(activeTriggerState).find((k)=>activeTriggerState[k]);
    const hasMessageAlreadyStarted = enableEpExternalMessageCleanup && activeTriggerId?.endsWith('-started');
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        if (hasMessageAlreadyStarted) return;
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger,
        hasMessageAlreadyStarted
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("7tXrp", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("cHKtk", function(module, exports) {

var $hG9ZM = parcelRequire("hG9ZM");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $7tXrp = parcelRequire("7tXrp");


var $bZmiL = parcelRequire("bZmiL");

const $0db05c5b00b76da2$export$4af81e07a25a3fcc = (source)=>{
    // TODO: During productionization replace with EligibleTouchpoints type for source
    const { cloudId: cloudId, edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const eligibleTouchpoint = (0, $7tXrp.getEligibleTouchpointForEdition)(source, edition);
    const offeringName = eligibleTouchpoint?.requestedEdition ?? 'standard';
    const isEnabledStandardEdition = edition === (0, $d9tcB.ConfluenceEdition).STANDARD;
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $hG9ZM.default), {
        variables: {
            cloudId: cloudId,
            offeringName: offeringName,
            shouldCheckForTrial: isEnabledStandardEdition
        },
        fetchPolicy: 'cache-first',
        skip: !isEnabledStandardEdition || isSiteAdmin || !eligibleTouchpoint,
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/experiment-confluence-enable-end-user-request"
    });
    const { isEligibleForEndUserRequestStandard: isEligibleForEndUserRequestStandard } = (0, $42omo.useMemo)(()=>{
        const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
        const isInCollection = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION')?.entitlementId;
        const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
        const changeOfferingExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
        const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingExperienceUrl);
        const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
        const entitlementId = entitlementInfo?.entitlementId;
        const transactionAccountId = entitlement?.transactionAccount?.key;
        // Additional eligibility checks for Standard
        const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft;
        const isInTrial = Boolean(trialTimeLeft && trialTimeLeft > 0);
        const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
        const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && invoiceableStatus === 'NOT_INVOICEABLE';
        return {
            isEligibleForEndUserRequestStandard: Boolean(!loading && !isInCollection && isEnabledStandardEdition && hasPaymentDetailsEntered && !canUpgrade && Boolean(userId) && Boolean(changeOfferingExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId) && !isInTrial && !isInPredunning)
        };
    }, [
        data,
        loading,
        isEnabledStandardEdition,
        userId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isEligibleForEndUserRequestStandard) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'useEnableEndUserRequestUpgrade',
                attributes: {
                    cohort: (0, $6mKj3.expVal)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'not-enrolled'),
                    flagKey: 'twcg-1169_ceurs2p_end_user_requests',
                    touchpoint: source,
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    }, [
        edition,
        isEligibleForEndUserRequestStandard,
        createAnalyticsEvent,
        source
    ]);
    return {
        showRequestUpgradeButton: // Standard Edition
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequestStandard && (0, $6mKj3.expValEquals)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'variation'),
        loading: loading
    };
};
module.exports["useEnableEndUserRequestUpgrade"] = $0db05c5b00b76da2$export$4af81e07a25a3fcc;

});

parcelRegister("hG9ZM", function(module, exports) {
/**
 * @generated SignedSource<<3566b1065bbfe80593a6707992c628d5>>
 * @relayHash 95c17f8ab13d7575aa221eba1b6971a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2
const $a3d3dc9056ba2c7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldCheckForTrial"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v11 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v14 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v15 = [
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v15 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "CcpInvoiceGroup"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "CcpSubscription"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "95c17f8ab13d7575aa221eba1b6971a5",
            "id": "e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2",
            "metadata": {},
            "name": "useEnableEndUserRequestUpgradeQuery",
            "operationKind": "query",
            "text": "query useEnableEndUserRequestUpgradeQuery($cloudId:ID!,$offeringName:String!,$shouldCheckForTrial:Boolean!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlementId,entitlement{id,__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}},transactionAccount{__typename,key,isBillToPresent,...on Node{__isNode:__typename,id}},relatesFromEntitlements{__typename,entitlementId,relationshipType},preDunning@include(if:$shouldCheckForTrial){__typename,status}\n        subscription@include(if:$shouldCheckForTrial){__typename,trial{__typename,timeLeft},accountDetails{__typename,invoiceGroup{__typename,invoiceable,...on CcpInvoiceGroup{id}}},...on CcpSubscription{id}}}}}}"
        }
    };
}();
$a3d3dc9056ba2c7e$var$node.hash = "ab7d869d4ea7e269d66f1403bf66098f";
var $a3d3dc9056ba2c7e$export$2e2bcd8739ae039 = $a3d3dc9056ba2c7e$var$node;
module.exports["default"] = $a3d3dc9056ba2c7e$export$2e2bcd8739ae039;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("8tIbq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $aL2YV = parcelRequire("aL2YV");


var $iINa5 = parcelRequire("iINa5");

const $50e1434d8c6bc030$export$6a6a5d23d75b0f62 = ({ selectors: selectors, options: options })=>(0, $dh538.fg)('platform-dst-top-layer') ? /*#__PURE__*/ $42omo.createElement((0, $iINa5.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    }) : /*#__PURE__*/ $42omo.createElement((0, $aL2YV.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    });
module.exports["UNSAFE_UpdateOnChange"] = $50e1434d8c6bc030$export$6a6a5d23d75b0f62;

});

parcelRegister("aL2YV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $2MPqq = parcelRequire("2MPqq");

const $f6f1a6e9b09a2c7f$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $f6f1a6e9b09a2c7f$export$6a6a5d23d75b0f62 = ({ selectors: selectors = [
    'body'
], options: options = $f6f1a6e9b09a2c7f$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $42omo.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer)=>observer.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
module.exports["UNSAFE_UpdateOnChange"] = $f6f1a6e9b09a2c7f$export$6a6a5d23d75b0f62;

});

parcelRegister("iINa5", function(module, exports) {
const $768b0f08d22b5f25$export$6a6a5d23d75b0f62 = (_props)=>null;
module.exports["UNSAFE_UpdateOnChange"] = $768b0f08d22b5f25$export$6a6a5d23d75b0f62;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

const $e5ba90f4b97bd7c1$var$i18n = (0, $aXWIB.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $aXWIB.useIntl)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("gd8AW", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("2YerA", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("jCM2u")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("jCM2u")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("jCM2u")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("fqrVl")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("fqrVl")).Reasons);

var $jCM2u = parcelRequire("jCM2u");


var $fqrVl = parcelRequire("fqrVl");


});

parcelRegister("jCM2u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5xIym = parcelRequire("5xIym");


var $5B9n6 = parcelRequire("5B9n6");


var $fqrVl = parcelRequire("fqrVl");

const $32c19fce160b377b$var$LATEST_VERSION = (0, $5B9n6.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $32c19fce160b377b$var$CrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)(()=>({
        isEnabled: false,
        reason: (0, $fqrVl.Reasons).NO_PROVIDER
    }));
const $32c19fce160b377b$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $5B9n6.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $5xIym.createAPIv0)(onOpen),
                    apiV1: (0, $5B9n6.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $fqrVl.Reasons).NO_API_SUPPORT
                };
        }
    };
const $32c19fce160b377b$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $42omo.useMemo)(()=>$32c19fce160b377b$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32c19fce160b377b$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $32c19fce160b377b$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $42omo.useContext)($32c19fce160b377b$var$CrossFlowContext);
    return (0, $42omo.useMemo)(()=>negotiateApi($32c19fce160b377b$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $32c19fce160b377b$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $32c19fce160b377b$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $32c19fce160b377b$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $32c19fce160b377b$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $32c19fce160b377b$export$655b6c19a0daddb8;

});

parcelRegister("5xIym", function(module, exports) {
const $1eb0c594c750199f$export$a4ad2735b021c132 = 0;
const $1eb0c594c750199f$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $1eb0c594c750199f$export$9ff7368ac93fcf2d;

});

parcelRegister("5B9n6", function(module, exports) {
const $12de2f6721823415$export$a4ad2735b021c132 = 1;
const $12de2f6721823415$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $12de2f6721823415$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $12de2f6721823415$export$8fd5792fc468459f;

});

parcelRegister("fqrVl", function(module, exports) {
const $4db9b154d66dd01a$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $4db9b154d66dd01a$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $4db9b154d66dd01a$export$3411873bfd520bb6;
module.exports["Reasons"] = $4db9b154d66dd01a$export$da2d4f2f250d6f84;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("618I0"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("618I0", function(module, exports) {

let $4619977a62937b7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4619977a62937b7e$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("kOUwv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $1P1Tu.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $9zUhf.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $9zUhf.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("1eaCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("2azjJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $5648f131343e99e5$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$5648f131343e99e5$var$AkGrid(multiplier * num),
        half: ()=>$5648f131343e99e5$var$AkGrid(0.5 * num),
        twice: ()=>$5648f131343e99e5$var$AkGrid(2 * num)
    });
const $5648f131343e99e5$export$85fc379452d91af0 = $5648f131343e99e5$var$AkGrid(1);
const $5648f131343e99e5$export$b9930dabfa4a3a3 = '56px';
const $5648f131343e99e5$export$f6af7620e8789c39 = '200px';
const $5648f131343e99e5$export$64d8573e83b64ff8 = '150px';
const $5648f131343e99e5$export$a3da89b899389ed8 = '780px';
const $5648f131343e99e5$export$ce4512df260a325a = 780;
const $5648f131343e99e5$export$a406031ed42c8e02 = '1130px';
const $5648f131343e99e5$export$e00021bea368c518 = $5648f131343e99e5$export$85fc379452d91af0.multiple(4);
const $5648f131343e99e5$export$30310ee354b45eb0 = $5648f131343e99e5$export$85fc379452d91af0.multiple(6);
module.exports["grid"] = $5648f131343e99e5$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $5648f131343e99e5$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $5648f131343e99e5$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $5648f131343e99e5$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $5648f131343e99e5$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $5648f131343e99e5$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $5648f131343e99e5$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $5648f131343e99e5$export$30310ee354b45eb0;

});

parcelRegister("5k6WH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $uRQKa = parcelRequire("uRQKa");


var $6ttbq = parcelRequire("6ttbq");

const $479e1e8ac650b5b6$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    (0, $42omo.useEffect)(()=>{
        if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $479e1e8ac650b5b6$export$c537e63161742ce3;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $42omo.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("1662I", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ccb09ee82030ea4$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $6b5eb = parcelRequire("6b5eb");


var $b5utg = parcelRequire("b5utg");

var $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK = 604800000;
function $0ccb09ee82030ea4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var diff = (0, $e0mB4.default)(date).getTime() - (0, $6b5eb.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("e0mB4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a322980fc7bdc1cb$export$2e2bcd8739ae039);

var $ghphD = parcelRequire("ghphD");


var $b5utg = parcelRequire("b5utg");

function $a322980fc7bdc1cb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $ghphD.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});

parcelRegister("6b5eb", function(module, exports) {
$parcel$export(module.exports, "default", () => $47f7d34a77e920df$export$2e2bcd8739ae039);

var $3Klnc = parcelRequire("3Klnc");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $47f7d34a77e920df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var year = (0, $3Klnc.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $e0mB4.default)(fourthOfJanuary);
    return date;
}

});

parcelRegister("3Klnc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ba63f43afaf9481$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $2ba63f43afaf9481$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e0mB4.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e0mB4.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $lzcvT.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("bMPhU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $frIzR.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "@confluence/space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<560475f7b94ff8b73d41c9418925ef8b>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("ckcSY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45233a62a3f56b9e4911deb2a2339447>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f91591f413eb2d9$var$_react = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $8f91591f413eb2d9$var$_baseNew = $8f91591f413eb2d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8f91591f413eb2d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f91591f413eb2d9$var$NotificationIcon = (props)=>/*#__PURE__*/ $8f91591f413eb2d9$var$_react.default.createElement($8f91591f413eb2d9$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$8f91591f413eb2d9$var$NotificationIcon.displayName = 'NotificationIcon';
var $8f91591f413eb2d9$var$_default = module.exports.default = $8f91591f413eb2d9$var$NotificationIcon;

});

parcelRegister("28NpI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1d2d6708d394f801c1e7c6452a7750c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18f2a8adc52b2e32$var$_react = $18f2a8adc52b2e32$var$_interopRequireDefault((parcelRequire("42omo")));

var $18f2a8adc52b2e32$var$_baseNew = $18f2a8adc52b2e32$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $18f2a8adc52b2e32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $18f2a8adc52b2e32$var$ThemeIcon = (props)=>/*#__PURE__*/ $18f2a8adc52b2e32$var$_react.default.createElement($18f2a8adc52b2e32$var$_baseNew.default, Object.assign({
        name: "ThemeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$18f2a8adc52b2e32$var$ThemeIcon.displayName = 'ThemeIcon';
var $18f2a8adc52b2e32$var$_default = module.exports.default = $18f2a8adc52b2e32$var$ThemeIcon;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $e0ycV = parcelRequire("e0ycV");


var $jRsqV = parcelRequire("jRsqV");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $g5QRf = parcelRequire("g5QRf");


var $5tmwS = parcelRequire("5tmwS");


var $cHaKZ = parcelRequire("cHaKZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5YfNL = parcelRequire("5YfNL");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions.liveDoc : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    if (isLivePage && isMarkdownMode) {
        let t3;
        if ($[4] !== color || $[5] !== label.id) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5YfNL.PageMarkdownIcon), {
                label: "",
                color: color,
                testId: label.id
            });
            $[4] = color;
            $[5] = label.id;
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    let t3;
    if ($[7] !== Icon || $[8] !== color || $[9] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[7] = Icon;
        $[8] = color;
        $[9] = label.id;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[type];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    if (isLivePage && isMarkdownMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5YfNL.PageMarkdownIcon), {
        label: "",
        color: color,
        testId: label.id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jRsqV))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("jRsqV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e75905caaf7b6b39$var$_react = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("42omo")));

var $e75905caaf7b6b39$var$_baseNew = $e75905caaf7b6b39$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e75905caaf7b6b39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e75905caaf7b6b39$var$NotepadIcon = (props)=>/*#__PURE__*/ $e75905caaf7b6b39$var$_react.default.createElement($e75905caaf7b6b39$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$e75905caaf7b6b39$var$NotepadIcon.displayName = 'NotepadIcon';
var $e75905caaf7b6b39$var$_default = module.exports.default = $e75905caaf7b6b39$var$NotepadIcon;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("5YfNL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $c9cfd0dc6a889fde$var$SPACING_TO_SIZE = {
    none: 16,
    spacious: 20
};
const $c9cfd0dc6a889fde$export$d1952cddb6415bbf = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { label: label, color: color, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "none" : t1;
    const size = $c9cfd0dc6a889fde$var$SPACING_TO_SIZE[spacing];
    const stroke = color ?? "var(--ds-icon-subtle, #505258)";
    const hasLabel = label.length > 0;
    let t2;
    if ($[0] !== hasLabel || $[1] !== label) {
        t2 = hasLabel ? {
            "aria-label": label,
            role: "img"
        } : {
            "aria-hidden": true
        };
        $[0] = hasLabel;
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    let t4;
    let t5;
    if ($[3] !== stroke) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M14.0625 6.5625H8.4375V0.9375M14.0625 6.5625V10M14.0625 6.5625C14.0625 6.16232 13.9035 5.77853 13.6206 5.49556L9.50444 1.37944C9.22147 1.09647 8.83768 0.9375 8.4375 0.9375M8.4375 0.9375H2.5C1.63705 0.9375 0.9375 1.63706 0.9375 2.5V17.5C0.9375 18.3629 1.63706 19.0625 2.5 19.0625",
            stroke: stroke,
            strokeWidth: "1.875",
            strokeLinejoin: "round"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M5.9375 20V13.4375H6.40625L8.75 17.8125L11.0938 13.4375H11.5625V20",
            stroke: stroke,
            strokeWidth: "1.875",
            strokeLinejoin: "round"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M16.5625 13.5V19.0625M16.5625 19.0625L19.0625 16.5625M16.5625 19.0625L14.0625 16.5625",
            stroke: stroke,
            strokeWidth: "1.875",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        });
        $[3] = stroke;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else {
        t3 = $[4];
        t4 = $[5];
        t5 = $[6];
    }
    let t6;
    if ($[7] !== size || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            "data-testid": testId,
            width: size,
            height: size,
            ...t2,
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t3, t4, t5);
        $[7] = size;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = testId;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ label: label, color: color, spacing: spacing = 'none', testId: testId })=>{
    const size = $c9cfd0dc6a889fde$var$SPACING_TO_SIZE[spacing];
    const stroke = color ?? "var(--ds-icon-subtle, #505258)";
    const hasLabel = label.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        "data-testid": testId,
        width: size,
        height: size,
        ...hasLabel ? {
            'aria-label': label,
            role: 'img'
        } : {
            'aria-hidden': true
        },
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.0625 6.5625H8.4375V0.9375M14.0625 6.5625V10M14.0625 6.5625C14.0625 6.16232 13.9035 5.77853 13.6206 5.49556L9.50444 1.37944C9.22147 1.09647 8.83768 0.9375 8.4375 0.9375M8.4375 0.9375H2.5C1.63705 0.9375 0.9375 1.63706 0.9375 2.5V17.5C0.9375 18.3629 1.63706 19.0625 2.5 19.0625",
        stroke: stroke,
        strokeWidth: "1.875",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.9375 20V13.4375H6.40625L8.75 17.8125L11.0938 13.4375H11.5625V20",
        stroke: stroke,
        strokeWidth: "1.875",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.5625 13.5V19.0625M16.5625 19.0625L19.0625 16.5625M16.5625 19.0625L14.0625 16.5625",
        stroke: stroke,
        strokeWidth: "1.875",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
module.exports["PageMarkdownIcon"] = $c9cfd0dc6a889fde$export$d1952cddb6415bbf;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("kvJHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $42omo.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $cbc8g.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("hrSFW", function(module, exports) {
var $cb3f5eae1efed147$var$has = Object.prototype.hasOwnProperty;
function $cb3f5eae1efed147$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $cb3f5eae1efed147$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($cb3f5eae1efed147$var$has.call(foo, ctor) && ++len && !$cb3f5eae1efed147$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$cb3f5eae1efed147$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $cb3f5eae1efed147$export$de8294bb3be0322f;

});

parcelRegister("24xEE", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f4e2c76b2dc4439a$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f4e2c76b2dc4439a$export$30ab340faaed55d4 = (experience)=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f4e2c76b2dc4439a$var$useConstructor(()=>experience.start());
    return null;
};
module.exports["useUFOComponentExperience"] = $f4e2c76b2dc4439a$export$30ab340faaed55d4;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("kqIWy", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("7DldS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f2cdb4cb36c37cab$export$bc9ec39841ba8fd3 = {
    CHAT: 'chat',
    SEARCH_QF_PILL: 'search-qf-connect-apps-pill',
    SEARCH_FPS_CONNECT_APPS_BUTTON: 'search-fps-connect-apps-button'
};
const $f2cdb4cb36c37cab$export$ec3ac09cbc485f99 = (surface)=>surface?.startsWith('search-') === true;
const $f2cdb4cb36c37cab$var$initialState = {
    product: '',
    siteId: '',
    experienceId: 'ai-mate',
    assistanceServiceConfig: undefined,
    surface: undefined
};
const $f2cdb4cb36c37cab$var$rovoSettingsConfig = /*#__PURE__*/ (0, $42omo.createContext)($f2cdb4cb36c37cab$var$initialState);
const $f2cdb4cb36c37cab$var$rovoSettingsModalMountedContext = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $f2cdb4cb36c37cab$export$e6e0575f100c37ab = $f2cdb4cb36c37cab$var$rovoSettingsConfig.Provider;
const $f2cdb4cb36c37cab$export$c32765f1b1c62608 = $f2cdb4cb36c37cab$var$rovoSettingsModalMountedContext.Provider;
const $f2cdb4cb36c37cab$export$db68c798d50f727e = ()=>(0, $42omo.useContext)($f2cdb4cb36c37cab$var$rovoSettingsConfig);
const $f2cdb4cb36c37cab$export$ddb548fa2ffa23a3 = ()=>(0, $42omo.useContext)($f2cdb4cb36c37cab$var$rovoSettingsModalMountedContext);
module.exports["RovoSettingsModalSurface"] = $f2cdb4cb36c37cab$export$bc9ec39841ba8fd3;
module.exports["isSearchSurface"] = $f2cdb4cb36c37cab$export$ec3ac09cbc485f99;
module.exports["RovoSettingsConfigProvider"] = $f2cdb4cb36c37cab$export$e6e0575f100c37ab;
module.exports["RovoSettingsModalMountedProvider"] = $f2cdb4cb36c37cab$export$c32765f1b1c62608;
module.exports["useRovoSettingsConfig"] = $f2cdb4cb36c37cab$export$db68c798d50f727e;
module.exports["useIsRovoSettingsModalProviderMounted"] = $f2cdb4cb36c37cab$export$ddb548fa2ffa23a3;

});

parcelRegister("7ZiAi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c17fc71688854b9e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $c17fc71688854b9e$export$defe85febe8b728c;

});

parcelRegister("efXed", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $02aebea47caa4c41$export$d158fa15757a1890 = /*#__PURE__*/ (0, $42omo.createContext)(false);
function $02aebea47caa4c41$export$abfcaeeca4ae7a55() {
    return (0, $42omo.useContext)($02aebea47caa4c41$export$d158fa15757a1890);
}
module.exports["HasCustomThemeContext"] = $02aebea47caa4c41$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $02aebea47caa4c41$export$abfcaeeca4ae7a55;

});

parcelRegister("lcVz9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

function $6b6d58426e4ff3f5$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $6b6d58426e4ff3f5$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $6b6d58426e4ff3f5$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $dh538.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, iconProps));
};
var $6b6d58426e4ff3f5$export$2e2bcd8739ae039 = $6b6d58426e4ff3f5$var$IconRenderer;
module.exports["default"] = $6b6d58426e4ff3f5$export$2e2bcd8739ae039;

});

parcelRegister("i63G2", function(module, exports) {
/* themed-pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $4jOXe = parcelRequire("4jOXe");

const $c0a568cbd64db8db$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $c0a568cbd64db8db$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $c0a568cbd64db8db$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $c0a568cbd64db8db$export$66240319f1f78d74 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        ...(0, $4jOXe.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($c0a568cbd64db8db$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $c0a568cbd64db8db$var$styles.rootT26Shape, $c0a568cbd64db8db$var$shapeStyles[shape], hasBorder && $c0a568cbd64db8db$var$styles.border, $c0a568cbd64db8db$var$appearanceStyles[appearance], isSelected && $c0a568cbd64db8db$var$styles.selected, isDisabled && $c0a568cbd64db8db$var$styles.disabled),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $c0a568cbd64db8db$export$66240319f1f78d74;

});

parcelRegister("4jOXe", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $9048d266fac6ebf2$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $9048d266fac6ebf2$export$e4c95325a21f9785;

});

parcelRegister("l7sDu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

var $24xEE = parcelRequire("24xEE");


var $4rFRN = parcelRequire("4rFRN");

function $eebcb10e5daa907f$var$useUFOExperience(id, config, instanceId) {
    return (0, $42omo.useMemo)(()=>new (0, $5aVN7.UFOExperience)(id, config, instanceId), [
        id,
        config,
        instanceId
    ]);
}
function $eebcb10e5daa907f$export$cdefb2a8b53f879f(key) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[key];
    const experience = $eebcb10e5daa907f$var$useUFOExperience(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
    (0, $24xEE.useUFOComponentExperience)(experience); // this hook starts the experience and aborts it when the component is unmounted
    return experience;
}
function $eebcb10e5daa907f$export$15f9dc99109fec75(key) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[key];
    return new (0, $5aVN7.UFOExperience)(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
}
module.exports["useExperienceTracker"] = $eebcb10e5daa907f$export$cdefb2a8b53f879f;
module.exports["createExperienceTracker"] = $eebcb10e5daa907f$export$15f9dc99109fec75;

});

parcelRegister("kxhju", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $iEfsZ = parcelRequire("iEfsZ");


var $42omo = parcelRequire("42omo");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $42omo.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "@confluence/web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("4ri4I", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $9zUhf.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $9zUhf.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("LSims", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "@confluence/content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<ee5ebd1d8707f26d05d3db2a4a758946>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("a6VRS", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Custom icon for a managed (synced) open folder.
 * Renders an open folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $6b5b62a1c1d5201a$export$d5c72b0cf938803f = ({ label: label, size: size = 'medium', color: color })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.31055 2.75H12C13.1046 2.75 14 3.64543 14 4.75V6H14.6599C15.5809 6 16.2416 6.88783 15.9771 7.77002L15.3081 10H13.7419L14.4919 7.5H4.55811L2.75806 13.5H10V15H1.75C0.783502 15 0 14.2165 0 13.25V3C0 1.89543 0.895431 1 2 1H5.56055L7.31055 2.75ZM2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V12.4731L3.14795 6.97998C3.32243 6.39838 3.85788 6 4.46509 6H12.5V4.75C12.5 4.47386 12.2761 4.25 12 4.25H6.68945L4.93945 2.5H2Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderOpenIcon"] = $6b5b62a1c1d5201a$export$d5c72b0cf938803f;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "@confluence/storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<ce267d56c5b6d7a41b23a639614e5b9e>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("fj1Kw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kNHXO = parcelRequire("kNHXO");


var $iVuOI = parcelRequire("iVuOI");

const $cfc409e85fa5c319$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $cfc409e85fa5c319$export$9923361bd43fa030 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iVuOI.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kNHXO))),
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $cfc409e85fa5c319$var$toggleButtonTooltipOptions,
        isSelected: isSelected
    }));
module.exports["AppSwitcher"] = $cfc409e85fa5c319$export$9923361bd43fa030;

});

parcelRegister("iG5N1", function(module, exports) {
/* custom-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");


var $8zs3p = parcelRequire("8zs3p");


var $efXed = parcelRequire("efXed");


var $f5yHb = parcelRequire("f5yHb");

const $2ec964433c134e18$var$anchorStyles = {
    root: "_2rkofajl _1e0c1txw _4cvr1h6o _4t3izwfg",
    customLogoBorderRadius: "_2rkofajl",
    customLogoBorderRadiusT26Shape: "_2rko1mok",
    newMargin: "_ahbq1b66",
    newInteractionStates: "_irr31dpa _1di69yc7",
    newInteractionStatesCustomTheming: "_irr31rps _1di6yhlj"
};
const $2ec964433c134e18$var$sharedIconOrLogoContainerStyles = {
    root: "_1reo15vq _18m915vq _18zr1b66 _bna71tcg _rtys1kw7 _1jpx1f51",
    withFullHeightSidebar: "_p12f1osq _1ul91tcg"
};
const $2ec964433c134e18$var$iconContainerStyles = {
    root: "_1e0c1txw _p12f1tcg _vchh1ntv _10y4glyw"
};
const $2ec964433c134e18$var$logoContainerStyles = {
    root: "_1e0cglyw _p12fnklw _vchh1ntv _10y41txw"
}; /**
    * __Custom logo__
    *
    * Custom logo for the top navigation.
    *
    * To provide a responsive experience, it requires both a logo and an icon component.
    * The logo component will be used for large viewports, and the icon component will be used for small viewports.
    */ 
const $2ec964433c134e18$export$4156d88e9ccc616b = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($2ec964433c134e18$var$anchorStyles.root, $2ec964433c134e18$var$anchorStyles.customLogoBorderRadius, (0, $dh538.fg)('platform-dst-shape-theme-default') && $2ec964433c134e18$var$anchorStyles.customLogoBorderRadiusT26Shape, $2ec964433c134e18$var$anchorStyles.newMargin, hasCustomTheme ? $2ec964433c134e18$var$anchorStyles.newInteractionStatesCustomTheming : $2ec964433c134e18$var$anchorStyles.newInteractionStates),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $2ec964433c134e18$var$sharedIconOrLogoContainerStyles.root,
            $2ec964433c134e18$var$iconContainerStyles.root,
            isFhsEnabled && $2ec964433c134e18$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5yHb.LogoRenderer), {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $2ec964433c134e18$var$sharedIconOrLogoContainerStyles.root,
            $2ec964433c134e18$var$logoContainerStyles.root,
            isFhsEnabled && $2ec964433c134e18$var$sharedIconOrLogoContainerStyles.withFullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5yHb.LogoRenderer), {
        logoOrIcon: logo
    })));
};
module.exports["CustomLogo"] = $2ec964433c134e18$export$4156d88e9ccc616b;

});

parcelRegister("f5yHb", function(module, exports) {
/* logo-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $efXed = parcelRequire("efXed");

const $d4db46a03d6fc29e$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $d4db46a03d6fc29e$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
function $d4db46a03d6fc29e$export$35e88bd9b061a3a4({ logoOrIcon: LogoOrIcon, shouldUseNewLogoDesign: shouldUseNewLogoDesign }) {
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ $42omo.createElement(LogoOrIcon, {
        label: "",
        size: "small",
        shouldUseNewLogoDesign: shouldUseNewLogoDesign,
        iconColor: `var(${$d4db46a03d6fc29e$export$24328117f1132113})`,
        textColor: `var(${$d4db46a03d6fc29e$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ $42omo.createElement(LogoOrIcon, {
        size: "small",
        shouldUseNewLogoDesign: shouldUseNewLogoDesign,
        label: "",
        appearance: "brand"
    });
}
module.exports["themedLogoIcon"] = $d4db46a03d6fc29e$export$24328117f1132113;
module.exports["themedLogoText"] = $d4db46a03d6fc29e$export$91b0830f8f4ab279;
module.exports["LogoRenderer"] = $d4db46a03d6fc29e$export$35e88bd9b061a3a4;

});

parcelRegister("2rzyy", function(module, exports) {
/* app-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $8zs3p = parcelRequire("8zs3p");


var $efXed = parcelRequire("efXed");


var $f5yHb = parcelRequire("f5yHb");

const $f59972940bc5f376$var$anchorStyles = {
    root: "_2rko19bv _1e0c1txw _4cvr1h6o _4t3izwfg _1o9zidpf _ahbq1b66 _1toh1r31 _5jyqglyw _mrqmnqa1 _1w901kw7",
    rootT26Shape: "_2rko1mok",
    interactionStates: "_irr31dpa _1di69yc7",
    interactionStatesCustomTheming: "_irr31rps _1di6yhlj",
    fullHeightSidebar: "_1reo15vq _18m915vq _1o9zkb7n"
};
const $f59972940bc5f376$var$logoWrapperStyles = {
    root: "_18zr1b66",
    fullHeightSidebar: "_p12f1osq"
};
const $f59972940bc5f376$var$iconContainerStyles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _p12f1tcg _c71l1tcg",
    fullHeightSidebar: "_1o9zidpf"
};
const $f59972940bc5f376$var$logoTextStyles = {
    root: "_1bsb1ris _p12fnklw _uiztglyw _y4tiv77o _1e0cglyw _10y418uv"
};
function $f59972940bc5f376$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
} /**
   * __App logo__
   *
   * The app logo for the top navigation.
   *
   * To provide a responsive experience, label text will render next to an icon at larger viewports.
   */ 
const $f59972940bc5f376$export$113a612889e1565d = ({ name: name, label: label, href: href, icon: icon, onClick: onClick })=>{
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const ref = (0, $42omo.useRef)(null);
    const nameRef = (0, $42omo.useRef)(null);
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)(); /**
                                               * Show the tooltip if the name is truncated
                                               */ 
    const canTooltipAppear = (0, $42omo.useCallback)(()=>{
        const text = nameRef.current;
        return Boolean(text && $f59972940bc5f376$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($f59972940bc5f376$var$anchorStyles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $f59972940bc5f376$var$anchorStyles.rootT26Shape, hasCustomTheme ? $f59972940bc5f376$var$anchorStyles.interactionStatesCustomTheming : $f59972940bc5f376$var$anchorStyles.interactionStates, isFhsEnabled && $f59972940bc5f376$var$anchorStyles.fullHeightSidebar),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.075",
        alignBlock: "center",
        xcss: (0, $1bHXt.cx)($f59972940bc5f376$var$logoWrapperStyles.root, isFhsEnabled && $f59972940bc5f376$var$logoWrapperStyles.fullHeightSidebar)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $f59972940bc5f376$var$iconContainerStyles.root,
            isFhsEnabled && $f59972940bc5f376$var$iconContainerStyles.fullHeightSidebar
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5yHb.LogoRenderer // Top nav always uses the new logo design
    ), {
        shouldUseNewLogoDesign: true,
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            $f59972940bc5f376$var$logoTextStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: name,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered in the nav item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            "aria-hidden": true,
            color: "inherit",
            weight: "semibold",
            maxLines: 1,
            ref: nameRef
        }, name))))));
};
module.exports["AppLogo"] = $f59972940bc5f376$export$113a612889e1565d;

});

parcelRegister("dukN8", function(module, exports) {
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");

function $d10523bc4e7074f3$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $42omo.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $d10523bc4e7074f3$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $42omo.forwardRef)($d10523bc4e7074f3$var$_ListItem);
module.exports["ListItem"] = $d10523bc4e7074f3$export$a7b06bfba60a8a78;

});

parcelRegister("aGop9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");


var $efXed = parcelRequire("efXed");


var $17zLw = parcelRequire("17zLw");

const $90c58b5063b4a6d0$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $17zLw.ThemedButton) : (0, $ccHMk.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["Button"] = $90c58b5063b4a6d0$export$353f5b6fc5456de1;

});

parcelRegister("17zLw", function(module, exports) {
/* themed-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $lcVz9 = parcelRequire("lcVz9");


var $i63G2 = parcelRequire("i63G2");

const $246516ea69fcef3e$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $246516ea69fcef3e$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i63G2.ThemedPressable), {
        ...props,
        ref: ref
    }, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            $246516ea69fcef3e$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lcVz9.default), {
        icon: IconBefore
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            $246516ea69fcef3e$var$textButtonStyles.text
        ])
    }, children));
});
module.exports["ThemedButton"] = $246516ea69fcef3e$export$f67fb575035cc7d0;

});

parcelRegister("8zu8b", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dukN8 = parcelRequire("dukN8");


var $iVuOI = parcelRequire("iVuOI");

const $44a5ab6ab1735952$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $dukN8.ListItem) : (0, $42omo.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iVuOI.IconButton), {
        ref: forwardedRef,
        icon: icon,
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        appearance: "subtle",
        isSelected: isSelected,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        // Only creating object when shortcut is provided
        tooltip: shortcut ? {
            shortcut: shortcut
        } : undefined
    }));
});
module.exports["EndItem"] = $44a5ab6ab1735952$export$b3477e90773be2d0;

});

parcelRegister("gaXc0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ckcSY = parcelRequire("ckcSY");


var $2uMjy = parcelRequire("2uMjy");


var $8zu8b = parcelRequire("8zu8b");

const $90d8da16fbe995a1$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $90d8da16fbe995a1$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $42omo.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2uMjy.BadgeContainer), {
        id: $90d8da16fbe995a1$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zu8b.EndItem), {
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ckcSY))),
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false,
        shortcut: shortcut
    }));
});
module.exports["Notifications"] = $90d8da16fbe995a1$export$36ba2f559d49a8f6;

});

parcelRegister("2uMjy", function(module, exports) {
/* badge-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $aed22086c0956b03$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $aed22086c0956b03$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ $42omo.createElement("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $gMc0m.default)([
            $aed22086c0956b03$var$styles.root
        ])
    }, children, /*#__PURE__*/ $42omo.createElement("div", {
        id: badgeId,
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            $aed22086c0956b03$var$styles.badgeContainer
        ])
    }, /*#__PURE__*/ $42omo.createElement(Badge, null)));
module.exports["BadgeContainer"] = $aed22086c0956b03$export$f710265eb5a003da;

});

parcelRegister("hOWPZ", function(module, exports) {
/**
 * @jsxRuntime classic
 */ 
var $42omo = parcelRequire("42omo");


var $ci7Ox = parcelRequire("ci7Ox");


var $2uMjy = parcelRequire("2uMjy");


var $8zu8b = parcelRequire("8zu8b");

const $2a846bdc2a978f08$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $2a846bdc2a978f08$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $42omo.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref,
        shortcut: shortcut
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zu8b.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2uMjy.BadgeContainer), {
        id: $2a846bdc2a978f08$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zu8b.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});
module.exports["Help"] = $2a846bdc2a978f08$export$1be7516c0280bee8;

});

parcelRegister("7Ek7o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $8zu8b = parcelRequire("8zu8b");

const $6682f6602289a7fc$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ src: src, ...props }, ref)=>{
    const ProfileAvatar = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            appearance: "circle",
            src: src,
            size: "small"
        }), [
        src
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zu8b.EndItem), {
        ...props,
        ref: ref,
        icon: ProfileAvatar
    });
});
module.exports["Profile"] = $6682f6602289a7fc$export$5120f2d0b8d4cab8;

});

parcelRegister("9xVAL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fIcbd = parcelRequire("fIcbd");


var $8zu8b = parcelRequire("8zu8b");

const $edb6938477f5d9c0$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zu8b.EndItem), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd)))
    }));
module.exports["Settings"] = $edb6938477f5d9c0$export$c72f6eaae7b9adff;

});

parcelRegister("9820v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ilSNM = parcelRequire("ilSNM");


var $dukN8 = parcelRequire("dukN8");


var $h964h = parcelRequire("h964h");

const $cf91a80b7e9b26e7$export$88195aaac9f90319 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label }, ref)=>/**
 * This component doesn't use `EndItem` internally because it renders a
 * `LinkIconButton` instead of an `IconButton`.
 *
 * We could make another abstraction, but this is the only top navigation item
 * that renders a link.
 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dukN8.ListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h964h.LinkIconButton), {
        ref: ref,
        label: label,
        href: href,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        testId: testId,
        interactionName: interactionName,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ilSNM))),
        appearance: "subtle",
        isTooltipDisabled: false
    })));
module.exports["LogIn"] = $cf91a80b7e9b26e7$export$88195aaac9f90319;

});

parcelRegister("h964h", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dE1p6 = parcelRequire("dE1p6");


var $efXed = parcelRequire("efXed");


var $bmUZj = parcelRequire("bmUZj");

const $2ba2fc0879cc18f5$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $bmUZj.ThemedLinkIconButton) : (0, $dE1p6.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["LinkIconButton"] = $2ba2fc0879cc18f5$export$edad7fca51b767e1;

});

parcelRegister("bmUZj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $jLMFb = parcelRequire("jLMFb");

function $38dcf72d1c5b31e8$var$ThemedLinkIconButtonFn({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label
    }, (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jLMFb.ThemedAnchor), {
            ...props,
            shape: "square",
            ref: (0, $3654r.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps?.onClick?.(event);
            },
            onMouseOver: (e)=>{
                triggerProps.onMouseOver?.(e);
                props.onMouseOver?.(e);
            },
            onMouseOut: (e)=>{
                triggerProps.onMouseOut?.(e);
                props.onMouseOut?.(e);
            },
            onMouseMove: (e)=>{
                triggerProps.onMouseMove?.(e);
                props.onMouseMove?.(e);
            },
            onMouseDown: (e)=>{
                triggerProps.onMouseDown?.(e);
                props.onMouseDown?.(e);
            },
            onFocus: (e)=>{
                triggerProps.onFocus?.(e);
                props.onFocus?.(e);
            },
            onBlur: (e)=>{
                triggerProps.onBlur?.(e);
                props.onBlur?.(e);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, label)));
}
const $38dcf72d1c5b31e8$export$a1ab08e79d264ec8 = (0, $3hoG4.default)($38dcf72d1c5b31e8$var$ThemedLinkIconButtonFn);
module.exports["ThemedLinkIconButton"] = $38dcf72d1c5b31e8$export$a1ab08e79d264ec8;

});

parcelRegister("jLMFb", function(module, exports) {
/* themed-anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $3hoG4 = parcelRequire("3hoG4");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");


var $4jOXe = parcelRequire("4jOXe");

const $68b3977a5ab1a438$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $68b3977a5ab1a438$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
const $68b3977a5ab1a438$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
}; /**
    * Props that are common between link buttons.
    */ 
function $68b3977a5ab1a438$var$ThemedAnchorFn({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        ...(0, $4jOXe.getPrimitiveSpreadProps)(props),
        ref: ref,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($68b3977a5ab1a438$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $68b3977a5ab1a438$var$styles.rootT26Shape, $68b3977a5ab1a438$var$shapeStyles[shape], hasBorder && $68b3977a5ab1a438$var$styles.border, $68b3977a5ab1a438$var$appearanceStyles[appearance], isSelected && $68b3977a5ab1a438$var$styles.selected, isDisabled && $68b3977a5ab1a438$var$styles.disabled)
    });
} /**
   * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
   *
   * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
   *
   * Polymorphism had many typing issues and required sacrificing type safety.
   *
   * Render props had problems passing down styles through `xcss` to the `children` function.
   */ 
const $68b3977a5ab1a438$export$1b69d1a78614cc52 = (0, $3hoG4.default)($68b3977a5ab1a438$var$ThemedAnchorFn);
module.exports["ThemedAnchor"] = $68b3977a5ab1a438$export$1b69d1a78614cc52;

});

parcelRegister("e1eDr", function(module, exports) {
/* custom-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $efXed = parcelRequire("efXed");

const $af11962bf99de229$var$styles = {
    root: "_1reo15vq _18m915vq _11c8fhey _o5721q9c _p12fuuw1 _1bto1l2s _bozg1b66 _y4tiu2gc _1e0cglyw _10y41txw",
    subtleText: "_syazazsu"
};
const $af11962bf99de229$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    return /*#__PURE__*/ $42omo.createElement("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $af11962bf99de229$var$styles.root,
            !hasCustomTheme && $af11962bf99de229$var$styles.subtleText
        ])
    }, children);
});
module.exports["CustomTitle"] = $af11962bf99de229$export$9ccddf7ee2a0e24e;

});

parcelRegister("lBYCH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $42omo.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("1KBSi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const t0 = !isLicensed;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $fEhQK.default), {
        ...t1,
        __callerPackage__: "@confluence/create-space"
    });
    let t2;
    if ($[2] !== canCreateData?.user?.confluence?.operations) {
        t2 = canCreateData?.user?.confluence?.operations.some($15029de520f1b9e8$var$_temp);
        $[2] = canCreateData?.user?.confluence?.operations;
        $[3] = t2;
    } else t2 = $[3];
    const canCreateSpace = Boolean(t2);
    let t3;
    if ($[4] !== canCreateSpace || $[5] !== loading) {
        t3 = {
            canCreateSpace: canCreateSpace,
            loading: loading
        };
        $[4] = canCreateSpace;
        $[5] = loading;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed,
        __callerPackage__: "@confluence/create-space"
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace,
        loading: loading
    };
};
function $15029de520f1b9e8$var$_temp(obj) {
    return obj?.operation === "create_space";
}
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<d77a8b66c12ddab3ba49d583bea28ad7>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("jojoK", function(module, exports) {
const $6eadce97261b744f$var$LOOM_URL_REGEX = // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
function $6eadce97261b744f$var$extractLoomVideoId(url) {
    const match = url.match($6eadce97261b744f$var$LOOM_URL_REGEX);
    return match?.groups?.videoId;
}
async function $6eadce97261b744f$var$digestMessage(message) {
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
    if (window?.crypto?.subtle?.digest) {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
    }
    return '';
}
async function $6eadce97261b744f$export$495fb2ecc80ca6c0(url) {
    try {
        const videoId = $6eadce97261b744f$var$extractLoomVideoId(url);
        if (videoId) {
            const data = atob('c2U1UTwgekZlVEYkP1MzRno1QmV5WXBoSE13SHg8RWpjM10saHJQZmhPMVVHKHM=') + videoId;
            const digestHex = await $6eadce97261b744f$var$digestMessage(data);
            return digestHex ? `vidhash-${digestHex}` : '';
        }
        return '';
    } catch (_) {
        return '';
    }
}
module.exports["getHashedLoomVideoIdFromUrl"] = $6eadce97261b744f$export$495fb2ecc80ca6c0;

});

parcelRegister("ibDKJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $cOrQJ = parcelRequire("cOrQJ");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $36Swo = parcelRequire("36Swo");

const $e5b02ec9368d4295$var$i18n = (0, $aXWIB.defineMessages)({
    tooltip: {
        id: "ai-common.ai-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $e5b02ec9368d4295$var$lozengeStyles = {
    lozenge: "_2rko12b0 _18zr1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
    tooltip: "_2rko12b0 _11c8wadc _vchhusvi _p12f7l9q _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
};
const $e5b02ec9368d4295$var$gradientWaveKeyframes = null;
const $e5b02ec9368d4295$var$sampResetStyles = null;
const $e5b02ec9368d4295$var$lozengeAnimatedBorder = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $e5b02ec9368d4295$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            $e5b02ec9368d4295$var$lozengeStyles.tooltip
        ])
    }, children);
});
const $e5b02ec9368d4295$export$48aba4499a97f6bf = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // We don't want to i18n the term 'AI Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        component: $e5b02ec9368d4295$var$CustomTooltip,
        content: formatMessage($e5b02ec9368d4295$var$i18n.tooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "ai-labs-lozenge",
        className: (0, $gMc0m.default)([
            $e5b02ec9368d4295$var$lozengeStyles.lozenge,
            "_2rko12b0 _18zr1b66 _kqswh2mm _bfhksm61 _1e0c1txw _4cvr1h6o _1bah1h6o _1pbyidpf _1tesidpf _rfx312b0 _1414t94y _p7f0t94y _7gpxt94y _syayt94y _1s6kyrfl _16qq1ajn _1kt9b3bt _1cs8stnw _1ankm4tz _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw _1g0v1mrw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "hug",
        space: "space.025",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36Swo.LabsIcon), {
        darkMode: colorMode === 'dark'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        weight: "semibold",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("samp", {
        className: (0, $gMc0m.default)([
            "_11c81kw7"
        ])
    }, "LABS"))))));
};
module.exports["AILabsLozenge"] = $e5b02ec9368d4295$export$48aba4499a97f6bf;

});

parcelRegister("36Swo", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $ffeb61eca9109eeb$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon-dark"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_1466_13761)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_1466_13761"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_1352_45568)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "#1E1F21"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_1352_45568"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    }))));
};
module.exports["LabsIcon"] = $ffeb61eca9109eeb$export$36be37b392de5213;

});

parcelRegister("evORK", function(module, exports) {

var $dlSEv = parcelRequire("dlSEv");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $dlSEv.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        // eslint-disable-next-line confluence-targeting-usage/no-legacy-tap-personalization-api -- To be migrated to useSiteTraits. See ACTIVATION-2527
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("cbBHq", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $42omo = parcelRequire("42omo");


var $lvOsp = parcelRequire("lvOsp");


var $9wGTI = parcelRequire("9wGTI");


var $2PxwR = parcelRequire("2PxwR");


var $6gwjd = parcelRequire("6gwjd");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $6gwjd.default), {
        __callerPackage__: "@confluence/smart-create"
    });
    return (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) {
            preloadSmartCreationModalQuery();
            (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
        }
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("2xC2p"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("2xC2p", function(module, exports) {

let $1d9c2b5af836991f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d9c2b5af836991f$var$load("2N8TW"),
    $1d9c2b5af836991f$var$load("j3QFG"),
    $1d9c2b5af836991f$var$load("cj0Rr"),
    $1d9c2b5af836991f$var$load("c0JsV"),
    $1d9c2b5af836991f$var$load("h3ABO"),
    $1d9c2b5af836991f$var$load("kczDh"),
    $1d9c2b5af836991f$var$load("6vHwB"),
    $1d9c2b5af836991f$var$load("dafa3"),
    $1d9c2b5af836991f$var$load("iEUHW"),
    $1d9c2b5af836991f$var$load("kbwlB"),
    $1d9c2b5af836991f$var$load("2YffH"),
    $1d9c2b5af836991f$var$load("9XOeB"),
    $1d9c2b5af836991f$var$load("xu7ej"),
    $1d9c2b5af836991f$var$load("iQ4FP"),
    $1d9c2b5af836991f$var$load("ix1qx"),
    $1d9c2b5af836991f$var$load("amnV8"),
    $1d9c2b5af836991f$var$load("iVpKC"),
    $1d9c2b5af836991f$var$load("9anPW"),
    $1d9c2b5af836991f$var$load("5hHiM"),
    $1d9c2b5af836991f$var$load("ekVkn"),
    $1d9c2b5af836991f$var$load("6wmiZ"),
    $1d9c2b5af836991f$var$load("im1VN"),
    $1d9c2b5af836991f$var$load("jZxyE"),
    $1d9c2b5af836991f$var$load("gWJnq"),
    $1d9c2b5af836991f$var$load("9JqIY"),
    $1d9c2b5af836991f$var$load("ad7Qp"),
    $1d9c2b5af836991f$var$load("16ESi"),
    $1d9c2b5af836991f$var$load("gnDXu"),
    $1d9c2b5af836991f$var$load("93EyF"),
    $1d9c2b5af836991f$var$load("6EuUL"),
    $1d9c2b5af836991f$var$load("lbhYb"),
    $1d9c2b5af836991f$var$load("emINS"),
    $1d9c2b5af836991f$var$load("fZvb9"),
    $1d9c2b5af836991f$var$load("1w4HF"),
    $1d9c2b5af836991f$var$load("lTK3c"),
    $1d9c2b5af836991f$var$load("1WXdc"),
    $1d9c2b5af836991f$var$load("b2FtX"),
    $1d9c2b5af836991f$var$load("kzf0u"),
    $1d9c2b5af836991f$var$load("7BszR"),
    $1d9c2b5af836991f$var$load("hhss7"),
    $1d9c2b5af836991f$var$load("6iz6l"),
    $1d9c2b5af836991f$var$load("4SCW2"),
    $1d9c2b5af836991f$var$load("1WLQT"),
    $1d9c2b5af836991f$var$load("8uDd1"),
    $1d9c2b5af836991f$var$load("hdYRX"),
    $1d9c2b5af836991f$var$load("7cXiI"),
    $1d9c2b5af836991f$var$load("5V8sC"),
    $1d9c2b5af836991f$var$load("57oeB"),
    $1d9c2b5af836991f$var$load("cRtGo"),
    $1d9c2b5af836991f$var$load("6wr18"),
    $1d9c2b5af836991f$var$load("jvHRs"),
    $1d9c2b5af836991f$var$load("3BYXV"),
    $1d9c2b5af836991f$var$load("c251E"),
    $1d9c2b5af836991f$var$load("k4cyN"),
    $1d9c2b5af836991f$var$load("Wowvf"),
    $1d9c2b5af836991f$var$load("ffEVr"),
    $1d9c2b5af836991f$var$load("5sTNh"),
    $1d9c2b5af836991f$var$load("jOUAD"),
    $1d9c2b5af836991f$var$load("6bVVs"),
    $1d9c2b5af836991f$var$load("7mo6o"),
    $1d9c2b5af836991f$var$load("hkt44"),
    $1d9c2b5af836991f$var$load("jnVKv"),
    $1d9c2b5af836991f$var$load("bgHzk"),
    $1d9c2b5af836991f$var$load("7EorR"),
    $1d9c2b5af836991f$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("6gwjd", function(module, exports) {
/**
 * @generated SignedSource<<a3348c8e36a607de9ae3301a1935d17b>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641
const $7b2c6142b984d24d$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e04a1fbd9772100897718d8eb52d327f",
            "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
            "metadata": {},
            "name": "ConfluenceSmartCreationModalQuery",
            "operationKind": "query",
            "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$7b2c6142b984d24d$var$node.hash = "b82822dc05785ac3b5e50c2feec2f4f2";
var $7b2c6142b984d24d$export$2e2bcd8739ae039 = $7b2c6142b984d24d$var$node;
module.exports["default"] = $7b2c6142b984d24d$export$2e2bcd8739ae039;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("8hkPB", function(module, exports) {
/* SmartFolderSyncIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $jY68A = parcelRequire("jY68A");

const $ae9f424642e328f9$var$i18n = (0, $aXWIB.defineMessages)({
    syncingFolder: {
        id: "smart-folder.sync-icon.syncing",
        defaultMessage: "Syncing folder"
    }
});
const $ae9f424642e328f9$var$spinAnimation = null;
const $ae9f424642e328f9$var$styles = {
    root: "_1e0c116y _4cvr1h6o _1bah1h6o _j7hqtakz _5sag7r0q _tip812c5 _1pglp3kn"
}; /**
    * A small animated sync icon shown while a smart folder is being synchronised.
    *
    * Renders a rotating `SyncIcon` wrapped in an `inline-flex` container.
    * The animation is applied to the wrapper (not the SVG itself) so that React
    * re-renders of the SVG do not reset the spin timeline.
    */ 
const $ae9f424642e328f9$export$ff90b815577daa98 = ({ testId: testId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const label = intl.formatMessage($ae9f424642e328f9$var$i18n.syncingFolder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $ae9f424642e328f9$var$styles.root,
        testId: testId,
        role: "status",
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jY68A))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};
module.exports["SmartFolderSyncIcon"] = $ae9f424642e328f9$export$ff90b815577daa98;

});

parcelRegister("6ld6a", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $6a9Hv = parcelRequire("6a9Hv");


var $da6ky = parcelRequire("da6ky");


var $jtuBN = parcelRequire("jtuBN");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipQuery || $[9] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery
        };
        $[8] = skipQuery;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), baseQueryOptions);
    if (!data) {
        let t8;
        let t9;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[11] = t8;
            $[12] = t9;
        } else {
            t8 = $[11];
            t9 = $[12];
        }
        let t10;
        if ($[13] !== error || $[14] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[13] = error;
            $[14] = loading;
            $[15] = t10;
        } else t10 = $[15];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[16] !== allowedWebItems || $[17] !== data || $[18] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        $[16] = allowedWebItems;
        $[17] = data;
        $[18] = notAllowedWebItems;
        $[19] = webItems;
        $[20] = webSections;
    } else {
        webItems = $[19];
        webSections = $[20];
    }
    let t8;
    if ($[21] !== error || $[22] !== webItems || $[23] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[21] = error;
        $[22] = webItems;
        $[23] = webSections;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("26eSY", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $j3O94 = parcelRequire("j3O94");


var $gjFIy = parcelRequire("gjFIy");

function $81e208d7c03fb2bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81e208d7c03fb2bd$var$showAboveQueries = (0, $j3O94.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$showBelowQueries = (0, $gjFIy.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $81e208d7c03fb2bd$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $81e208d7c03fb2bd$var$defaultHiddenStyles,
            above && $81e208d7c03fb2bd$var$showAboveQueries[above],
            below && $81e208d7c03fb2bd$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $81e208d7c03fb2bd$export$f6a3d19be20f5819;

});

parcelRegister("j3O94", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $9K4OG = parcelRequire("9K4OG");


var $1LBzd = parcelRequire("1LBzd");


var $dhECE = parcelRequire("dhECE");

const $0e33cce764fb92cd$export$918f8818cfbbeb2c = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $dhECE.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $0e33cce764fb92cd$export$918f8818cfbbeb2c;

});

parcelRegister("1LBzd", function(module, exports) {
const $a161739fae125cf6$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $a161739fae125cf6$export$2d293d9871c38e91 = Object.keys($a161739fae125cf6$export$e5ee4fe8b989fd09);
const $a161739fae125cf6$export$b7ed752a57b4177b = $a161739fae125cf6$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $a161739fae125cf6$export$2d293d9871c38e91;

});

parcelRegister("gjFIy", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $9K4OG = parcelRequire("9K4OG");


var $1LBzd = parcelRequire("1LBzd");


var $bWLcG = parcelRequire("bWLcG");

const $2c6e513510594637$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $2c6e513510594637$export$b2a4e2b0c6417297;

});

parcelRegister("291hi", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $j3O94 = parcelRequire("j3O94");


var $gjFIy = parcelRequire("gjFIy");

const $725b0c40c654c097$var$hideAboveQueries = (0, $j3O94.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$var$hideBelowQueries = (0, $gjFIy.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $725b0c40c654c097$var$hideAboveQueries[above],
            below && $725b0c40c654c097$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Hide"] = $725b0c40c654c097$export$bed28288a051538;

});

parcelRegister("awSMG", function(module, exports) {
const $4ce470d2dd3584e9$export$6ff460ddb5710005 = 'editor:offline-steps-';
const $4ce470d2dd3584e9$export$7023de141f2ab721 = 'meta';
const $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7 = 'steps';
const $4ce470d2dd3584e9$export$9fd1ded1027f9ea2 = 2;
module.exports["OFFLINE_STEPS_DATABASE_NAME_PREFIX"] = $4ce470d2dd3584e9$export$6ff460ddb5710005;
module.exports["OFFLINE_META_STORE_NAME"] = $4ce470d2dd3584e9$export$7023de141f2ab721;
module.exports["OFFLINE_STEPS_STORE_NAME"] = $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7;
module.exports["OFFLINE_STEPS_DATABASE_VERSION"] = $4ce470d2dd3584e9$export$9fd1ded1027f9ea2;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("TlnoT"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("TlnoT"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("ddmQY"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("TlnoT", function(module, exports) {

let $0a65b815130303b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0a65b815130303b5$var$load("lkOIY"),
    $0a65b815130303b5$var$load("6wr18"),
    $0a65b815130303b5$var$load("khyhL"),
    $0a65b815130303b5$var$load("ffEVr"),
    $0a65b815130303b5$var$load("hhss7"),
    $0a65b815130303b5$var$load("kHOMt"),
    $0a65b815130303b5$var$load("7EorR"),
    $0a65b815130303b5$var$load("Wowvf"),
    $0a65b815130303b5$var$load("cRtGo"),
    $0a65b815130303b5$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("ddmQY", function(module, exports) {

let $99ee3773125bddc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ee3773125bddc9$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("7yn0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4ri4I = parcelRequire("4ri4I");


var $58PBI = parcelRequire("58PBI");

const $41894bf31b7b5c77$export$c6419170331da813 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { children: children, editSource: t1 } = t0;
    const editSource = t1 === undefined ? "" : t1;
    const preloader = (0, $42omo.useContext)((0, $58PBI.EditContentButtonPreloaderContext));
    const [doPreload, setDoPreload] = (0, $42omo.useState)(false);
    const [t2, t3] = (0, $4ri4I.useEditSource)();
    const { editSource: contextEditSource } = t2;
    const { setEditSource: setEditSource } = t3;
    let t4;
    if ($[0] !== editSource || $[1] !== setEditSource) {
        t4 = ()=>{
            setEditSource(editSource);
            setDoPreload(true);
        };
        $[0] = editSource;
        $[1] = setEditSource;
        $[2] = t4;
    } else t4 = $[2];
    const onHover = t4;
    let t5;
    if ($[3] !== children || $[4] !== onHover) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, children);
        $[3] = children;
        $[4] = onHover;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== contextEditSource || $[7] !== doPreload || $[8] !== editSource || $[9] !== preloader) {
        t6 = editSource === contextEditSource && doPreload && preloader ? preloader({}) : null;
        $[6] = contextEditSource;
        $[7] = doPreload;
        $[8] = editSource;
        $[9] = preloader;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t5, t6);
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
module.exports["CreateContentButtonPreloader"] = $41894bf31b7b5c77$export$c6419170331da813;

});

parcelRegister("7DERG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0c65948d0a153f5$export$92e41deae5b713d0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "c07Cp",
    name: 'ConfluenceSmartCreationModalLoader',
    loader: async ()=>(await (parcelRequire("gXz7g"))).ConfluenceSmartCreationModalManager
});
module.exports["ConfluenceSmartCreationModalLoader"] = $b0c65948d0a153f5$export$92e41deae5b713d0;

});

parcelRegister("gXz7g", function(module, exports) {

let $c58d65637ab6e9ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c58d65637ab6e9ee$var$load("gs8si").then(()=>parcelRequire('iaA9H'));

});

parcelRegister("c5zvz", function(module, exports) {
$parcel$export(module.exports, "useConfluenceStandardToPremiumPUBTouchpoint", () => (parcelRequire("fBwOr")).useConfluenceStandardToPremiumPUBTouchpoint);
$parcel$export(module.exports, "StandardToPremiumModalMountComponent", () => (parcelRequire("5DQLv")).StandardToPremiumModalMountComponent);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5izcQ = parcelRequire("5izcQ");


var $bedQP = parcelRequire("bedQP");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");



var $fBwOr = parcelRequire("fBwOr");


var $5DQLv = parcelRequire("5DQLv");

const $ce6cbe4a9370c72f$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce6cbe4a9370c72f$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw _1ydi18uv",
            __cmplp.className
        ])
    });
});

const $ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IlAy6",
    name: "EditionAwarenessUpsellLoadable",
    loader: async ()=>(await (parcelRequire("29qEi"))).EditionAwarenessUpsell
});
const $ce6cbe4a9370c72f$export$f255ec0f3619af65 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(({ navVersion: navVersion })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$RemovedSpotlightTarget, {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable, {
        navVersion: navVersion
    })));
});
module.exports["EditionAwarenessUpsellExperiment"] = $ce6cbe4a9370c72f$export$f255ec0f3619af65;

});

parcelRegister("fBwOr", function(module, exports) {

var $e3pFO = parcelRequire("e3pFO");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $50xoH = parcelRequire("50xoH");


var $7Sm4c = parcelRequire("7Sm4c");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $99oLS = parcelRequire("99oLS");


var $hxSIT = parcelRequire("hxSIT");


var $aT8im = parcelRequire("aT8im");


var $jMyy4 = parcelRequire("jMyy4");

const $000cc169882182f2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    persistentUpgradeMenuItemFreePlanTitle: {
        id: "experiment-edition-awareness-for-standard-to-premium.section.message.persistent-upgrade.menuitem.premiumplan.title",
        defaultMessage: "Upgrade"
    }
});
const $000cc169882182f2$export$70b32605d3b8db81 = (navVersion)=>{
    const [renderFailed, setRenderFailed] = (0, $42omo.useState)(false);
    const { cloudId: cloudId, isEligibleForUpsellExperiment: isEligibleForUpsellExperiment, hasDismissedButton: hasDismissedButton } = (0, $aT8im.useConfluenceStandardToPremiumExperiment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal, setModalProps: setModalProps } = (0, $99oLS.useConfluenceStandardToPremiumModalActions)();
    // isEligibleForUpsellExperiment checks for experiment enrollment as well
    const meetsBaseEligibility = isEligibleForUpsellExperiment && hasDismissedButton;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $e3pFO.default), {
        interopApolloAggClient: true,
        variables: {
            cloudId: cloudId,
            productKey: 'confluence',
            trialOfferingName: 'Premium'
        },
        skip: !meetsBaseEligibility,
        __callerPackage__: "@confluence/experiment-edition-awareness-for-standard-to-premium"
    });
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) {
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'persistent-upgrade-button-standard-to-premium',
                source: 'useConfluenceStandardToPremiumPUBTouchpoint',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion,
                    error: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isEligibleForStandardToPremiumPersistentUpgradeButton = meetsBaseEligibility && !renderFailed;
    const experienceUrl = data?.tenantContexts?.[0]?.entitlementInfo?.paidEntitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    if (!loading && isEligibleForStandardToPremiumPersistentUpgradeButton && (!experienceUrl || experienceUrl?.includes('admin/billing'))) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'error',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessStandardToPremiumDialog',
            attributes: {
                product: 'confluence',
                touchpointIntent: 'startTrial',
                dialogId: 'standard-to-premium',
                dialogType: 'modal',
                error: 'No change offering URL found for premium upgrade - using fallback',
                navVersion: navVersion,
                changeOfferingUrl: experienceUrl ?? '',
                isEligibleForStandardToPremiumPersistentUpgradeButton: isEligibleForStandardToPremiumPersistentUpgradeButton
            },
            source: 'useConfluenceStandardToPremiumPUBTouchpoint'
        }
    }).fire();
    // remove the edition from the change plan urls so they land on the plan selection page for hams || ccp
    // there may be a key in shared tenant context api that can be used instead of this
    const learnMoreUrl = (0, $hxSIT.useBuildLearnMoreLink)(experienceUrl);
    const handlePUBClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'persistent-upgrade-button-standard-to-premium',
                attributes: {
                    growthFeature: 'EditionAwareness',
                    navVersion: navVersion
                },
                source: 'useConfluenceStandardToPremiumPUBTouchpoint'
            }
        }).fire();
        setModalProps({
            experienceUrl: experienceUrl ?? '',
            learnMoreUrl: learnMoreUrl,
            navVersion: navVersion
        });
        showModal({
            touchpointId: 'edition-awareness-standard-to-premium-pub'
        });
    }, [
        createAnalyticsEvent,
        showModal,
        setModalProps,
        experienceUrl,
        learnMoreUrl,
        navVersion
    ]);
    if (!isEligibleForStandardToPremiumPersistentUpgradeButton || loading || error) return [];
    return [
        {
            heading: {
                ...$000cc169882182f2$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanTitle
            },
            items: [
                {
                    action: ()=>handlePUBClick(),
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
                        onError: ()=>setRenderFailed(true)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $50xoH.EditionAwarenessStandardPubTouchpoint), {
                        product: "confluence",
                        testId: "edition-awareness-standard-pub-touchpoint",
                        navVersion: navVersion
                    })),
                    key: 'try-premium-plan'
                }
            ]
        }
    ];
};
module.exports["useConfluenceStandardToPremiumPUBTouchpoint"] = $000cc169882182f2$export$70b32605d3b8db81;

});

parcelRegister("e3pFO", function(module, exports) {
/**
 * @generated SignedSource<<d7191aacd7cf9cb4f2383db589b1a978>>
 * @relayHash be3ae060e2f957b2adfb254e6120448a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54149d8226391da92fe5e768c4f208171509220a72b1dc7c3344710a49c8b746
const $99718f6709017e62$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "trialOfferingName"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "inTrialOrPreDunning": false
            }
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "trialOfferingName"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "paidEntitlement",
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "alias": "paidEntitlement",
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "be3ae060e2f957b2adfb254e6120448a",
            "id": "54149d8226391da92fe5e768c4f208171509220a72b1dc7c3344710a49c8b746",
            "metadata": {},
            "name": "useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery",
            "operationKind": "query",
            "text": "query useConfluenceStandardToPremiumPUBTouchpointconfluenceEditionAwarenessQuery($cloudId:ID!,$productKey:String!,$trialOfferingName:String!){tenantContexts(cloudIds:[$cloudId])@optIn(to:[\"CcpAllUserUpgradeAndPay\",\"HamsAllUserUpgradeAndPay\"]){entitlementInfo(hamsProductKey:$productKey){__typename,paidEntitlement:entitlement(where:{inTrialOrPreDunning:false}){__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$trialOfferingName){__typename,experienceUrl}},id}}}}"
        }
    };
}();
$99718f6709017e62$var$node.hash = "8dd9df30188856b8fcd47f1be57af4fa";
var $99718f6709017e62$export$2e2bcd8739ae039 = $99718f6709017e62$var$node;
module.exports["default"] = $99718f6709017e62$export$2e2bcd8739ae039;

});

parcelRegister("50xoH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $343be00b8c32c969$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label",
        defaultMessage: "Try the Premium plan"
    },
    persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge",
        defaultMessage: "FREE 30-DAY TRIAL"
    }
});
const $343be00b8c32c969$var$menuItemContentStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexWrap: 'nowrap'
});
const $343be00b8c32c969$var$lozengeContainerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100'
});
function $343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl({ product: product, testId: testId, navVersion: navVersion }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'editionAwarenessStandardToPremiumPUB',
                attributes: {
                    source: 'EditionAwarenessStandardPubTouchpoint',
                    product: product,
                    navVersion: navVersion
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $343be00b8c32c969$var$menuItemContentStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLabelExperiment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $343be00b8c32c969$var$lozengeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 'discovery' : 'new'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $343be00b8c32c969$export$defe85febe8b728c.persistentUpgradeMenuItemStandardToPremiumPlanLozengeExperiment))));
}
function $343be00b8c32c969$export$bf5f4133d9c358a3(props) {
    const { product: product, navVersion: navVersion } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleOnError = (0, $42omo.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            source: 'unknownErrorSource',
            attributes: {
                product: product,
                edition: 'standard',
                navVersion: navVersion,
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        product,
        navVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        onError: handleOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($343be00b8c32c969$var$EditionAwarenessStandardPubTouchpointImpl, props));
}
module.exports["EditionAwarenessStandardPubTouchpoint"] = $343be00b8c32c969$export$bf5f4133d9c358a3;

});

parcelRegister("99oLS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9968f6026062a518$var$initialState = {
    isOpen: false,
    learnMoreUrl: '',
    experienceUrl: '',
    navVersion: undefined
};
const $9968f6026062a518$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        },
    setModalProps: ({ learnMoreUrl: learnMoreUrl, experienceUrl: experienceUrl, navVersion: navVersion })=>({ setState: setState })=>{
            setState({
                learnMoreUrl: learnMoreUrl,
                experienceUrl: experienceUrl,
                navVersion: navVersion
            });
        }
};
const $9968f6026062a518$var$store = (0, $1P1Tu.createStore)({
    initialState: $9968f6026062a518$var$initialState,
    actions: $9968f6026062a518$var$actions,
    name: 'editionAwarenessStandardToPremiumModalStore'
});
const $9968f6026062a518$export$d912d1373319011f = (0, $9zUhf.createActionsHook)($9968f6026062a518$var$store);
const $9968f6026062a518$export$cd5aa218e504e6f3 = (0, $9zUhf.createHook)($9968f6026062a518$var$store);
module.exports["useConfluenceStandardToPremiumModalActions"] = $9968f6026062a518$export$d912d1373319011f;
module.exports["useConfluenceStandardToPremiumModal"] = $9968f6026062a518$export$cd5aa218e504e6f3;

});

parcelRegister("hxSIT", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8c4b8f8f76d4beac$export$9bcf733c7567f1c = (baseUrl)=>{
    const FALLBACK_URL = '/admin/billing';
    return (0, $42omo.useMemo)(()=>{
        if (!baseUrl) return FALLBACK_URL;
        try {
            const url = new URL(baseUrl);
            const isHams = url.pathname.includes('change-edition');
            if (isHams) // remove "/<edition>" at the end of the path
            url.pathname = url.pathname.split('/').slice(0, -1).join('/');
            else {
                url.searchParams.delete('offeringName');
                url.searchParams.delete('offeringname');
            }
            return url.toString();
        } catch (err) {
            return FALLBACK_URL;
        }
    }, [
        baseUrl
    ]);
};
module.exports["useBuildLearnMoreLink"] = $8c4b8f8f76d4beac$export$9bcf733c7567f1c;

});

parcelRegister("5DQLv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Xlut2",
    name: "LazyStandardToPremiumModal",
    loader: async ()=>(await (parcelRequire("fsRco"))).StandardToPremiumModal
});
const $cf9f6e6dcd5627ce$export$4b9ed4d06294662c = ()=>{
    if ((0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cf9f6e6dcd5627ce$var$LazyStandardToPremiumModal, null);
    return null;
};
module.exports["StandardToPremiumModalMountComponent"] = $cf9f6e6dcd5627ce$export$4b9ed4d06294662c;

});

parcelRegister("fsRco", function(module, exports) {

let $b422bcbc3e970d16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b422bcbc3e970d16$var$load("6wr18"),
    $b422bcbc3e970d16$var$load("hUapU"),
    $b422bcbc3e970d16$var$load("lRtGG"),
    $b422bcbc3e970d16$var$load("ffEVr"),
    $b422bcbc3e970d16$var$load("9CRBg")
]).then(()=>parcelRequire('hCU0r'));

});

parcelRegister("29qEi", function(module, exports) {

let $191117f70c562550$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $191117f70c562550$var$load("bAAhx"),
    $191117f70c562550$var$load("gdwbX"),
    $191117f70c562550$var$load("6wr18"),
    $191117f70c562550$var$load("dshly"),
    $191117f70c562550$var$load("jyuXn"),
    $191117f70c562550$var$load("eeaKR"),
    $191117f70c562550$var$load("ffEVr"),
    $191117f70c562550$var$load("lz2pE")
]).then(()=>parcelRequire('7Bwbp'));

});

parcelRegister("BHGIm", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2d7c1ebdd99982dc$var$initialState = {
    isOpen: false
};
const $2d7c1ebdd99982dc$var$actions = {
    showModal: ({ touchpointId: touchpointId })=>({ setState: setState })=>{
            setState({
                isOpen: true,
                touchpointId: touchpointId
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
const $2d7c1ebdd99982dc$var$store = (0, $1P1Tu.createStore)({
    initialState: $2d7c1ebdd99982dc$var$initialState,
    actions: $2d7c1ebdd99982dc$var$actions,
    name: 'trialPlanComparisonModalStore'
});
const $2d7c1ebdd99982dc$export$9babf328a7e7b769 = (0, $9zUhf.createActionsHook)($2d7c1ebdd99982dc$var$store);
const $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e = (0, $9zUhf.createHook)($2d7c1ebdd99982dc$var$store);
module.exports["useTrialPlanComparisonModalActions"] = $2d7c1ebdd99982dc$export$9babf328a7e7b769;
module.exports["useTrialPlanComparisonModal"] = $2d7c1ebdd99982dc$export$d2b5dd4cfe103c4e;

});

parcelRegister("3fBqY", function(module, exports) {
const $13dafddd01cc0e12$export$c447f2d04f7089f6 = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
module.exports["isAtlassianStaff"] = $13dafddd01cc0e12$export$c447f2d04f7089f6;

});

parcelRegister("CRB7F", function(module, exports) {

var $84DXu = parcelRequire("84DXu");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/long-running-task/manifest.ts
var $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $84DXu.ConfluenceLongRunningTaskAriResourceOwner),
    resourceType: (0, $84DXu.ConfluenceLongRunningTaskAriResourceType),
    resourceIdSlug: "activation/{activationId}/{taskId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        taskId: /[0-9]+/
    }
};
// src/confluence/long-running-task/index.ts
var $074d201f1b439f20$export$ebd9af01759f4a9a = class _ConfluenceLongRunningTaskAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get taskId() {
        return this._taskId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.qualifier,
            platformQualifier: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.resourceOwner,
            resourceType: $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.taskId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                taskId: opts.taskId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $074d201f1b439f20$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            taskId: this.taskId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._taskId = opts.resourceIdSegmentValues.taskId;
    }
};
module.exports["ConfluenceLongRunningTaskAri"] = $074d201f1b439f20$export$ebd9af01759f4a9a;

});

parcelRegister("84DXu", function(module, exports) {
// src/confluence/long-running-task/types.ts
var $5e0db15e3d7f033e$export$c3f2be88215e7f96 = "confluence", $5e0db15e3d7f033e$export$d803f499be36f7e2 = "long-running-task";
module.exports["ConfluenceLongRunningTaskAriResourceOwner"] = $5e0db15e3d7f033e$export$c3f2be88215e7f96;
module.exports["ConfluenceLongRunningTaskAriResourceType"] = $5e0db15e3d7f033e$export$d803f499be36f7e2;

});

parcelRegister("bnxm6", function(module, exports) {
/**
 * @generated SignedSource<<233d941dd96e1c1cdbf01598d7bae72f>>
 * @relayHash 50ebcdd0474c653398920de0204e0d3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b43ca842fc02bd31386938e87cdca2d5726a7e55f51bece2c77eb96a4972c339
const $0598d1e099a39fc5$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "HelpPanelQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "HelpPanelQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "50ebcdd0474c653398920de0204e0d3d",
            "id": "b43ca842fc02bd31386938e87cdca2d5726a7e55f51bece2c77eb96a4972c339",
            "metadata": {},
            "name": "HelpPanelQuery",
            "operationKind": "query",
            "text": "query HelpPanelQuery{user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary}}}"
        }
    };
}();
$0598d1e099a39fc5$var$node.hash = "0ed6e0fbff1bd8304e19c670d1c755dc";
var $0598d1e099a39fc5$export$2e2bcd8739ae039 = $0598d1e099a39fc5$var$node;
module.exports["default"] = $0598d1e099a39fc5$export$2e2bcd8739ae039;

});

parcelRegister("14QAi", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $lzcvT = parcelRequire("lzcvT");


var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

parcelRegister("bQIml", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $3dacbbeae0d408d7$export$dc5d1c021e0a8741 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "oTpkC",
    name: "KeyboardShortcutsDialog",
    loader: async ()=>{
        return (await (parcelRequire("dmdzK"))).KeyboardShortcutsDialog;
    }
});
module.exports["KeyboardShortcutsDialog"] = $3dacbbeae0d408d7$export$dc5d1c021e0a8741;

});

parcelRegister("dmdzK", function(module, exports) {

let $9b97dc4880e5ad4b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b97dc4880e5ad4b$var$load("7EorR"),
    $9b97dc4880e5ad4b$var$load("3WCRn")
]).then(()=>parcelRequire('cIjy3'));

});

parcelRegister("gLUd5", function(module, exports) {
$parcel$export(module.exports, "exitBranchFn", () => (parcelRequire("5Z4kM")).exitBranchFn);
$parcel$export(module.exports, "isBranchDeployFn", () => (parcelRequire("5Z4kM")).isBranchDeployFn);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $5Z4kM = parcelRequire("5Z4kM");


//Plain div to display while chunk loads, avoids help menu resizing after loading
// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
const $9708b4b4a3dbcb64$var$loadingDiv = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            width: '100%',
            height: 29
        }
    });

const $9708b4b4a3dbcb64$export$b39479f42d974760 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RVoYJ",
    name: "FeedbackCollectorButton",
    loader: async ()=>(await (parcelRequire("jBmCK"))).FeedbackCollectorButton,
    loading: $9708b4b4a3dbcb64$var$loadingDiv
});

});

parcelRegister("jBmCK", function(module, exports) {

let $e45305a9815fea20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e45305a9815fea20$var$load("6wr18"),
    $e45305a9815fea20$var$load("ffEVr"),
    $e45305a9815fea20$var$load("3aT4s")
]).then(()=>parcelRequire('3ZEEP'));

});

parcelRegister("5Z4kM", function(module, exports) {
/* eslint no-restricted-syntax: 0 */ 
var $jiJCD = parcelRequire("jiJCD");


var $68uaC = parcelRequire("68uaC");

const $45b602e848c81a5d$export$28445d8a8237c240 = 'useFrontendBranch';
const $45b602e848c81a5d$export$2db401a6b81eceee = 'useFrontendBuildVersion';
const $45b602e848c81a5d$var$BIFROST_OVERRIDE = 'bifrost-override';
const $45b602e848c81a5d$export$399982ccb22744fa = ()=>{
    const urlComponents = (0, $jiJCD.parse)(window.location.href, true);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$var$BIFROST_OVERRIDE);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$export$28445d8a8237c240);
    (0, $68uaC.Cookies).remove($45b602e848c81a5d$export$2db401a6b81eceee);
    window.location.assign((0, $jiJCD.format)({
        path: urlComponents.path,
        query: {
            ...urlComponents.query,
            [$45b602e848c81a5d$export$28445d8a8237c240]: 'off',
            [$45b602e848c81a5d$export$2db401a6b81eceee]: 'off'
        },
        hash: urlComponents.hash
    }));
};
const $45b602e848c81a5d$export$6b1dc8f4a2350eb5 = ()=>{
    let cookieBasedBranchVersion;
    const isBifrost = window.__IS_BIFROST__;
    let bifrostOverrideVersion;
    try {
        cookieBasedBranchVersion = (0, $68uaC.Cookies).get($45b602e848c81a5d$export$28445d8a8237c240);
        if (isBifrost) bifrostOverrideVersion = (0, $68uaC.Cookies).get('bifrost-override');
    } catch (err) {
        // Likely a firefox edge-case: "Error: can't access dead object"
        // Occasionally, document.cookie is cleaned up despite living
        // references -- including js-cookie's
        cookieBasedBranchVersion = 'off';
        if (isBifrost) bifrostOverrideVersion = 'off';
    }
    if (isBifrost) return !!(bifrostOverrideVersion && !bifrostOverrideVersion.includes('CLASSIC-off-off'));
    return !!(cookieBasedBranchVersion && cookieBasedBranchVersion !== 'off');
};
module.exports["exitBranchFn"] = $45b602e848c81a5d$export$399982ccb22744fa;
module.exports["isBranchDeployFn"] = $45b602e848c81a5d$export$6b1dc8f4a2350eb5;

});

parcelRegister("hjhCz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4367945ac32e8223$export$b878bc0015f3472e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LVIQc",
    name: "LazyAddPersonalSpaceDialog",
    loader: async ()=>(await (parcelRequire("1DYrK"))).AddPersonalSpaceDialog
});
module.exports["LazyAddPersonalSpaceDialog"] = $4367945ac32e8223$export$b878bc0015f3472e;

});

parcelRegister("1DYrK", function(module, exports) {

let $1328526244a12550$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1328526244a12550$var$load("Wowvf"),
    $1328526244a12550$var$load("hhss7"),
    $1328526244a12550$var$load("kHOMt"),
    $1328526244a12550$var$load("4AAsh")
]).then(()=>parcelRequire('YvPDh'));

});

parcelRegister("2mPpz", function(module, exports) {

var $byfJM = parcelRequire("byfJM");

const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $479bf4f98cf9c8c7$export$8a57effc6307f916;

});

parcelRegister("byfJM", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $T9xHm = parcelRequire("T9xHm");


var $1eSke = parcelRequire("1eSke");

var $4H1Ql = parcelRequire("4H1Ql");


var $kO3gu = parcelRequire("kO3gu");


var $a8wvv = parcelRequire("a8wvv");


var $9dOtv = parcelRequire("9dOtv");


var $eXPKf = parcelRequire("eXPKf");

var $MnX4h = parcelRequire("MnX4h");


var $2HRxT = parcelRequire("2HRxT");

const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $T9xHm.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kO3gu.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $MnX4h.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $573f4005c25c6dbc$export$8a57effc6307f916;

});

parcelRegister("9dOtv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $42omo.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $94fea169e2cb8de7$export$3d127465d22fe4e5;

});

parcelRegister("6Ht9d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $42omo.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $876859b1b10b173e$export$5523c5f3222291d0;

});

parcelRegister("cyz5M", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $3NyPa = parcelRequire("3NyPa");

var $h6POP = parcelRequire("h6POP");


var $hOVIX = parcelRequire("hOVIX");


var $4oTqF = parcelRequire("4oTqF");


var $eNels = parcelRequire("eNels");


var $aEUWC = parcelRequire("aEUWC");


var $2amyA = parcelRequire("2amyA");


var $Sjnjb = parcelRequire("Sjnjb");


var $cqOSB = parcelRequire("cqOSB");


var $4S89c = parcelRequire("4S89c");


var $9iUWG = parcelRequire("9iUWG");


var $fUB5z = parcelRequire("fUB5z");


var $2HRxT = parcelRequire("2HRxT");


var $5pgAV = parcelRequire("5pgAV");


var $42omo = parcelRequire("42omo");


var $lVEBn = parcelRequire("lVEBn");

const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $42omo.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            const isTriggerChoreographingEnabled = (0, $c6GJD.default).checkGate('post-office_enable_trigger-choreographing');
            /// https://switcheroo.atlassian.com/ui/gates/e8049c84-32d5-4452-a52f-5b92940a1b55/key/post-office_enable-i18n-migration-pull
            const isI18nMigrationInAppEnabled = (0, $c6GJD.default).checkGate('post-office_enable-i18n-migration-pull');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $42omo.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = isTriggerChoreographingEnabled && (0, $9iUWG.isClientTriggeredMessage)(triggerType);
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $cqOSB.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $42omo.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId
                ]);
                const messageContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                    messageTemplateId: messageTemplateId,
                    isEnabled: isUFOEnabled,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4oTqF.MessageContextProvider), {
                        value: messageContextValue,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5pgAV.RecommendationProvider), {
                            value: recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT,
                            children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                                fallback: loadingComponent,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eNels.MaybeI18nProvider), {
                                        messageTemplateId: messageTemplateId,
                                        placementId: placementId,
                                        isI18nMigrationInAppEnabled: isI18nMigrationInAppEnabled,
                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4S89c.MaybeManualMessageViewedEvent), {
                                            isManual: !!waitForTrigger,
                                            children: [
                                                !waitForTrigger && messageSuccessComponent,
                                                /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                                    onError: onError,
                                                    messageInstanceId: messageInstanceId,
                                                    ...componentProps,
                                                    waitForTrigger: waitForTrigger
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
                // Triggered messages handle choreography with TriggeredMessageValidator
                if (waitForTrigger) return /*#__PURE__*/ (0, $l998X.jsx)((0, $Sjnjb.TriggeredMessageValidator), {
                    waitForTrigger: waitForTrigger,
                    children: messageContent
                });
                // Regular messages use automatic choreography
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $lVEBn.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: messageContent
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $765afc5340447923$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $765afc5340447923$export$7b7e5a348ef9a7c1;

});

parcelRegister("lVEBn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $iX6G3 = parcelRequire("iX6G3");


var $42omo = parcelRequire("42omo");

const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $iX6G3.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $5d2b57d7f45b3b6a$export$8db7ba034addcd65;

});

parcelRegister("3nDO6", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6YvRD = parcelRequire("6YvRD");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8393a846181017db$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8393a846181017db$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8393a846181017db$var$importHelper(await (parcelRequire("3MpkQ")));
        case 'da':
            return $8393a846181017db$var$importHelper(await (parcelRequire("byKYQ")));
        case 'de':
            return $8393a846181017db$var$importHelper(await (parcelRequire("Ny4Dt")));
        case 'en-GB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lwrPN")));
        case 'en-US':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cfGkc")));
        case 'en-XA':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eBjVi")));
        case 'en-XB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("b9V4D")));
        case 'en-ZZ':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cjS15")));
        case 'en':
            return $8393a846181017db$var$importHelper(await Promise.resolve((parcelRequire("6YvRD"))));
        case 'es':
            return $8393a846181017db$var$importHelper(await (parcelRequire("fUiux")));
        case 'et':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6DVur")));
        case 'fi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8FDQ0")));
        case 'fr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7zYd1")));
        case 'hr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kUL2N")));
        case 'hu':
            return $8393a846181017db$var$importHelper(await (parcelRequire("6eZER")));
        case 'it':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eUqg6")));
        case 'ja':
            return $8393a846181017db$var$importHelper(await (parcelRequire("at2wl")));
        case 'ko':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ihALB")));
        case 'nb':
            return $8393a846181017db$var$importHelper(await (parcelRequire("1ZGET")));
        case 'nl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIxnh")));
        case 'pl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9WZ2j")));
        case 'pt-BR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bhB5c")));
        case 'ro':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ckNRb")));
        case 'ru':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ir1xn")));
        case 'sl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("di9OC")));
        case 'sr-RS':
            return $8393a846181017db$var$importHelper(await (parcelRequire("jIjgo")));
        case 'sr-YR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8E5tZ")));
        case 'sr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("75Frc")));
        case 'sv':
            return $8393a846181017db$var$importHelper(await (parcelRequire("aCqVE")));
        case 'th':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2q19p")));
        case 'tr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kP7UO")));
        case 'uk':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cJoPm")));
        case 'vi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("h62OK")));
        case 'zh-CN':
            return $8393a846181017db$var$importHelper(await (parcelRequire("95Xcn")));
        case 'zh-TW':
            return $8393a846181017db$var$importHelper(await (parcelRequire("dzsOs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6YvRD));
    }
};
module.exports["messagesLoader"] = $8393a846181017db$export$720676d8cac8fbb;

});

parcelRegister("3MpkQ", function(module, exports) {

let $2c0981d7c54f4e53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c0981d7c54f4e53$var$load("bv8GZ").then(()=>parcelRequire('74xff'));

});

parcelRegister("byKYQ", function(module, exports) {

let $022bfd294816e214$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $022bfd294816e214$var$load("cdeuH").then(()=>parcelRequire('hQIGt'));

});

parcelRegister("Ny4Dt", function(module, exports) {

let $094f020f0aa3b5f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $094f020f0aa3b5f7$var$load("7gF8f").then(()=>parcelRequire('j9sSr'));

});

parcelRegister("lwrPN", function(module, exports) {

let $fab22d73b102392e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fab22d73b102392e$var$load("djb49").then(()=>parcelRequire('4tVXT'));

});

parcelRegister("cfGkc", function(module, exports) {

let $8eb7b7970922d5fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8eb7b7970922d5fc$var$load("koawN").then(()=>parcelRequire('k7TQm'));

});

parcelRegister("eBjVi", function(module, exports) {

let $aa13f9b6f0cd2936$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa13f9b6f0cd2936$var$load("6htQT").then(()=>parcelRequire('lIWyQ'));

});

parcelRegister("b9V4D", function(module, exports) {

let $81fccea2c7692076$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $81fccea2c7692076$var$load("fi75i").then(()=>parcelRequire('5QCdA'));

});

parcelRegister("cjS15", function(module, exports) {

let $8f8128f149f291d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f8128f149f291d2$var$load("ksTQ6").then(()=>parcelRequire('4EAWY'));

});

parcelRegister("fUiux", function(module, exports) {

let $b94a6e00f1130c23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b94a6e00f1130c23$var$load("5CGnz").then(()=>parcelRequire('1PSNt'));

});

parcelRegister("6DVur", function(module, exports) {

let $4d62fae3367e8fba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d62fae3367e8fba$var$load("X0Jic").then(()=>parcelRequire('cNrRQ'));

});

parcelRegister("8FDQ0", function(module, exports) {

let $65010e043670e359$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $65010e043670e359$var$load("9Oxgj").then(()=>parcelRequire('5L1ix'));

});

parcelRegister("7zYd1", function(module, exports) {

let $584a81908bcf6b02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $584a81908bcf6b02$var$load("kAg8V").then(()=>parcelRequire('f4vYC'));

});

parcelRegister("kUL2N", function(module, exports) {

let $f39d8798e3aacd6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f39d8798e3aacd6e$var$load("36XYg").then(()=>parcelRequire('jRDUE'));

});

parcelRegister("6eZER", function(module, exports) {

let $48b3e0de1ed42ace$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48b3e0de1ed42ace$var$load("fM2oh").then(()=>parcelRequire('lmfGu'));

});

parcelRegister("eUqg6", function(module, exports) {

let $adaaaa1542ad404d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adaaaa1542ad404d$var$load("xnqy2").then(()=>parcelRequire('J7CId'));

});

parcelRegister("at2wl", function(module, exports) {

let $79ee915b8a5cfa5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79ee915b8a5cfa5f$var$load("awkVi").then(()=>parcelRequire('iEu8X'));

});

parcelRegister("ihALB", function(module, exports) {

let $d4f655a3a30906cd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4f655a3a30906cd$var$load("11DLa").then(()=>parcelRequire('lklBt'));

});

parcelRegister("1ZGET", function(module, exports) {

let $173c9412aa2d6ea2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $173c9412aa2d6ea2$var$load("barSq").then(()=>parcelRequire('edhkG'));

});

parcelRegister("jIxnh", function(module, exports) {

let $e5ac03dff8d9aeff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5ac03dff8d9aeff$var$load("a8heY").then(()=>parcelRequire('aFb9z'));

});

parcelRegister("9WZ2j", function(module, exports) {

let $73e8e060a723dc38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73e8e060a723dc38$var$load("6hlNE").then(()=>parcelRequire('bAPfw'));

});

parcelRegister("bhB5c", function(module, exports) {

let $836e0c1dd75645f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $836e0c1dd75645f5$var$load("2bqSD").then(()=>parcelRequire('c1E8Q'));

});

parcelRegister("ckNRb", function(module, exports) {

let $8fae06d114550a7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8fae06d114550a7b$var$load("j6IGj").then(()=>parcelRequire('88y6K'));

});

parcelRegister("ir1xn", function(module, exports) {

let $d6bbf0de65f9bce4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6bbf0de65f9bce4$var$load("bJykp").then(()=>parcelRequire('8Rjw5'));

});

parcelRegister("di9OC", function(module, exports) {

let $9ad491ee252155d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9ad491ee252155d7$var$load("7Rbde").then(()=>parcelRequire('awMdX'));

});

parcelRegister("jIjgo", function(module, exports) {

let $e5a111b573c22c47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5a111b573c22c47$var$load("l8auu").then(()=>parcelRequire('eNbID'));

});

parcelRegister("8E5tZ", function(module, exports) {

let $64b64febd9024da4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64b64febd9024da4$var$load("3ColL").then(()=>parcelRequire('YVOUf'));

});

parcelRegister("75Frc", function(module, exports) {

let $529924b6cea297fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $529924b6cea297fd$var$load("2VSOH").then(()=>parcelRequire('fEcqf'));

});

parcelRegister("aCqVE", function(module, exports) {

let $7bb257853d40c532$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7bb257853d40c532$var$load("dh2Er").then(()=>parcelRequire('6TlJn'));

});

parcelRegister("2q19p", function(module, exports) {

let $1c2ee6fb468abb06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c2ee6fb468abb06$var$load("kyBJI").then(()=>parcelRequire('7Nysq'));

});

parcelRegister("kP7UO", function(module, exports) {

let $f28eb5e89a23de79$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f28eb5e89a23de79$var$load("eBLgB").then(()=>parcelRequire('1gaUd'));

});

parcelRegister("cJoPm", function(module, exports) {

let $944cf23be3b0d1a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $944cf23be3b0d1a4$var$load("ahhGv").then(()=>parcelRequire('bcwM6'));

});

parcelRegister("h62OK", function(module, exports) {

let $c7252eb9922192b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7252eb9922192b6$var$load("1Zesg").then(()=>parcelRequire('7fZ9R'));

});

parcelRegister("95Xcn", function(module, exports) {

let $69f280464f678177$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69f280464f678177$var$load("eLlpV").then(()=>parcelRequire('15VSW'));

});

parcelRegister("dzsOs", function(module, exports) {

let $9e14e4de0de5cb5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9e14e4de0de5cb5f$var$load("bV8sS").then(()=>parcelRequire('dU88R'));

});

parcelRegister("8SCD0", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ineA9 = parcelRequire("ineA9");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6c9af975b930043$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $e6c9af975b930043$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("9DoTa")));
        case 'da':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4qglW")));
        case 'de':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bfbM8")));
        case 'en-GB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("auur8")));
        case 'en-US':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqlmj")));
        case 'en-XA':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4LGQD")));
        case 'en-XB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iQahz")));
        case 'en-ZZ':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1vN03")));
        case 'en':
            return $e6c9af975b930043$var$importHelper(await Promise.resolve((parcelRequire("ineA9"))));
        case 'es':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("l8F02")));
        case 'et':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4lx9v")));
        case 'fi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7SJgz")));
        case 'fr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2hAcG")));
        case 'hr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3KRsA")));
        case 'hu':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lorva")));
        case 'it':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7z1yN")));
        case 'ja':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6Lmbg")));
        case 'ko':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hDbAj")));
        case 'nb':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("ifA95")));
        case 'nl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("c8rti")));
        case 'pl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kWAHY")));
        case 'pt-BR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("8m74M")));
        case 'ro':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("cHbRQ")));
        case 'ru':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iginQ")));
        case 'sl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("buteN")));
        case 'sr-RS':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kXpFG")));
        case 'sr-YR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("6DRMN")));
        case 'sr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("bytiP")));
        case 'sv':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("5eaPb")));
        case 'th':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2JhNV")));
        case 'tr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lJjy6")));
        case 'uk':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hqddP")));
        case 'vi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("lRJ6S")));
        case 'zh-CN':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        case 'zh-TW':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("aazgg")));
        case 'zh':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dNB4M")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ineA9));
    }
};
module.exports["messagesLoader"] = $e6c9af975b930043$export$720676d8cac8fbb;

});

parcelRegister("9DoTa", function(module, exports) {

let $703b0ff5e45f39ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $703b0ff5e45f39ca$var$load("i5eMd").then(()=>parcelRequire('bvjlk'));

});

parcelRegister("4qglW", function(module, exports) {

let $33864678917c99b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33864678917c99b3$var$load("4UPfH").then(()=>parcelRequire('IzetR'));

});

parcelRegister("bfbM8", function(module, exports) {

let $82fa3abe0ee41d1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82fa3abe0ee41d1e$var$load("gd4qs").then(()=>parcelRequire('b60fG'));

});

parcelRegister("auur8", function(module, exports) {

let $7a3450d5cacf3802$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a3450d5cacf3802$var$load("fviv5").then(()=>parcelRequire('d1j2S'));

});

parcelRegister("hqlmj", function(module, exports) {

let $caf56ecfe84fe48c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caf56ecfe84fe48c$var$load("hEkXc").then(()=>parcelRequire('dnFPq'));

});

parcelRegister("4LGQD", function(module, exports) {

let $378cc9e57c8473fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $378cc9e57c8473fa$var$load("6oOC9").then(()=>parcelRequire('4WIcD'));

});

parcelRegister("iQahz", function(module, exports) {

let $db750f2ad2fc95cb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db750f2ad2fc95cb$var$load("le1sE").then(()=>parcelRequire('7DdDO'));

});

parcelRegister("1vN03", function(module, exports) {

let $119eb210e4162adb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $119eb210e4162adb$var$load("eBoC7").then(()=>parcelRequire('hWRzS'));

});

parcelRegister("l8F02", function(module, exports) {

let $f63a26007ba32907$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f63a26007ba32907$var$load("bNv64").then(()=>parcelRequire('c7q37'));

});

parcelRegister("4lx9v", function(module, exports) {

let $32a2d6f90f7dc6dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32a2d6f90f7dc6dd$var$load("bAoKR").then(()=>parcelRequire('6eH2E'));

});

parcelRegister("7SJgz", function(module, exports) {

let $5bd0b07a6c7362cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bd0b07a6c7362cc$var$load("4Afgd").then(()=>parcelRequire('Plo13'));

});

parcelRegister("2hAcG", function(module, exports) {

let $1a99408df5c40000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1a99408df5c40000$var$load("cMubu").then(()=>parcelRequire('iY0zC'));

});

parcelRegister("3KRsA", function(module, exports) {

let $2bbf230e3c7786a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bbf230e3c7786a6$var$load("oUCro").then(()=>parcelRequire('6luhh'));

});

parcelRegister("lorva", function(module, exports) {

let $f9312c1c621b494e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9312c1c621b494e$var$load("3fLE9").then(()=>parcelRequire('lqPAG'));

});

parcelRegister("7z1yN", function(module, exports) {

let $581d0323511a36f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $581d0323511a36f5$var$load("8hOn0").then(()=>parcelRequire('85Nk7'));

});

parcelRegister("6Lmbg", function(module, exports) {

let $4ec85677d908e5ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ec85677d908e5ea$var$load("h4OCL").then(()=>parcelRequire('gdGRk'));

});

parcelRegister("hDbAj", function(module, exports) {

let $cd5f10a6a7e39aac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd5f10a6a7e39aac$var$load("bcQs2").then(()=>parcelRequire('eVsDT'));

});

parcelRegister("ifA95", function(module, exports) {

let $d495aa769fbc0b39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d495aa769fbc0b39$var$load("aBa7j").then(()=>parcelRequire('76Zjl'));

});

parcelRegister("c8rti", function(module, exports) {

let $8d5b8aafb917ed74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d5b8aafb917ed74$var$load("b544F").then(()=>parcelRequire('8JOK1'));

});

parcelRegister("kWAHY", function(module, exports) {

let $f3f5b2f1a0e0f500$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3f5b2f1a0e0f500$var$load("K6fhx").then(()=>parcelRequire('5eTse'));

});

parcelRegister("8m74M", function(module, exports) {

let $6155ddfe74a250ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6155ddfe74a250ea$var$load("gZU54").then(()=>parcelRequire('1OKs8'));

});

parcelRegister("cHbRQ", function(module, exports) {

let $93e2b4d7e19c96a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93e2b4d7e19c96a8$var$load("hlJc4").then(()=>parcelRequire('Xa5VS'));

});

parcelRegister("iginQ", function(module, exports) {

let $d4b7fb3604fa2dd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d4b7fb3604fa2dd6$var$load("4Wdqb").then(()=>parcelRequire('7W27q'));

});

parcelRegister("buteN", function(module, exports) {

let $85d92d084d6748bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85d92d084d6748bf$var$load("bJMZS").then(()=>parcelRequire('hu9se'));

});

parcelRegister("kXpFG", function(module, exports) {

let $03eff490f7a06afd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03eff490f7a06afd$var$load("exiT6").then(()=>parcelRequire('llE8x'));

});

parcelRegister("6DRMN", function(module, exports) {

let $4d601b614fe17619$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d601b614fe17619$var$load("jLkRH").then(()=>parcelRequire('195GW'));

});

parcelRegister("bytiP", function(module, exports) {

let $8699999c641b845b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8699999c641b845b$var$load("dmrYq").then(()=>parcelRequire('inCkW'));

});

parcelRegister("5eaPb", function(module, exports) {

let $3ce6a816be8813ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ce6a816be8813ae$var$load("k10Cs").then(()=>parcelRequire('6CeqQ'));

});

parcelRegister("2JhNV", function(module, exports) {

let $1fcd9849f2e198be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fcd9849f2e198be$var$load("g5LV7").then(()=>parcelRequire('88szQ'));

});

parcelRegister("lJjy6", function(module, exports) {

let $fd1cf6ff1ab4b3c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd1cf6ff1ab4b3c6$var$load("1n8w9").then(()=>parcelRequire('8mq9f'));

});

parcelRegister("hqddP", function(module, exports) {

let $caef1efdd7b47752$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $caef1efdd7b47752$var$load("2QtDQ").then(()=>parcelRequire('gOCry'));

});

parcelRegister("lRJ6S", function(module, exports) {

let $feb18a1e86664bd6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $feb18a1e86664bd6$var$load("i2vEA").then(()=>parcelRequire('8bOb4'));

});

parcelRegister("dNB4M", function(module, exports) {

let $a0bc9c843510574d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0bc9c843510574d$var$load("f1B4n").then(()=>parcelRequire('03O98'));

});

parcelRegister("aazgg", function(module, exports) {

let $767630bad9dc7d72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $767630bad9dc7d72$var$load("l079e").then(()=>parcelRequire('eLabs'));

});

parcelRegister("kdvUL", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Mosz = parcelRequire("8Mosz");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a5b98d263d96b9ca$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a5b98d263d96b9ca$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5kzWa")));
        case 'da':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("i4vm8")));
        case 'de':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2criv")));
        case 'en-GB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7leZF")));
        case 'en-US':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("lIduW")));
        case 'en-XA':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Ga8j")));
        case 'en-XB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9SvDD")));
        case 'en-ZZ':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ilsDR")));
        case 'en':
            return $a5b98d263d96b9ca$var$importHelper(await Promise.resolve((parcelRequire("8Mosz"))));
        case 'es':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("eA1bq")));
        case 'et':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("20oYo")));
        case 'fi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5uv0c")));
        case 'fr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aT1Cx")));
        case 'hr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("loDZu")));
        case 'hu':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("j3kFT")));
        case 'it':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("ks52q")));
        case 'ja':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aTDBw")));
        case 'ko':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bTqNO")));
        case 'nb':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("10NvT")));
        case 'nl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("4Yta3")));
        case 'pl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7T2DO")));
        case 'pt-BR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("86KYZ")));
        case 'ro':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("9ZXMc")));
        case 'ru':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bP7Hx")));
        case 'sl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("3iSMg")));
        case 'sr-RS':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("gjRTJ")));
        case 'sr-YR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("dDE21")));
        case 'sr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7Se25")));
        case 'sv':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("giWmH")));
        case 'th':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2rtZr")));
        case 'tr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("az1hp")));
        case 'uk':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hW673")));
        case 'vi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("34J1c")));
        case 'zh-CN':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cMfEi")));
        case 'zh-TW':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("iVQsE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Mosz));
    }
};
module.exports["messagesLoader"] = $a5b98d263d96b9ca$export$720676d8cac8fbb;

});

parcelRegister("5kzWa", function(module, exports) {

let $3e1ab25bd080ef18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e1ab25bd080ef18$var$load("1jsQH").then(()=>parcelRequire('fa8lP'));

});

parcelRegister("i4vm8", function(module, exports) {

let $d280ec5dc220c64f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d280ec5dc220c64f$var$load("deyvi").then(()=>parcelRequire('e3sAb'));

});

parcelRegister("2criv", function(module, exports) {

let $19a1e074f016a288$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19a1e074f016a288$var$load("6dERU").then(()=>parcelRequire('gch8x'));

});

parcelRegister("7leZF", function(module, exports) {

let $558620019a9af14d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $558620019a9af14d$var$load("kTurq").then(()=>parcelRequire('8ptsW'));

});

parcelRegister("lIduW", function(module, exports) {

let $fce82d783e15c0ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fce82d783e15c0ae$var$load("fbIIm").then(()=>parcelRequire('a6GY6'));

});

parcelRegister("6Ga8j", function(module, exports) {

let $4dce8689974dee0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4dce8689974dee0c$var$load("7l3it").then(()=>parcelRequire('8fxxk'));

});

parcelRegister("9SvDD", function(module, exports) {

let $7311b2ec66131e05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7311b2ec66131e05$var$load("i64HJ").then(()=>parcelRequire('efBlj'));

});

parcelRegister("ilsDR", function(module, exports) {

let $d5b067deab340511$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5b067deab340511$var$load("j0PWv").then(()=>parcelRequire('ks6TI'));

});

parcelRegister("eA1bq", function(module, exports) {

let $a9d558780c2a5d28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9d558780c2a5d28$var$load("dlmud").then(()=>parcelRequire('imT4f'));

});

parcelRegister("20oYo", function(module, exports) {

let $175ef3f7b5281c9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $175ef3f7b5281c9e$var$load("7snhF").then(()=>parcelRequire('cQTYN'));

});

parcelRegister("5uv0c", function(module, exports) {

let $3ff7cd8091ce22a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ff7cd8091ce22a4$var$load("cbkj0").then(()=>parcelRequire('j8AG8'));

});

parcelRegister("aT1Cx", function(module, exports) {

let $7ed04c3d213b805a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7ed04c3d213b805a$var$load("17m16").then(()=>parcelRequire('cdNFz'));

});

parcelRegister("loDZu", function(module, exports) {

let $f93adc2ef4ae79f5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f93adc2ef4ae79f5$var$load("eQZk8").then(()=>parcelRequire('8akbo'));

});

parcelRegister("j3kFT", function(module, exports) {

let $ddee55b7ab979037$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ddee55b7ab979037$var$load("b4NO6").then(()=>parcelRequire('gPFiy'));

});

parcelRegister("ks52q", function(module, exports) {

let $ee3a549cc562cf0d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee3a549cc562cf0d$var$load("1K1Fj").then(()=>parcelRequire('dIMMS'));

});

parcelRegister("aTDBw", function(module, exports) {

let $7eedc2fbe15b315c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7eedc2fbe15b315c$var$load("38sfA").then(()=>parcelRequire('css4w'));

});

parcelRegister("bTqNO", function(module, exports) {

let $8a899f28c59c2af5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a899f28c59c2af5$var$load("bjmre").then(()=>parcelRequire('9R9u0'));

});

parcelRegister("10NvT", function(module, exports) {

let $0bcc32df5e9c1b1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bcc32df5e9c1b1f$var$load("asvK9").then(()=>parcelRequire('6DTdr'));

});

parcelRegister("4Yta3", function(module, exports) {

let $39f362cd04b24307$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $39f362cd04b24307$var$load("7v6wU").then(()=>parcelRequire('ceZMk'));

});

parcelRegister("7T2DO", function(module, exports) {

let $5bdfb7f14449e2c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bdfb7f14449e2c0$var$load("aEpRh").then(()=>parcelRequire('jtjwW'));

});

parcelRegister("86KYZ", function(module, exports) {

let $5e73541143b39bdc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e73541143b39bdc$var$load("3fuR9").then(()=>parcelRequire('l8CqS'));

});

parcelRegister("9ZXMc", function(module, exports) {

let $74782de4a4745e6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74782de4a4745e6c$var$load("bSjyK").then(()=>parcelRequire('fFbIU'));

});

parcelRegister("bP7Hx", function(module, exports) {

let $89ba6e7402c93988$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89ba6e7402c93988$var$load("fMrUo").then(()=>parcelRequire('hHfxK'));

});

parcelRegister("3iSMg", function(module, exports) {

let $267d8b2ea98c2197$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $267d8b2ea98c2197$var$load("glLvq").then(()=>parcelRequire('lr9gd'));

});

parcelRegister("gjRTJ", function(module, exports) {

let $be183aac679ffec9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be183aac679ffec9$var$load("fFGjZ").then(()=>parcelRequire('ilsFV'));

});

parcelRegister("dDE21", function(module, exports) {

let $9eddf85990b84494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9eddf85990b84494$var$load("fEAqG").then(()=>parcelRequire('8xJoA'));

});

parcelRegister("7Se25", function(module, exports) {

let $5bb876238d07b83c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bb876238d07b83c$var$load("e9tHh").then(()=>parcelRequire('b1h3K'));

});

parcelRegister("giWmH", function(module, exports) {

let $bdeb99e2433e700b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bdeb99e2433e700b$var$load("9eNkX").then(()=>parcelRequire('2OLbL'));

});

parcelRegister("2rtZr", function(module, exports) {

let $1c755dc3df24f4b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c755dc3df24f4b3$var$load("fTPgj").then(()=>parcelRequire('lSTN4'));

});

parcelRegister("az1hp", function(module, exports) {

let $7b0e2a6644cdd48f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7b0e2a6644cdd48f$var$load("h0uBE").then(()=>parcelRequire('74ATO'));

});

parcelRegister("hW673", function(module, exports) {

let $d0ec98572b185326$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d0ec98572b185326$var$load("lKa7i").then(()=>parcelRequire('3fixv'));

});

parcelRegister("34J1c", function(module, exports) {

let $23d4aa8a0a9f8628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23d4aa8a0a9f8628$var$load("9aufD").then(()=>parcelRequire('kafqC'));

});

parcelRegister("cMfEi", function(module, exports) {

let $94d61b4e9741d415$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $94d61b4e9741d415$var$load("gDiIK").then(()=>parcelRequire('19yAM'));

});

parcelRegister("iVQsE", function(module, exports) {

let $dc863e8c0dddf9f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc863e8c0dddf9f8$var$load("j9OUx").then(()=>parcelRequire('jSsWA'));

});

parcelRegister("9QvUi", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $NT2w1 = parcelRequire("NT2w1");


var $2mPpz = parcelRequire("2mPpz");


var $eXPKf = parcelRequire("eXPKf");


var $42omo = parcelRequire("42omo");


var $2xYsH = parcelRequire("2xYsH");


var $hnA4H = parcelRequire("hnA4H");

const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $42omo.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NT2w1.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2xYsH.default), {
                    analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $13bb23ac78effffb$var$PlacementMemoized = /*#__PURE__*/ (0, $42omo.memo)($13bb23ac78effffb$var$Placement);
var $13bb23ac78effffb$export$2e2bcd8739ae039 = $13bb23ac78effffb$var$PlacementMemoized;
module.exports["default"] = $13bb23ac78effffb$export$2e2bcd8739ae039;

});

parcelRegister("2xYsH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $42omo = parcelRequire("42omo");

class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);
var $1916333c8b5a116e$export$2e2bcd8739ae039 = $1916333c8b5a116e$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $1916333c8b5a116e$export$2e2bcd8739ae039;

});

parcelRegister("hnA4H", function(module, exports) {
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $f3b0e253e752d4df$export$85183a312807388d;

});

parcelRegister("3sMdn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $7p5xt = parcelRequire("7p5xt");


var $56M4r = parcelRequire("56M4r");


var $6F6hl = parcelRequire("6F6hl");


var $hmRr5 = parcelRequire("hmRr5");


var $4cUZH = parcelRequire("4cUZH");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $0affb4f68c8513c7$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $4cUZH.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p5xt.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
        "aria-checked": selected,
        "aria-describedby": `${id}-radio`,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hmRr5.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemradio",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, this attribute are passed to ButtonItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        title: title,
        interactionName: interactionName,
        ...rest,
        // Override ButtonItem's default aria-current, as aria-checked is the correct attribute for menuitemradio (A11Y-37930)
        "aria-current": undefined
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        id: `${id}-radio`
    }, "radio button ", selected));
};
var $0affb4f68c8513c7$export$2e2bcd8739ae039 = $0affb4f68c8513c7$var$DropdownItemRadio;
module.exports["default"] = $0affb4f68c8513c7$export$2e2bcd8739ae039;

});

parcelRegister("hmRr5", function(module, exports) {
/* radio-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $01850bf21ecc815c$var$svgStyles = null; /**
                         * __Radio icon__
                         *
                         * Used to visually represent the selected state in DropdownItemRadio
                         *
                         * @internal
                         */ 
const $01850bf21ecc815c$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "7.5",
        fill: "currentColor",
        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
        strokeWidth: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        fill: "inherit"
    })));
};
var $01850bf21ecc815c$export$2e2bcd8739ae039 = $01850bf21ecc815c$var$RadioIcon;
module.exports["default"] = $01850bf21ecc815c$export$2e2bcd8739ae039;

});

parcelRegister("4cUZH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mnSH = parcelRequire("6mnSH");


var $5g4rt = parcelRequire("5g4rt");

function $1119aafb00a8a88b$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $42omo.useContext)((0, $5g4rt.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $42omo.useContext)((0, $6mnSH.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $42omo.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    /**
   * Set the initial state of the context provider's store,
   * if it doesn't already have a persisted value for this id.
   */ if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        const newGroupState = {
            ...existing,
            [id]: defaultSelected || false
        };
        setGroupState(group, newGroupState);
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $1119aafb00a8a88b$export$2e2bcd8739ae039 = $1119aafb00a8a88b$var$useRadioState;
module.exports["default"] = $1119aafb00a8a88b$export$2e2bcd8739ae039;

});

parcelRegister("6mnSH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $ea384564884ae281$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $42omo.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $ee7An.default)
});
module.exports["RadioGroupContext"] = $ea384564884ae281$export$a79eda4ff50e30b6;

});

parcelRegister("fywGr", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $5cryL = parcelRequire("5cryL");


var $8Z78B = parcelRequire("8Z78B");


var $1k2r8 = parcelRequire("1k2r8");

const $7aae32df106d9977$export$864cb1c5b7b9b39 = ()=>{
    // When the centralized onboarding state experiment is enabled, use the centralized preloader
    // to ensure all onboarding state queries hit the cache.
    if ((0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return (0, $1k2r8.preloadAllOnboardingState)();
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS))
        }
    });
};
module.exports["preloadEditorOnboardingState"] = $7aae32df106d9977$export$864cb1c5b7b9b39;

});

parcelRegister("blg7q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $af81f9ffe316c2e0$export$69cf3fc83b854da4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4AEfs",
    name: "ConversationAssistantNavBarButton",
    loader: async ()=>(await (parcelRequire("g0ULV"))).ConversationAssistantNavBarButton
});
module.exports["ConversationAssistantNavBarButton"] = $af81f9ffe316c2e0$export$69cf3fc83b854da4;

});

parcelRegister("g0ULV", function(module, exports) {

let $ba88af29327439b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ba88af29327439b4$var$load("8l20h"),
    $ba88af29327439b4$var$load("5V8sC"),
    $ba88af29327439b4$var$load("57oeB"),
    $ba88af29327439b4$var$load("6vAv8"),
    $ba88af29327439b4$var$load("bbnf3"),
    $ba88af29327439b4$var$load("jSoew"),
    $ba88af29327439b4$var$load("k4cyN"),
    $ba88af29327439b4$var$load("9nwFZ"),
    $ba88af29327439b4$var$load("gM13h")
]).then(()=>parcelRequire('1RPPn'));

});

parcelRegister("i834V", function(module, exports) {

var $42omo = parcelRequire("42omo");

// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

var $l998X = parcelRequire("l998X");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $gWjCD = parcelRequire("gWjCD");


var $hYnlH = parcelRequire("hYnlH");

const $09b5fb30979be8a6$export$cf9a3fbf9c3c14ce = (headers)=>(config)=>async (opts)=>{
            const isPostOfficeSynthetic = opts.request.orchestrationContext.recipient?.userId && opts.request.statsig.checkGate({
                identifiers: {
                    atlassianAccountId: opts.request.orchestrationContext.recipient.userId
                }
            }, 'post-office-is-post-office-synthetic');
            if (!isPostOfficeSynthetic) opts.koa.ctx.set(headers);
            return (0, $hYnlH.defaultPlacementMiddleware)(config)(opts);
        };
const $09b5fb30979be8a6$export$80d235e32c5248a6 = 'private, max-age=300, stale-while-revalidate=600, stale-if-error=900';
const $09b5fb30979be8a6$export$dc0291b7f6e541b = 'private, max-age=120, stale-while-revalidate=300, stale-if-error=900';
const $09b5fb30979be8a6$export$c81528d4fcbfbe9f = 'private, max-age=600, stale-while-revalidate=900, stale-if-error=900';
const $09b5fb30979be8a6$export$49b0f46a7b9264ff = $09b5fb30979be8a6$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $09b5fb30979be8a6$export$80d235e32c5248a6
});
const $09b5fb30979be8a6$export$f90e17deb35ce39f = $09b5fb30979be8a6$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $09b5fb30979be8a6$export$80d235e32c5248a6
});
const $09b5fb30979be8a6$export$86309966c8dcb8f0 = $09b5fb30979be8a6$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $09b5fb30979be8a6$export$80d235e32c5248a6
});
const $09b5fb30979be8a6$export$d70cd3c2d3a8b23f = $09b5fb30979be8a6$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $09b5fb30979be8a6$export$dc0291b7f6e541b
});
const $09b5fb30979be8a6$export$5379d5ee2ecb6877 = $09b5fb30979be8a6$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $09b5fb30979be8a6$export$dc0291b7f6e541b
});
const $09b5fb30979be8a6$export$c499d39834887909 = $09b5fb30979be8a6$export$cf9a3fbf9c3c14ce({
    ['cache-control']: $09b5fb30979be8a6$export$c81528d4fcbfbe9f
});



var $j0Fou = parcelRequire("j0Fou");


var $8Hyz1 = parcelRequire("8Hyz1");


var $c6GJD = parcelRequire("c6GJD");

const $9248136efba77bb2$export$8ea6555e3e46f620 = 'not-enrolled';
const $9248136efba77bb2$var$NON_VARIANT_COHORTS = new Set([
    'control',
    $9248136efba77bb2$export$8ea6555e3e46f620
]);
const $9248136efba77bb2$export$963cdca6c7580c53 = [
    {
        // https://switcheroo.atlassian.com/ui/gates/4bb14a49-572d-4f41-99b8-3d8ca5260adc/key/rovo-ext_left_nav_rovo_extension_cta
        messageTemplateId: 'rovo-extension-install-cta-left-nav',
        statsigExperiment: 'rovo-ext_left_nav_rovo_extension_cta',
        statsigParameterName: 'cohort',
        statsigTestCohortPredicate: (experimentValue)=>!$9248136efba77bb2$var$NON_VARIANT_COHORTS.has(experimentValue),
        shouldProceedToStatsigEvaluation: ()=>{
            if (typeof navigator === 'undefined') return false;
            const userAgent = navigator.userAgent || '';
            return userAgent.indexOf('Chrome') >= 0;
        }
    }
];


const { createFrontend: $5902bd5901ea73a0$var$createFrontend, createBackend: $5902bd5901ea73a0$var$createBackend } = (0, $gWjCD.createPlacement)({
    placementId: 'confluence-side-nav',
    options: {
        choreographer: {
            isDefaultEnabled: false
        }
    }
});
const $5902bd5901ea73a0$export$d90b37843c84d1c3 = $5902bd5901ea73a0$var$createBackend({
    customMiddleware: (0, $09b5fb30979be8a6$export$5379d5ee2ecb6877)
}); // Props passed from Product to Placement
const $5902bd5901ea73a0$var$confluenceSideNavStyles = null;
const $5902bd5901ea73a0$var$SORTED_NBA = [
    'CONNECT_3P_TOOLS_NUDGE',
    'CREATE_WITH_ROVO_NUDGE',
    'CREATE_SPACE',
    'CREATE_PAGE',
    'CREATE_WHITEBOARD',
    '1_ON_1_LOOM_NUDGE',
    'LOOM_AI_MEETING_NOTES',
    'RESURRECTED_USER_NUDGE',
    'ROVO_EXTENSION_CTA'
]; // todo: Resolve backend ordering incorrectly
const $5902bd5901ea73a0$var$sortMessages = (messages = [])=>{
    return messages.sort((a, b)=>{
        return(// @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
        $5902bd5901ea73a0$var$SORTED_NBA.indexOf(a?.nextBestActionType) - // @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
        $5902bd5901ea73a0$var$SORTED_NBA.indexOf(b?.nextBestActionType));
    });
};
const $5902bd5901ea73a0$export$55486c2b6964dcf2 = $5902bd5901ea73a0$var$createFrontend((Messages)=>({ preloadedInitialData: preloadedInitialData, onDismiss: onDismiss, onSideNavClick: onSideNavClick, onCallback: onCallback, currentRoute: currentRoute })=>{
        const [{ messages: messages, status: status }, setMessageState] = (0, $42omo.useState)(()=>{
            if (preloadedInitialData) return preloadedInitialData?.messages?.length > 0 ? {
                status: 'done',
                messages: $5902bd5901ea73a0$var$sortMessages(preloadedInitialData?.messages)
            } : {
                messages: undefined,
                status: 'done'
            };
            return {
                messages: undefined,
                status: 'loading'
            };
        });
        const context = (0, $8Hyz1.usePostOfficeSideNavMessages)();
        const isDone = status === 'done';
        const { data: data, error: error, isLoading: isLoading } = (0, $j0Fou.usePlacementApi)('/', {
            autoRefetch: {
                isEnabled: !isDone,
                updateKey: 'confluence-side-nav'
            }
        });
        const handleOnDismissed = (0, $42omo.useCallback)(()=>{
            // no more messages until the next fetch
            onDismiss({
                messages: []
            });
            setMessageState({
                messages: undefined,
                status: 'done'
            });
        }, [
            onDismiss
        ]);
        const handleOnSideNavClick = (0, $42omo.useCallback)((nextBestActionType)=>{
            // display the next message
            setMessageState((prevState)=>{
                if (prevState.messages) {
                    const newMessages = prevState.messages.slice(1);
                    onSideNavClick(nextBestActionType, {
                        messages: newMessages
                    });
                    return {
                        messages: newMessages,
                        status: 'done'
                    };
                }
                onSideNavClick(nextBestActionType, {
                    messages: []
                });
                return prevState;
            });
        }, [
            onSideNavClick
        ]);
        (0, $42omo.useEffect)(()=>{
            if (!isLoading && !isDone) setMessageState({
                messages: $5902bd5901ea73a0$var$sortMessages(data?.messages),
                status: 'done'
            });
        }, [
            isLoading,
            isDone,
            data
        ]);
        const displayedMessage = (0, $42omo.useMemo)(()=>{
            if (!messages?.length) return;
            const filteredMessages = messages.filter((message)=>{
                // @ts-expect-error Property 'explicitEnableRequired' does not exist on type 'BackendMessageBody<SerializableRecord>'
                if (message.explicitEnableRequired) // @ts-expect-error Property 'nextBestActionType' does not exist on type 'BackendMessageBody<SerializableRecord>'
                return context?.enabledMessages.includes(message.nextBestActionType);
                if (message.messageTemplateId === 'rovo-extension-install-cta-left-nav') {
                    // Don't show on FPS to avoid collision with existing install CTA (built outside of PO)
                    if (currentRoute?.includes('/search')) return false;
                }
                return true;
            });
            if (!filteredMessages.length) return;
             // https://switcheroo.atlassian.com/ui/gates/f775d661-abc2-488d-b58c-c28fab9bd58f/key/po_enable_confluence-side-nav-exp-messages
            if ((0, $c6GJD.default).checkGate('po_enable_confluence-side-nav-exp-messages')) {
                for (const message of filteredMessages){
                    const experimentalMessage = (0, $9248136efba77bb2$export$963cdca6c7580c53).find((msg)=>msg.messageTemplateId === message.messageTemplateId); // Non-experimental messages are always eligible and should not be overridden by
                    // later experimental messages in the order they are defined.
                    if (!experimentalMessage) return {
                        message: message
                    };
                    if (experimentalMessage.shouldProceedToStatsigEvaluation && !experimentalMessage.shouldProceedToStatsigEvaluation()) continue;
                    const experimentCohort = (0, $c6GJD.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, (0, $9248136efba77bb2$export$8ea6555e3e46f620));
                    if (experimentalMessage.statsigTestCohortPredicate(experimentCohort)) return {
                        message: message,
                        experimentCohort: experimentCohort
                    };
                }
                return undefined;
            }
            return filteredMessages[0] ? {
                message: filteredMessages[0]
            } : undefined;
        }, [
            messages,
            context,
            currentRoute
        ]);
        if (error) return null;
        if (status === 'loading') return null;
        if (!displayedMessage) return null;
        const { message: message, experimentCohort: experimentCohort } = displayedMessage;
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_18s8utpp _1e0c1txw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)(Messages.render, {
                ...message,
                experimentCohort: experimentCohort,
                onSideNavClick: handleOnSideNavClick,
                handleOnDismissed: handleOnDismissed,
                onCallback: onCallback
            })
        });
    });





/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $fVUfS = parcelRequire("fVUfS");


var $4oTqF = parcelRequire("4oTqF");


var $aXWIB = parcelRequire("aXWIB");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $j01vW = parcelRequire("j01vW");

const $03729da3c84b8424$var$actionsStyles = null;
const $03729da3c84b8424$export$b52183d5cfb26dc9 = ({ whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, handleOnDismissed: handleOnDismissed })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1yt4mkb0 _kqswstnw _1e0c1txw _154iidpf _1xi2idpf"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $j01vW.AdControls), {
            iconSize: "small",
            showWhyAmISeeingThis: true,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
            onDismissed: handleOnDismissed
        })
    });
};






var $ecnYn = parcelRequire("ecnYn");








var $2W0qg = parcelRequire("2W0qg");

const $a7ac04a55b20aff6$export$183b689fd14b3c3e = ({ ctaText: ctaText, onCTAClick: onCTAClick, pressableStyle: pressableStyle })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        onClick: onCTAClick,
        xcss: pressableStyle,
        children: ctaText
    });
};



var $gVWoV = parcelRequire("gVWoV");


var $jVJ5P = parcelRequire("jVJ5P");




const $aa858a0a625ad49c$export$a5eee42871f883eb = (onMessageClick, clickedElement)=>{
    const { messageClicked: messageClicked, messageDismissed: messageDismissed } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        onMessageClick(e);
        // Dismiss Create Whiteboard and Create Page message instances after the user clicks on the action
        // This is so that if the user reloads the page, the message is not shown again.
        // Otherwise, there is a delay of 5 mins due to us using cached tap-sidecar with a 5-min TTL so the latest TAP trait info won't be retrieved till then
        if (clickedElement.clickIdentifier.includes('CREATE_WHITEBOARD') || clickedElement.clickIdentifier.includes('CREATE_PAGE')) messageDismissed().catch(()=>{});
    }, [
        clickedElement,
        messageClicked,
        messageInstanceClicked,
        onMessageClick
    ]);
    return {
        handleClick: handleClick
    };
};


const $80f001f343de2af3$var$nextBestActionButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '120px',
    paddingLeft: '0',
    paddingRight: '0',
    whiteSpace: 'nowrap',
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    ':hover': {
        textDecoration: 'underline'
    }
});
const $80f001f343de2af3$export$2f350203e9a62d5 = ({ ctaMessage: ctaMessage, onCTAClick: onCTAClick, nextBestActionType: nextBestActionType })=>{
    const clickedElement = (0, $42omo.useMemo)(()=>{
        return {
            clickIdentifier: `next-best-action-message-${nextBestActionType}`,
            clickedElement: 'link'
        };
    }, [
        nextBestActionType
    ]);
    const { handleClick: handleClick } = (0, $aa858a0a625ad49c$export$a5eee42871f883eb)(onCTAClick, clickedElement);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7ac04a55b20aff6$export$183b689fd14b3c3e), {
        ctaText: ctaMessage,
        onCTAClick: handleClick,
        pressableStyle: $80f001f343de2af3$var$nextBestActionButtonStyles
    });
};



/*--Banner Content--*/ const $c1690906a8b95e96$var$confluenceNbaMessageStylesCss = null;
const $c1690906a8b95e96$var$styles = {
    confluenceNbaMessage: "_2rko1mok _1e0c1txw _kqswh2mm _4cvr1h6o _bfhk1s93 _1bsb1osq _ca0qutpp _u5f3utpp _19bvutpp _n3td12x7 _1ubta3nm _d0altlke"
};
const $c1690906a8b95e96$var$iconContainerStyles = null;
const $c1690906a8b95e96$var$bodyContentStyles = null;
const $c1690906a8b95e96$var$headerStyles = null;
const $c1690906a8b95e96$var$BodyContent = ({ header: header, ctaMessage: ctaMessage, onMessageClick: onMessageClick, nextBestActionType: nextBestActionType })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _18u01ylp _19bvu2gc _2hwxzwfg _1bsb1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                role: "presentation",
                className: (0, $gMc0m.default)([
                    "_11c81qyo _1bsb1osq _n3tdu2gc"
                ]),
                children: header
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $80f001f343de2af3$export$2f350203e9a62d5), {
                ctaMessage: ctaMessage,
                onCTAClick: onMessageClick,
                nextBestActionType: nextBestActionType
            })
        ]
    });
};
const $c1690906a8b95e96$var$whyAmISeeingThisModalContent = {
    title: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        id: "post-office.ad-controls.next-best-action-title.why-am-i-seeing-this",
        defaultMessage: "Why am I seeing this?"
    }),
    message: /*#__PURE__*/ (0, $l998X.jsx)("p", {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-message.recommendation-basis",
            defaultMessage: "This recommendation is based on:"
        })
    }),
    reasons: [
        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-reason.actions-done-so-far",
            defaultMessage: "What you\u2019ve done so far in the product"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.ad-controls.next-best-action-reason.suggestions",
            defaultMessage: "What we suggest to help you get the most value from Atlassian"
        })
    ]
};
const $c1690906a8b95e96$export$7e6be280c02f2a40 = ({ icon: icon, header: header, ctaMessage: ctaMessage, onMessageClick: onMessageClick, handleOnDismissed: handleOnDismissed, nextBestActionType: nextBestActionType })=>{
    const { messageInstanceId: messageInstanceId } = (0, $4oTqF.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const clickedElement = (0, $42omo.useMemo)(()=>{
        return {
            clickIdentifier: `next-best-action-message-${nextBestActionType}`,
            clickedElement: 'link'
        };
    }, [
        nextBestActionType
    ]);
    const { handleClick: handleClick } = (0, $aa858a0a625ad49c$export$a5eee42871f883eb)(onMessageClick, clickedElement);
    const handleMessageClick = (e)=>{
        const currentTarget = e.currentTarget;
        let target = e.target;
        while(target.parentNode){
            if (target.tagName.toLowerCase() === 'button' || target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'html' // this is for the modal & its transparent background
            ) // Don't open action since these child elements should've already handled the click
            return;
             // Open action if the click is on the banner message itself
            if (target === currentTarget) {
                handleClick(e);
                return;
            } // Keep traversing up the DOM tree
            target = target.parentNode;
        }
    };
    return (0, $c6GJD.default).checkGate('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        testId: "confluence-next-best-action-message",
        xcss: $c1690906a8b95e96$var$styles.confluenceNbaMessage,
        onClick: handleMessageClick,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _kqswstnw _154i1crf _1bsb1ylp _4t3i1ylp"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($c1690906a8b95e96$var$BodyContent, {
                header: header,
                ctaMessage: ctaMessage,
                onMessageClick: onMessageClick,
                nextBestActionType: nextBestActionType
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $03729da3c84b8424$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: $c1690906a8b95e96$var$whyAmISeeingThisModalContent,
                handleOnDismissed: handleOnDismissed
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "confluence-next-best-action-message",
        onClick: handleMessageClick,
        className: (0, $gMc0m.default)([
            "_2rko1mok _1yt41jtk _1e0c1txw _kqswh2mm _4cvr1h6o _bfhk1s93 _1bsb1osq _1ubta3nm _d0altlke"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _kqswstnw _154i1crf _1bsb1ylp _4t3i1ylp"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($c1690906a8b95e96$var$BodyContent, {
                header: header,
                ctaMessage: ctaMessage,
                onMessageClick: onMessageClick,
                nextBestActionType: nextBestActionType
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $03729da3c84b8424$export$b52183d5cfb26dc9), {
                whyAmISeeingThisModalContent: $c1690906a8b95e96$var$whyAmISeeingThisModalContent,
                handleOnDismissed: handleOnDismissed
            })
        ]
    });
};








const $35b175a412bc889c$var$NBAIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M33.2748 18.1208H12.979V28.0375H33.2748V18.1208Z",
                    fill: "#BF63F3"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M26.9667 11.9624H6.6709V21.8791H26.9667V11.9624Z",
                    fill: "#FCA700"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M26.9665 18.1208H12.979V21.8792H26.9665V18.1208Z",
                    fill: "#AE2A19"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M32.0125 21.7042L27.6416 26.075L25.3833 23.7542L26.3583 22.8084L27.6583 24.1417L31.0541 20.7458L32.0166 21.7083L32.0125 21.7042Z",
                    fill: "white"
                })
            ]
        })
    });
const $35b175a412bc889c$export$e080ae79c37ff1d1 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    const headerText = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.craete-space-header",
        defaultMessage: "Centralize your team's projects, and docs."
    });
    const ctaMessage = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-space-cta-message",
        defaultMessage: "Create space"
    });
    const onMessageClick = (0, $42omo.useCallback)(()=>{
        onSideNavClick('CREATE_SPACE');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c1690906a8b95e96$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)($35b175a412bc889c$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_SPACE"
    });
};












const $c464bf5040a30410$var$NBAIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M27.0876 12.9458H10.0293V30H27.0835V12.9458H27.0876ZM13.6876 18.4291H23.4335V16.6H13.6876V18.4291ZM13.6876 22.3875H23.4335V20.5583H13.6876V22.3875ZM19.7793 26.3458H13.6876V24.5166H19.7793V26.3458Z",
                    fill: "#BF63F3"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M23.7292 18.954L20 19.9999L21.0458 16.2707L30.3458 6.9707L33.0292 9.65404L23.7292 18.954Z",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.3708 12.9458L21.0458 16.2708L20.9542 16.6H23.4333V18.4291H20.4417L20 20L23.7292 18.9541L27.0875 15.5958V12.9458H24.3708Z",
                    fill: "#09326C"
                })
            ]
        })
    });
const $c464bf5040a30410$export$5688887910bb9e45 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    const headerText = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-page-header",
        defaultMessage: "Plan projects, take notes, and track tasks."
    });
    const ctaMessage = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-page-cta-message",
        defaultMessage: "Create page"
    });
    const onMessageClick = (0, $42omo.useCallback)(()=>{
        onSideNavClick('CREATE_PAGE');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c1690906a8b95e96$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)($c464bf5040a30410$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_PAGE"
    });
};












const $d199a8732a4514bd$var$NBAIcon = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M25.4297 21.0963C25.4963 20.7255 25.5297 20.3255 25.5297 19.9088C25.5297 19.4922 25.4963 19.0838 25.4255 18.7047C25.0213 16.4588 23.463 15.0755 21.2713 14.7172C20.8963 14.6547 20.5047 14.6255 20.1005 14.6255C19.6963 14.6255 19.2672 14.6588 18.8797 14.7255C16.6922 15.0922 15.1338 16.4713 14.7297 18.7047C14.663 19.0838 14.6255 19.4838 14.6255 19.9088C14.6255 20.3338 14.6588 20.7255 14.7255 21.0963C15.1255 23.3255 16.6838 24.7088 18.8797 25.0755C19.2672 25.1422 19.6755 25.1755 20.1005 25.1755C20.5255 25.1755 20.9005 25.1463 21.2713 25.0838C23.463 24.7255 25.0255 23.3422 25.4255 21.0963H25.4297Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.37109 19.317L13.8711 8.17529L20.3711 19.317H7.37109Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.846 14.9922C16.2043 15.5672 15.0627 16.838 14.7293 18.7047C14.6918 18.9047 14.6668 19.1047 14.646 19.3172H20.3668L17.846 14.9922Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M29.917 20.8838H20.7837V30.0171H29.917V20.8838Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.7837 20.8877V25.146C20.9504 25.1294 21.1129 25.1085 21.2754 25.0835C23.467 24.7294 25.0254 23.3419 25.4295 21.096C25.442 21.0294 25.4545 20.9585 25.4629 20.8877H20.7837Z",
                fill: "#AE2A19"
            })
        ]
    });
const $d199a8732a4514bd$export$aafbf2fddacf0f4f = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
    const intl = (0, $aXWIB.useIntl)();
    const headerText = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-whiteboard-header",
        defaultMessage: "Dream up new ideas, and visualize your work."
    });
    const ctaMessage = intl.formatMessage({
        id: "post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message",
        defaultMessage: "Create whiteboard"
    });
    const onMessageClick = (0, $42omo.useCallback)(()=>{
        onSideNavClick('CREATE_WHITEBOARD');
    }, [
        onSideNavClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c1690906a8b95e96$export$7e6be280c02f2a40), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)($d199a8732a4514bd$var$NBAIcon, {}),
        header: headerText,
        ctaMessage: ctaMessage,
        onMessageClick: onMessageClick,
        handleOnDismissed: handleOnDismissed,
        nextBestActionType: "CREATE_WHITEBOARD"
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var $kd6Go = parcelRequire("kd6Go");

function $c9da4167a1cad8de$export$a7a9523472993e97(value) {
    const result = $c9da4167a1cad8de$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $c9da4167a1cad8de$export$226b3eccf92c9ed9(value) {
    const result = $c9da4167a1cad8de$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $c9da4167a1cad8de$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else if (!('nextBestActionType' in value)) errors.push({
        path: 'value["nextBestActionType"]',
        expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
        value: undefined
    });
    else {
        let value__nextBestActionType___valid = false;
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_SPACE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_PAGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WHITEBOARD",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                path: 'value["nextBestActionType"]',
                expected: "1_ON_1_LOOM_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                path: 'value["nextBestActionType"]',
                expected: "LOOM_AI_MEETING_NOTES",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                path: 'value["nextBestActionType"]',
                expected: "RESURRECTED_USER_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WITH_ROVO_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                path: 'value["nextBestActionType"]',
                expected: "ROVO_EXTENSION_CTA",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                path: 'value["nextBestActionType"]',
                expected: "CONNECT_3P_TOOLS_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $be442de82982a974$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $c9da4167a1cad8de$export$a7a9523472993e97),
            stage: ({ message: message })=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    },
                    nextBestAction: message.context.nextBestActionType
                })
        }
    }));
const $be442de82982a974$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $c9da4167a1cad8de$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            switch(nextBestActionType){
                case 'CREATE_SPACE':
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $35b175a412bc889c$export$e080ae79c37ff1d1), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                case 'CREATE_PAGE':
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c464bf5040a30410$export$5688887910bb9e45), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                case 'CREATE_WHITEBOARD':
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d199a8732a4514bd$export$aafbf2fddacf0f4f), {
                        onSideNavClick: onSideNavClick,
                        handleOnDismissed: handleOnDismissed
                    });
                default:
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
            }
        }
    }
});






var $e7qVY = parcelRequire("e7qVY");


/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $bYRk6 = parcelRequire("bYRk6");


var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");


var $gj7hi = parcelRequire("gj7hi");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");



var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");








var $7XIdu = parcelRequire("7XIdu");

var $1d00e431c4e07331$exports = {};
$1d00e431c4e07331$exports = new URL("heart.91f6fb22.svg", import.meta.url).toString();


const $790c28d90e90729b$var$styles = {
    container: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _1rjcutpp _kqswh2mm _16jlkb7n _bfhk1s93 _y4tiutpp _bozg12x7",
    link: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _syaz12zz _k48p1wq8 _80omtlke _bfhk1j28 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz",
    headerRow: "_1bah1yb4 _4cvr1y6m _1bsb1osq",
    inlineStack: "_1bsb1osq"
};
const $790c28d90e90729b$var$i18n = (0, $aXWIB.defineMessages)({
    headerText: {
        id: "post-office.confluence-resurrected-user-welcome-back.next-best-action.header",
        defaultMessage: "Welcome back"
    },
    bodyText: {
        id: "post-office.confluence-resurrected-user-welcome-back.body",
        defaultMessage: "Catch up on the top discussions and highlights from your team."
    },
    ctaMessage: {
        id: "post-office.confluence-resurrected-user-welcome-back.cta",
        defaultMessage: "See what's popular"
    },
    closeLabel: {
        id: "post-office.confluence-resurrected-user-welcome-back.close",
        defaultMessage: "Close"
    },
    imageAltText: {
        id: "post-office.confluence-resurrected-user-welcome-back.image-alt",
        defaultMessage: "Two hearts overlapped with each other"
    }
});
const $790c28d90e90729b$export$1a9faf036da14396 = ({ onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed, nextBestActionType: nextBestActionType })=>{
    const intl = (0, $aXWIB.useIntl)();
    const imageAltText = intl.formatMessage($790c28d90e90729b$var$i18n.imageAltText); // For PO events
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'confluenceResurrectedUserWelcomeSidebarNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismissClicked = ()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'resurrected-user-welcome-back-dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'resurrectedUserWelcomeBackDismiss'
        }); // moves to the next message in queue
        handleOnDismissed();
    };
    const handleCtaClicked = ()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'resurrected-user-welcome-back-cta',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'open'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'resurrectedUserWelcomeBackCta'
        }); // moves to the next message in queue and also calls necessary action in confluence
        onSideNavClick(nextBestActionType);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            source: 'confluence-resurrected-user-welcome-back-message'
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            xcss: $790c28d90e90729b$var$styles.container,
            testId: "confluence-resurrected-user-welcome-back-message",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $790c28d90e90729b$var$styles.inlineStack,
                shouldWrap: false,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1d00e431c4e07331$exports))),
                        alt: imageAltText
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        alignInline: "start",
                        grow: "fill",
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                xcss: $790c28d90e90729b$var$styles.headerRow,
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                        shouldWrap: false,
                                        alignBlock: "center",
                                        grow: "fill",
                                        spread: "space-between",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                            size: "xsmall",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                ...$790c28d90e90729b$var$i18n.headerText
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                                        appearance: "subtle",
                                        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                            ...$790c28d90e90729b$var$i18n.closeLabel
                                        }),
                                        isTooltipDisabled: false,
                                        onClick: handleDismissClicked,
                                        spacing: "compact"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...$790c28d90e90729b$var$i18n.bodyText
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                xcss: $790c28d90e90729b$var$styles.link,
                                testId: "cta-link",
                                onClick: handleCtaClicked,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...$790c28d90e90729b$var$i18n.ctaMessage
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $1471031bb9b0e33a$export$a7a9523472993e97(value) {
    const result = $1471031bb9b0e33a$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $1471031bb9b0e33a$export$226b3eccf92c9ed9(value) {
    const result = $1471031bb9b0e33a$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $1471031bb9b0e33a$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"RESURRECTED_USER_NUDGE"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "RESURRECTED_USER_NUDGE",
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $99e15f17ae435c58$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend((0, $e7qVY.defaultMessageBackend));
const $99e15f17ae435c58$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $1471031bb9b0e33a$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $790c28d90e90729b$export$1a9faf036da14396), {
                onSideNavClick: onSideNavClick,
                handleOnDismissed: handleOnDismissed,
                nextBestActionType: nextBestActionType
            });
        }
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










var $7p4As = parcelRequire("7p4As");





























var $b02a171e835975fc$exports = {};
$b02a171e835975fc$exports = new URL("notes.c9738615.png", import.meta.url).toString();


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $75c0e64826899008$export$a7a9523472993e97(value) {
    const result = $75c0e64826899008$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $75c0e64826899008$export$226b3eccf92c9ed9(value) {
    const result = $75c0e64826899008$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $75c0e64826899008$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"1_ON_1_LOOM_NUDGE"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "1_ON_1_LOOM_NUDGE",
            value: value["nextBestActionType"]
        });
        if (!('explicitEnableRequired' in value)) errors.push({
            path: 'value["explicitEnableRequired"]',
            expected: 'true',
            value: undefined
        });
        else if (value["explicitEnableRequired"] !== true) errors.push({
            path: 'value["explicitEnableRequired"]',
            expected: true,
            value: value["explicitEnableRequired"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $df51ae92ee3b789a$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend((0, $e7qVY.defaultMessageBackend));
const $df51ae92ee3b789a$var$whyAmISeeingThisModalContent = {
    title: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this",
        defaultMessage: "Why am I seeing this?"
    }),
    message: /*#__PURE__*/ (0, $l998X.jsx)("p", {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis",
            defaultMessage: "This recommendation is based on:"
        })
    }),
    reasons: [
        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far",
            defaultMessage: "What you\u2019ve done so far in the product"
        }),
        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions",
            defaultMessage: "What we suggest to help you get the most value from Atlassian"
        })
    ]
};
const $df51ae92ee3b789a$var$styles = {
    container: "_2rko1mok _1yt4utpp _bfhkhfxm _1bsb1osq",
    body: "_19pku2gc",
    ctaWrapper: "_19pkutpp"
};
const $df51ae92ee3b789a$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $75c0e64826899008$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
            const { messageDismissed: messageDismissed } = (0, $jVJ5P.useMessageEvent)();
            const intl = (0, $aXWIB.useIntl)();
            const headerText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header",
                defaultMessage: "Automate meeting notes"
            });
            const bodyText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body",
                defaultMessage: "Instead of manually typing meeting notes, why not try Loom to record meetings?"
            });
            const ctaText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta",
                defaultMessage: "Try now"
            });
            const closeLabel = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close",
                defaultMessage: "Close"
            });
            const imageAltText = intl.formatMessage({
                id: "post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt",
                defaultMessage: "Notepad with sparkling background"
            });
            const handleDismiss = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: 'dismiss',
                        clickedElement: 'button',
                        buttonType: 'secondary'
                    },
                    action: {
                        actionType: 'dismiss'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                handleOnDismissed();
            };
            const handleCloseClicked = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: '1on1-loom-close',
                        clickedElement: 'button',
                        buttonType: 'secondary'
                    },
                    action: {
                        actionType: 'dismiss'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                onSideNavClick(nextBestActionType);
            };
            const handleCtaClicked = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: '1on1-loom-cta',
                        clickedElement: 'button',
                        buttonType: 'primary'
                    },
                    action: {
                        actionType: 'open'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                onSideNavClick(nextBestActionType);
            };
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                data: {
                    source: 'confluence-side-nav-1-on-1-loom-nudge-message'
                },
                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        $df51ae92ee3b789a$var$styles.container
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            spread: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b02a171e835975fc$exports))),
                                    alt: imageAltText,
                                    height: "56",
                                    width: "56"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $j01vW.AdControls), {
                                            iconSize: "small",
                                            showWhyAmISeeingThis: true,
                                            whyAmISeeingThisModalContent: $df51ae92ee3b789a$var$whyAmISeeingThisModalContent,
                                            onDismissed: handleDismiss
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                            onClick: handleCloseClicked,
                                            appearance: "subtle",
                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                                            label: closeLabel
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "small",
                            children: headerText
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $df51ae92ee3b789a$var$styles.body
                            ]),
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $df51ae92ee3b789a$var$styles.ctaWrapper
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                                onClick: handleCtaClicked,
                                href: "https://www.loom.com/welcome",
                                spacing: "compact",
                                target: "_blank",
                                children: ctaText
                            })
                        })
                    ]
                })
            });
        }
    }
});












// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $81c8334869cc5a01$export$a7a9523472993e97(value) {
    const result = $81c8334869cc5a01$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $81c8334869cc5a01$export$226b3eccf92c9ed9(value) {
    const result = $81c8334869cc5a01$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $81c8334869cc5a01$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('testProp' in value)) errors.push({
            path: 'value["testProp"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["testProp"] !== 'string') errors.push({
            path: 'value["testProp"]',
            expected: 'string',
            value: value["testProp"]
        });
        if (!('testObjProp' in value)) errors.push({
            path: 'value["testObjProp"]',
            expected: 'object',
            value: undefined
        });
        else if (typeof value["testObjProp"] !== 'object' || value["testObjProp"] === null || Array.isArray(value["testObjProp"])) errors.push({
            path: 'value["testObjProp"]',
            expected: 'object',
            value: value["testObjProp"]
        });
        else {
            if (!('testObjPropKey' in value["testObjProp"])) errors.push({
                path: 'value["testObjProp"]["testObjPropKey"]',
                expected: 'string',
                value: undefined
            });
            else if (typeof value["testObjProp"]["testObjPropKey"] !== 'string') errors.push({
                path: 'value["testObjProp"]["testObjPropKey"]',
                expected: 'string',
                value: value["testObjProp"]["testObjPropKey"]
            });
        }
        if (!('testArrayProp' in value)) errors.push({
            path: 'value["testArrayProp"]',
            expected: 'number[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["testArrayProp"])) errors.push({
                path: 'value["testArrayProp"]',
                expected: 'array',
                value: value["testArrayProp"]
            });
            if (Array.isArray(value["testArrayProp"])) value["testArrayProp"].forEach((element, index)=>{
                if (typeof element !== 'number') errors.push({
                    path: 'element',
                    expected: 'number',
                    value: element
                });
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $9c8f5058878835b9$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $81c8334869cc5a01$export$a7a9523472993e97),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $81c8334869cc5a01$export$a7a9523472993e97),
            stage: ({ message: message })=>{
                message.context.testProp = `Hello ${message.context.testProp} !`;
                return Promise.resolve(message.context);
            }
        }
    }));
const $9c8f5058878835b9$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $81c8334869cc5a01$export$a7a9523472993e97),
        Component: ({ handleOnDismissed: handleOnDismissed })=>{
            const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
            const { messageDismissed: messageDismissed } = (0, $jVJ5P.useMessageEvent)();
            const onDismissed = ()=>{
                messageInstanceClicked({
                    messageEventType: 'clicked',
                    clickedElement: {
                        clickIdentifier: 'confluence-side-nav-create-a-space-dismiss',
                        clickedElement: 'button',
                        buttonType: 'secondary'
                    },
                    action: {
                        actionType: 'dismiss'
                    },
                    additionalMetadataFromFrontend: {}
                });
                messageDismissed();
                handleOnDismissed();
            };
            return /*#__PURE__*/ (0, $l998X.jsx)("button", {
                onClick: onDismissed,
                children: "Dismiss"
            });
        }
    }
});









/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $gdv5Z = parcelRequire("gdv5Z");



















const $f72d282748906e18$export$75019b1a004a783d = ()=>// eslint-disable-next-line @atlassian/a11y/role-img-alt
    /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        role: "img",
        width: "80",
        height: "92",
        viewBox: "0 0 80 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                "clip-path": "url(#clip0_2327_84459)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M3.01494 50.2585C1.34983 44.4516 4.70743 38.3943 10.5143 36.7292L31.543 30.6993C37.3499 29.0342 43.4072 32.3918 45.0723 38.1987L51.1021 59.2274C52.7672 65.0343 49.4096 71.0916 43.6027 72.7567L22.5741 78.7865C16.7672 80.4516 10.7099 77.094 9.04481 71.2871L3.01494 50.2585Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        "clip-path": "url(#clip1_2327_84459)",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("g", {
                            "clip-path": "url(#clip2_2327_84459)",
                            children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M37.6067 56.0157C30.2172 54.7386 28.1868 54.8133 25.4524 55.5974C22.244 56.5174 19.8923 58.636 18.5252 63.0876L18.2999 63.8158C18.1166 64.4149 18.0954 64.6161 18.1575 64.8325C18.2195 65.0489 18.3806 65.1979 18.854 65.3354L23.7082 66.7149C23.9684 66.7965 24.1713 66.8163 24.3536 66.7641C24.5724 66.7013 24.6872 66.5513 24.8129 66.164L25.1795 64.9659C25.7556 63.1222 26.5223 62.3559 27.689 62.0213C28.7099 61.7286 29.9957 61.6722 31.6974 61.9649L36.5788 62.7511C37.0783 62.8421 37.5213 62.598 37.5952 62.0303L38.3544 56.9723C38.4284 56.4046 38.1895 56.1218 37.6067 56.0157ZM16.4195 53.5425C23.8089 54.8196 25.8393 54.7449 28.5737 53.9608C31.7821 53.0408 34.1338 50.9222 35.5009 46.4706L35.7262 45.7424C35.9095 45.1433 35.9307 44.9421 35.8686 44.7257C35.8066 44.5093 35.6455 44.3603 35.1721 44.2228L30.3179 42.8433C30.0577 42.7617 29.8548 42.7419 29.6725 42.7941C29.4537 42.8569 29.3389 43.0069 29.2132 43.3942L28.8466 44.5923C28.2705 46.436 27.5038 47.2023 26.3371 47.5369C25.3162 47.8296 24.0304 47.886 22.3287 47.5933L17.4474 46.8071C16.9478 46.7161 16.5049 46.9602 16.4309 47.5279L15.6717 52.5859C15.5977 53.1536 15.8366 53.4364 16.4195 53.5425Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_2327_84459",
                style: {
                    maskType: 'alpha'
                },
                maskUnits: "userSpaceOnUse",
                x: "42",
                y: "34",
                width: "47",
                height: "46",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M84.5407 70.1354C85.399 68.8074 86.1676 67.3446 86.8433 65.7294C87.5189 64.1142 88.0399 62.4937 88.382 60.9391C90.4423 51.6574 86.6686 43.8231 78.8282 38.9377C77.4887 38.1071 76.0405 37.3553 74.4713 36.6989C72.9021 36.0425 71.2192 35.49 69.6242 35.1148C60.6205 32.9978 52.4142 35.7994 47.265 43.7403C46.3964 45.0801 45.6116 46.5686 44.9302 48.1976C44.2488 49.8267 43.7528 51.3873 43.4099 52.9308C41.3701 62.1507 45.1318 69.9746 52.9733 74.9092C54.3603 75.7813 55.8756 76.5666 57.5047 77.248C59.1337 77.9294 60.6241 78.4122 62.158 78.7781C71.1529 80.9293 79.3919 78.1143 84.5361 70.1334L84.5407 70.1354Z",
                    fill: "#E2E3E4"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                mask: "url(#mask0_2327_84459)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M65.4465 54.2364C48.7381 38.7562 43.5093 13.5402 54.257 -7.8265C56.8701 -13.0214 60.2302 -17.5913 64.1386 -21.4774L21.9822 -42.6824L-33.085 66.7933L44.6016 105.87C46.0277 93.9323 49.5157 82.0341 55.2309 70.6721C58.1886 64.7921 61.6171 59.3074 65.448 54.2371L65.4465 54.2364Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M65.4458 54.2338C82.2906 31.934 106.91 17.6731 133.454 13.3867L64.1379 -21.48C60.2294 -17.5938 56.8694 -13.024 54.2563 -7.82904C43.5086 13.5377 48.7381 38.7558 65.4458 54.2338Z",
                        fill: "#AF59E0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M191.971 42.8203L153.078 23.2568C152.288 28.7116 150.622 34.1336 148.009 39.3286C134.987 65.2179 103.443 75.6484 77.5534 62.6258C73.0307 60.3509 68.9819 57.5093 65.4457 54.2328C61.6162 59.3039 58.1856 64.7893 55.2286 70.6678C49.5142 82.0285 46.0276 93.9273 44.5993 105.866L136.904 152.296L191.971 42.8203Z",
                        fill: "#6A9A23"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M65.4459 54.2343C68.9821 57.5108 73.0309 60.3524 77.5536 62.6273C103.443 75.6499 134.987 65.2194 148.009 39.3301C150.623 34.1351 152.288 28.7131 153.079 23.2584L133.454 13.3872C106.91 17.6737 82.2906 31.9345 65.4459 54.2343Z",
                        fill: "#1868DB"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M50.8357 59.1709C52.0329 63.3459 50.6336 67.65 47.5945 70.3584C43.5378 65.6894 41.9154 59.6856 43.4099 52.9307C43.7528 51.3873 44.2491 49.8271 44.9304 48.1982C45.4556 46.9426 46.0423 45.7704 46.6814 44.6855L50.8357 59.1709Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M77.573 60.512L56.5132 56.8549L57.1141 53.3945L78.1739 57.0517L77.573 60.512Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M63.7844 67.1848L67.4416 46.125L70.9019 46.7259L67.2448 67.7857L63.7844 67.1848Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_2327_84459",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M3.01494 50.2585C1.34983 44.4516 4.70743 38.3943 10.5143 36.7292L31.543 30.6993C37.3499 29.0342 43.4072 32.3918 45.0723 38.1987L51.1021 59.2274C52.7672 65.0343 49.4096 71.0916 43.6027 72.7567L22.5741 78.7865C16.7672 80.4516 10.7099 77.094 9.04481 71.2871L3.01494 50.2585Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip1_2327_84459",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32.8142",
                            height: "32.8142",
                            fill: "white",
                            transform: "translate(6.54558 43.5566) rotate(-16)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip2_2327_84459",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "22.5673",
                            height: "21.5753",
                            fill: "white",
                            transform: "translate(13.193 47.5195) rotate(-16)"
                        })
                    })
                ]
            })
        ]
    });


const $0d2b0a9a332bd020$var$i18n = (0, $aXWIB.defineMessages)({
    headingLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.heading",
        defaultMessage: "You describe, Rovo creates"
    },
    bodyLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.body",
        defaultMessage: "With a simple prompt, Rovo can draft a page or whiteboard."
    },
    callToActionLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action",
        defaultMessage: "Show me how"
    },
    dismissLabel: {
        id: "post-office.confluence-create-with-rovo-side-nav-nudge.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $0d2b0a9a332bd020$var$styles = {
    root: "_2rko1mok _kqswh2mm _16jlkb7n _bfhk1s93",
    primaryContentContainer: "_1yt4pxbi _16jlkb7n",
    callToActionContainer: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _bfhk1j28 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz",
    imageContainer: "_16jlidpf _1o9zidpf _i0dl1wug",
    closeButtonContainer: "_kqswstnw _154iu2gc _1xi2u2gc"
};
const $0d2b0a9a332bd020$export$73f0a7caafa5e72e = ({ action: action, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceCreateWithRovoSideNavNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireMessageInstanceClicked = ({ actionType: actionType, clickedElement: clickedElement })=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: actionType
            },
            additionalMetadataFromFrontend: {}
        });
    };
    const handleOnPrimaryActionClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'open',
            clickedElement: {
                clickIdentifier: 'showMeHow',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWithRovoSideNavNudgeCta'
        });
        onPrimaryActionClick?.(action);
    };
    const handleOnDismissClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'dismiss',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'cross-icon'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createWithRovoSideNavNudgeDismiss'
        });
        onDismissClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            source: 'confluence-create-with-rovo-side-nav-nudge'
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            xcss: $0d2b0a9a332bd020$var$styles.root,
            testId: "confluence-create-with-rovo-side-nav-nudge",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    xcss: $0d2b0a9a332bd020$var$styles.primaryContentContainer,
                    gap: "space.100",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...$0d2b0a9a332bd020$var$i18n.headingLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...$0d2b0a9a332bd020$var$i18n.bodyLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                xcss: $0d2b0a9a332bd020$var$styles.callToActionContainer,
                                onClick: handleOnPrimaryActionClick,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    color: "color.link",
                                    size: "medium",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...$0d2b0a9a332bd020$var$i18n.callToActionLabel
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: $0d2b0a9a332bd020$var$styles.imageContainer,
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f72d282748906e18$export$75019b1a004a783d), {})
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $0d2b0a9a332bd020$var$styles.closeButtonContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...props,
                                size: "small"
                            }),
                        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...$0d2b0a9a332bd020$var$i18n.dismissLabel
                        }),
                        isTooltipDisabled: false,
                        onClick: handleOnDismissClick
                    })
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $91a2f4e421da3f7b$export$a7a9523472993e97(value) {
    const result = $91a2f4e421da3f7b$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $91a2f4e421da3f7b$export$226b3eccf92c9ed9(value) {
    const result = $91a2f4e421da3f7b$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $91a2f4e421da3f7b$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else if (!('nextBestActionType' in value)) errors.push({
        path: 'value["nextBestActionType"]',
        expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
        value: undefined
    });
    else {
        let value__nextBestActionType___valid = false;
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_0 = [];
            if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_SPACE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_1 = [];
            if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_PAGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_2 = [];
            if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WHITEBOARD",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_3 = [];
            if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                path: 'value["nextBestActionType"]',
                expected: "1_ON_1_LOOM_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_4 = [];
            if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                path: 'value["nextBestActionType"]',
                expected: "LOOM_AI_MEETING_NOTES",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_5 = [];
            if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                path: 'value["nextBestActionType"]',
                expected: "RESURRECTED_USER_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_6 = [];
            if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                path: 'value["nextBestActionType"]',
                expected: "CREATE_WITH_ROVO_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_7 = [];
            if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                path: 'value["nextBestActionType"]',
                expected: "ROVO_EXTENSION_CTA",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) {
            const value__nextBestActionType___errors_8 = [];
            if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                path: 'value["nextBestActionType"]',
                expected: "CONNECT_3P_TOOLS_NUDGE",
                value: value["nextBestActionType"]
            });
            if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
        }
        if (!value__nextBestActionType___valid) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $9a5b08e01a85fa28$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend((0, $e7qVY.defaultMessageBackend));
const $9a5b08e01a85fa28$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $91a2f4e421da3f7b$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $0d2b0a9a332bd020$export$73f0a7caafa5e72e), {
                action: nextBestActionType,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});


// integrated-teams/{your-team}/message-templates/{message-template}/src/placements/in-app-v2/{placement-id}/index.tsx




var $hwVbs = parcelRequire("hwVbs");


// See the current list of valid CCP product IDS here:
// This is a constant used to standardized the value of the "any" field in the message metadata
const $8e15ca4f373a0a86$var$AnyValue = 'any';
const $8e15ca4f373a0a86$export$d7170743086edf62 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $8e15ca4f373a0a86$export$749a64c68d670e1c = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $8e15ca4f373a0a86$export$7452609cc2879709 = '46ccaa9e-cdb0-4995-8886-5827a5ff162b';
const $8e15ca4f373a0a86$export$d3304f5525ccba77 = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $8e15ca4f373a0a86$export$c44082beda68c821 = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $8e15ca4f373a0a86$export$3ffd6e56cffd07e5 = '0b8ea1e2-52df-11ea-8d77-2e728ce88125';
const $8e15ca4f373a0a86$export$e91f394c1f32343a = '7c917705-866d-4b6b-b266-0fc7633e8342';
const $8e15ca4f373a0a86$export$9135e98f8bbab458 = '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2';
const $8e15ca4f373a0a86$export$a5e8ad58f7670c77 = 'f44da23e-5907-4d81-8a78-33bedee10969';
const $8e15ca4f373a0a86$export$8ce8b463868cb16e = 'b6c5632b-6018-4656-b2ac-3e32e7cef0d3';
const $8e15ca4f373a0a86$export$174b0d3ebcf732d2 = 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551';
const $8e15ca4f373a0a86$export$fe6a238b700ff48b = '91ae3e3f-138e-43be-98cc-48df03d13c32';
const $8e15ca4f373a0a86$export$23a18b32c52da583 = '56cce7cb-8c54-4103-8736-e64d1ab00128';
const $8e15ca4f373a0a86$export$a9a5d8e6a4b07b3 = '7683a73e-423d-41a1-b43f-d497656f8b5d';
const $8e15ca4f373a0a86$export$b729c699fa9f25a6 = 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905';
const $8e15ca4f373a0a86$export$64ae0929ad3ee453 = 'dbe4d391-d570-4313-ab0f-3a02dbab4720';
const $8e15ca4f373a0a86$export$2ee82f14fe1b2d80 = $8e15ca4f373a0a86$var$AnyValue;
const $8e15ca4f373a0a86$export$a0b0b6a3fe1e8702 = 'fake-id';
const $8e15ca4f373a0a86$export$ba7683be5feaa33e = {
    JiraSoftwareCcpId: $8e15ca4f373a0a86$export$d7170743086edf62,
    JiraServiceManagementCcpId: $8e15ca4f373a0a86$export$749a64c68d670e1c,
    JiraWorkManagementCloudCcpId: $8e15ca4f373a0a86$export$7452609cc2879709,
    JiraProductDiscoveryCcpId: $8e15ca4f373a0a86$export$d3304f5525ccba77,
    ConfluenceCloudCcpId: $8e15ca4f373a0a86$export$c44082beda68c821,
    StatuspageCcpId: $8e15ca4f373a0a86$export$3ffd6e56cffd07e5,
    AtlasCcpId: $8e15ca4f373a0a86$export$e91f394c1f32343a,
    CompassCcpId: $8e15ca4f373a0a86$export$9135e98f8bbab458,
    AtlassianAnalyticsCcpId: $8e15ca4f373a0a86$export$a5e8ad58f7670c77,
    AtlassianWhiteboardCcpId: $8e15ca4f373a0a86$export$8ce8b463868cb16e,
    OpsgenieCcpId: $8e15ca4f373a0a86$export$174b0d3ebcf732d2,
    RovoCcpId: $8e15ca4f373a0a86$export$fe6a238b700ff48b,
    RovoDevCcpId: $8e15ca4f373a0a86$export$23a18b32c52da583,
    LoomCcpId: $8e15ca4f373a0a86$export$a9a5d8e6a4b07b3,
    FocusCcpId: $8e15ca4f373a0a86$export$b729c699fa9f25a6,
    StudioCcpId: $8e15ca4f373a0a86$export$64ae0929ad3ee453,
    AnyProductCcpId: $8e15ca4f373a0a86$export$2ee82f14fe1b2d80,
    TestProductCcpId: $8e15ca4f373a0a86$export$a0b0b6a3fe1e8702
};
const $8e15ca4f373a0a86$export$ed719b477b100ccf = 'free';
const $8e15ca4f373a0a86$export$9c0d875ac3fc7486 = 'standard';
const $8e15ca4f373a0a86$export$ef90b2d2063bbde5 = 'premium';
const $8e15ca4f373a0a86$export$de3613be25133e67 = $8e15ca4f373a0a86$var$AnyValue;
const $8e15ca4f373a0a86$export$3089d1941106d80a = {
    FreeEdition: $8e15ca4f373a0a86$export$ed719b477b100ccf,
    StandardEdition: $8e15ca4f373a0a86$export$9c0d875ac3fc7486,
    PremiumEdiiton: $8e15ca4f373a0a86$export$ef90b2d2063bbde5,
    AnyEdition: $8e15ca4f373a0a86$export$de3613be25133e67
};
const $8e15ca4f373a0a86$export$935920ee20f5fbfd = 'signup';
const $8e15ca4f373a0a86$export$af08535a504b4ba1 = 'd1to6ai';
const $8e15ca4f373a0a86$export$2e8b1b8d42494923 = 'ffp';
const $8e15ca4f373a0a86$export$2887820b2787a3b = 'fo';
const $8e15ca4f373a0a86$export$17c81379c0af852c = 'mcu';
const $8e15ca4f373a0a86$export$7af8db49468f6ca0 = 'mau';
const $8e15ca4f373a0a86$export$4a4a9bf2ef44c9d3 = 'macm'; // Month Active Community Member
const $8e15ca4f373a0a86$export$1d22059176a01613 = 'purchase';
const $8e15ca4f373a0a86$export$62e129faf973b35b = 'm2_ati';
const $8e15ca4f373a0a86$export$b2e16dc790f0af57 = 'peu';
const $8e15ca4f373a0a86$export$b02d9c969aca0c41 = 'event_registration';
const $8e15ca4f373a0a86$export$6086e660e37fefd1 = 'tech_alert';
const $8e15ca4f373a0a86$export$74d3ca88165fd9c7 = 'commerce_notification';
const $8e15ca4f373a0a86$export$95514713d19a18ca = 'webinar_invites';
const $8e15ca4f373a0a86$export$91eb8e25419b040e = 'demo';
const $8e15ca4f373a0a86$export$2d677556a829b674 = 'survey_research';
const $8e15ca4f373a0a86$export$c1b571ea4fc68de = 'clickthrough';
const $8e15ca4f373a0a86$export$abb11c2932ba2d5f = {
    SignupGoal: $8e15ca4f373a0a86$export$935920ee20f5fbfd,
    D1to6aiGoal: $8e15ca4f373a0a86$export$af08535a504b4ba1,
    FfpGoal: $8e15ca4f373a0a86$export$2e8b1b8d42494923,
    FoGoal: $8e15ca4f373a0a86$export$2887820b2787a3b,
    McuGoal: $8e15ca4f373a0a86$export$17c81379c0af852c,
    MauGoal: $8e15ca4f373a0a86$export$7af8db49468f6ca0,
    MacmGoal: $8e15ca4f373a0a86$export$4a4a9bf2ef44c9d3,
    PurchaseGoal: $8e15ca4f373a0a86$export$1d22059176a01613,
    M2AtiGoal: $8e15ca4f373a0a86$export$62e129faf973b35b,
    PeuGoal: $8e15ca4f373a0a86$export$b2e16dc790f0af57,
    EventRegistrationGoal: $8e15ca4f373a0a86$export$b02d9c969aca0c41,
    TechAlertGoal: $8e15ca4f373a0a86$export$6086e660e37fefd1,
    CommerceNotificationGoal: $8e15ca4f373a0a86$export$74d3ca88165fd9c7,
    WebinarInvitesGoal: $8e15ca4f373a0a86$export$95514713d19a18ca,
    DemoGoal: $8e15ca4f373a0a86$export$91eb8e25419b040e,
    SurveryResearchGoal: $8e15ca4f373a0a86$export$2d677556a829b674,
    ClickthroughGoal: $8e15ca4f373a0a86$export$c1b571ea4fc68de
};
const $8e15ca4f373a0a86$export$428528e1e61b68ff = 'ui';
const $8e15ca4f373a0a86$export$d4c7c79f2dff5f1f = 'track';
const $8e15ca4f373a0a86$export$287340d0a2f482b0 = 'screen';
const $8e15ca4f373a0a86$var$ValidGASv3EventTypes = {
    UIEventTypeGASv3: $8e15ca4f373a0a86$export$428528e1e61b68ff,
    TrackEventTypeGASv3: $8e15ca4f373a0a86$export$d4c7c79f2dff5f1f,
    ScreenEventTypeGASv3: $8e15ca4f373a0a86$export$287340d0a2f482b0
};
const $8e15ca4f373a0a86$export$42867c57e2cf7ae6 = {
    SignupGoal: $8e15ca4f373a0a86$export$935920ee20f5fbfd,
    D1to6aiGoal: $8e15ca4f373a0a86$export$af08535a504b4ba1,
    FfpGoal: $8e15ca4f373a0a86$export$2e8b1b8d42494923,
    FoGoal: $8e15ca4f373a0a86$export$2887820b2787a3b,
    McuGoal: $8e15ca4f373a0a86$export$17c81379c0af852c,
    MauGoal: $8e15ca4f373a0a86$export$7af8db49468f6ca0,
    PurchaseGoal: $8e15ca4f373a0a86$export$1d22059176a01613,
    M2AtiGoal: $8e15ca4f373a0a86$export$62e129faf973b35b,
    PeuGoal: $8e15ca4f373a0a86$export$b2e16dc790f0af57
};
const $8e15ca4f373a0a86$export$db4eeb1cca300952 = ()=>{
    return (transformFn)=>{
        return transformFn;
    };
};
// Format the product name to be more readable
const $8e15ca4f373a0a86$var$formatProductName = (ccpId)=>{
    // Find the constant name from the ccpId
    const [ccpIdKey] = Object.entries($8e15ca4f373a0a86$export$ba7683be5feaa33e).find(([_, value])=>value === ccpId) ?? [];
    if (!ccpIdKey) return ccpId;
    const nameWithoutSuffix = ccpIdKey.replace('CcpId', '');
    return nameWithoutSuffix.replace(/([A-Z])/g, ' $1').trim();
};
const $8e15ca4f373a0a86$export$59107169de84951d = Object.values($8e15ca4f373a0a86$export$ba7683be5feaa33e).filter((id)=>id !== $8e15ca4f373a0a86$export$ba7683be5feaa33e.TestProductCcpId && id !== $8e15ca4f373a0a86$export$ba7683be5feaa33e.AnyProductCcpId).map((id)=>({
        id: id,
        displayName: $8e15ca4f373a0a86$var$formatProductName(id)
    }));
const $8e15ca4f373a0a86$export$61f1f24062fabe34 = (goalId)=>Object.values($8e15ca4f373a0a86$export$42867c57e2cf7ae6).includes(goalId);


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $281fc623b96f7ccb$export$a7a9523472993e97(value) {
    const result = $281fc623b96f7ccb$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $281fc623b96f7ccb$export$226b3eccf92c9ed9(value) {
    const result = $281fc623b96f7ccb$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $281fc623b96f7ccb$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"ROVO_EXTENSION_CTA"',
            value: undefined
        });
        else if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") errors.push({
            path: 'value["nextBestActionType"]',
            expected: "ROVO_EXTENSION_CTA",
            value: value["nextBestActionType"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


/* LeftNavCtaMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1Whri = parcelRequire("1Whri");











var $2Nwuj = parcelRequire("2Nwuj");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");







var $1309157366734b92$exports = {};
$1309157366734b92$exports = new URL("chrome-icon.40414d4b.svg", import.meta.url).toString();


var $310fc6422cb75df4$exports = {};
$310fc6422cb75df4$exports = new URL("rovo-icon.a638efdd.svg", import.meta.url).toString();








const $7143f179a15c6305$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    linkText: {
        id: "rovo-extension-install-cta-left-nav.link",
        defaultMessage: "Get the browser extension"
    },
    jiraLinkText: {
        id: "rovo-extension-install-cta-left-nav.jira-link",
        defaultMessage: "Get the browser extension"
    },
    jiraRovoLinkText: {
        id: "rovo-extension-install-cta-left-nav.jira-rovo-link",
        defaultMessage: "Get the Rovo extension"
    },
    rovoIconAlt: {
        id: "rovo-extension-install-cta-left-nav.rovo-icon-alt",
        defaultMessage: "Rovo Icon"
    },
    chromeIconAlt: {
        id: "rovo-extension-install-cta-left-nav.chrome-icon-alt",
        defaultMessage: "Google Chrome Icon"
    },
    jiraIconAlt: {
        id: "rovo-extension-install-cta-left-nav.jira-icon-alt",
        defaultMessage: "Jira Icon"
    },
    dismissLabel: {
        id: "rovo-extension-install-cta-left-nav.dismiss-label",
        defaultMessage: "Dismiss message"
    }
});
const $7143f179a15c6305$export$1d02164cdbd97674 = {
    'copy-version-b': (0, $aXWIB.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.copy-version-b",
            defaultMessage: "Get answers for work, anywhere"
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.copy-version-b",
            defaultMessage: "Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab."
        }
    }),
    'copy-version-c': (0, $aXWIB.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.copy-version-c",
            defaultMessage: "Unlock Rovo in every tab"
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.copy-version-c",
            defaultMessage: "50K+ workers use it to chat with AI that understands their company."
        }
    }),
    'jira-take-anywhere': (0, $aXWIB.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.jira-take-anywhere",
            defaultMessage: "Jira. Anywhere."
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.jira-take-anywhere",
            defaultMessage: "Manage issues, get instant insights, and act on Jira from any tab in your browser."
        }
    }),
    'jira-rovo': (0, $aXWIB.defineMessages)({
        heading: {
            id: "rovo-extension-install-cta-left-nav.heading.jira-rovo",
            defaultMessage: "Jira. Anywhere."
        },
        description: {
            id: "rovo-extension-install-cta-left-nav.description.jira-rovo",
            defaultMessage: "Manage issues, get instant insights, and act on Jira from any tab in your browser."
        }
    })
};


const $93ff7bd26183d865$var$styles = {
    boxContainer: "_1yt4utpp _zulpu2gc _2rko12b0 _ae4v1h6o _1bah1h6o _1e0c1txw _1bsb1osq _4cvr1y6m _bfhk1s93",
    contentStack: "_zulpu2gc _1bsb1osq",
    headerRow: "_1bah1yb4 _4cvr1y6m _1bsb1osq",
    iconAndTitle: "_zulpu2gc",
    iconContainer: "_1e0c1txw _4cvr1h6o"
};
const $93ff7bd26183d865$var$getLinkUrl = (cohort)=>{
    const UTM_CONTENT = `side_nav_install_cta_${cohort}`;
    return `https://chromewebstore.google.com/detail/rovo-search-chat-and-more/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=confluence-side-nav&utm_medium=banner&utm_campaign=rovo_extension_side_nav_install_cta&utm_content=${UTM_CONTENT}`;
};
const $93ff7bd26183d865$var$selectCopyForCohort = (cohort)=>{
    return (0, $7143f179a15c6305$export$1d02164cdbd97674)[cohort] || (0, $7143f179a15c6305$export$1d02164cdbd97674)['copy-version-b'];
};
const $93ff7bd26183d865$export$217ec4c85bc42809 = ({ context: context, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
    const { experimentCohort: experimentCohort } = context;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { heading: heading, description: description } = $93ff7bd26183d865$var$selectCopyForCohort(experimentCohort);
    const { messageClicked: messageClicked } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const headingText = formatMessage(heading);
    const descriptionText = formatMessage(description);
    const linkText = formatMessage((0, $7143f179a15c6305$export$defe85febe8b728c).linkText);
    const rovoIconAlt = formatMessage((0, $7143f179a15c6305$export$defe85febe8b728c).rovoIconAlt);
    const chromeIconAlt = formatMessage((0, $7143f179a15c6305$export$defe85febe8b728c).chromeIconAlt);
    const dismissLabel = formatMessage((0, $7143f179a15c6305$export$defe85febe8b728c).dismissLabel);
    const linkUrl = $93ff7bd26183d865$var$getLinkUrl(experimentCohort);
    const handleDismiss = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        handleOnDismissed();
    };
    const handleLinkClick = ()=>{
        messageClicked();
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'installLink',
                clickedElement: 'link'
            },
            action: {
                actionType: 'open',
                destinationUrl: linkUrl
            },
            additionalMetadataFromFrontend: {
                experimentCohort: experimentCohort,
                source: 'confluence-side-nav'
            }
        });
        onSideNavClick('ROVO_EXTENSION_CTA');
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: (0, $1Whri.cx)($93ff7bd26183d865$var$styles.boxContainer),
        style: {
            border: `1px solid ${"var(--ds-border, #0B120E24)"}`
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            xcss: (0, $1Whri.cx)($93ff7bd26183d865$var$styles.contentStack),
            testId: "rovo-left-nav-content",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    xcss: (0, $1Whri.cx)($93ff7bd26183d865$var$styles.headerRow),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            xcss: (0, $1Whri.cx)($93ff7bd26183d865$var$styles.iconAndTitle),
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                                    xcss: (0, $1Whri.cx)($93ff7bd26183d865$var$styles.iconContainer),
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($310fc6422cb75df4$exports))),
                                            alt: rovoIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                flexShrink: 0,
                                                zIndex: 2
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1309157366734b92$exports))),
                                            alt: chromeIconAlt,
                                            width: 24,
                                            height: 24,
                                            style: {
                                                marginLeft: '-8px',
                                                flexShrink: 0,
                                                zIndex: 1
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "xsmall",
                                    children: headingText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                            label: dismissLabel,
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: handleDismiss
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    size: "small",
                    children: descriptionText
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: linkUrl,
                    target: "blank",
                    onClick: handleLinkClick,
                    children: linkText
                })
            ]
        })
    });
};


const $e2590681d1c6a329$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $281fc623b96f7ccb$export$a7a9523472993e97),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: (0, $8e15ca4f373a0a86$export$7af8db49468f6ca0),
                            targetProduct: [
                                (0, $8e15ca4f373a0a86$export$fe6a238b700ff48b)
                            ],
                            edition: [
                                (0, $8e15ca4f373a0a86$export$de3613be25133e67)
                            ]
                        }
                    }
                })
        }
    }));
const $e2590681d1c6a329$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $hwVbs.noValidation)(),
        Component: (props)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $93ff7bd26183d865$export$217ec4c85bc42809), {
                ...props,
                context: {
                    experimentCohort: props.experimentCohort,
                    source: 'confluence-side-nav'
                }
            });
        }
    }
});















const $512c3370a975cef3$export$f83734c268a0a1ff = ({ onDismissed: onDismissed, clickIdentifier: clickIdentifier })=>{
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const { messageDismissed: messageDismissed } = (0, $jVJ5P.useMessageEvent)();
    const handleDismiss = ()=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: clickIdentifier,
                clickedElement: 'button',
                buttonType: 'secondary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        messageDismissed();
        onDismissed();
    };
    return {
        handleDismiss: handleDismiss
    };
};


const $f55feeef638d64a0$export$f3737296d91f3061 = async ({ messageTemplateId: messageTemplateId, siteId: siteId, tcsClient: tcsClient, logger: logger })=>{
    try {
        logger?.info({
            siteId: siteId,
            messageTemplateId: messageTemplateId
        }, 'Getting products from TCS');
        const tcsResponse = await tcsClient?.cloud?.getTcsRecord(`${siteId}.xflow.license.information`);
        if (!tcsResponse || !tcsResponse.data) {
            logger?.error({
                siteId: siteId,
                messageTemplateId: messageTemplateId
            }, 'No license information found for siteId');
            throw new Error(`No license information found for siteId: ${siteId}`);
        }
        const products = tcsResponse.data.products;
        const hasJira = products['jira-software.ondemand']?.state === 'ACTIVE';
        const hasConfluence = products['confluence.ondemand']?.state === 'ACTIVE';
        const hasLoom = products['loom']?.state === 'ACTIVE';
        const hasRovo = products['rovo.ondemand']?.state === 'ACTIVE';
        return {
            hasJira: hasJira,
            hasConfluence: hasConfluence,
            hasLoom: hasLoom,
            hasRovo: hasRovo,
            hostname: tcsResponse.data.hostname
        };
    } catch (error) {
        logger?.error({
            error: error,
            siteId: siteId,
            messageTemplateId: messageTemplateId
        }, 'Error retrieving license information from TCS');
        throw error;
    }
};


/* generic-banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $inPa6 = parcelRequire("inPa6");






















var $d79aafe5b4762c09$exports = {};
$d79aafe5b4762c09$exports = new URL("twc-app-tiles.b4f04c82.svg", import.meta.url).toString();


const $a6cc29a1ce3266e7$var$styles = {
    root: "_2rko1mok _bfhk1s93 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _19pkutpp _2hwxutpp _otyrutpp _18u0utpp",
    appTilesWrapper: "_19pkutpp",
    headerRow: "_zulputpp _1e0c1txw _4cvr1y6m _1bah1yb4"
};
const $a6cc29a1ce3266e7$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        id: "twc.sidenav.banner.generic.heading",
        defaultMessage: "Explore Teamwork Collection"
    },
    subheadingJira: {
        id: "twc.sidenav.banner.generic.subheading.jira",
        defaultMessage: "Discover how the other apps can accelerate your workflows in Jira"
    },
    subheadingConfluence: {
        id: "twc.sidenav.banner.generic.subheading.confluence",
        defaultMessage: "Discover how the other apps can accelerate your workflows in Confluence"
    },
    appTilesAlt: {
        id: "twc.sidenav.banner.generic.app.tiles.alt",
        defaultMessage: "App tiles illustration"
    },
    ctaButton: {
        id: "twc.sidenav.banner.generic.cta",
        defaultMessage: "Try now"
    },
    closeLabel: {
        id: "twc.sidenav.banner.generic.close",
        defaultMessage: "Close"
    }
});
const $a6cc29a1ce3266e7$export$a350437cbfeb32d4 = ({ href: href, locale: locale, product: product, messageInstanceId: messageInstanceId, onClose: onClose, onCtaClick: onCtaClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcGenericBanner',
            attributes: {
                product: product,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
    }, [
        createAnalyticsEvent,
        product,
        messageInstanceId,
        locale
    ]);
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcGenericBannerClose',
            attributes: {
                product: product,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
        onClose?.();
    };
    const handleCtaClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcGenericBannerCta',
            attributes: {
                product: product,
                messageInstanceId: messageInstanceId,
                locale: locale,
                arm: 'generic'
            }
        }).fire('growth');
        onCtaClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a6cc29a1ce3266e7$var$styles.root,
        testId: "twc-generic-banner",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $a6cc29a1ce3266e7$var$styles.headerRow,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $a6cc29a1ce3266e7$var$styles.appTilesWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d79aafe5b4762c09$exports))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($d79aafe5b4762c09$exports))),
                                alt: formatMessage($a6cc29a1ce3266e7$var$messages.appTilesAlt),
                                testId: "twc-generic-banner-app-tiles",
                                width: 91
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            onClick: handleClose,
                            label: formatMessage($a6cc29a1ce3266e7$var$messages.closeLabel),
                            testId: "twc-generic-banner-close",
                            appearance: "subtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            testId: "twc-generic-banner-heading",
                            children: formatMessage($a6cc29a1ce3266e7$var$messages.heading)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtle",
                            testId: "twc-generic-banner-subheading",
                            children: product === 'jira' ? formatMessage($a6cc29a1ce3266e7$var$messages.subheadingJira) : formatMessage($a6cc29a1ce3266e7$var$messages.subheadingConfluence)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                    shouldFitContainer: true,
                    href: href,
                    testId: "twc-generic-banner-cta",
                    onClick: handleCtaClick,
                    target: "_blank",
                    children: formatMessage($a6cc29a1ce3266e7$var$messages.ctaButton)
                })
            ]
        })
    });
};


/* personalized-banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 























var $lAFHW = parcelRequire("lAFHW");








const $e0ae5d18bf9a16eb$var$styles = {
    root: "_2rko1mok _bfhk1s93 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _19pkutpp _2hwxutpp _otyrutpp _18u0utpp",
    headerRow: "_zulputpp _1e0c1txw _4cvr1y6m _1bah1yb4",
    logoWrapper: "_19pk12x7"
};
const $e0ae5d18bf9a16eb$var$messages = (0, $aXWIB.defineMessages)({
    subheadingConfluence: {
        id: "twc.sidenav.banner.personalized.subheading.confluence",
        defaultMessage: "Create with Rovo"
    },
    subheadingJira: {
        id: "twc.sidenav.banner.personalized.subheading.jira",
        defaultMessage: "Plan your next team project"
    },
    subheadingLoom: {
        id: "twc.sidenav.banner.personalized.subheading.loom",
        defaultMessage: "Set up video meetings"
    },
    logoLabelConfluence: {
        id: "twc.sidenav.banner.personalized.logo.label.confluence",
        defaultMessage: "Confluence"
    },
    logoLabelJira: {
        id: "twc.sidenav.banner.personalized.logo.label.jira",
        defaultMessage: "Jira"
    },
    logoLabelLoom: {
        id: "twc.sidenav.banner.personalized.logo.label.loom",
        defaultMessage: "Loom"
    },
    heading: {
        id: "twc.sidenav.banner.personalized.heading",
        defaultMessage: "Explore Teamwork Collection"
    },
    ctaButton: {
        id: "twc.sidenav.banner.personalized.cta",
        defaultMessage: "Get started"
    },
    closeLabel: {
        id: "twc.sidenav.banner.personalized.close",
        defaultMessage: "Close"
    }
});
const $e0ae5d18bf9a16eb$var$subheadingByApp = {
    confluence: $e0ae5d18bf9a16eb$var$messages.subheadingConfluence,
    jira: $e0ae5d18bf9a16eb$var$messages.subheadingJira,
    loom: $e0ae5d18bf9a16eb$var$messages.subheadingLoom
};
const $e0ae5d18bf9a16eb$var$logoLabelByApp = {
    confluence: $e0ae5d18bf9a16eb$var$messages.logoLabelConfluence,
    jira: $e0ae5d18bf9a16eb$var$messages.logoLabelJira,
    loom: $e0ae5d18bf9a16eb$var$messages.logoLabelLoom
};
const $e0ae5d18bf9a16eb$var$logoComponentByApp = {
    confluence: (0, $lAFHW.ConfluenceLogo),
    jira: (0, $lAFHW.JiraLogo),
    loom: (0, $lAFHW.LoomLogo)
};
const $e0ae5d18bf9a16eb$export$44c5a4ad6d35d2bf = ({ href: href, locale: locale, recommendedApp: recommendedApp, messageInstanceId: messageInstanceId, onClose: onClose, onCtaClick: onCtaClick, experimentKey: experimentKey, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const logoLabel = formatMessage($e0ae5d18bf9a16eb$var$logoLabelByApp[recommendedApp]);
    const LogoComponent = $e0ae5d18bf9a16eb$var$logoComponentByApp[recommendedApp];
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            recommendedApp: recommendedApp,
            messageInstanceId: messageInstanceId,
            locale: locale,
            experimentKey: experimentKey,
            actionTier: actionTier,
            targetTenantId: targetTenantId,
            collectionEntitlementId: collectionEntitlementId,
            arm: 'personalized'
        }), [
        recommendedApp,
        messageInstanceId,
        locale,
        experimentKey,
        actionTier,
        targetTenantId,
        collectionEntitlementId
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            name: 'twcPersonalizedBanner',
            attributes: analyticsAttributes
        }).fire('growth');
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const handleClose = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerClose',
            attributes: analyticsAttributes
        }).fire('growth');
        onClose?.();
    };
    const handleCtaClick = ()=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'twcPersonalizedBannerCta',
            attributes: analyticsAttributes
        }).fire('growth');
        onCtaClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $e0ae5d18bf9a16eb$var$styles.root,
        testId: "twc-personalized-banner",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $e0ae5d18bf9a16eb$var$styles.headerRow,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $e0ae5d18bf9a16eb$var$styles.logoWrapper,
                            testId: "twc-personalized-banner-logo",
                            children: /*#__PURE__*/ (0, $l998X.jsx)(LogoComponent, {
                                shouldUseNewLogoDesign: true,
                                appearance: "brand",
                                size: "xsmall",
                                label: logoLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            onClick: handleClose,
                            label: formatMessage($e0ae5d18bf9a16eb$var$messages.closeLabel),
                            testId: "twc-personalized-banner-close",
                            appearance: "subtle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xsmall",
                            testId: "twc-personalized-banner-heading",
                            children: formatMessage($e0ae5d18bf9a16eb$var$messages.heading)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtle",
                            testId: "twc-personalized-banner-subheading",
                            children: formatMessage($e0ae5d18bf9a16eb$var$subheadingByApp[recommendedApp])
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                    shouldFitContainer: true,
                    href: href,
                    testId: "twc-personalized-banner-cta",
                    onClick: handleCtaClick,
                    target: "_blank",
                    children: formatMessage($e0ae5d18bf9a16eb$var$messages.ctaButton)
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $3667a9ec0d5cf904$export$a7a9523472993e97(value) {
    const result = $3667a9ec0d5cf904$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $3667a9ec0d5cf904$export$226b3eccf92c9ed9(value) {
    const result = $3667a9ec0d5cf904$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $3667a9ec0d5cf904$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('product' in value)) errors.push({
            path: 'value["product"]',
            expected: '"jira" | "confluence" | "jira-confluence"',
            value: undefined
        });
        else {
            let value__product___valid = false;
            if (!value__product___valid) {
                const value__product___errors_0 = [];
                if (value["product"] !== "jira") value__product___errors_0.push({
                    path: 'value["product"]',
                    expected: "jira",
                    value: value["product"]
                });
                if (value__product___errors_0.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_1 = [];
                if (value["product"] !== "confluence") value__product___errors_1.push({
                    path: 'value["product"]',
                    expected: "confluence",
                    value: value["product"]
                });
                if (value__product___errors_1.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_2 = [];
                if (value["product"] !== "jira-confluence") value__product___errors_2.push({
                    path: 'value["product"]',
                    expected: "jira-confluence",
                    value: value["product"]
                });
                if (value__product___errors_2.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) errors.push({
                path: 'value["product"]',
                expected: '"jira" | "confluence" | "jira-confluence"',
                value: value["product"]
            });
        }
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if ('orgId' in value && value['orgId'] !== undefined) {
            if (typeof value["orgId"] !== 'string') errors.push({
                path: 'value["orgId"]',
                expected: 'string',
                value: value["orgId"]
            });
        }
        if ('twcEntitlementId' in value && value['twcEntitlementId'] !== undefined) {
            if (typeof value["twcEntitlementId"] !== 'string') errors.push({
                path: 'value["twcEntitlementId"]',
                expected: 'string',
                value: value["twcEntitlementId"]
            });
        }
        if ('redirectTo' in value && value['redirectTo'] !== undefined) {
            let value__redirectTo___valid = false;
            if (!value__redirectTo___valid) {
                const value__redirectTo___errors_0 = [];
                if (value["redirectTo"] !== "jira") value__redirectTo___errors_0.push({
                    path: 'value["redirectTo"]',
                    expected: "jira",
                    value: value["redirectTo"]
                });
                if (value__redirectTo___errors_0.length === 0) value__redirectTo___valid = true;
            }
            if (!value__redirectTo___valid) {
                const value__redirectTo___errors_1 = [];
                if (value["redirectTo"] !== "confluence") value__redirectTo___errors_1.push({
                    path: 'value["redirectTo"]',
                    expected: "confluence",
                    value: value["redirectTo"]
                });
                if (value__redirectTo___errors_1.length === 0) value__redirectTo___valid = true;
            }
            if (!value__redirectTo___valid) errors.push({
                path: 'value["redirectTo"]',
                expected: '"jira" | "confluence"',
                value: value["redirectTo"]
            });
        }
        if (!('recommendedApp' in value)) errors.push({
            path: 'value["recommendedApp"]',
            expected: '"confluence" | "jira" | "loom"',
            value: undefined
        });
        else {
            let value__recommendedApp___valid = false;
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_0 = [];
                if (value["recommendedApp"] !== "confluence") value__recommendedApp___errors_0.push({
                    path: 'value["recommendedApp"]',
                    expected: "confluence",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_0.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_1 = [];
                if (value["recommendedApp"] !== "jira") value__recommendedApp___errors_1.push({
                    path: 'value["recommendedApp"]',
                    expected: "jira",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_1.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) {
                const value__recommendedApp___errors_2 = [];
                if (value["recommendedApp"] !== "loom") value__recommendedApp___errors_2.push({
                    path: 'value["recommendedApp"]',
                    expected: "loom",
                    value: value["recommendedApp"]
                });
                if (value__recommendedApp___errors_2.length === 0) value__recommendedApp___valid = true;
            }
            if (!value__recommendedApp___valid) errors.push({
                path: 'value["recommendedApp"]',
                expected: '"confluence" | "jira" | "loom"',
                value: value["recommendedApp"]
            });
        }
        if (!('actionTier' in value)) errors.push({
            path: 'value["actionTier"]',
            expected: '"high" | "medium" | "low"',
            value: undefined
        });
        else {
            let value__actionTier___valid = false;
            if (!value__actionTier___valid) {
                const value__actionTier___errors_0 = [];
                if (value["actionTier"] !== "high") value__actionTier___errors_0.push({
                    path: 'value["actionTier"]',
                    expected: "high",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_0.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) {
                const value__actionTier___errors_1 = [];
                if (value["actionTier"] !== "medium") value__actionTier___errors_1.push({
                    path: 'value["actionTier"]',
                    expected: "medium",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_1.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) {
                const value__actionTier___errors_2 = [];
                if (value["actionTier"] !== "low") value__actionTier___errors_2.push({
                    path: 'value["actionTier"]',
                    expected: "low",
                    value: value["actionTier"]
                });
                if (value__actionTier___errors_2.length === 0) value__actionTier___valid = true;
            }
            if (!value__actionTier___valid) errors.push({
                path: 'value["actionTier"]',
                expected: '"high" | "medium" | "low"',
                value: value["actionTier"]
            });
        }
        if ('targetTenantId' in value && value['targetTenantId'] !== undefined) {
            if (typeof value["targetTenantId"] !== 'string') errors.push({
                path: 'value["targetTenantId"]',
                expected: 'string',
                value: value["targetTenantId"]
            });
        }
        if ('collectionEntitlementId' in value && value['collectionEntitlementId'] !== undefined) {
            if (typeof value["collectionEntitlementId"] !== 'string') errors.push({
                path: 'value["collectionEntitlementId"]',
                expected: 'string',
                value: value["collectionEntitlementId"]
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $14fc469cdcc7247d$export$cf98bfae195146d6 = async (requestContext, orgId, entitlementId, messageInstanceId, messageTemplateId)=>{
    const { logger: logger, graphqlClients: graphqlClients } = requestContext;
    if (!orgId) {
        logger.error({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId
        }, 'Org ID not available');
        return undefined;
    }
    if (!entitlementId) {
        logger.error({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId
        }, 'Entitlement ID not available');
        return undefined;
    }
    try {
        const orgProfile = await graphqlClients.growthUnifiedProfile.getOrgProfile(orgId, {
            entitlementId: entitlementId
        });
        const [onboardingContext] = orgProfile.twcOnboardingContext ?? [];
        if (!onboardingContext) {
            logger.error({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                orgId: orgId,
                entitlementId: entitlementId
            }, 'No TWC onboarding context found in GUPS profile');
            return undefined;
        }
        const { onboardingUrl: onboardingUrl } = onboardingContext;
        if (!onboardingUrl) {
            logger.error({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                orgId: orgId,
                entitlementId: entitlementId
            }, 'No onboarding URL found in TWC onboarding context');
            return undefined;
        }
        logger.info({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            orgId: orgId,
            entitlementId: entitlementId,
            onboardingUrl: onboardingUrl
        }, 'Successfully fetched onboarding URL from GUPS');
        return onboardingUrl;
    } catch (error) {
        logger.error({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            orgId: orgId,
            entitlementId: entitlementId,
            error: error
        }, 'Error fetching onboarding URL from GUPS');
        return undefined;
    }
};



var $7HNmk = parcelRequire("7HNmk");

const $a4af3265470706d8$var$LOOM_ONBOARDING_URL_PROD = 'https://www.loom.com/meetings';
const $a4af3265470706d8$var$LOOM_ONBOARDING_URL_NON_PROD = 'https://stage.loom.com/meetings';
// Unified Rovo create surface — tenant-agnostic, AI-first Confluence create experience.
const $a4af3265470706d8$var$CONFLUENCE_CREATE_WITH_ROVO_URL = 'https://create.rovo.com';
const $a4af3265470706d8$export$7abc4e1301ef2c74 = (environmentType)=>{
    return environmentType === 'Production' ? $a4af3265470706d8$var$LOOM_ONBOARDING_URL_PROD : $a4af3265470706d8$var$LOOM_ONBOARDING_URL_NON_PROD;
};
const $a4af3265470706d8$export$3ed1a38fca957822 = async ({ redirectTo: redirectTo, requestContext: requestContext, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, orgId: orgId, twcEntitlementId: twcEntitlementId })=>{
    switch(redirectTo){
        case 'jira':
            return (0, $14fc469cdcc7247d$export$cf98bfae195146d6)(requestContext, orgId, twcEntitlementId, messageInstanceId, messageTemplateId);
        case 'confluence':
            return $a4af3265470706d8$var$CONFLUENCE_CREATE_WITH_ROVO_URL;
        default:
            {
                const _exhaustive = redirectTo;
                return _exhaustive;
            }
    }
};





var $hOVIX = parcelRequire("hOVIX");

const $a541bb7276570a07$var$MESSAGE_TEMPLATE_ID = 'twc-sidenav-banner';
const $a541bb7276570a07$var$MISSING_APP_EXPERIMENT = 'twcg_missing_app_activation_banner';
/**
 * Returns the Atlassian home URL for the given environment.
 * Used as the ultimate fallback when TCS lookup fails.
 */ const $a541bb7276570a07$var$getAtlassianHomeUrl = (env)=>env === 'Production' ? 'https://home.atlassian.com' : 'https://home.stg.atlassian.com';
/**
 * Returns the site-specific Jira "For you" URL via TCS hostname lookup.
 * Falls back to the Atlassian home URL if TCS lookup fails.
 */ const $a541bb7276570a07$var$getJiraForYouUrl = async (tcsClient, logger, cloudId, env)=>{
    try {
        const { hostname: hostname } = await (0, $f55feeef638d64a0$export$f3737296d91f3061)({
            messageTemplateId: $a541bb7276570a07$var$MESSAGE_TEMPLATE_ID,
            siteId: cloudId,
            tcsClient: tcsClient,
            logger: logger
        });
        const url = new URL(`https://${hostname}/jira/for-you`);
        url.searchParams.set('cloudId', cloudId);
        return url.toString();
    } catch  {
        return $a541bb7276570a07$var$getAtlassianHomeUrl(env);
    }
};
const $a541bb7276570a07$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $hwVbs.noValidation)(),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $3667a9ec0d5cf904$export$a7a9523472993e97),
            stage: async ({ message: message, request: request })=>{
                const { logger: logger, orchestrationContext: orchestrationContext, statsig: statsig } = request;
                const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, triggerId: triggerId } = message;
                const { cloudId: tenantId } = message.context;
                const { locale: locale } = orchestrationContext;
                const { recommendedApp: recommendedApp, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId, orgId: orgId, twcEntitlementId: twcEntitlementId } = message.context;
                if (!tenantId || typeof tenantId !== 'string') {
                    logger.error({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId
                    }, 'Tenant ID not available');
                    request.metrics.counter('twc-sidenav-banner.conf.error.count', {
                        reason: 'tenant-id-not-available'
                    }).incr();
                    throw new Error('Tenant ID not available');
                }
                // Everything is driven by the Statsig experiment arm.
                const armValue = statsig.getExperimentValue({
                    identifiers: {
                        tenantId: tenantId
                    }
                }, {
                    name: $a541bb7276570a07$var$MISSING_APP_EXPERIMENT,
                    parameter: 'arm',
                    defaultValue: 'control'
                });
                const arm = armValue === 'generic' || armValue === 'personalized' ? armValue : 'control';
                const jiraForYouUrl = ()=>$a541bb7276570a07$var$getJiraForYouUrl(request.restApiClients?.tcsClient, request.logger, tenantId, request.executionRuntime.getEnvironmentType());
                const commonReturn = {
                    ...message.context,
                    arm: arm,
                    recommendedApp: recommendedApp,
                    actionTier: actionTier,
                    targetTenantId: targetTenantId,
                    collectionEntitlementId: collectionEntitlementId,
                    messageInstanceId: messageInstanceId,
                    locale: locale
                };
                switch(arm){
                    case 'control':
                        // Abort hydration so the message does not block other placement candidates.
                        logger.info({
                            messageInstanceId: messageInstanceId,
                            messageTemplateId: messageTemplateId,
                            triggerId: triggerId,
                            arm: arm
                        }, "Control arm \u2014 aborting hydration");
                        request.metrics.counter('twc-sidenav-banner.conf.info.count', {
                            reason: 'control-arm'
                        }).incr();
                        throw new (0, $hOVIX.HydrationAbortError)('Control cohort - abort hydration');
                    case 'generic':
                        {
                            // Render GenericBanner with GUPS-derived onboarding URL.
                            const redirectTo = (0, $7HNmk.resolveRedirectTo)(message.context.redirectTo);
                            let onboardingUrl = await (0, $a4af3265470706d8$export$3ed1a38fca957822)({
                                redirectTo: redirectTo,
                                requestContext: request,
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                orgId: orgId,
                                twcEntitlementId: twcEntitlementId
                            });
                            if (!onboardingUrl) {
                                onboardingUrl = await jiraForYouUrl();
                                logger.info({
                                    messageTemplateId: messageTemplateId,
                                    messageInstanceId: messageInstanceId,
                                    triggerId: triggerId,
                                    arm: arm
                                }, "No onboarding URL found for generic arm \u2014 defaulting to Jira For You");
                                request.metrics.counter('twc-sidenav-banner.conf.info.count', {
                                    reason: 'generic-defaulted-to-jira-for-you'
                                }).incr();
                            }
                            request.metrics.counter('twc-sidenav-banner.conf.success.count', {
                                arm: arm
                            }).incr();
                            return {
                                ...commonReturn,
                                redirectTo: redirectTo,
                                onboardingUrl: onboardingUrl
                            };
                        }
                    case 'personalized':
                        {
                            // Render PersonalizedBanner with recommendedApp-specific URL.
                            // recommendedApp is required by schema — validated before hydration.
                            const redirectTo = recommendedApp === 'jira' || recommendedApp === 'confluence' ? recommendedApp : (0, $7HNmk.resolveRedirectTo)(message.context.redirectTo);
                            let onboardingUrl = await (0, $a4af3265470706d8$export$3ed1a38fca957822)({
                                redirectTo: redirectTo,
                                requestContext: request,
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                orgId: orgId,
                                twcEntitlementId: twcEntitlementId
                            });
                            if (!onboardingUrl) {
                                onboardingUrl = await jiraForYouUrl();
                                logger.info({
                                    messageTemplateId: messageTemplateId,
                                    messageInstanceId: messageInstanceId,
                                    triggerId: triggerId,
                                    recommendedApp: recommendedApp
                                }, "No onboarding URL found for personalized arm \u2014 defaulting to Jira For You");
                                request.metrics.counter('twc-sidenav-banner.conf.info.count', {
                                    reason: 'personalized-defaulted-to-jira-for-you'
                                }).incr();
                            }
                            request.metrics.counter('twc-sidenav-banner.conf.success.count', {
                                arm: arm
                            }).incr();
                            return {
                                ...commonReturn,
                                redirectTo: redirectTo,
                                onboardingUrl: onboardingUrl
                            };
                        }
                }
            }
        }
    }));
const $a541bb7276570a07$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $3667a9ec0d5cf904$export$a7a9523472993e97),
        Component: ({ handleOnDismissed: handleOnDismissed, onboardingUrl: onboardingUrl, messageInstanceId: messageInstanceId, locale: locale, arm: arm, redirectTo: redirectTo, recommendedApp: recommendedApp, experimentKey: experimentKey, actionTier: actionTier, targetTenantId: targetTenantId, collectionEntitlementId: collectionEntitlementId })=>{
            const { handleDismiss: handleDismiss } = (0, $512c3370a975cef3$export$f83734c268a0a1ff)({
                onDismissed: handleOnDismissed,
                clickIdentifier: arm === 'personalized' ? 'twc-sidenav-banner-personalized-dismiss' : arm === 'generic' ? 'twc-sidenav-banner-generic-dismiss' : 'twc-sidenav-banner-dismiss'
            });
            // arm drives all rendering — no other conditions.
            if (arm === 'personalized' && recommendedApp && actionTier) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e0ae5d18bf9a16eb$export$44c5a4ad6d35d2bf), {
                locale: locale,
                recommendedApp: recommendedApp,
                onClose: handleDismiss,
                onCtaClick: handleDismiss,
                href: onboardingUrl,
                messageInstanceId: messageInstanceId,
                experimentKey: experimentKey,
                actionTier: actionTier,
                targetTenantId: targetTenantId,
                collectionEntitlementId: collectionEntitlementId
            });
            if (arm === 'generic') return /*#__PURE__*/ (0, $l998X.jsx)((0, $a6cc29a1ce3266e7$export$a350437cbfeb32d4), {
                locale: locale,
                product: redirectTo,
                onClose: handleDismiss,
                onCtaClick: handleDismiss,
                href: onboardingUrl,
                messageInstanceId: messageInstanceId
            });
            // control (or any unrecognised arm): no banner shown.
            return null;
        }
    }
});






// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $9d1d6294e64dd992$export$a7a9523472993e97(value) {
    const result = $9d1d6294e64dd992$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $9d1d6294e64dd992$export$226b3eccf92c9ed9(value) {
    const result = $9d1d6294e64dd992$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $9d1d6294e64dd992$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('product' in value)) errors.push({
            path: 'value["product"]',
            expected: '"jira" | "confluence"',
            value: undefined
        });
        else {
            let value__product___valid = false;
            if (!value__product___valid) {
                const value__product___errors_0 = [];
                if (value["product"] !== "jira") value__product___errors_0.push({
                    path: 'value["product"]',
                    expected: "jira",
                    value: value["product"]
                });
                if (value__product___errors_0.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) {
                const value__product___errors_1 = [];
                if (value["product"] !== "confluence") value__product___errors_1.push({
                    path: 'value["product"]',
                    expected: "confluence",
                    value: value["product"]
                });
                if (value__product___errors_1.length === 0) value__product___valid = true;
            }
            if (!value__product___valid) errors.push({
                path: 'value["product"]',
                expected: '"jira" | "confluence"',
                value: value["product"]
            });
        }
        if (!('orgId' in value)) errors.push({
            path: 'value["orgId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["orgId"] !== 'string') errors.push({
            path: 'value["orgId"]',
            expected: 'string',
            value: value["orgId"]
        });
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if (!('twcEntitlementId' in value)) errors.push({
            path: 'value["twcEntitlementId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["twcEntitlementId"] !== 'string') errors.push({
            path: 'value["twcEntitlementId"]',
            expected: 'string',
            value: value["twcEntitlementId"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $0434e5e136afde69$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $hwVbs.noValidation)(),
            stage: ()=>({
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    }
                })
        },
        hydrate: {
            validate: (0, $9d1d6294e64dd992$export$a7a9523472993e97),
            stage: async ({ message: message, request: request })=>{
                const { logger: logger, statsig: statsig } = request;
                const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, triggerId: triggerId } = message;
                const { cloudId: tenantId } = message.context;
                if (!tenantId || typeof tenantId !== 'string') {
                    logger.error({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        triggerId: triggerId
                    }, 'Tenant ID not available');
                    throw new Error('Tenant ID not available');
                }
                statsig.getExperimentValue({
                    identifiers: {
                        tenantId: tenantId
                    }
                }, {
                    name: 'twcg-991-jtbd-onboarding-a-a-fo',
                    parameter: 'isEnabled',
                    defaultValue: false
                });
                throw Error('Control cohort - abort hydration');
            }
        }
    }));
const $0434e5e136afde69$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $9d1d6294e64dd992$export$a7a9523472993e97),
        Component: ()=>null
    }
});






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $PAiZW = parcelRequire("PAiZW");





























/**
 * Derives environment type from the current hostname (for use in browser).
 * Prod -> admin.atlassian.com; staging/dev/other -> admin.stg.atlassian.com (org path appended when building URLs).
 */ function $167554a28fb498ce$export$469d38ee9e6df4c6(hostname) {
    if (typeof hostname !== 'string') return 'prod';
    const h = hostname.toLowerCase();
    if (h.includes('dev.') || h.includes('.dev')) return 'dev';
    if (h.includes('stg') || h.includes('staging')) return 'staging';
    return 'prod';
}
function $167554a28fb498ce$export$76bb37a926058cca(envType) {
    return envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
}
function $167554a28fb498ce$export$1f35d872aef2b7bd(orgId, envType) {
    const base = envType === 'prod' ? 'https://admin.atlassian.com' : 'https://admin.stg.atlassian.com';
    return `${base}/o/${orgId}/rovo`;
}
function $167554a28fb498ce$export$d3d28c6fd94dcc27(orgId, envType) {
    if (orgId && orgId.trim() !== '') return $167554a28fb498ce$export$1f35d872aef2b7bd(orgId, envType);
    return $167554a28fb498ce$export$76bb37a926058cca(envType);
}





var $61993e20f2b735fa$exports = {};
$61993e20f2b735fa$exports = new URL("rovo-icon.999e8c7b.png", import.meta.url).toString();


const $ed326e0a448f79a5$export$5b537697406f44db = ()=>/*#__PURE__*/ (0, $l998X.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($61993e20f2b735fa$exports))),
        alt: "Rovo",
        width: 32,
        height: 32
    });


const $6963f8645de678dc$var$i18n = (0, $aXWIB.defineMessages)({
    headingLabel: {
        id: "post-office.confluence-rovo-onboarding-banner.heading",
        defaultMessage: "Rovo is ready for you"
    },
    bodyLabel: {
        id: "post-office.confluence-rovo-onboarding-banner.body",
        defaultMessage: "Power up your workspace. Set up and configure connectors to unlock all Rovo's potential."
    },
    callToActionLabel: {
        id: "post-office.confluence-rovo-onboarding-banner.call.to.action",
        defaultMessage: "Get started"
    },
    whyAmISeeingThisModalMessage: {
        id: "post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message",
        defaultMessage: "We think setting up Rovo and connecting apps will improve your team's productivity. You're seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo's features by configuring connectors."
    },
    whyAmISeeingThisModalReason: {
        id: "post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason",
        defaultMessage: "Rovo is available to your team and you are an organizational admin"
    }
});
const $6963f8645de678dc$var$styles = {
    root: "_2rko1mok _kqswh2mm _16jlkb7n _bfhk1s93",
    primaryContentContainer: "_1yt4pxbi _16jlkb7n",
    headingContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    iconContainer: "_1o9zidpf _1bsbzwfg _4t3izwfg",
    ctaWrapper: "_19pk1b66",
    adControlsContainer: "_kqswstnw _154iu2gc _1xi2u2gc"
};
const $6963f8645de678dc$export$badffec00386b3b8 = ({ action: action, orgId: orgIdFromMessage, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const postOfficeContext = (0, $PAiZW.usePostOfficeContext)(); // Use orgId from message context first; fallback to product/placement context (e.g. when message payload omits it but event context has it)
    const orgId = orgIdFromMessage ?? (typeof postOfficeContext?.orgId === 'string' ? postOfficeContext.orgId : undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!messageInstanceViewed) return;
        messageInstanceViewed();
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceRovoOnboardingBanner'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireMessageInstanceClicked = ({ actionType: actionType, clickedElement: clickedElement })=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: actionType
            },
            additionalMetadataFromFrontend: {}
        });
    };
    const rovoAdminUrl = (0, $42omo.useMemo)(()=>{
        if (!globalThis.location) return '#';
        const envType = (0, $167554a28fb498ce$export$469d38ee9e6df4c6)(globalThis.location.hostname);
        return (0, $167554a28fb498ce$export$d3d28c6fd94dcc27)(orgId, envType);
    }, [
        orgId
    ]);
    const handleOnPrimaryActionClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'open',
            clickedElement: {
                clickIdentifier: 'getStarted',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'rovoOnboardingBannerCta'
        });
        onPrimaryActionClick?.(action);
        if (rovoAdminUrl && rovoAdminUrl !== '#' && globalThis.location) globalThis.location.href = rovoAdminUrl;
    };
    const handleOnDismissed = (_dismissedMessageInstanceId)=>{
        onDismissClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            source: 'confluence-rovo-onboarding-banner'
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            xcss: $6963f8645de678dc$var$styles.root,
            testId: "confluence-rovo-onboarding-banner",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    xcss: $6963f8645de678dc$var$styles.primaryContentContainer,
                    gap: "space.100",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            xcss: $6963f8645de678dc$var$styles.headingContainer,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $6963f8645de678dc$var$styles.iconContainer,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ed326e0a448f79a5$export$5b537697406f44db), {})
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...$6963f8645de678dc$var$i18n.headingLabel
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...$6963f8645de678dc$var$i18n.bodyLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $6963f8645de678dc$var$styles.ctaWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                                href: rovoAdminUrl,
                                onClick: handleOnPrimaryActionClick,
                                spacing: "compact",
                                target: "_self",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...$6963f8645de678dc$var$i18n.callToActionLabel
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $6963f8645de678dc$var$styles.adControlsContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $j01vW.AdControls), {
                        iconSize: "small",
                        spacing: "compact",
                        onDismissed: handleOnDismissed,
                        showWhyAmISeeingThis: true,
                        whyAmISeeingThisModalContent: {
                            message: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...$6963f8645de678dc$var$i18n.whyAmISeeingThisModalMessage
                            }),
                            reasons: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...$6963f8645de678dc$var$i18n.whyAmISeeingThisModalReason
                                }, "reason")
                            ]
                        }
                    })
                })
            ]
        })
    });
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $3e52838073f45a31$export$a7a9523472993e97(value) {
    const result = $3e52838073f45a31$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $3e52838073f45a31$export$226b3eccf92c9ed9(value) {
    const result = $3e52838073f45a31$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $3e52838073f45a31$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: undefined
        });
        else {
            let value__nextBestActionType___valid = false;
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_0 = [];
                if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_SPACE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_1 = [];
                if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_PAGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_2 = [];
                if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WHITEBOARD",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_3 = [];
                if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                    path: 'value["nextBestActionType"]',
                    expected: "1_ON_1_LOOM_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_4 = [];
                if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                    path: 'value["nextBestActionType"]',
                    expected: "LOOM_AI_MEETING_NOTES",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_5 = [];
                if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                    path: 'value["nextBestActionType"]',
                    expected: "RESURRECTED_USER_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_6 = [];
                if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WITH_ROVO_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_7 = [];
                if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                    path: 'value["nextBestActionType"]',
                    expected: "ROVO_EXTENSION_CTA",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_8 = [];
                if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CONNECT_3P_TOOLS_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) errors.push({
                path: 'value["nextBestActionType"]',
                expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
                value: value["nextBestActionType"]
            });
        }
        if ('tenantId' in value && value['tenantId'] !== undefined) {
            if (typeof value["tenantId"] !== 'string') errors.push({
                path: 'value["tenantId"]',
                expected: 'string',
                value: value["tenantId"]
            });
        }
        if ('orgId' in value && value['orgId'] !== undefined) {
            if (typeof value["orgId"] !== 'string') errors.push({
                path: 'value["orgId"]',
                expected: 'string',
                value: value["orgId"]
            });
        }
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


const $0677bde15ab9c4ab$var$PLACEMENT_LABEL = 'Confluence Rovo onboarding banner';
const $0677bde15ab9c4ab$var$MESSAGE_TEMPLATE_ID = 'confluence-rovo-onboarding-banner';
const $0677bde15ab9c4ab$var$hydrateStage = async ({ message: message, request: request })=>{
    request.logger.info({
        messageInstanceId: message.messageInstanceId,
        messageTemplateId: message.messageTemplateId ?? $0677bde15ab9c4ab$var$MESSAGE_TEMPLATE_ID,
        placementLabel: $0677bde15ab9c4ab$var$PLACEMENT_LABEL
    }, 'Rovo onboarding banner hydrated successfully');
    return message.context;
};
const $0677bde15ab9c4ab$export$aa90bc928dfe5f3c = $0677bde15ab9c4ab$var$hydrateStage;
const $0677bde15ab9c4ab$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend(()=>({
        transformMetadata: {
            validate: (0, $3e52838073f45a31$export$a7a9523472993e97),
            stage: (input)=>{
                const context = input.message.context;
                return {
                    goalMetadata: {
                        primaryGoal: {
                            goalId: 'clickthrough'
                        }
                    },
                    nextBestAction: context.nextBestActionType
                };
            }
        },
        hydrate: {
            validate: (0, $3e52838073f45a31$export$a7a9523472993e97),
            stage: $0677bde15ab9c4ab$var$hydrateStage
        }
    }));
const $0677bde15ab9c4ab$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $3e52838073f45a31$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, orgId: orgId, handleOnDismissed: handleOnDismissed, onSideNavClick: onSideNavClick })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6963f8645de678dc$export$badffec00386b3b8), {
                action: nextBestActionType,
                orgId: orgId,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});


// integrated-teams/{your-team}/message-templates/{message-template}/src/placements/in-app-v2/{placement-id}/index.tsx










// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



function $0e6ba358cf0b003d$export$a7a9523472993e97(value) {
    const result = $0e6ba358cf0b003d$export$a22775fa5e2eebd9(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new (0, $kd6Go.AssertError)('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data;
}
function $0e6ba358cf0b003d$export$226b3eccf92c9ed9(value) {
    const result = $0e6ba358cf0b003d$export$a22775fa5e2eebd9(value);
    return result.success;
}
function $0e6ba358cf0b003d$export$a22775fa5e2eebd9(value) {
    const errors = [];
    const originalData = value;
    if (typeof value !== 'object' || value === null || Array.isArray(value)) errors.push({
        path: 'value',
        expected: 'MessageTemplateContext',
        value: value
    });
    else {
        if (!('nextBestActionType' in value)) errors.push({
            path: 'value["nextBestActionType"]',
            expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
            value: undefined
        });
        else {
            let value__nextBestActionType___valid = false;
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_0 = [];
                if (value["nextBestActionType"] !== "CREATE_SPACE") value__nextBestActionType___errors_0.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_SPACE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_0.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_1 = [];
                if (value["nextBestActionType"] !== "CREATE_PAGE") value__nextBestActionType___errors_1.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_PAGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_1.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_2 = [];
                if (value["nextBestActionType"] !== "CREATE_WHITEBOARD") value__nextBestActionType___errors_2.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WHITEBOARD",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_2.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_3 = [];
                if (value["nextBestActionType"] !== "1_ON_1_LOOM_NUDGE") value__nextBestActionType___errors_3.push({
                    path: 'value["nextBestActionType"]',
                    expected: "1_ON_1_LOOM_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_3.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_4 = [];
                if (value["nextBestActionType"] !== "LOOM_AI_MEETING_NOTES") value__nextBestActionType___errors_4.push({
                    path: 'value["nextBestActionType"]',
                    expected: "LOOM_AI_MEETING_NOTES",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_4.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_5 = [];
                if (value["nextBestActionType"] !== "RESURRECTED_USER_NUDGE") value__nextBestActionType___errors_5.push({
                    path: 'value["nextBestActionType"]',
                    expected: "RESURRECTED_USER_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_5.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_6 = [];
                if (value["nextBestActionType"] !== "CREATE_WITH_ROVO_NUDGE") value__nextBestActionType___errors_6.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CREATE_WITH_ROVO_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_6.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_7 = [];
                if (value["nextBestActionType"] !== "ROVO_EXTENSION_CTA") value__nextBestActionType___errors_7.push({
                    path: 'value["nextBestActionType"]',
                    expected: "ROVO_EXTENSION_CTA",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_7.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) {
                const value__nextBestActionType___errors_8 = [];
                if (value["nextBestActionType"] !== "CONNECT_3P_TOOLS_NUDGE") value__nextBestActionType___errors_8.push({
                    path: 'value["nextBestActionType"]',
                    expected: "CONNECT_3P_TOOLS_NUDGE",
                    value: value["nextBestActionType"]
                });
                if (value__nextBestActionType___errors_8.length === 0) value__nextBestActionType___valid = true;
            }
            if (!value__nextBestActionType___valid) errors.push({
                path: 'value["nextBestActionType"]',
                expected: '"CREATE_SPACE" | "CREATE_PAGE" | "CREATE_WHITEBOARD" | "1_ON_1_LOOM_NUDGE" | "LOOM_AI_MEETING_NOTES" | "RESURRECTED_USER_NUDGE" | "CREATE_WITH_ROVO_NUDGE" | "ROVO_EXTENSION_CTA" | "CONNECT_3P_TOOLS_NUDGE"',
                value: value["nextBestActionType"]
            });
        }
        if (!('cohort' in value)) errors.push({
            path: 'value["cohort"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cohort"] !== 'string') errors.push({
            path: 'value["cohort"]',
            expected: 'string',
            value: value["cohort"]
        });
        if (!('cloudId' in value)) errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["cloudId"] !== 'string') errors.push({
            path: 'value["cloudId"]',
            expected: 'string',
            value: value["cloudId"]
        });
        if (!('userId' in value)) errors.push({
            path: 'value["userId"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["userId"] !== 'string') errors.push({
            path: 'value["userId"]',
            expected: 'string',
            value: value["userId"]
        });
        if (!('unconnectedApps' in value)) errors.push({
            path: 'value["unconnectedApps"]',
            expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["unconnectedApps"])) errors.push({
                path: 'value["unconnectedApps"]',
                expected: 'array',
                value: value["unconnectedApps"]
            });
            if (Array.isArray(value["unconnectedApps"])) value["unconnectedApps"].forEach((element, index)=>{
                {
                    let element_valid = false;
                    if (!element_valid) {
                        const element_errors_0 = [];
                        if (element !== "google-drive") element_errors_0.push({
                            path: 'element',
                            expected: "google-drive",
                            value: element
                        });
                        if (element_errors_0.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_1 = [];
                        if (element !== "slack") element_errors_1.push({
                            path: 'element',
                            expected: "slack",
                            value: element
                        });
                        if (element_errors_1.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_2 = [];
                        if (element !== "figma") element_errors_2.push({
                            path: 'element',
                            expected: "figma",
                            value: element
                        });
                        if (element_errors_2.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_3 = [];
                        if (element !== "github") element_errors_3.push({
                            path: 'element',
                            expected: "github",
                            value: element
                        });
                        if (element_errors_3.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_4 = [];
                        if (element !== "onedrive") element_errors_4.push({
                            path: 'element',
                            expected: "onedrive",
                            value: element
                        });
                        if (element_errors_4.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_5 = [];
                        if (element !== "sharepoint") element_errors_5.push({
                            path: 'element',
                            expected: "sharepoint",
                            value: element
                        });
                        if (element_errors_5.length === 0) element_valid = true;
                    }
                    if (!element_valid) errors.push({
                        path: 'element',
                        expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"',
                        value: element
                    });
                }
            });
        }
        if (!('topApps' in value)) errors.push({
            path: 'value["topApps"]',
            expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"[]',
            value: undefined
        });
        else {
            if (!Array.isArray(value["topApps"])) errors.push({
                path: 'value["topApps"]',
                expected: 'array',
                value: value["topApps"]
            });
            if (Array.isArray(value["topApps"])) value["topApps"].forEach((element, index)=>{
                {
                    let element_valid = false;
                    if (!element_valid) {
                        const element_errors_0 = [];
                        if (element !== "google-drive") element_errors_0.push({
                            path: 'element',
                            expected: "google-drive",
                            value: element
                        });
                        if (element_errors_0.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_1 = [];
                        if (element !== "slack") element_errors_1.push({
                            path: 'element',
                            expected: "slack",
                            value: element
                        });
                        if (element_errors_1.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_2 = [];
                        if (element !== "figma") element_errors_2.push({
                            path: 'element',
                            expected: "figma",
                            value: element
                        });
                        if (element_errors_2.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_3 = [];
                        if (element !== "github") element_errors_3.push({
                            path: 'element',
                            expected: "github",
                            value: element
                        });
                        if (element_errors_3.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_4 = [];
                        if (element !== "onedrive") element_errors_4.push({
                            path: 'element',
                            expected: "onedrive",
                            value: element
                        });
                        if (element_errors_4.length === 0) element_valid = true;
                    }
                    if (!element_valid) {
                        const element_errors_5 = [];
                        if (element !== "sharepoint") element_errors_5.push({
                            path: 'element',
                            expected: "sharepoint",
                            value: element
                        });
                        if (element_errors_5.length === 0) element_valid = true;
                    }
                    if (!element_valid) errors.push({
                        path: 'element',
                        expected: '"google-drive" | "slack" | "figma" | "github" | "onedrive" | "sharepoint"',
                        value: element
                    });
                }
            });
        }
        if (!('department' in value)) errors.push({
            path: 'value["department"]',
            expected: 'string',
            value: undefined
        });
        else if (typeof value["department"] !== 'string') errors.push({
            path: 'value["department"]',
            expected: 'string',
            value: value["department"]
        });
    }
    if (errors.length === 0) return {
        success: true,
        data: value
    };
    return {
        success: false,
        data: originalData,
        errors: errors
    };
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




































var $gi7cm = parcelRequire("gi7cm");


var $78z3f = parcelRequire("78z3f");

var $cy0MC = parcelRequire("cy0MC");

/**
 * The "no signal" fallback row. Defined as its own typed constant (rather
 * than indexed off `HARDCODED_DEFAULTS`) so the type system can guarantee it
 * exists — TypeScript would otherwise widen indexed access on
 * `Record<string, …>` to `… | undefined`, forcing a dead-code `?? []`
 * fallback. Single source of truth for the "absolute last resort" list —
 * used by:
 *
 * - The implicit-message creator's outer `try/catch` (so a thrown error
 *   doesn't suppress the banner; we still emit a sensible recommendation).
 * - The React component's prop default (so Storybook stories and any other
 *   prop-less render path still show something coherent).
 *
 * `HARDCODED_DEFAULTS.na` below points at this same constant so the two
 * surfaces can never drift.
 *
 * TODO(ACTIVATION-2809): Confirm with PM whether "total cascade failure"
 * should surface the `na` defaults at all, or whether silently suppressing
 * the banner is the preferred UX. We picked "show na defaults" because the
 * cascade is designed never to legitimately produce `[]` — but the product
 * call deserves an explicit yes.
 */ const $bb8451f74f829999$export$8594dab83de99a34 = [
    'google-drive',
    'slack',
    'github'
];
const $bb8451f74f829999$export$5dbf4404d8d730eb = {
    c_suite: [
        'google-drive',
        'slack',
        'github'
    ],
    customer_service: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    data_science: [
        'google-drive',
        'github',
        'slack'
    ],
    design: [
        'google-drive',
        'figma',
        'slack'
    ],
    engineering: [
        'google-drive',
        'github',
        'slack'
    ],
    finance: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    human_resources: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    information_technology: [
        'google-drive',
        'slack',
        'github'
    ],
    legal: [
        'google-drive',
        'slack',
        'sharepoint'
    ],
    marketing: [
        'google-drive',
        'slack',
        'figma'
    ],
    // `na` is the "no signal" floor row — kept in sync with the standalone
    // `DEFAULT_FALLBACK_APPS` export above by referencing the same constant.
    na: $bb8451f74f829999$export$8594dab83de99a34,
    operations: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    other: [
        'google-drive',
        'github',
        'slack'
    ],
    product_management: [
        'google-drive',
        'figma',
        'slack'
    ],
    program_management: [
        'google-drive',
        'onedrive',
        'sharepoint'
    ],
    sales: [
        'google-drive',
        'slack',
        'sharepoint'
    ]
}; /* eslint-enable camelcase */ 


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $6xdDU = parcelRequire("6xdDU");









var $3yXh4 = parcelRequire("3yXh4");

const $e9197596153e89d9$export$a02c2a50480baf7b = [
    'figma',
    'github',
    'slack',
    'google-drive',
    'onedrive'
];
const $e9197596153e89d9$export$7cd9f89abe222b98 = [
    'design',
    'product_management',
    'marketing',
    'engineering',
    'information_technology',
    'other',
    'operations',
    'finance',
    'legal',
    'human_resources',
    'na',
    'program_management',
    'sales'
];
function $e9197596153e89d9$var$getAnimationSvgForApp(app) {
    switch(app){
        case 'figma':
            return 0, $3yXh4.SvgSetupTeamUpdateFigma;
        case 'github':
            return 0, $3yXh4.SvgSetupTeamUpdateGithub;
        case 'slack':
            return 0, $3yXh4.SvgSetupTeamUpdateSlack;
        case 'google-drive':
            return 0, $3yXh4.SvgSetupTeamUpdateGdrive;
        case 'onedrive':
            return 0, $3yXh4.SvgSetupTeamUpdateOnedrive;
    }
}
function $e9197596153e89d9$export$fdb84c48733d7de8({ topApps: topApps, department: department }) {
    // Step 1: return the SVG for the highest-priority app if any are provided.
    // topApps is pre-filtered to AnimationApp values, so every element has a
    // dedicated SVG — we just take the first one.
    if (topApps && topApps.length > 0) return $e9197596153e89d9$var$getAnimationSvgForApp(topApps[0]);
    // Step 2: department-based fallback
    if (department) switch(department){
        case 'design':
        case 'product_management':
        case 'marketing':
            return 0, $3yXh4.SvgSetupTeamUpdateFigma;
        case 'engineering':
        case 'information_technology':
            return 0, $3yXh4.SvgSetupTeamUpdateGithub;
        case 'other':
        case 'operations':
            return 0, $3yXh4.SvgSetupTeamUpdateSlack;
        case 'finance':
        case 'legal':
        case 'human_resources':
        case 'na':
        case 'program_management':
        case 'sales':
            return 0, $3yXh4.SvgSetupTeamUpdateGdrive;
    }
    // Final fallback: Google Drive (matches the original hardcoded SvgTeamUpdate)
    return 0, $3yXh4.SvgSetupTeamUpdateGdrive;
}



var $kpbJr = parcelRequire("kpbJr");


var $eZjNP = parcelRequire("eZjNP");




const $6d0e7c3f977004b4$var$styles = {
    dynamicComponentContainer: "_4t3i1osq"
};
const $6d0e7c3f977004b4$var$i18n = (0, $aXWIB.defineMessages)({
    modalTitle: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.title",
        defaultMessage: "Connect your most-used apps"
    },
    modalSubtitle: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.subtitle",
        defaultMessage: "<strong>Bring your team\u2019s work</strong> into Confluence pages with rich, interactive previews \u2013 no tab-switching needed."
    },
    modalTeammatesEmpty: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.empty",
        defaultMessage: "Teams stay in sync by seeing live updates directly in Confluence."
    },
    modalTeammatesFew: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.few",
        defaultMessage: "Your team is already using {appName} to work smarter."
    },
    modalTeammatesMany: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.many",
        defaultMessage: "\uD83D\uDE4C <strong>{numTeammates} teammates</strong> already connected {appName} to Confluence."
    },
    modalTeammatesLots: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.teammates.lots",
        defaultMessage: "\uD83D\uDE4C <strong>50+ teammates</strong> already connected {appName} to Confluence."
    },
    modalDismiss: {
        id: "post-office.confluence-connect-3p-tools-nudge.modal.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $6d0e7c3f977004b4$export$2586b970714caf78 = ({ isOpen: isOpen, onClose: onClose, connectorItems: connectorItems, numTeammates: numTeammates, appName: appName, topApps: topApps, department: department })=>{
    const intl = (0, $aXWIB.useIntl)();
    const AnimationSvg = (0, $42omo.useMemo)(()=>(0, $e9197596153e89d9$export$fdb84c48733d7de8)({
            topApps: topApps,
            department: department
        }), [
        topApps,
        department
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            onClose: onClose,
            testId: "confluence-connect-3p-tools-modal",
            width: "x-large",
            label: intl.formatMessage($6d0e7c3f977004b4$var$i18n.modalTitle),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpbJr.SplitScreen), {
                screen: "confluence-connect-3p-tools-modal",
                title: intl.formatMessage($6d0e7c3f977004b4$var$i18n.modalTitle),
                subtitle: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...$6d0e7c3f977004b4$var$i18n.modalSubtitle,
                    values: {
                        strong: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)("strong", {
                                children: chunks
                            })
                    }
                }),
                hideLogo: true,
                dynamicComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    backgroundColor: "color.background.accent.blue.subtlest.hovered",
                    xcss: $6d0e7c3f977004b4$var$styles.dynamicComponentContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {}),
                        children: /*#__PURE__*/ (0, $l998X.jsx)(AnimationSvg, {})
                    })
                }),
                imageAlt: "",
                footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    justifyContent: "start",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...$6d0e7c3f977004b4$var$i18n.modalDismiss
                        })
                    })
                }),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eZjNP.ThirdPartyConnectorList), {
                            items: connectorItems
                        }),
                        numTeammates !== undefined && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            paddingBlockStart: "space.200",
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: [
                                    numTeammates === 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...$6d0e7c3f977004b4$var$i18n.modalTeammatesEmpty
                                    }),
                                    numTeammates >= 1 && numTeammates <= 20 && /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...$6d0e7c3f977004b4$var$i18n.modalTeammatesFew,
                                        values: {
                                            appName: appName
                                        }
                                    }),
                                    numTeammates >= 21 && numTeammates <= 50 && /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...$6d0e7c3f977004b4$var$i18n.modalTeammatesMany,
                                        values: {
                                            numTeammates: numTeammates,
                                            appName: appName,
                                            strong: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)("strong", {
                                                    children: chunks
                                                })
                                        }
                                    }),
                                    numTeammates > 50 && /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...$6d0e7c3f977004b4$var$i18n.modalTeammatesLots,
                                        values: {
                                            appName: appName,
                                            strong: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)("strong", {
                                                    children: chunks
                                                })
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};


const $d44ec7634d3da856$var$APP_CONFIG = {
    'google-drive': {
        displayName: 'Google Drive',
        productKey: (0, $78z3f.ProductKeys3P).GoogleDrive
    },
    slack: {
        displayName: 'Slack',
        productKey: (0, $78z3f.ProductKeys3P).Slack
    },
    figma: {
        displayName: 'Figma',
        productKey: (0, $78z3f.ProductKeys3P).Figma
    },
    github: {
        displayName: 'GitHub',
        productKey: (0, $78z3f.ProductKeys3P).Github
    },
    onedrive: {
        displayName: 'OneDrive',
        productKey: (0, $78z3f.ProductKeys3P).OneDrive
    },
    sharepoint: {
        displayName: 'SharePoint',
        productKey: (0, $78z3f.ProductKeys3P).Sharepoint
    }
};
const $d44ec7634d3da856$var$i18n = (0, $aXWIB.defineMessages)({
    headingLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.heading",
        defaultMessage: "See more at a glance"
    },
    multiAppBodyLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.multi-app-body",
        defaultMessage: "Connect your apps to embed rich links in this space."
    },
    singleAppBodyLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.single-app-body",
        defaultMessage: "Connect {appName} to embed rich links in this space."
    },
    callToActionForMultiAppLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.multi-app.call.to.action",
        defaultMessage: "Connect apps"
    },
    callToActionForSingleAppLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.single-app.call.to.action",
        defaultMessage: "Connect {appName}"
    },
    dismissLabel: {
        id: "post-office.confluence-connect-3p-tools-nudge.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $d44ec7634d3da856$var$styles = {
    root: "_2rko1mok _kqswh2mm _16jlkb7n _bfhk1s93",
    primaryContentContainer: "_1yt4pxbi _16jlkb7n",
    callToActionContainer: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _bfhk1j28 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz",
    iconsColumn: "_16jlidpf _1o9zidpf _i0dl1wug _19bvpxbi _ca0qpxbi",
    iconWrapper: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1w55 _1bsb1tcg _4t3i1tcg",
    iconWrapperOverlap: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1w55 _1bsb1tcg _4t3i1tcg _18u0x0bf",
    closeButtonContainer: "_kqswstnw _154iu2gc _1xi2u2gc"
};
// `defaults.ts`. Used only when the component is rendered without
// `unconnectedApps` (Storybook / standalone usage). In production the creator
// always emits a non-empty list, so this default rarely fires.
const $d44ec7634d3da856$var$FALLBACK_APPS = (0, $bb8451f74f829999$export$8594dab83de99a34); /**
                                                                                    * Recognised cohort values for the `cc-connect-your-3p-tools-in-onboarding`
                                                                                    * experiment. Any other value (including `undefined`, `''`, `'control'`,
                                                                                    * `'not-enrolled'`, or unknown strings) is treated as a Statsig anomaly and
                                                                                    * suppresses the banner.
                                                                                    */ 
const $d44ec7634d3da856$var$COHORT_SINGLE = 'single-connect-in-onboarding';
const $d44ec7634d3da856$var$COHORT_MULTI = 'multi-connect-in-onboarding';
function $d44ec7634d3da856$var$cohortToLimit(cohort) {
    switch(cohort){
        case $d44ec7634d3da856$var$COHORT_SINGLE:
            return 1;
        case $d44ec7634d3da856$var$COHORT_MULTI:
            return 3;
        default:
            return null;
    }
} // Maximum recommendations we ever request from `use3pConnectorResources`.
// Matches the largest cohort limit so the same hook call serves every cohort.
const $d44ec7634d3da856$var$MAX_CONNECTORS = 3;
const $d44ec7634d3da856$export$6cced77b2ab4e73e = ({ action: action, unconnectedApps: unconnectedApps = $d44ec7634d3da856$var$FALLBACK_APPS, cohort: cohort, cloudId: cloudId, userId: userId, topApps: topApps, department: department, numTeammates: numTeammates, appName: appName, onPrimaryActionClick: onPrimaryActionClick, onDismissClick: onDismissClick })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { messageInstanceClicked: messageInstanceClicked, messageInstanceViewed: messageInstanceViewed } = (0, $gVWoV.useMessageInstanceEvent)();
    const [appIcons, setAppIcons] = (0, $42omo.useState)(new Map());
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const intl = (0, $aXWIB.useIntl)(); // Look up which of the recommended apps the user has already connected so
    // we can trim them out of the banner. Without this filter the nudge can
    // keep recommending apps that the user has already authenticated against,
    // which is a poor onboarding UX (the whole point of the nudge is to drive
    // fresh connections).
    // `use3pConnectorResources` is always called (the hook signature requires
    // `cloudId`), but `cloudId` may be `undefined` in Storybook / standalone
    // usage. In that case we pass `''` — the hook still runs, initialises
    // `isLoading: true`, and falls back to its unauthenticated default list
    // (`DEFAULT_SMARTLINKS_CONNECTOR_FALLBACKS`). The component therefore
    // renders `null` during the initial async tick even in Storybook; that is
    // a known cosmetic trade-off for a single source of truth on connection
    // state in production. `onConnectorConnected` is wired below into each
    // connector's `onConnect` callback so the hook's local state updates
    // without a page reload after a successful in-modal auth — without this
    // the just-connected app would keep showing in the nudge until refresh.
    const { connectorResources: connectorResources, isLoading: isConnectorLoading, onConnectorConnected: onConnectorConnected } = (0, $gi7cm.use3pConnectorResources)({
        cloudId: cloudId ?? '',
        userId: userId,
        maxConnectors: $d44ec7634d3da856$var$MAX_CONNECTORS
    }); // Build a Set of productKeys the user has authenticated against so we can
    // filter the recommended `unconnectedApps` list down to the truly fresh
    // ones. Recomputed only when `connectorResources` identity changes.
    const connectedProductKeys = new Set(connectorResources.filter((r)=>r.isAuthenticated).map((r)=>r.productKey));
    const freshApps = unconnectedApps.filter((app)=>!connectedProductKeys.has($d44ec7634d3da856$var$APP_CONFIG[app].productKey));
    const cohortLimit = $d44ec7634d3da856$var$cohortToLimit(cohort);
    const appsToRender = cohortLimit !== null ? freshApps.slice(0, cohortLimit) : []; // Has the banner actually committed to rendering on this paint? Mirrors the
    // suppression conditions below so analytics fire exactly once per user who
    // truly sees the nudge — not for the brief mounted-then-suppressed window
    // that exists for every user while `use3pConnectorResources` is loading or
    // when their connection state ultimately suppresses the banner. Without
    // this gate the "viewed" count is inflated by every mount, corrupting
    // experiment exposure metrics.
    const willRender = cohortLimit !== null && !isConnectorLoading && freshApps.length >= cohortLimit; // Track whether the viewed event has already fired for this mount, so we
    // don't double-fire if the component re-renders for any reason after the
    // guard transitions to true (e.g. a parent re-render or cohort prop change
    // that keeps `willRender` true).
    const hasFiredViewedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!willRender || hasFiredViewedRef.current) return;
        hasFiredViewedRef.current = true;
        if (messageInstanceViewed) messageInstanceViewed({
            ...cohort !== undefined && {
                cohort: cohort
            }
        });
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'ConfluenceConnect3pToolsSideNavNudge'
        }); // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally only re-runs when `willRender` flips
    }, [
        willRender
    ]); // Load icons from ThirdPartyConfigs on mount / when unconnectedApps changes
    (0, $42omo.useEffect)(()=>{
        let cancelled = false;
        const loadIcons = async ()=>{
            const iconMap = new Map();
            for (const app of appsToRender){
                const config = await (0, $cy0MC.ThirdPartyConfigs).get($d44ec7634d3da856$var$APP_CONFIG[app].productKey);
                if (config && !cancelled) iconMap.set(app, config.icon);
            }
            if (!cancelled) setAppIcons(iconMap);
        };
        loadIcons();
        return ()=>{
            cancelled = true;
        }; // eslint-disable-next-line react-hooks/exhaustive-deps -- appsToRender identity is derived; we want to re-run only when its membership changes
    }, [
        appsToRender.join(',')
    ]);
    const fireMessageInstanceClicked = ({ actionType: actionType, clickedElement: clickedElement })=>{
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: actionType
            },
            additionalMetadataFromFrontend: {
                ...cohort !== undefined && {
                    cohort: cohort
                }
            }
        });
    };
    const handleOnPrimaryActionClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'open',
            clickedElement: {
                clickIdentifier: 'showMeHow',
                clickedElement: 'button',
                buttonType: 'primary'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connect3pToolsSideNavNudgeCta'
        });
        onPrimaryActionClick?.(action);
        setIsModalOpen(true);
    };
    const handleOnModalClose = ()=>{
        setIsModalOpen(false); // Dismiss the nudge after the user closes the modal — once they've interacted
        // with the primary action, we don't need to show it again.
        onDismissClick?.();
    };
    const handleOnDismissClick = ()=>{
        fireMessageInstanceClicked({
            actionType: 'dismiss',
            clickedElement: {
                clickIdentifier: 'dismiss',
                clickedElement: 'cross-icon'
            }
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connect3pToolsSideNavNudgeDismiss'
        });
        onDismissClick?.();
    }; // Suppression rules in priority order:
    //
    // 1. Unknown / missing cohort (control, not-enrolled, '', undefined, etc.)
    //    signals a Statsig anomaly — fail closed and render nothing rather
    //    than nudge with an arbitrary default size. Without this guard we'd
    //    silently default to multi-app sizing for users who were never
    //    enrolled, which both biases experiment metrics and ships an
    //    unintended treatment to control users.
    // 2. While the connector lookup is in flight, render nothing to avoid a
    //    flash-then-vanish if the user turns out to already have enough apps
    //    connected. The hook starts with `isLoading: true` so this guard
    //    naturally covers the first render.
    // 3. If fewer fresh recommendations remain than the cohort requires, don't
    //    fall back to a smaller list — just suppress. Product decision: the
    //    single- and multi-app variants are different treatments in the
    //    experiment, so emitting a 1-app banner under the multi-app cohort
    //    would contaminate that arm. Suppress instead so the experiment
    //    remains clean.
    if (cohortLimit === null || isConnectorLoading || freshApps.length < cohortLimit) return null;
    const isSingleApp = appsToRender.length === 1;
    const bodyMessage = isSingleApp ? $d44ec7634d3da856$var$i18n.singleAppBodyLabel : $d44ec7634d3da856$var$i18n.multiAppBodyLabel;
    const ctaMessage = isSingleApp ? $d44ec7634d3da856$var$i18n.callToActionForSingleAppLabel : $d44ec7634d3da856$var$i18n.callToActionForMultiAppLabel;
    const firstApp = appsToRender[0];
    const messageValues = isSingleApp && firstApp ? {
        appName: $d44ec7634d3da856$var$APP_CONFIG[firstApp].displayName
    } : undefined;
    const connectorItems = appsToRender.reduce((acc, app)=>{
        const Icon = appIcons.get(app);
        if (!Icon) return acc;
        acc.push({
            icon: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: $d44ec7634d3da856$var$APP_CONFIG[app].displayName,
                size: "medium"
            }),
            name: $d44ec7634d3da856$var$APP_CONFIG[app].displayName,
            onConnect: async ()=>{
                onPrimaryActionClick?.(action); // Tell `use3pConnectorResources` that this productKey just
                // connected so its local cache flips to `isAuthenticated: true`.
                // The next render of this component will then filter the
                // just-connected app out of `freshApps` and re-evaluate the
                // cohort guard — preventing the stale-state bug where the
                // banner kept advertising an app the user had already linked.
                onConnectorConnected($d44ec7634d3da856$var$APP_CONFIG[app].productKey);
            }
        });
        return acc;
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bYRk6.default), {
        data: {
            source: 'confluence-connect-3p-tools-nudge'
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                xcss: $d44ec7634d3da856$var$styles.root,
                testId: "confluence-connect-3p-tools-nudge",
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: $d44ec7634d3da856$var$styles.iconsColumn,
                        alignItems: "start",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            direction: "row",
                            alignItems: "center",
                            children: appsToRender.map((app, index)=>{
                                const Icon = appIcons.get(app);
                                if (!Icon) return null;
                                return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: index === 0 ? $d44ec7634d3da856$var$styles.iconWrapper : $d44ec7634d3da856$var$styles.iconWrapperOverlap,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                                        label: "",
                                        size: "small"
                                    })
                                }, app);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        xcss: $d44ec7634d3da856$var$styles.primaryContentContainer,
                        gap: "space.100",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...$d44ec7634d3da856$var$i18n.headingLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...bodyMessage,
                                    values: messageValues
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                    xcss: $d44ec7634d3da856$var$styles.callToActionContainer,
                                    onClick: handleOnPrimaryActionClick,
                                    testId: "connect-3p-tools-cta-button",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.link",
                                        size: "medium",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                            ...ctaMessage,
                                            values: messageValues
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $d44ec7634d3da856$var$styles.closeButtonContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                    ...props,
                                    size: "small"
                                }),
                            label: intl.formatMessage($d44ec7634d3da856$var$i18n.dismissLabel),
                            isTooltipDisabled: false,
                            onClick: handleOnDismissClick
                        })
                    })
                ]
            }),
            numTeammates !== undefined && appName !== undefined ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6d0e7c3f977004b4$export$2586b970714caf78), {
                isOpen: isModalOpen,
                onClose: handleOnModalClose,
                connectorItems: connectorItems,
                numTeammates: numTeammates,
                appName: appName,
                topApps: topApps,
                department: department
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6d0e7c3f977004b4$export$2586b970714caf78), {
                isOpen: isModalOpen,
                onClose: handleOnModalClose,
                connectorItems: connectorItems,
                topApps: topApps,
                department: department
            })
        ]
    });
};



const $1936115387c22025$var$ANIMATION_APPS = new Set((0, $e9197596153e89d9$export$a02c2a50480baf7b));
const $1936115387c22025$var$DEPARTMENTS = new Set((0, $e9197596153e89d9$export$7cd9f89abe222b98));
const $1936115387c22025$export$e7843a8f64a8d87c = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createMessageBackend((0, $e7qVY.defaultMessageBackend));
const $1936115387c22025$export$fa9bb46961aca2cc = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createMessageFrontend({
    render: {
        validate: (0, $0e6ba358cf0b003d$export$a7a9523472993e97),
        Component: ({ nextBestActionType: nextBestActionType, cohort: cohort, cloudId: cloudId, userId: userId, unconnectedApps: unconnectedApps, topApps: topApps, department: department, onSideNavClick: onSideNavClick, handleOnDismissed: handleOnDismissed })=>{
            const narrowedTopApps = (0, $42omo.useMemo)(()=>topApps.filter((app)=>$1936115387c22025$var$ANIMATION_APPS.has(app)), [
                topApps
            ]);
            const narrowedDepartment = (0, $42omo.useMemo)(()=>$1936115387c22025$var$DEPARTMENTS.has(department) ? department : undefined, [
                department
            ]);
            // `unconnectedApps` is populated server-side by the implicit-message-creator
            // via a 3-tier cascade (team-type TAP trait → site-wide TAP trait → hardcoded
            // defaults). On total creator failure the message is suppressed entirely
            // (see implicit-message/index.ts outer catch), so this prop is always
            // non-empty in production.
            // `cloudId` and `userId` are required and used by Connect3pTools to call
            // `use3pConnectorResources` and suppress the nudge when the user is
            // already connected to enough of the recommended apps.
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $d44ec7634d3da856$export$6cced77b2ab4e73e), {
                action: nextBestActionType,
                cohort: cohort,
                cloudId: cloudId,
                userId: userId,
                unconnectedApps: unconnectedApps,
                topApps: narrowedTopApps,
                department: narrowedDepartment,
                onPrimaryActionClick: onSideNavClick,
                onDismissClick: handleOnDismissed
            });
        }
    }
});



var $cJD7j = parcelRequire("cJD7j");


const $5f5786590bba7e9c$var$messageBackends = [
    (0, $be442de82982a974$export$e7843a8f64a8d87c)({
        messageTemplateId: 'confluence-create-a-space'
    }),
    (0, $9c8f5058878835b9$export$e7843a8f64a8d87c)({
        messageTemplateId: 'confluence-side-nav-create-a-space'
    }),
    (0, $df51ae92ee3b789a$export$e7843a8f64a8d87c)({
        messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge'
    }),
    (0, $99e15f17ae435c58$export$e7843a8f64a8d87c)({
        messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge'
    }),
    (0, $9a5b08e01a85fa28$export$e7843a8f64a8d87c)({
        messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge'
    }),
    (0, $e2590681d1c6a329$export$e7843a8f64a8d87c)({
        messageTemplateId: 'rovo-extension-install-cta-left-nav'
    }),
    (0, $a541bb7276570a07$export$e7843a8f64a8d87c)({
        messageTemplateId: 'twc-sidenav-banner'
    }),
    (0, $0434e5e136afde69$export$e7843a8f64a8d87c)({
        messageTemplateId: 'twc-sidenav-a-a-banner'
    }),
    (0, $0677bde15ab9c4ab$export$e7843a8f64a8d87c)({
        messageTemplateId: 'confluence-rovo-onboarding-banner'
    }),
    (0, $1936115387c22025$export$e7843a8f64a8d87c)({
        messageTemplateId: 'confluence-3p-tools-nudge-banner'
    })
];
const $5f5786590bba7e9c$var$messageFrontends = [
    (0, $be442de82982a974$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-create-a-space'
    }),
    (0, $9c8f5058878835b9$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-side-nav-create-a-space'
    }),
    (0, $df51ae92ee3b789a$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge'
    }),
    (0, $99e15f17ae435c58$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge'
    }),
    (0, $9a5b08e01a85fa28$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge'
    }),
    (0, $e2590681d1c6a329$export$fa9bb46961aca2cc)({
        messageTemplateId: 'rovo-extension-install-cta-left-nav'
    }),
    (0, $a541bb7276570a07$export$fa9bb46961aca2cc)({
        messageTemplateId: 'twc-sidenav-banner'
    }),
    (0, $0434e5e136afde69$export$fa9bb46961aca2cc)({
        messageTemplateId: 'twc-sidenav-a-a-banner'
    }),
    (0, $0677bde15ab9c4ab$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-rovo-onboarding-banner'
    }),
    (0, $1936115387c22025$export$fa9bb46961aca2cc)({
        messageTemplateId: 'confluence-3p-tools-nudge-banner'
    })
];
const $5f5786590bba7e9c$export$fb7710cf8bc72648 = (0, $5902bd5901ea73a0$export$d90b37843c84d1c3).createPlacementBackend({
    messageTemplates: $5f5786590bba7e9c$var$messageBackends
});
const $5f5786590bba7e9c$export$af2bcbdc04a2d456 = (0, $5902bd5901ea73a0$export$55486c2b6964dcf2).createPlacementFrontendComponent({
    messageTemplates: $5f5786590bba7e9c$var$messageFrontends
});
const $5f5786590bba7e9c$export$5a7767152ae0305f = $5f5786590bba7e9c$export$fb7710cf8bc72648((0, $cJD7j.productionRuntime));



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $bZSO8 = parcelRequire("bZSO8");


var $bAyaS = parcelRequire("bAyaS");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $eB1TF = parcelRequire("eB1TF");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV = 'poConfluenceSideNavCreate';
const $45373df583cce1d3$export$f78bffe31fffa115 = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const [preloadedInitialData, setInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('confluence-side-nav');
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const sideNavRef = (0, $42omo.useRef)(null);
    const currentRoute = (0, $dPJCf.useRouteUrl)({
        selector: (routeUrl)=>routeUrl || ''
    });
    const { setIsOpen: setIsUniversalCreateOpen } = (0, $eB1TF.useUniversalCreateActions)();
    const onDismiss = (0, $42omo.useCallback)((data)=>{
        setInitialData(data);
    }, [
        setInitialData
    ]);
    const onSideNavClick = (0, $42omo.useCallback)((nextBestActionType, data)=>{
        setInitialData(data);
        switch(nextBestActionType){
            case 'CREATE_PAGE':
                push((0, $bZSO8.buildCreationLink)({
                    contentType: 'page',
                    source: $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV
                }));
                break;
            case 'CREATE_WHITEBOARD':
                push((0, $bZSO8.buildCreationLink)({
                    contentType: 'whiteboard',
                    source: $45373df583cce1d3$var$PO_CONFLUENCE_SIDE_NAV
                }));
                break;
            case 'CREATE_SPACE':
                // The second argument for openDrawer is the location string, which can be undefined or 'topCreateNav'
                // Since we're using the side nav to open the drawer, undefined is passed here.
                openDrawer(sideNavRef, undefined);
                break;
            case 'CREATE_WITH_ROVO_NUDGE':
                setIsUniversalCreateOpen(true);
                (0, $17wUi.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY, 'true');
                break;
            case 'RESURRECTED_USER_NUDGE':
                push((0, $1NBp8.HOME).toUrl(undefined, {
                    query: {
                        feedType: 'POPULAR'
                    }
                }));
                break;
            default:
                return;
        }
    }, [
        openDrawer,
        push,
        setInitialData,
        setIsUniversalCreateOpen
    ]);
    const memoizedPlacementProps = (0, $42omo.useMemo)(()=>({
            preloadedInitialData: preloadedInitialData,
            onDismiss: onDismiss,
            onSideNavClick: onSideNavClick,
            currentRoute: currentRoute,
            disableInitialData: Boolean(preloadedInitialData)
        }), [
        preloadedInitialData,
        onDismiss,
        onSideNavClick,
        currentRoute
    ]);
    /**
   * This is memoized to avoid any fetch calls getting cancelled inside `ConfluenceSideNav` due to
   * rerenders from changing context values (.ie usePostOfficeSideNavMessages).
   */ const PlacementInternals = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f5786590bba7e9c$export$af2bcbdc04a2d456), memoizedPlacementProps)), [
        memoizedPlacementProps
    ]);
    if (!(0, $9wGTI.fg)('post-office-connie-side-nav-killswitch') || !(0, $9wGTI.fg)('post-office-connie-side-nav-v4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    if ((0, $9wGTI.fg)('post-office-confluence-side-nav-placement-rollout')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "confluence-side-nav-placement",
        "data-vc": "confluence-side-nav-placement",
        ...ssrPlaceholderIdProp
    }, PlacementInternals);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
});
module.exports["PostOfficeConfluenceSideNavPlacement"] = $45373df583cce1d3$export$f78bffe31fffa115;

});

parcelRegister("92JEG", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $d66becf3e4056778$export$8bcdb86a7ad5ef4b = ()=>{
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED)
    ]);
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $ivb8S.deserializeState)(data);
    return {
        isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed
    };
};
module.exports["useHasDismissedNav4CollapseReminderSpotlight"] = $d66becf3e4056778$export$8bcdb86a7ad5ef4b;

});

parcelRegister("7HNmk", function(module, exports) {
const $c118ea8559248667$var$DEFAULT_REDIRECT_TO = 'jira';
function $c118ea8559248667$export$ef12ca92ab4cd865(value) {
    if (value === 'jira' || value === 'confluence') return value;
    return $c118ea8559248667$var$DEFAULT_REDIRECT_TO;
}
module.exports["resolveRedirectTo"] = $c118ea8559248667$export$ef12ca92ab4cd865;

});


//# sourceMappingURL=PageLayout.f7e26fc7.js.map
